import { E164Number } from 'libphonenumber-js';
import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "SIEVerificationSource": [
      "PhysicalControlUnitOutage",
      "StripeReport",
      "ZReport"
    ]
  }
};
      export default result;
    
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Base64Data: { input: string; output: string; }
  Color: { input: string; output: string; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Duration: { input: string; output: string; }
  E164: { input: E164Number; output: E164Number; }
  EmailAddress: { input: string; output: string; }
  Int53: { input: number; output: number; }
  JSONObject: { input: {}; output: {}; }
  OpaqueColor: { input: string; output: string; }
  PlainTime: { input: string; output: string; }
  PlainYearMonth: { input: string; output: string; }
  SieAccountNumber: { input: string; output: string; }
  URL: { input: string; output: string; }
  Version: { input: string; output: string; }
  Void: { input: void; output: void; }
};

export type AcceptDeliveryHeroIntegrationTermsOfServiceInput = {
  hasAccount: Scalars['Boolean']['input'];
  isReceivingOrders: Scalars['Boolean']['input'];
};

export enum AcceptTermsOfServiceResult {
  Success = 'Success'
}

export type AccessToken = {
  __typename?: 'AccessToken';
  expires?: Maybe<Scalars['DateTime']['output']>;
  parseToken?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  user?: Maybe<User>;
};

export enum AdditionStatus {
  Added = 'Added',
  Present = 'Present'
}

export enum ApiEnvironment {
  Beta = 'Beta',
  Dev = 'Dev',
  Stable = 'Stable'
}

export enum App {
  Admin = 'Admin',
  Client = 'Client',
  Kitchen = 'Kitchen',
  Order = 'Order'
}

export type AppSupportStatus = {
  __typename?: 'AppSupportStatus';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  blockedText?: Maybe<Scalars['String']['output']>;
  updateLink?: Maybe<Scalars['URL']['output']>;
  updateLinkTitle?: Maybe<Scalars['String']['output']>;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  app?: Maybe<App>;
  gitRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  platform?: Maybe<Platform>;
  userDevicesCount?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Version']['output']>;
};

export type AppVersionFilter = {
  app?: InputMaybe<Array<App>>;
  platform?: InputMaybe<Array<Platform>>;
};

export enum AuthorizationPermission {
  Authenticated = 'Authenticated',
  LabelWrite = 'LabelWrite',
  OrderCreator = 'OrderCreator',
  OrganizationAccountingWrite = 'OrganizationAccountingWrite',
  OrganizationRead = 'OrganizationRead',
  OrganizationUserWrite = 'OrganizationUserWrite',
  OrganizationWrite = 'OrganizationWrite',
  RestaurantCashAdjustmentWrite = 'RestaurantCashAdjustmentWrite',
  RestaurantDiscountWrite = 'RestaurantDiscountWrite',
  RestaurantDiscountedCheckout = 'RestaurantDiscountedCheckout',
  RestaurantExternalPaymentCheckout = 'RestaurantExternalPaymentCheckout',
  RestaurantMenuStockWrite = 'RestaurantMenuStockWrite',
  RestaurantMenuWrite = 'RestaurantMenuWrite',
  RestaurantOpenOrderWrite = 'RestaurantOpenOrderWrite',
  RestaurantOpenPriceCheckout = 'RestaurantOpenPriceCheckout',
  RestaurantOpeningHoursWrite = 'RestaurantOpeningHoursWrite',
  RestaurantOrderRead = 'RestaurantOrderRead',
  RestaurantOrderRefund = 'RestaurantOrderRefund',
  RestaurantPosWrite = 'RestaurantPosWrite',
  RestaurantRead = 'RestaurantRead',
  RestaurantReportRead = 'RestaurantReportRead',
  RestaurantReportWrite = 'RestaurantReportWrite',
  RestaurantSettingsWrite = 'RestaurantSettingsWrite',
  RestaurantWrite = 'RestaurantWrite',
  SuperUser = 'SuperUser',
  UserWrite = 'UserWrite',
  UserWriteInSudoMode = 'UserWriteInSudoMode'
}

export enum CancelTransactionResult {
  Failed = 'Failed',
  Success = 'Success'
}

export type CardVerification = {
  __typename?: 'CardVerification';
  clientSecret?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type CardVerificationInput = {
  idempotencyKey: Scalars['String']['input'];
};

export type CashAdjustment = {
  __typename?: 'CashAdjustment';
  amount?: Maybe<Scalars['Int53']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CashAdjustmentEdge = {
  __typename?: 'CashAdjustmentEdge';
  cursor: Scalars['String']['output'];
  node: CashAdjustment;
};

export type CashAdjustmentPage = {
  __typename?: 'CashAdjustmentPage';
  edges: Array<CashAdjustmentEdge>;
  pageInfo: PageInfo;
};

export type Cashregister = {
  __typename?: 'Cashregister';
  address?: Maybe<Scalars['String']['output']>;
  controlUnit?: Maybe<ControlUnit>;
  id: Scalars['ID']['output'];
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<CashregisterLocation>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  softwareName?: Maybe<Scalars['String']['output']>;
  softwareVersion?: Maybe<Scalars['String']['output']>;
};

export type CashregisterLocation = {
  __typename?: 'CashregisterLocation';
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ChangeUserEmailRequest = {
  __typename?: 'ChangeUserEmailRequest';
  id: Scalars['ID']['output'];
};

export type CheckoutOpenOrderItemsInput = {
  appLabel: Scalars['String']['input'];
  /** The location of the device that placed the order. */
  deviceLocation?: InputMaybe<CoordinatesInput>;
  /** A specific amount to discount from the total amount payable. Can only be used by employees. */
  discountAmount?: InputMaybe<Scalars['Int53']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  /** The Employee that placed the order, when placing an order from a Till while being logged in as an Employee */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided, the mutation will abort if the computed total amount doesn't match the value given here.
   *
   * This value should reflect the exact amount that the customer will be asked to pay in the payment step. It might however be lower than the final amount, if the customer adds tip in the payment step.
   *
   * Note that this amount should thus include everything that the customer should pay for, that is:
   * - Each item, including VAT
   * - Each addon item, including VAT
   * - Delivery cost, including VAT
   * - Discount
   * - Tip
   */
  expectedTotalAmount?: InputMaybe<Scalars['Int']['input']>;
  /** An idempotency key is a unique value generated by the client which the server uses to recognize subsequent retries of the same request. How you create unique keys is up to you, but we suggest using V4 UUIDs, or another random string with enough entropy to avoid collisions. */
  idempotencyKey: Scalars['String']['input'];
  /** An identifier that is unique to this particular device and installation of client. */
  installationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<OpenOrderItemInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** Any data passed in here will be returned as is when querying for it later. The server never acts upon the data in here. */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** The terminal that the card payment should be made on. This is only applicable if using a payment provider that uses physical card terminals. */
  posTerminalId?: InputMaybe<Scalars['ID']['input']>;
  /** If this is provided as true the order will go directly to the "Delivered" state after being paid, and will thus not show up in Loco PoS Kitchen */
  productsHandedToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  pushToken?: InputMaybe<PushTokenInput>;
  /** If provided, instead of sending a digital receipt, the original receipt will be printed on the specified printer and the digital receipt will be a copy of the receipt. */
  receiptPrinterId?: InputMaybe<Scalars['ID']['input']>;
  /** The Till this order was placed from */
  tillId?: InputMaybe<Scalars['ID']['input']>;
  tip?: InputMaybe<Scalars['Int']['input']>;
  type: MenuType;
};

export type ConnectDeliveryHeroIntegrationInput = {
  deliveryHeroChainId: Scalars['String']['input'];
  deliveryHeroVendorId: Scalars['String']['input'];
};

export type ControlUnit = {
  __typename?: 'ControlUnit';
  address?: Maybe<Scalars['String']['output']>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  productionNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  /** Vertical position in the range -90..90 where 90 denotes the north pole, and -90 the south pole */
  latitude: Scalars['Float']['output'];
  /** Horizontal position in the range -90..90 where positive values are to the east of the prime meridian, and negative values are to the west */
  longitude: Scalars['Float']['output'];
};

export type CoordinatesInput = {
  /** Vertical position in the range -90..90 where 90 denotes the north pole, and -90 the south pole */
  latitude: Scalars['Float']['input'];
  /** Horizontal position in the range -90..90 where positive values are to the east of the prime meridian, and negative values are to the west */
  longitude: Scalars['Float']['input'];
};

export enum Currency {
  Sek = 'SEK'
}

/** Represents a range of time spanning from 'start' (including) to 'end' (excluding) */
export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a range of time spanning from 'start' (including) to 'end' (excluding) */
export type DateTimeRangeInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export enum DeletionStatus {
  Absent = 'Absent',
  Deleted = 'Deleted'
}

export type Delivery = {
  __typename?: 'Delivery';
  distance?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Duration']['output']>;
};

export type DeliveryAddressInput = {
  /** City name */
  city: Scalars['String']['input'];
  /** Delivery instructions for driver */
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Code to apartment block */
  entryCode?: InputMaybe<Scalars['String']['input']>;
  /** Apartment number or building name */
  house?: InputMaybe<Scalars['String']['input']>;
  /** Name of person receiving order */
  recipient: Scalars['String']['input'];
  /** Street name and number */
  street: Scalars['String']['input'];
};

export type DeliveryCostArea = {
  __typename?: 'DeliveryCostArea';
  geometry?: Maybe<Array<Coordinates>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<MenuAddonProduct>;
};

export type DeliveryCostAreaInput = {
  geometry: Array<CoordinatesInput>;
  name: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};

export type DeliveryHeroSetupQuestionnaire = {
  __typename?: 'DeliveryHeroSetupQuestionnaire';
  hasAccount?: Maybe<Scalars['Boolean']['output']>;
  isReceivingOrders?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveryLocation = {
  __typename?: 'DeliveryLocation';
  /** Required permission: RestaurantOpenOrderWrite */
  amountPayableForOpenOrders?: Maybe<Scalars['Int53']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  eatInEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantOpenOrderWrite */
  openOrders?: Maybe<Array<OpenOrder>>;
  takeAwayEnabled?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<DeliveryLocationType>;
};

export enum DeliveryLocationActiveFilter {
  /** Only return active delivery locations */
  Active = 'Active',
  /** Include inactive delivery locations */
  All = 'All'
}

export type DeliveryLocationFilter = {
  active?: InputMaybe<DeliveryLocationActiveFilter>;
  menuType?: InputMaybe<MenuTypeFilter>;
};

export type DeliveryLocationInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type: DeliveryLocationType;
};

export type DeliveryLocationPatch = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Consider this flag a temporary solution until we get rid of cload and can more easily rework the delivery location data and logic */
  onlyTakeAway?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DeliveryLocationType {
  /** A cash desk is by default used both by eat in and take away */
  CashDesk = 'CashDesk',
  /** A table is only used by eat in */
  Table = 'Table'
}

export type DeliveryTimeArea = {
  __typename?: 'DeliveryTimeArea';
  geometry?: Maybe<Array<Coordinates>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Duration']['output']>;
};

export type DeliveryTimeAreaInput = {
  geometry: Array<CoordinatesInput>;
  name: Scalars['String']['input'];
  time: Scalars['Duration']['input'];
};

export type DeliveryTimeSlot = {
  __typename?: 'DeliveryTimeSlot';
  deadline?: Maybe<Scalars['DateTime']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Design = {
  __typename?: 'Design';
  adminImage?: Maybe<Scalars['URL']['output']>;
  background: PaletteColor;
  backgroundColor: Scalars['OpaqueColor']['output'];
  backgroundImage?: Maybe<Scalars['URL']['output']>;
  categoryBackgroundColor: Scalars['OpaqueColor']['output'];
  categoryTextColor: Scalars['Color']['output'];
  error: PaletteColor;
  headerTextColor: Scalars['Color']['output'];
  id: Scalars['ID']['output'];
  menuBackgroundColor: Scalars['Color']['output'];
  menuTextColor: Scalars['Color']['output'];
  primary: PaletteColor;
  productOverlayColor: Scalars['Color']['output'];
  restaurantHeaderImage?: Maybe<Scalars['URL']['output']>;
  restaurantPreviewImage?: Maybe<Scalars['URL']['output']>;
  secondary: PaletteColor;
  textColor: Scalars['Color']['output'];
};

export type DesignPatch = {
  /** Size should be 444 * 202 */
  adminImage?: InputMaybe<Scalars['URL']['input']>;
  background?: InputMaybe<PaletteColorInput>;
  backgroundColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  backgroundImage?: InputMaybe<Scalars['URL']['input']>;
  categoryBackgroundColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  categoryTextColor?: InputMaybe<Scalars['Color']['input']>;
  error?: InputMaybe<PaletteColorInput>;
  headerTextColor?: InputMaybe<Scalars['Color']['input']>;
  menuBackgroundColor?: InputMaybe<Scalars['Color']['input']>;
  menuTextColor?: InputMaybe<Scalars['Color']['input']>;
  primary?: InputMaybe<PaletteColorInput>;
  productOverlayColor?: InputMaybe<Scalars['Color']['input']>;
  restaurantHeaderImage?: InputMaybe<Scalars['URL']['input']>;
  restaurantPreviewImage?: InputMaybe<Scalars['URL']['input']>;
  secondary?: InputMaybe<PaletteColorInput>;
  textColor?: InputMaybe<Scalars['Color']['input']>;
};

export type DigitalSlip = {
  __typename?: 'DigitalSlip';
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountLimit?: Maybe<Scalars['Int']['output']>;
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  /** If present, the discount can only be used on orders from that menu */
  menuType?: Maybe<MenuType>;
  /** Required permission: SuperUser */
  metaOrganization?: Maybe<MetaOrganization>;
  minAmount?: Maybe<Scalars['Int']['output']>;
  normalizedCode?: Maybe<Scalars['String']['output']>;
  numberOfTimesPerUser?: Maybe<Scalars['Int']['output']>;
  /** Required permission: Authenticated */
  numberOfTimesUsedByMe?: Maybe<Scalars['Int']['output']>;
  /** If present, the discount can only be used during these periods */
  openingHours?: Maybe<Array<OpeningHoursPeriod>>;
  restaurant?: Maybe<Restaurant>;
  title?: Maybe<Scalars['String']['output']>;
  /** The total amount that this discount have shaved off for all users */
  totalDiscountAmount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Semantically unreliable and clients can easily calculate the usability themselves */
  usability?: Maybe<DiscountUsability>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type DiscountEdge = {
  __typename?: 'DiscountEdge';
  cursor: Scalars['String']['output'];
  node: Discount;
};

export type DiscountInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountLimit?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Int']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  menuType?: InputMaybe<MenuType>;
  minAmount?: InputMaybe<Scalars['Int']['input']>;
  numberOfTimesPerUser?: InputMaybe<Scalars['Int']['input']>;
  openingHours?: InputMaybe<Array<OpeningHoursPeriodInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiscountPage = {
  __typename?: 'DiscountPage';
  edges: Array<DiscountEdge>;
  pageInfo: PageInfo;
};

export type DiscountPatch = {
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  menuType?: InputMaybe<MenuType>;
  openingHours?: InputMaybe<Array<OpeningHoursPeriodInput>>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Gives if the discount is *usable* or the reason why it's not. Be aware that new members might be added in the future */
export enum DiscountUsability {
  Disabled = 'Disabled',
  Expired = 'Expired',
  Misconfigured = 'Misconfigured',
  MissingAuth = 'MissingAuth',
  NotStarted = 'NotStarted',
  /** If the discount is not within the specified week day time periods */
  NotWithinOpeningHours = 'NotWithinOpeningHours',
  Usable = 'Usable',
  UsedBySomeone = 'UsedBySomeone',
  UsedByYou = 'UsedByYou'
}

export enum EatInServicePolicy {
  /** The order will be delivered to the table. The product is automatically moved to history if it is printed */
  CompleteAutomatically = 'CompleteAutomatically',
  /** The order will be delivered to the table. The product must be manually moved to history */
  CompleteManually = 'CompleteManually',
  /** The customer picks up the order at the cash desk. The customer gets a push notification when it is ready */
  DeliverToCashDesk = 'DeliverToCashDesk'
}

export type Employee = {
  __typename?: 'Employee';
  canListDiscounts?: Maybe<Scalars['Boolean']['output']>;
  canListProductsWithOpenPrice?: Maybe<Scalars['Boolean']['output']>;
  canLogoutTill?: Maybe<Scalars['Boolean']['output']>;
  canMakeCashAdjustments?: Maybe<Scalars['Boolean']['output']>;
  canManageOpenOrders?: Maybe<Scalars['Boolean']['output']>;
  canRefundOrders?: Maybe<Scalars['Boolean']['output']>;
  canUpdateMenu?: Maybe<Scalars['Boolean']['output']>;
  canViewHistory?: Maybe<Scalars['Boolean']['output']>;
  canViewReceipts?: Maybe<Scalars['Boolean']['output']>;
  groups?: Maybe<Array<EmployeeGroup>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
};

export type EmployeeGroup = {
  __typename?: 'EmployeeGroup';
  canListDiscounts?: Maybe<Scalars['Boolean']['output']>;
  canListProductsWithOpenPrice?: Maybe<Scalars['Boolean']['output']>;
  canLogoutTill?: Maybe<Scalars['Boolean']['output']>;
  canMakeCashAdjustments?: Maybe<Scalars['Boolean']['output']>;
  canManageOpenOrders?: Maybe<Scalars['Boolean']['output']>;
  canRefundOrders?: Maybe<Scalars['Boolean']['output']>;
  canUpdateMenu?: Maybe<Scalars['Boolean']['output']>;
  canViewHistory?: Maybe<Scalars['Boolean']['output']>;
  canViewReceipts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EmployeeGroupInput = {
  canListDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  canListProductsWithOpenPrice?: InputMaybe<Scalars['Boolean']['input']>;
  canLogoutTill?: InputMaybe<Scalars['Boolean']['input']>;
  canMakeCashAdjustments?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOpenOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canRefundOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canUpdateMenu?: InputMaybe<Scalars['Boolean']['input']>;
  canViewHistory?: InputMaybe<Scalars['Boolean']['input']>;
  canViewReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type EmployeeGroupPatch = {
  canListDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  canListProductsWithOpenPrice?: InputMaybe<Scalars['Boolean']['input']>;
  canLogoutTill?: InputMaybe<Scalars['Boolean']['input']>;
  canMakeCashAdjustments?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOpenOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canRefundOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canUpdateMenu?: InputMaybe<Scalars['Boolean']['input']>;
  canViewHistory?: InputMaybe<Scalars['Boolean']['input']>;
  canViewReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeInput = {
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};

export type EmployeePatch = {
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ExportYouniumUsageInput = {
  email: Scalars['EmailAddress']['input'];
  month: Scalars['PlainYearMonth']['input'];
  youniumPassword: Scalars['String']['input'];
  youniumUsername: Scalars['String']['input'];
};

export enum FixedDeliveryTime {
  Asap = 'ASAP',
  Any = 'Any'
}

/** DEPRECATED: Use 'FixedDeliveryTime' instead */
export enum FixedServingTime {
  Asap = 'ASAP',
  Any = 'Any'
}

export type FortnoxAccountingImportCredentials = {
  authorizationCode: Scalars['String']['input'];
  redirectUrl: Scalars['URL']['input'];
};

export type FortnoxAccountingImportJob = {
  __typename?: 'FortnoxAccountingImportJob';
  id: Scalars['ID']['output'];
  logEntries?: Maybe<Array<FortnoxAccountingImportJobLogEntry>>;
  status?: Maybe<FortnoxAccountingImportJobStatus>;
};

export type FortnoxAccountingImportJobLogEntry = {
  __typename?: 'FortnoxAccountingImportJobLogEntry';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export enum FortnoxAccountingImportJobStatus {
  Failed = 'Failed',
  ManuallyImported = 'ManuallyImported',
  Pending = 'Pending',
  Success = 'Success'
}

export type GlobalStatistics = {
  __typename?: 'GlobalStatistics';
  id: Scalars['ID']['output'];
  salesByMenuTypeAndTimePeriod?: Maybe<Array<GlobalStatisticsSalesByMenuTypeAndTimePeriod>>;
  salesByRestaurant?: Maybe<Array<GlobalStatisticsSalesByRestaurant>>;
};

export type GlobalStatisticsSalesByMenuTypeAndTimePeriod = {
  __typename?: 'GlobalStatisticsSalesByMenuTypeAndTimePeriod';
  count?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  menuType?: Maybe<MenuType>;
  when?: Maybe<Scalars['String']['output']>;
};

export type GlobalStatisticsSalesByRestaurant = {
  __typename?: 'GlobalStatisticsSalesByRestaurant';
  count?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  restaurant?: Maybe<Restaurant>;
};

export type HistoricalOpenOrderFilter = {
  deliveryLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type HumanOrderNumberRange = {
  __typename?: 'HumanOrderNumberRange';
  maximum: Scalars['Int']['output'];
  minimum: Scalars['Int']['output'];
};

export type HumanOrderNumberRangeInput = {
  maximum: Scalars['Int']['input'];
  minimum: Scalars['Int']['input'];
};

export type IncidentMessage = {
  __typename?: 'IncidentMessage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  iconUrl?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  dateTimeRange?: Maybe<DateTimeRange>;
  id: Scalars['ID']['output'];
  invoiceItems?: Maybe<Array<InvoiceItem>>;
  smsCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  id: Scalars['ID']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  totalAmount?: Maybe<Scalars['Int53']['output']>;
  transactionChannel?: Maybe<TransactionChannel>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
};

export type KitchenDisplay = {
  __typename?: 'KitchenDisplay';
  id: Scalars['ID']['output'];
  slips?: Maybe<Array<DigitalSlip>>;
};

export enum KitchenOrderQueueSorting {
  EstimatedDelivery = 'EstimatedDelivery',
  OrderPlacedAt = 'OrderPlacedAt'
}

export type LegacyOpeningHours = {
  __typename?: 'LegacyOpeningHours';
  day: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  openFrom: Scalars['Int']['output'];
  openTo: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type LegacyOpeningHoursError = {
  __typename?: 'LegacyOpeningHoursError';
  cause: Scalars['String']['output'];
  source: LegacyOpeningHours;
};

export type LightModeRestaurantTheme = {
  __typename?: 'LightModeRestaurantTheme';
  accentColor: Scalars['OpaqueColor']['output'];
  fallbackAccentColor: Scalars['OpaqueColor']['output'];
  primaryColor: Scalars['OpaqueColor']['output'];
  retroProductButtonsColorByCategory?: Maybe<Array<RetroProductButtonsColorByCategory>>;
  retroProductButtonsDefaultColor: Scalars['OpaqueColor']['output'];
  secondaryColor: Scalars['OpaqueColor']['output'];
};

export type LightModeRestaurantThemeInput = {
  accentColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  fallbackAccentColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  primaryColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  retroProductButtonsColorByCategory?: InputMaybe<Array<RetroProductButtonsColorByCategoryInput>>;
  retroProductButtonsDefaultColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  secondaryColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
};

export type MarketingPushNotification = {
  __typename?: 'MarketingPushNotification';
  deviceCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type Menu = {
  __typename?: 'Menu';
  /** Required permission: RestaurantRead */
  addonProduct?: Maybe<MenuAddonProduct>;
  /** Required permission: RestaurantRead */
  addonProducts?: Maybe<Array<MenuAddonProduct>>;
  /** Required permission: RestaurantRead */
  alternativeGroup?: Maybe<MenuAlternativeGroup>;
  /** Required permission: RestaurantRead */
  alternativeGroups?: Maybe<Array<MenuAlternativeGroup>>;
  category?: Maybe<MenuCategory>;
  course?: Maybe<MenuCourse>;
  courses?: Maybe<Array<MenuCourse>>;
  csvData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  page?: Maybe<MenuPage>;
  pages?: Maybe<Array<MenuPage>>;
  product?: Maybe<MenuProduct>;
  /** Required permission: RestaurantRead */
  productOpeningHours?: Maybe<Array<OpeningHours>>;
  /** Required permission: RestaurantRead */
  products?: Maybe<Array<MenuProduct>>;
  /** Required permission: RestaurantRead */
  reportGroups?: Maybe<Array<MenuReportGroup>>;
};


export type MenuAddonProductArgs = {
  id: Scalars['ID']['input'];
};


export type MenuAlternativeGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MenuCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MenuCourseArgs = {
  id: Scalars['ID']['input'];
};


export type MenuPageArgs = {
  id: Scalars['ID']['input'];
};


export type MenuProductArgs = {
  id: Scalars['ID']['input'];
};

export enum MenuActiveFilter {
  /** Only return active products and non-empty pages & categories */
  Active = 'Active',
  /** Include inactive products and empty pages & categories */
  All = 'All'
}

export type MenuAddonProduct = {
  __typename?: 'MenuAddonProduct';
  id: Scalars['ID']['output'];
  isDeliveryCost?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<MenuAddonProductProperties>;
};

export type MenuAddonProductInput = {
  isDeliveryCost?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  properties: MenuAddonProductPropertiesInput;
};

export type MenuAddonProductPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<MenuAddonProductPropertiesPatch>;
};

export type MenuAddonProductProperties = {
  __typename?: 'MenuAddonProductProperties';
  description?: Maybe<Scalars['String']['output']>;
  /** Temporary flag if this addon product hasn't yet been converted to the new format where there is no distinction between menu types */
  hasLegacyFormat?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['URL']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  /** Required permission: RestaurantRead */
  reportGroup?: Maybe<MenuReportGroup>;
  stateId: Scalars['ID']['output'];
};

export type MenuAddonProductPropertiesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['URL']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Int']['input'];
  reportGroupId: Scalars['ID']['input'];
};

export type MenuAddonProductPropertiesPatch = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['URL']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  reportGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MenuAlternativeGroup = {
  __typename?: 'MenuAlternativeGroup';
  alternativeItems?: Maybe<Array<MenuAlternativeItem>>;
  forceChoice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCountable?: Maybe<Scalars['Boolean']['output']>;
  maxChoices?: Maybe<Scalars['Int']['output']>;
  minChoices?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MenuAlternativeGroupInput = {
  alternativeItems: Array<MenuAlternativeItemInput>;
  forceChoice?: InputMaybe<Scalars['Boolean']['input']>;
  isCountable?: InputMaybe<Scalars['Boolean']['input']>;
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
  minChoices?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type MenuAlternativeGroupPatch = {
  alternativeItems?: InputMaybe<Array<MenuAlternativeItemInput>>;
  forceChoice?: InputMaybe<Scalars['Boolean']['input']>;
  isCountable?: InputMaybe<Scalars['Boolean']['input']>;
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
  minChoices?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MenuAlternativeItem = {
  __typename?: 'MenuAlternativeItem';
  addonProduct?: Maybe<MenuAddonProduct>;
  countableUsage?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type MenuAlternativeItemInput = {
  addonProductId?: InputMaybe<Scalars['ID']['input']>;
  countableUsage?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MenuCategory = {
  __typename?: 'MenuCategory';
  defaultCourse?: Maybe<MenuCourse>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantRead */
  newProductDefaultValues?: Maybe<MenuProductDefaultValues>;
  page?: Maybe<MenuPage>;
  productCount?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<MenuProduct>>;
  temporarilyDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MenuCategoryInput = {
  name: Scalars['String']['input'];
  temporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuCategoryPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  temporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuCourse = {
  __typename?: 'MenuCourse';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type MenuCourseInput = {
  name: Scalars['String']['input'];
};

export type MenuCoursePatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MenuFilter = {
  active?: InputMaybe<MenuActiveFilter>;
  includeProductsWithOpenPrice?: InputMaybe<Scalars['Boolean']['input']>;
  tillId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<MenuType>>;
};

export type MenuPage = {
  __typename?: 'MenuPage';
  categories?: Maybe<Array<MenuCategory>>;
  categoryCount?: Maybe<Scalars['Int']['output']>;
  defaultCourse?: Maybe<MenuCourse>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  temporarilyDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MenuPageInput = {
  name: Scalars['String']['input'];
  temporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuPagePatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  temporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuProduct = {
  __typename?: 'MenuProduct';
  category?: Maybe<MenuCategory>;
  defaultCourse?: Maybe<MenuCourse>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<MenuProductProperties>;
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
};


export type MenuProductPropertiesArgs = {
  menuType: MenuType;
};

export type MenuProductDefaultValues = {
  __typename?: 'MenuProductDefaultValues';
  defaultCourse?: Maybe<MenuCourse>;
  delivery?: Maybe<MenuProductVariantDefaultValues>;
  eatIn?: Maybe<MenuProductVariantDefaultValues>;
  id: Scalars['ID']['output'];
  takeAway?: Maybe<MenuProductVariantDefaultValues>;
};

export type MenuProductInput = {
  defaultCourseId?: InputMaybe<Scalars['ID']['input']>;
  delivery?: InputMaybe<MenuProductPropertiesInput>;
  eatIn?: InputMaybe<MenuProductPropertiesInput>;
  name: Scalars['String']['input'];
  quantityAvailable?: InputMaybe<Scalars['Int']['input']>;
  takeAway?: InputMaybe<MenuProductPropertiesInput>;
};

export type MenuProductPatch = {
  defaultCourseId?: InputMaybe<Scalars['ID']['input']>;
  delivery?: InputMaybe<MenuProductPropertiesPatch>;
  eatIn?: InputMaybe<MenuProductPropertiesPatch>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantityAvailable?: InputMaybe<Scalars['Int']['input']>;
  takeAway?: InputMaybe<MenuProductPropertiesPatch>;
};

export type MenuProductProperties = {
  __typename?: 'MenuProductProperties';
  alternativeGroups?: Maybe<Array<MenuAlternativeGroup>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['URL']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  openingHours?: Maybe<OpeningHours>;
  price?: Maybe<Scalars['Int']['output']>;
  priceIsOpen?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantRead */
  printAt?: Maybe<Array<Printer>>;
  /** Required permission: RestaurantRead */
  reportGroup?: Maybe<MenuReportGroup>;
  /** Required permission: RestaurantRead */
  secondaryPrinters?: Maybe<Array<Printer>>;
  stateId: Scalars['ID']['output'];
  temporarilyDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantRead */
  tills?: Maybe<Array<Till>>;
};

export type MenuProductPropertiesInput = {
  alternativeGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['URL']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  openingHoursId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceIsOpen?: InputMaybe<Scalars['Boolean']['input']>;
  printAt?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportGroupId?: InputMaybe<Scalars['ID']['input']>;
  secondaryPrinterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  temporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuProductPropertiesPatch = {
  alternativeGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['URL']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  openingHoursId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceIsOpen?: InputMaybe<Scalars['Boolean']['input']>;
  printAt?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportGroupId?: InputMaybe<Scalars['ID']['input']>;
  secondaryPrinterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  temporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuProductVariantDefaultValues = {
  __typename?: 'MenuProductVariantDefaultValues';
  alternativeGroups?: Maybe<Array<MenuAlternativeGroup>>;
  id: Scalars['ID']['output'];
  openingHours?: Maybe<OpeningHours>;
  printAt?: Maybe<Array<Printer>>;
  reportGroup?: Maybe<MenuReportGroup>;
  secondaryPrinters?: Maybe<Array<Printer>>;
};

export type MenuReportGroup = {
  __typename?: 'MenuReportGroup';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['Int']['output']>;
};

export type MenuReportGroupInput = {
  name: Scalars['String']['input'];
  vatRate: Scalars['Int']['input'];
};

export enum MenuSystem {
  Legacy = 'Legacy',
  Neue = 'Neue'
}

export enum MenuType {
  Delivery = 'Delivery',
  EatIn = 'EatIn',
  GiftCard = 'GiftCard',
  TakeAway = 'TakeAway'
}

export enum MenuTypeFilter {
  All = 'All',
  Delivery = 'Delivery',
  EatIn = 'EatIn',
  GiftCard = 'GiftCard',
  TakeAway = 'TakeAway'
}

export type Message = {
  __typename?: 'Message';
  id: Scalars['ID']['output'];
  status?: Maybe<MessageStatus>;
};

export enum MessageStatus {
  Delivered = 'Delivered',
  Errored = 'Errored',
  Pending = 'Pending',
  Sent = 'Sent'
}

export type MetaOrganization = {
  __typename?: 'MetaOrganization';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Required permission: SuperUser */
  discount?: Maybe<Discount>;
  /** Required permission: SuperUser */
  discounts?: Maybe<DiscountPage>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  restaurants?: Maybe<RestaurantPage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MetaOrganizationDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type MetaOrganizationDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type MetaOrganizationRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type MetaOrganizationEdge = {
  __typename?: 'MetaOrganizationEdge';
  cursor: Scalars['String']['output'];
  node: MetaOrganization;
};

export type MetaOrganizationInput = {
  /** Must be between 1 and 50 characters */
  name: Scalars['String']['input'];
};

export type MetaOrganizationPage = {
  __typename?: 'MetaOrganizationPage';
  edges: Array<MetaOrganizationEdge>;
  pageInfo: PageInfo;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Required permission: RestaurantWrite */
  acceptDeliveryHeroIntegrationTermsOfService?: Maybe<Restaurant>;
  /** Required permission: OrganizationWrite */
  acceptFortnoxAccountingImportIntegrationTermsOfService?: Maybe<Organization>;
  /** Required permission: RestaurantWrite */
  acceptOrderDisplaySystemTermsOfService?: Maybe<Restaurant>;
  /** Required permission: RestaurantWrite */
  acceptPersonalkollenIntegrationTermsOfService?: Maybe<Restaurant>;
  /** Required permission: Authenticated */
  acceptTermsOfService: AcceptTermsOfServiceResult;
  /** Required permission: RestaurantSettingsWrite */
  activateRestaurant?: Maybe<Restaurant>;
  /** Required permission: SuperUser */
  addRestaurantToMetaOrganization?: Maybe<AdditionStatus>;
  /** Required permission: RestaurantOrderRefund */
  cancelOpenOrderItems?: Maybe<OpenOrder>;
  /** Required permission: RestaurantOrderRefund */
  cancelOrderIntent?: Maybe<RefundIntent>;
  /** Required permission: Authenticated */
  cancelPaymentIntent?: Maybe<PaymentIntent>;
  /** Required permission: RestaurantOrderRefund */
  cancelRefundIntent?: Maybe<RefundIntent>;
  /**
   * Required permission: RestaurantWrite
   * @deprecated Use cancelPaymentIntent/cancelRefundIntent instead
   */
  cancelTransaction: CancelTransactionResult;
  /** Required permission: RestaurantOpenOrderWrite */
  checkoutOpenOrderItems?: Maybe<OrderIntent>;
  /**
   * Lock and return some jobs in the printer queue. The server might not give you all jobs in the queue at the same time.
   *
   * A job will remain locked for 1 minute, during which time it will temporarily be removed from the queue. Thus, you need to print the returned jobs within one minute, and call the "finishPrinterJob" mutation to signal that the job was successfully printed.
   *
   * If you haven't been able to print a job when nearing the two minute mark, you should stop trying since it will go back in the queue and could be picked up by another worker.
   *
   * Required permission: RestaurantWrite
   */
  claimPrinterJobs?: Maybe<Array<PrinterJob>>;
  completePhoneNumberVerification?: Maybe<AccessToken>;
  confirmChangeUserEmail?: Maybe<User>;
  connectDeliveryHeroIntegration?: Maybe<Restaurant>;
  createAccessToken?: Maybe<AccessToken>;
  /** Required permission: SuperUser */
  createCardVerification?: Maybe<CardVerification>;
  /** Required permission: RestaurantCashAdjustmentWrite or RestaurantReportWrite */
  createCashAdjustment?: Maybe<CashAdjustment>;
  /** Required permission: RestaurantReportWrite */
  createCashregisterReport?: Maybe<ZReport>;
  /** Required permission: RestaurantWrite */
  createDeliveryCostArea?: Maybe<Restaurant>;
  /** Required permission: RestaurantSettingsWrite */
  createDeliveryLocation?: Maybe<DeliveryLocation>;
  /** Required permission: RestaurantWrite */
  createDeliveryTimeArea?: Maybe<Restaurant>;
  /** Required permission: SuperUser */
  createDiscount?: Maybe<Discount>;
  /** Required permission: RestaurantPosWrite */
  createEmployee?: Maybe<Employee>;
  /** Required permission: RestaurantPosWrite */
  createEmployeeGroup?: Maybe<EmployeeGroup>;
  /** Required permission: RestaurantMenuWrite */
  createMenuAddonProduct?: Maybe<MenuAddonProduct>;
  /** Required permission: RestaurantMenuWrite */
  createMenuAlternativeGroup?: Maybe<MenuAlternativeGroup>;
  /** Required permission: RestaurantMenuWrite */
  createMenuCategory?: Maybe<MenuCategory>;
  /** Required permission: RestaurantMenuWrite */
  createMenuCourse?: Maybe<MenuCourse>;
  /** Required permission: RestaurantMenuWrite */
  createMenuPage?: Maybe<MenuPage>;
  /** Required permission: RestaurantMenuWrite */
  createMenuProduct?: Maybe<MenuProduct>;
  /** Required permission: RestaurantReportWrite */
  createMenuReportGroup?: Maybe<MenuReportGroup>;
  /** Required permission: SuperUser */
  createMetaOrganization?: Maybe<MetaOrganization>;
  /** Required permission: RestaurantOpenOrderWrite */
  createOpenOrder?: Maybe<OpenOrder>;
  /** Required permission: RestaurantOpenOrderWrite */
  createOpenOrderBatch?: Maybe<OpenOrder>;
  /** Required permission: RestaurantOpeningHoursWrite */
  createOpeningHours?: Maybe<OpeningHours>;
  /** Required permission: Authenticated */
  createOrderIntent?: Maybe<OrderIntent>;
  /** Required permission: Authenticated */
  createOrganization?: Maybe<Organization>;
  /** Required permission: OrganizationUserWrite */
  createOrganizationUser?: Maybe<OrganizationUser>;
  /** Required permission: Authenticated */
  createPaymentIntent?: Maybe<PaymentIntent>;
  /** Required permission: Authenticated */
  createPaymentIntentRetry?: Maybe<PaymentIntent>;
  /** Required permission: RestaurantReportWrite */
  createPaymentMethod?: Maybe<PaymentMethod>;
  /** Required permission: SuperUser */
  createPhysicalControlUnitOutage?: Maybe<PhysicalControlUnitOutage>;
  /** Required permission: SuperUser */
  createPhysicalControlUnitOutageReport?: Maybe<PhysicalControlUnitOutageReport>;
  /** Required permission: RestaurantSettingsWrite */
  createPhysicalPrinter?: Maybe<PhysicalPrinter>;
  /** Required permission: RestaurantSettingsWrite */
  createPrinterQueue?: Maybe<PrinterQueue>;
  /** Required permission: RestaurantOrderRefund */
  createRefundIntent?: Maybe<RefundIntent>;
  /** Required permission: OrganizationWrite */
  createRestaurant?: Maybe<Restaurant>;
  /** Required permission: RestaurantReportRead */
  createRestaurantControlUnitOutageReport?: Maybe<RestaurantControlUnitOutageReport>;
  /** Required permission: LabelWrite */
  createRestaurantDeliveryLocationShortUrls?: Maybe<Array<RestaurantDeliveryLocationShortUrl>>;
  /** Required permission: RestaurantDiscountWrite */
  createRestaurantDiscount?: Maybe<Discount>;
  /** Required permission: LabelWrite */
  createShortUrl?: Maybe<ShortUrl>;
  /** Required permission: RestaurantPosWrite */
  createTill?: Maybe<Till>;
  createUser?: Maybe<User>;
  /** Required permission: SuperUser */
  createWhiteLabel?: Maybe<WhiteLabel>;
  /**
   * Required permission: RestaurantWrite
   * @deprecated Update 'temporarilyDisabled' with the updateRestaurant mutation instead
   */
  deactivateRestaurant?: Maybe<Restaurant>;
  /** Required permission: RestaurantWrite */
  deleteDeliveryCostArea?: Maybe<Restaurant>;
  /** Required permission: RestaurantSettingsWrite */
  deleteDeliveryLocation?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantWrite */
  deleteDeliveryTimeArea?: Maybe<Restaurant>;
  /** Required permission: SuperUser */
  deleteDiscount?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantPosWrite */
  deleteEmployee?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantPosWrite */
  deleteEmployeeGroup?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantMenuWrite */
  deleteMenuAddonProduct?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantMenuWrite */
  deleteMenuAlternativeGroup?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantMenuWrite */
  deleteMenuCategory?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantMenuWrite */
  deleteMenuCourse?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantMenuWrite */
  deleteMenuPage?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantMenuWrite */
  deleteMenuProduct?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantReportWrite */
  deleteMenuReportGroup?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantOpeningHoursWrite */
  deleteOpeningHours?: Maybe<DeletionStatus>;
  /** Required permission: OrganizationUserWrite */
  deleteOrganizationUser?: Maybe<Organization>;
  /** Required permission: RestaurantReportWrite */
  deletePaymentMethod?: Maybe<DeletionStatus>;
  /** Required permission: RestaurantSettingsWrite */
  deletePhysicalPrinter?: Maybe<Restaurant>;
  /** Required permission: RestaurantSettingsWrite */
  deletePrinterQueue?: Maybe<Restaurant>;
  /** Required permission: SuperUser */
  deleteRestaurant?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantDiscountWrite */
  deleteRestaurantDiscount?: Maybe<DeletionStatus>;
  /** Required permission: UserWrite */
  deleteStripeCard?: Maybe<User>;
  /** Required permission: RestaurantPosWrite */
  deleteTill?: Maybe<DeletionStatus>;
  /** Required permission: UserWrite */
  deleteUser?: Maybe<Scalars['Void']['output']>;
  /** Required permission: SuperUser */
  deleteWhiteLabel?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantWrite */
  emptyNetsConnectCloudTerminalPrinterBuffer?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantWrite */
  enableDeliveryHeroIntegration?: Maybe<Restaurant>;
  /** Required permission: Authenticated */
  enterSudoMode?: Maybe<SudoModeTicket>;
  /** Required permission: RestaurantOpenOrderWrite */
  expediteOpenOrder?: Maybe<Scalars['Void']['output']>;
  /** Required permission: SuperUser */
  exportYouniumUsage?: Maybe<Scalars['Void']['output']>;
  /**
   * Indicate that you failed your current attempt at printing the indicated job. Call this mutation after you have claimed a job (using the "claimPrinterJobs") and failed to print it.
   *
   * Required permission: RestaurantWrite
   */
  failPrinterJob?: Maybe<Scalars['Void']['output']>;
  finalizeOrderIntent?: Maybe<Order>;
  finalizePaymentIntent?: Maybe<OrderIntent>;
  /**
   * Required permission: RestaurantWrite
   * @deprecated Use the 'finalizeRefundIntent2' mutation instead
   */
  finalizeRefundIntent?: Maybe<Order>;
  /** Required permission: RestaurantOrderRefund */
  finalizeRefundIntent2?: Maybe<RefundIntent>;
  /** Required permission: RestaurantWrite */
  finishOrder?: Maybe<Order>;
  /**
   * Mark a printer job as finished. Call this mutation after you have claimed a job (using the "claimPrinterJobs") and printed it successfully.
   *
   * Required permission: RestaurantWrite
   */
  finishPrinterJob?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantReportRead */
  generateRestaurantOrderSalesBreakdown?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantSettingsWrite */
  identifyPhysicalPrinter?: Maybe<PhysicalPrinter>;
  /** Required permission: RestaurantSettingsWrite */
  identifyPhysicalPrinters?: Maybe<Array<PhysicalPrinter>>;
  /** Required permission: RestaurantMenuWrite */
  importMenuFromCsv?: Maybe<Scalars['Void']['output']>;
  /** Required permission: OrganizationAccountingWrite */
  linkFortnoxAccountingImportAccount?: Maybe<Organization>;
  /** Required permission: RestaurantReportWrite */
  linkNetsConnectCloudAccount?: Maybe<Restaurant>;
  /** Required permission: RestaurantWrite */
  linkPersonalkollenAccount?: Maybe<Restaurant>;
  /** Required permission: RestaurantReportWrite */
  linkSwishNumber?: Maybe<Restaurant>;
  /** Required permission: OrganizationAccountingWrite */
  markFortnoxAccountingImportAsManuallyImported?: Maybe<FortnoxAccountingImportJob>;
  /**
   * Sets the flag "completedByCustomer" to true, which indicates that the customer has indicated that the order has been received by them
   *
   * Required permission: OrderCreator
   */
  markOrderAsCompletedByCustomer?: Maybe<Order>;
  /**
   * Sets the flag "needsKitchenPrint" to false, which indicates that this order has been printed by Loco PoS Kitchen
   *
   * Required permission: RestaurantWrite
   */
  markOrderAsPrintedInKitchen?: Maybe<Order>;
  /** Required permission: Authenticated */
  migrateDeviceInstallation?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantOpenOrderWrite */
  moveOpenOrderItems?: Maybe<OpenOrderItemsMoved>;
  /** Required permission: RestaurantRead */
  printOrderReceiptCopy?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantOpenOrderWrite */
  printProForma?: Maybe<Scalars['Void']['output']>;
  /** Required permission: SuperUser */
  publishWhiteLabel?: Maybe<WhiteLabel>;
  /** Required permission: RestaurantMenuWrite */
  rearrangeMenuAddonProducts?: Maybe<RearrangalStatus>;
  /** Required permission: RestaurantMenuWrite */
  rearrangeMenuAlternativeGroups?: Maybe<RearrangalStatus>;
  /** Required permission: RestaurantMenuWrite */
  rearrangeMenuCategories?: Maybe<RearrangalStatus>;
  /** Required permission: RestaurantMenuWrite */
  rearrangeMenuCourses?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantMenuWrite */
  rearrangeMenuPages?: Maybe<RearrangalStatus>;
  /** Required permission: RestaurantMenuWrite */
  rearrangeMenuProducts?: Maybe<RearrangalStatus>;
  /** Required permission: Authenticated */
  refreshAccessToken?: Maybe<AccessToken>;
  /** Required permission: RestaurantReportWrite */
  refreshPosTerminals?: Maybe<Restaurant>;
  /**
   * DEPRECATED: Use "createRefundIntent" instead
   *
   * Required permission: RestaurantWrite
   */
  refundOrder?: Maybe<Order>;
  /** Required permission: RestaurantReportWrite */
  registerCashregister?: Maybe<Restaurant>;
  /** Required permission: RestaurantReportWrite */
  registerControlUnit?: Maybe<Restaurant>;
  /** Required permission: RestaurantMenuWrite */
  relocateMenuCategory?: Maybe<RelocationStatus>;
  /** Required permission: RestaurantMenuWrite */
  relocateMenuProduct?: Maybe<RelocationStatus>;
  /** Required permission: SuperUser */
  removeRestaurantFromMetaOrganization?: Maybe<RemovalStatus>;
  requestAccessToken?: Maybe<VerifyPhoneNumberRequest>;
  /** Required permission: UserWriteInSudoMode */
  requestChangeUserEmail?: Maybe<ChangeUserEmailRequest>;
  requestResetUserPasswordEmail?: Maybe<Scalars['Void']['output']>;
  /** Required permission: OrganizationUserWrite */
  resendOrganizationUserInvite?: Maybe<OrganizationUser>;
  resetUserPassword?: Maybe<AccessToken>;
  /** Required permission: SuperUser */
  restorePhysicalControlUnitOutage?: Maybe<PhysicalControlUnitOutage>;
  /** Required permission: OrganizationAccountingWrite */
  retryFortnoxAccountingImport?: Maybe<FortnoxAccountingImportJob>;
  /** Required permission: RestaurantReportWrite */
  scheduleCashregisterReportGeneration?: Maybe<Restaurant>;
  /** Required permission: LabelWrite */
  sendMarketingPushNotification?: Maybe<MarketingPushNotification>;
  /** Required permission: RestaurantWrite */
  sendMessageToUserRegardingOrder?: Maybe<Message>;
  /**
   * Send a digital receipt to the user that placed an order.
   *
   * If no phone number is supplied, the phone number that was used to pay with Swish will be used.
   *
   * Required permission: RestaurantRead
   */
  sendReceiptLinkViaSms?: Maybe<Scalars['Void']['output']>;
  /** Required permission: RestaurantOpeningHoursWrite */
  setDeliveryTimeSlotDisabled?: Maybe<TogglingStatus>;
  /** Required permission: RestaurantMenuWrite */
  setMenuTypeTemporarilyDisabled?: Maybe<TogglingStatus>;
  /** Required permission: OrganizationAccountingWrite */
  setOrganizationAccountantEmail?: Maybe<Organization>;
  /** Required permission: OrganizationAccountingWrite */
  setOrganizationAccountingPlan?: Maybe<Organization>;
  /** Required permission: RestaurantOpeningHoursWrite */
  setRestaurantOpeningHours?: Maybe<OpeningHours>;
  /** Required permission: OrganizationWrite */
  setStripeAccountId?: Maybe<Organization>;
  /** Required permission: OrganizationAccountingWrite */
  unlinkFortnoxAccountingImportAccount?: Maybe<Organization>;
  /** Required permission: RestaurantReportWrite */
  unlinkSwishNumber?: Maybe<Restaurant>;
  /** Required permission: RestaurantWrite */
  updateDeliveryHeroIntegrationSettings?: Maybe<Restaurant>;
  /** Required permission: RestaurantSettingsWrite */
  updateDeliveryLocation?: Maybe<DeliveryLocation>;
  /** Required permission: SuperUser */
  updateDiscount?: Maybe<Discount>;
  /** Required permission: RestaurantPosWrite */
  updateEmployee?: Maybe<Employee>;
  /** Required permission: RestaurantPosWrite */
  updateEmployeeGroup?: Maybe<EmployeeGroup>;
  /** Required permission: RestaurantMenuWrite */
  updateMenuAddonProduct?: Maybe<MenuAddonProduct>;
  /** Required permission: RestaurantMenuWrite */
  updateMenuAlternativeGroup?: Maybe<MenuAlternativeGroup>;
  /** Required permission: RestaurantMenuWrite or RestaurantMenuStockWrite */
  updateMenuCategory?: Maybe<MenuCategory>;
  /** Required permission: RestaurantMenuWrite */
  updateMenuCourse?: Maybe<MenuCourse>;
  /** Required permission: RestaurantMenuWrite or RestaurantMenuStockWrite */
  updateMenuPage?: Maybe<MenuPage>;
  /** Required permission: RestaurantMenuWrite or RestaurantMenuStockWrite */
  updateMenuProduct?: Maybe<MenuProduct>;
  /** Required permission: RestaurantOpenOrderWrite */
  updateOpenOrder?: Maybe<OpenOrder>;
  /** Required permission: RestaurantOpeningHoursWrite */
  updateOpeningHours?: Maybe<OpeningHours>;
  /** Required permission: OrganizationWrite */
  updateOrganization?: Maybe<Organization>;
  /** Required permission: OrganizationUserWrite */
  updateOrganizationUser?: Maybe<OrganizationUser>;
  /** Required permission: RestaurantReportWrite */
  updatePaymentMethod?: Maybe<PaymentMethod>;
  /** Required permission: RestaurantSettingsWrite */
  updatePhysicalPrinter?: Maybe<PhysicalPrinter>;
  /** Required permission: RestaurantReportWrite */
  updatePosTerminal?: Maybe<PosTerminal>;
  /** Required permission: RestaurantSettingsWrite */
  updatePrinterQueue?: Maybe<PrinterQueue>;
  /** Required permission: RestaurantSettingsWrite */
  updateRestaurant?: Maybe<Restaurant>;
  /** Required permission: RestaurantDiscountWrite */
  updateRestaurantDiscount?: Maybe<Discount>;
  /** Required permission: RestaurantSettingsWrite */
  updateRestaurantTheme?: Maybe<RestaurantTheme>;
  /** Required permission: RestaurantPosWrite */
  updateTill?: Maybe<Till>;
  /** Required permission: SuperUser */
  updateWhiteLabel?: Maybe<WhiteLabel>;
};


export type MutationAcceptDeliveryHeroIntegrationTermsOfServiceArgs = {
  input?: InputMaybe<AcceptDeliveryHeroIntegrationTermsOfServiceInput>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationAcceptFortnoxAccountingImportIntegrationTermsOfServiceArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationAcceptOrderDisplaySystemTermsOfServiceArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationAcceptPersonalkollenIntegrationTermsOfServiceArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationAcceptTermsOfServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateRestaurantArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationAddRestaurantToMetaOrganizationArgs = {
  metaOrganizationId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCancelOpenOrderItemsArgs = {
  input: OpenOrderCancelItemInput;
  openOrderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCancelOrderIntentArgs = {
  input?: InputMaybe<RefundIntentInput>;
  orderIntentId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCancelPaymentIntentArgs = {
  paymentIntentId: Scalars['ID']['input'];
};


export type MutationCancelRefundIntentArgs = {
  refundIntentId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCancelTransactionArgs = {
  posTerminalId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCheckoutOpenOrderItemsArgs = {
  input: CheckoutOpenOrderItemsInput;
  openOrderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationClaimPrinterJobsArgs = {
  printerQueueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCompletePhoneNumberVerificationArgs = {
  requestId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationConfirmChangeUserEmailArgs = {
  code: Scalars['String']['input'];
  requestId: Scalars['ID']['input'];
};


export type MutationConnectDeliveryHeroIntegrationArgs = {
  accessToken: Scalars['String']['input'];
  input: ConnectDeliveryHeroIntegrationInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateAccessTokenArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCreateCardVerificationArgs = {
  input: CardVerificationInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateCashAdjustmentArgs = {
  amount: Scalars['Int53']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateCashregisterReportArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateDeliveryCostAreaArgs = {
  input: DeliveryCostAreaInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateDeliveryLocationArgs = {
  input: DeliveryLocationInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateDeliveryTimeAreaArgs = {
  input: DeliveryTimeAreaInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateDiscountArgs = {
  input: DiscountInput;
  metaOrganizationId: Scalars['ID']['input'];
};


export type MutationCreateEmployeeArgs = {
  input: EmployeeInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateEmployeeGroupArgs = {
  input: EmployeeGroupInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateMenuAddonProductArgs = {
  input: MenuAddonProductInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateMenuAlternativeGroupArgs = {
  input: MenuAlternativeGroupInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateMenuCategoryArgs = {
  input: MenuCategoryInput;
  menuPageId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateMenuCourseArgs = {
  input: MenuCourseInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateMenuPageArgs = {
  input: MenuPageInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateMenuProductArgs = {
  input: MenuProductInput;
  menuCategoryId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateMenuReportGroupArgs = {
  input: MenuReportGroupInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateMetaOrganizationArgs = {
  input: MetaOrganizationInput;
};


export type MutationCreateOpenOrderArgs = {
  input: OpenOrderInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateOpenOrderBatchArgs = {
  input: OpenOrderBatchInput;
  openOrderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateOpeningHoursArgs = {
  input: OpeningHoursInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateOrderIntentArgs = {
  input: OrderIntentInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateOrganizationArgs = {
  input: OrganizationInput;
};


export type MutationCreateOrganizationUserArgs = {
  input: OrganizationUserInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreatePaymentIntentArgs = {
  input: PaymentIntentInput;
  orderIntentId: Scalars['ID']['input'];
};


export type MutationCreatePaymentIntentRetryArgs = {
  input: PaymentIntentRetryInput;
  paymentIntentId: Scalars['ID']['input'];
};


export type MutationCreatePaymentMethodArgs = {
  input: PaymentMethodInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreatePhysicalControlUnitOutageArgs = {
  physicalControlUnitId: Scalars['ID']['input'];
};


export type MutationCreatePhysicalControlUnitOutageReportArgs = {
  physicalControlUnitOutageId: Scalars['ID']['input'];
};


export type MutationCreatePhysicalPrinterArgs = {
  input: PhysicalPrinterInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreatePrinterQueueArgs = {
  input: PrinterQueueInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateRefundIntentArgs = {
  input?: InputMaybe<RefundIntentInput>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateRestaurantArgs = {
  input: RestaurantInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateRestaurantControlUnitOutageReportArgs = {
  restaurantControlUnitOutageId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateRestaurantDeliveryLocationShortUrlsArgs = {
  restaurantId: Scalars['ID']['input'];
  whiteLabelId: Scalars['ID']['input'];
};


export type MutationCreateRestaurantDiscountArgs = {
  input: DiscountInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateShortUrlArgs = {
  input: ShortUrlInput;
  whiteLabelId: Scalars['ID']['input'];
};


export type MutationCreateTillArgs = {
  input: TillInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreateWhiteLabelArgs = {
  input: WhiteLabelInput;
};


export type MutationDeactivateRestaurantArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteDeliveryCostAreaArgs = {
  deliveryCostAreaId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteDeliveryLocationArgs = {
  deliveryLocationId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteDeliveryTimeAreaArgs = {
  deliveryTimeAreaId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteDiscountArgs = {
  discountId: Scalars['ID']['input'];
  metaOrganizationId: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeArgs = {
  employeeId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeGroupArgs = {
  employeeGroupId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteMenuAddonProductArgs = {
  menuAddonProductId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteMenuAlternativeGroupArgs = {
  menuAlternativeGroupId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteMenuCategoryArgs = {
  menuCategoryId: Scalars['ID']['input'];
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteMenuCourseArgs = {
  menuCourseId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteMenuPageArgs = {
  menuPageId: Scalars['ID']['input'];
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteMenuProductArgs = {
  menuProductId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteMenuReportGroupArgs = {
  menuReportGroupId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteOpeningHoursArgs = {
  openingHoursId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationUserArgs = {
  organizationId: Scalars['ID']['input'];
  organizationUserId: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeletePhysicalPrinterArgs = {
  physicalPrinterId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeletePrinterQueueArgs = {
  printerQueueId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteRestaurantArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteRestaurantDiscountArgs = {
  discountId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationDeleteStripeCardArgs = {
  stripeCardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteTillArgs = {
  restaurantId: Scalars['ID']['input'];
  tillId: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteWhiteLabelArgs = {
  whiteLabelId: Scalars['ID']['input'];
};


export type MutationEmptyNetsConnectCloudTerminalPrinterBufferArgs = {
  posTerminalId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationEnableDeliveryHeroIntegrationArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationEnterSudoModeArgs = {
  password: Scalars['String']['input'];
};


export type MutationExpediteOpenOrderArgs = {
  input?: InputMaybe<OpenOrderExpeditionInput>;
  openOrderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationExportYouniumUsageArgs = {
  input: ExportYouniumUsageInput;
};


export type MutationFailPrinterJobArgs = {
  printerJobId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationFinalizeOrderIntentArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  orderIntentId: Scalars['ID']['input'];
};


export type MutationFinalizePaymentIntentArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId: Scalars['ID']['input'];
};


export type MutationFinalizeRefundIntentArgs = {
  refundIntentId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationFinalizeRefundIntent2Args = {
  refundIntentId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationFinishOrderArgs = {
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationFinishPrinterJobArgs = {
  printerJobId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationGenerateRestaurantOrderSalesBreakdownArgs = {
  input: RestaurantOrderSalesBreakdownInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationIdentifyPhysicalPrinterArgs = {
  physicalPrinterId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationIdentifyPhysicalPrintersArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationImportMenuFromCsvArgs = {
  csvData: Scalars['String']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationLinkFortnoxAccountingImportAccountArgs = {
  credentials: FortnoxAccountingImportCredentials;
  organizationId: Scalars['ID']['input'];
};


export type MutationLinkNetsConnectCloudAccountArgs = {
  credentials: NetsConnectCloudCredentials;
  restaurantId: Scalars['ID']['input'];
};


export type MutationLinkPersonalkollenAccountArgs = {
  credentials: PersonalkollenCredentials;
  restaurantId: Scalars['ID']['input'];
};


export type MutationLinkSwishNumberArgs = {
  restaurantId: Scalars['ID']['input'];
  swishNumber: Scalars['String']['input'];
};


export type MutationMarkFortnoxAccountingImportAsManuallyImportedArgs = {
  organizationId: Scalars['ID']['input'];
  sieVerificationId: Scalars['ID']['input'];
};


export type MutationMarkOrderAsCompletedByCustomerArgs = {
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationMarkOrderAsPrintedInKitchenArgs = {
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationMigrateDeviceInstallationArgs = {
  currentInstallationId: Scalars['String']['input'];
  previousInstallationId: Scalars['String']['input'];
  whiteLabelId: Scalars['ID']['input'];
};


export type MutationMoveOpenOrderItemsArgs = {
  input: OpenOrderMoveItemInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationPrintOrderReceiptCopyArgs = {
  orderId: Scalars['ID']['input'];
  printerQueueId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationPrintProFormaArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  openOrderId: Scalars['ID']['input'];
  printerId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
  tillId: Scalars['ID']['input'];
};


export type MutationPublishWhiteLabelArgs = {
  whiteLabelId: Scalars['ID']['input'];
};


export type MutationRearrangeMenuAddonProductsArgs = {
  order: Array<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationRearrangeMenuAlternativeGroupsArgs = {
  order: Array<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationRearrangeMenuCategoriesArgs = {
  menuPageId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationRearrangeMenuCoursesArgs = {
  order: Array<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationRearrangeMenuPagesArgs = {
  order: Array<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationRearrangeMenuProductsArgs = {
  menuCategoryId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationRefreshPosTerminalsArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationRefundOrderArgs = {
  hasCompletedManualAction?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationRegisterCashregisterArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationRegisterControlUnitArgs = {
  restaurantId: Scalars['ID']['input'];
  taxIdNumber: Scalars['String']['input'];
};


export type MutationRelocateMenuCategoryArgs = {
  fromMenuPageId: Scalars['ID']['input'];
  menuCategoryId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
  toMenuPageId: Scalars['ID']['input'];
};


export type MutationRelocateMenuProductArgs = {
  fromMenuCategoryId: Scalars['ID']['input'];
  menuProductId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
  toMenuCategoryId: Scalars['ID']['input'];
};


export type MutationRemoveRestaurantFromMetaOrganizationArgs = {
  metaOrganizationId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationRequestAccessTokenArgs = {
  metadata?: InputMaybe<VerifyPhoneNumberMetadata>;
  phoneNumber: Scalars['E164']['input'];
};


export type MutationRequestChangeUserEmailArgs = {
  email: Scalars['EmailAddress']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRequestResetUserPasswordEmailArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type MutationResendOrganizationUserInviteArgs = {
  organizationId: Scalars['ID']['input'];
  organizationUserId: Scalars['ID']['input'];
};


export type MutationResetUserPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRestorePhysicalControlUnitOutageArgs = {
  controlUnitOutageId: Scalars['ID']['input'];
};


export type MutationRetryFortnoxAccountingImportArgs = {
  organizationId: Scalars['ID']['input'];
  sieVerificationId: Scalars['ID']['input'];
};


export type MutationScheduleCashregisterReportGenerationArgs = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationSendMarketingPushNotificationArgs = {
  message: Scalars['String']['input'];
  whiteLabelId: Scalars['ID']['input'];
};


export type MutationSendMessageToUserRegardingOrderArgs = {
  message: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationSendReceiptLinkViaSmsArgs = {
  isRefund?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['E164']['input']>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationSetDeliveryTimeSlotDisabledArgs = {
  deliveryTimeSlotId: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
  periodicityInput?: InputMaybe<PeriodicityInput>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationSetMenuTypeTemporarilyDisabledArgs = {
  disabled: Scalars['Boolean']['input'];
  menuType: MenuType;
  restaurantId: Scalars['ID']['input'];
};


export type MutationSetOrganizationAccountantEmailArgs = {
  email: Scalars['EmailAddress']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationSetOrganizationAccountingPlanArgs = {
  accounts: Array<SieAccountInput>;
  organizationId: Scalars['ID']['input'];
};


export type MutationSetRestaurantOpeningHoursArgs = {
  periods: Array<OpeningHoursPeriodInput>;
  restaurantId: Scalars['ID']['input'];
};


export type MutationSetStripeAccountIdArgs = {
  authorizationCode: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationUnlinkFortnoxAccountingImportAccountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationUnlinkSwishNumberArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateDeliveryHeroIntegrationSettingsArgs = {
  input: UpdateDeliveryHeroIntegrationSettingsInput;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateDeliveryLocationArgs = {
  deliveryLocationId: Scalars['ID']['input'];
  patch: DeliveryLocationPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateDiscountArgs = {
  discountId: Scalars['ID']['input'];
  metaOrganizationId: Scalars['ID']['input'];
  patch: DiscountPatch;
};


export type MutationUpdateEmployeeArgs = {
  employeeId: Scalars['ID']['input'];
  patch: EmployeePatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateEmployeeGroupArgs = {
  employeeGroupId: Scalars['ID']['input'];
  patch: EmployeeGroupPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateMenuAddonProductArgs = {
  menuAddonProductId: Scalars['ID']['input'];
  patch: MenuAddonProductPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateMenuAlternativeGroupArgs = {
  menuAlternativeGroupId: Scalars['ID']['input'];
  patch: MenuAlternativeGroupPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateMenuCategoryArgs = {
  menuCategoryId: Scalars['ID']['input'];
  patch: MenuCategoryPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateMenuCourseArgs = {
  menuCourseId: Scalars['ID']['input'];
  patch: MenuCoursePatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateMenuPageArgs = {
  menuPageId: Scalars['ID']['input'];
  patch: MenuPagePatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateMenuProductArgs = {
  menuProductId: Scalars['ID']['input'];
  patch: MenuProductPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateOpenOrderArgs = {
  openOrderId: Scalars['ID']['input'];
  patch: OpenOrderPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateOpeningHoursArgs = {
  openingHoursId: Scalars['ID']['input'];
  patch: OpeningHoursPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  patch: OrganizationPatch;
};


export type MutationUpdateOrganizationUserArgs = {
  organizationId: Scalars['ID']['input'];
  organizationUserId: Scalars['ID']['input'];
  patch: OrganizationUserPatch;
};


export type MutationUpdatePaymentMethodArgs = {
  patch: PaymentMethodPatch;
  paymentMethodId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdatePhysicalPrinterArgs = {
  patch: PhysicalPrinterPatch;
  physicalPrinterId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdatePosTerminalArgs = {
  patch: PosTerminalPatch;
  posTerminalId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdatePrinterQueueArgs = {
  patch: PrinterQueuePatch;
  printerQueueId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateRestaurantArgs = {
  patch: RestaurantPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateRestaurantDiscountArgs = {
  discountId: Scalars['ID']['input'];
  patch: DiscountPatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateRestaurantThemeArgs = {
  patch: RestaurantThemePatch;
  restaurantId: Scalars['ID']['input'];
};


export type MutationUpdateTillArgs = {
  patch: TillPatch;
  restaurantId: Scalars['ID']['input'];
  tillId: Scalars['ID']['input'];
};


export type MutationUpdateWhiteLabelArgs = {
  patch: WhiteLabelPatch;
  whiteLabelId: Scalars['ID']['input'];
};

export type NetsConnectCloudCredentials = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Represents a range of time spanning from 'start' (including) to 'end' (excluding), optional for use in e.g. filters */
export type OpenDateTimeRangeInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Represents a range of an Int53 spanning from 'start' (including) to 'end' (including), optional for use in e.g. filters */
export type OpenInt53RangeInput = {
  end?: InputMaybe<Scalars['Int53']['input']>;
  start?: InputMaybe<Scalars['Int53']['input']>;
};

export type OpenOrder = {
  __typename?: 'OpenOrder';
  amountCanceled?: Maybe<Scalars['Int53']['output']>;
  amountMoved?: Maybe<Scalars['Int53']['output']>;
  amountPaid?: Maybe<Scalars['Int53']['output']>;
  amountPayable?: Maybe<Scalars['Int53']['output']>;
  batches?: Maybe<Array<OpenOrderBatch>>;
  batchesLength?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryLocation?: Maybe<DeliveryLocation>;
  id: Scalars['ID']['output'];
  itemsPayable?: Maybe<Array<OpenOrderMergedItem>>;
  lastBatch?: Maybe<OpenOrderBatch>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The state which this Open Order is currently in.
   *
   * - 'Canceled' - The open order has been canceled and cannot be used anymore.
   * - 'Done' - This open order has successfully resulted in an OrderIntent.
   * - 'Pending' - The order is still open and batches can be added.
   */
  state: OpenOrderState;
  type?: Maybe<MenuType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OpenOrderBatch = {
  __typename?: 'OpenOrderBatch';
  allItems?: Maybe<Array<OpenOrderBatchItem>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryLocation?: Maybe<DeliveryLocation>;
  deliveryTime?: Maybe<Scalars['DateTime']['output']>;
  employee?: Maybe<Employee>;
  fromOpenOrder?: Maybe<OpenOrder>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use allItems instead which contains an updated type */
  items?: Maybe<Array<OrderItem>>;
  message?: Maybe<Scalars['String']['output']>;
  /**
   * The state which this Open Order is currently in.
   *
   * - 'Canceled' - The batch has been canceled and shouldn't be delivered to the customer.
   * - 'Done' - The batch have been successfully delivered.
   * - 'Pending' - The batch is pending delivery to customer.
   */
  state: OpenOrderBatchState;
  till?: Maybe<Till>;
  type?: Maybe<MenuType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OpenOrderBatchInput = {
  appLabel: Scalars['String']['input'];
  /** When placing an EatIn or TakeAway order, this is the id of the location to deliver the items to. */
  deliveryLocationId?: InputMaybe<Scalars['ID']['input']>;
  deliveryTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The location of the device that opened the order. */
  deviceLocation?: InputMaybe<CoordinatesInput>;
  /** The Employee that placed the order, when placing an order from a Till while being logged in as an Employee */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided, the mutation will abort if the computed total amount doesn't match the value given here.
   *
   * This value should reflect the exact amount that the customer will be asked to pay in the payment step. It might however be lower than the final amount, if the customer adds tip in the payment step.
   *
   * Note that this amount should thus include everything that the customer should pay for, that is:
   * - Each item, including VAT
   * - Each addon item, including VAT
   * - Delivery cost, including VAT
   * - Discount
   * - Tip
   */
  expectedTotalAmount?: InputMaybe<Scalars['Int']['input']>;
  /** An idempotency key is a unique value generated by the client which the server uses to recognize subsequent retries of the same request. How you create unique keys is up to you, but we suggest using V4 UUIDs, or another random string with enough entropy to avoid collisions. */
  idempotencyKey: Scalars['String']['input'];
  /** An identifier that is unique to this particular device and installation of client. */
  installationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<OrderItemInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** If this is provided as true the order will go directly to the "Delivered" state after being paid, and will thus not show up in Loco PoS Kitchen */
  productsHandedToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  pushToken?: InputMaybe<PushTokenInput>;
  /** The Till this order was placed from */
  tillId: Scalars['ID']['input'];
  type: MenuType;
};

export type OpenOrderBatchItem = {
  __typename?: 'OpenOrderBatchItem';
  alternatives?: Maybe<Array<OrderAlternative>>;
  count?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<MenuCourse>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  product?: Maybe<OrderProduct>;
  status?: Maybe<OpenOrderBatchItemStatus>;
};

export type OpenOrderBatchItemStatus = {
  __typename?: 'OpenOrderBatchItemStatus';
  action?: Maybe<Scalars['String']['output']>;
  canceledReason?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  openOrder?: Maybe<OpenOrder>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export enum OpenOrderBatchState {
  Canceled = 'Canceled',
  Done = 'Done',
  Pending = 'Pending',
  Revoked = 'Revoked'
}

export type OpenOrderCancelItemInput = {
  canceledReason: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey: Scalars['String']['input'];
  items: Array<OpenOrderItemInput>;
  tillId: Scalars['ID']['input'];
};

export type OpenOrderEdge = {
  __typename?: 'OpenOrderEdge';
  cursor: Scalars['String']['output'];
  node: OpenOrder;
};

export type OpenOrderExpeditionInput = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type OpenOrderInput = {
  /** When placing an EatIn or TakeAway order, this is the id of the location to deliver the items to. */
  deliveryLocationId?: InputMaybe<Scalars['ID']['input']>;
  firstBatch?: InputMaybe<OpenOrderBatchInput>;
  /** An idempotency key is a unique value generated by the client which the server uses to recognize subsequent retries of the same request. How you create unique keys is up to you, but we suggest using V4 UUIDs, or another random string with enough entropy to avoid collisions." */
  idempotencyKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: MenuType;
};

export type OpenOrderItemInput = {
  count: Scalars['Int']['input'];
  itemId: Scalars['ID']['input'];
};

export type OpenOrderItemsMoved = {
  __typename?: 'OpenOrderItemsMoved';
  from?: Maybe<OpenOrder>;
  to?: Maybe<OpenOrder>;
};

export type OpenOrderMergedItem = {
  __typename?: 'OpenOrderMergedItem';
  alternatives?: Maybe<Array<OrderAlternative>>;
  count?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<MenuCourse>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<OpenOrderBatchItem>>;
  message?: Maybe<Scalars['String']['output']>;
  product?: Maybe<OrderProduct>;
};

export type OpenOrderMoveItemInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  fromOpenOrderId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  items: Array<OpenOrderItemInput>;
  tillId: Scalars['ID']['input'];
  toOpenOrderId: Scalars['ID']['input'];
};

export type OpenOrderPage = {
  __typename?: 'OpenOrderPage';
  edges: Array<OpenOrderEdge>;
  pageInfo: PageInfo;
};

export type OpenOrderPatch = {
  deliveryLocationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum OpenOrderState {
  Canceled = 'Canceled',
  Done = 'Done',
  Pending = 'Pending'
}

export type OpeningHours = {
  __typename?: 'OpeningHours';
  displayHours?: Maybe<OpeningHours>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  periods?: Maybe<Array<OpeningHoursPeriod>>;
  productVisibility?: Maybe<ProductVisibility>;
};

export type OpeningHoursInput = {
  displayHoursId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  periods: Array<OpeningHoursPeriodInput>;
  productVisibility?: InputMaybe<ProductVisibility>;
};

export type OpeningHoursPatch = {
  displayHoursId?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<Array<OpeningHoursPeriodInput>>;
  productVisibility?: InputMaybe<ProductVisibility>;
};

export type OpeningHoursPeriod = {
  __typename?: 'OpeningHoursPeriod';
  close?: Maybe<WeekDayTime>;
  open: WeekDayTime;
};

export type OpeningHoursPeriodInput = {
  close?: InputMaybe<WeekDayTimeInput>;
  open: WeekDayTimeInput;
};

export type Order = {
  __typename?: 'Order';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryHeroLongCode?: Maybe<Scalars['String']['output']>;
  deliveryTime?: Maybe<Scalars['DateTime']['output']>;
  discountAmount?: Maybe<Scalars['Int53']['output']>;
  employeeName?: Maybe<Scalars['String']['output']>;
  /** If the customer asked to get the order ASAP, this is the estimated time when we will deliver it */
  estimatedDeliveryTime?: Maybe<Scalars['DateTime']['output']>;
  /** The total amount, including tip & taxes */
  grossAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<OrderItem>>;
  /** True if this order needs to be printed by Loco POS Kitchen */
  needsKitchenPrint?: Maybe<Scalars['Boolean']['output']>;
  orderIntent?: Maybe<OrderIntent>;
  /** Required permission: Authenticated */
  paymentIntents?: Maybe<Array<PaymentIntent>>;
  paymentProvider?: Maybe<PaymentProvider>;
  pickedUpAt?: Maybe<Scalars['DateTime']['output']>;
  posTerminal?: Maybe<PosTerminal>;
  readyForPickupAt?: Maybe<Scalars['DateTime']['output']>;
  receipt?: Maybe<Receipt>;
  /** Required permission: RestaurantRead */
  receiptPrinter?: Maybe<PrinterQueue>;
  receiptViewKey?: Maybe<Scalars['String']['output']>;
  refundReceipts?: Maybe<Array<Maybe<Receipt>>>;
  refundedAmount?: Maybe<Scalars['Int53']['output']>;
  restaurant?: Maybe<Restaurant>;
  servingLocation?: Maybe<ServingLocation>;
  /** Required permission: RestaurantWrite */
  slips?: Maybe<Array<OrderSlip>>;
  status?: Maybe<OrderStatus>;
  statusForCustomer?: Maybe<OrderStatusForCustomer>;
  statusForCustomerSteps?: Maybe<Array<OrderStatusForCustomerStep>>;
  tipAmount?: Maybe<Scalars['Int53']['output']>;
  transactionChannel?: Maybe<TransactionChannel>;
  type?: Maybe<MenuType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userMessage?: Maybe<Scalars['String']['output']>;
  userPhoneNumber?: Maybe<Scalars['E164']['output']>;
};

export type OrderAlternative = {
  __typename?: 'OrderAlternative';
  addonProduct?: Maybe<OrderProduct>;
  alternativeGroup?: Maybe<OrderAlternativeGroup>;
  /** This field will only be present if the alternative is a countable alternative. Otherwise it will be null. */
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** For countable alternatives, this will be true if the count is greater than zero. */
  isChosen?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The total amount paid for this alternative. Equal to addonProduct.price * count. */
  totalAmount?: Maybe<Scalars['Int53']['output']>;
};

export type OrderAlternativeGroup = {
  __typename?: 'OrderAlternativeGroup';
  id: Scalars['ID']['output'];
  isCountable?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderAlternativeInput = {
  addonProduct?: InputMaybe<ProductLinkInput>;
  alternativeGroupId: Scalars['ID']['input'];
  alternativeItemName: Scalars['String']['input'];
  count: Scalars['Int']['input'];
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String']['output'];
  node: Order;
};

export type OrderFilter = {
  createdAt?: InputMaybe<OpenDateTimeRangeInput>;
  humanOrderNumber?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** This looks at all phone numbers connected to the order, e.g. Swish payer, receipt receiver, or the user that placed the order */
  phoneNumber?: InputMaybe<Scalars['E164']['input']>;
  totalAmount?: InputMaybe<OpenInt53RangeInput>;
  transactionChannels?: InputMaybe<Array<TransactionChannel>>;
};

export type OrderIntent = {
  __typename?: 'OrderIntent';
  /** For state "RequiresAction" this is the action that the user needs to perform. */
  action?: Maybe<OrderIntentAction>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryLocation?: Maybe<DeliveryLocation>;
  discountAmount?: Maybe<Scalars['Int53']['output']>;
  /** An access token that can be used to finalize the order intent without requiring an authenticated user. */
  finalizeAccessToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<OrderItem>>;
  /** Any metadata that was passed in by the client will be returned as is here. */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** If this order intent was created from an open order, this field will contain the open order. */
  openOrder?: Maybe<OpenOrder>;
  /** For state "Done" this is the Order that was created from this Order Intent. */
  order?: Maybe<Order>;
  /** If payment intents have been made for specific items in this order intent, this field will contain the items that have been paid for. */
  paidItems?: Maybe<Array<OrderIntentPaidItem>>;
  paymentIntents?: Maybe<Array<PaymentIntent>>;
  receiptPrinter?: Maybe<PrinterQueue>;
  /** For state "RefundPending" this is the RefundIntent that is currently pending. */
  refundIntent?: Maybe<RefundIntent>;
  /**
   * The state which this Order Intent is currently in.
   *
   * - 'Ready' - This order intent is ready to be finalized.
   * - 'RequiresAction' - An action is required to be performed by the user before this order intent can progress, see the 'action' field for more info.
   * - 'Done' - This order intent has successfully resulted in an Order.
   * - 'Failed' - The order intent has failed and will never result in an Order.
   */
  state: OrderIntentState;
  tipAmountPaid?: Maybe<Scalars['Int53']['output']>;
  tipAmountPayable?: Maybe<Scalars['Int53']['output']>;
  totalAmountPaid?: Maybe<Scalars['Int53']['output']>;
  totalAmountPayable?: Maybe<Scalars['Int53']['output']>;
  type?: Maybe<MenuType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatAmountPaid?: Maybe<Scalars['Int53']['output']>;
  vatAmountPayable?: Maybe<Scalars['Int53']['output']>;
};

export type OrderIntentAction = {
  __typename?: 'OrderIntentAction';
  /** For type "OpenSwish" this is the value of the QR code to display to the end user. */
  qrCodeValue?: Maybe<Scalars['String']['output']>;
  /**
   * For type "OpenSwish" and "UseIntegratedTerminal" this is an url which will give the current status of the payment request.
   *
   * When receiving a HTTP GET request, the response will contain a JSON document with a single field "status", which can have one of the following values:
   *
   * - 'CANCELED'
   * - 'CREATED'
   * - 'DECLINED'
   * - 'ERROR'
   * - 'PAID'
   */
  statusUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrderIntentActionType>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum OrderIntentActionType {
  /** Accept cash from the customer */
  AcceptCash = 'AcceptCash',
  /** Call createPaymentIntent */
  CreatePayments = 'CreatePayments',
  /** External action outside of the app */
  ExternalAction = 'ExternalAction',
  /** Open the browser at the given url */
  OpenBrowser = 'OpenBrowser',
  /** Open the Swish app, with the given url */
  OpenSwish = 'OpenSwish',
  /** Use an external terminal to accept payment */
  UseExternalTerminal = 'UseExternalTerminal',
  /** Use an integrated terminal to accept payment */
  UseIntegratedTerminal = 'UseIntegratedTerminal'
}

export type OrderIntentInput = {
  appLabel: Scalars['String']['input'];
  /** When placing a Delivery order, this is the address where to deliver the items to. */
  deliveryAddress?: InputMaybe<DeliveryAddressInput>;
  /** When placing a Delivery order, this is the geo-position of the location to deliver the items to. */
  deliveryLocation?: InputMaybe<CoordinatesInput>;
  /** When placing an EatIn or TakeAway order, this is the id of the location to deliver the items to. */
  deliveryLocationId?: InputMaybe<Scalars['String']['input']>;
  deliveryTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The location of the device that placed the order. */
  deviceLocation?: InputMaybe<CoordinatesInput>;
  /**
   * A specific amount to discount from the total amount payable. Can only be used by employees.
   *
   * Required permission: RestaurantDiscountedCheckout
   */
  discountAmount?: InputMaybe<Scalars['Int53']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * The Employee that placed the order, when placing an order from a Till while being logged in as an Employee
   *
   * Required permission: RestaurantPosWrite
   */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided, the mutation will abort if the computed total amount doesn't match the value given here.
   *
   * This value should reflect the exact amount that the customer will be asked to pay in the payment step. It might however be lower than the final amount, if the customer adds tip in the payment step.
   *
   * Note that this amount should thus include everything that the customer should pay for, that is:
   * - Each item, including VAT
   * - Each addon item, including VAT
   * - Delivery cost, including VAT
   * - Discount
   * - Tip
   */
  expectedTotalAmount?: InputMaybe<Scalars['Int']['input']>;
  /** An idempotency key is a unique value generated by the client which the server uses to recognize subsequent retries of the same request. How you create unique keys is up to you, but we suggest using V4 UUIDs, or another random string with enough entropy to avoid collisions. */
  idempotencyKey: Scalars['String']['input'];
  /** An identifier that is unique to this particular device and installation of client. */
  installationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<OrderItemInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** Any data passed in here will be returned as is when querying for it later. The server never acts upon the data in here. */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /**
   * The terminal that the card payment should be made on. This is only applicable if using a payment provider that uses physical card terminals.
   *
   * Required permission: RestaurantRead
   */
  posTerminalId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If this is provided as true the order will go directly to the "Delivered" state after being paid, and will thus not show up in Loco PoS Kitchen
   *
   * Required permission: RestaurantRead
   */
  productsHandedToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  pushToken?: InputMaybe<PushTokenInput>;
  /**
   * If provided, instead of sending a digital receipt, the original receipt will be printed on the specified printer and the digital receipt will be a copy of the receipt.
   *
   * Required permission: RestaurantRead
   */
  receiptPrinterId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The Till this order was placed from
   *
   * Required permission: RestaurantRead
   */
  tillId?: InputMaybe<Scalars['ID']['input']>;
  tip?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Used to indicate the origin of the order.
   *
   * This till become mandatory in the future, so make sure to always send it. If there isn't a value that fits your use case, please contact us.
   *
   * Valid values:
   * - TransactionChannel.Loco
   * - TransactionChannel.Order (required permission: RestaurantRead)
   * - TransactionChannel.SelfCheckout (required permission: RestaurantRead)
   * - TransactionChannel.Web
   * - TransactionChannel.WhiteLabel
   */
  transactionChannel?: InputMaybe<TransactionChannel>;
  type: MenuType;
};

export type OrderIntentPaidItem = {
  __typename?: 'OrderIntentPaidItem';
  count?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<OrderItem>;
};

export enum OrderIntentState {
  Done = 'Done',
  Failed = 'Failed',
  Finalizing = 'Finalizing',
  Ready = 'Ready',
  RefundFailed = 'RefundFailed',
  RefundPending = 'RefundPending',
  Refunded = 'Refunded',
  RequiresAction = 'RequiresAction'
}

export type OrderItem = {
  __typename?: 'OrderItem';
  alternatives?: Maybe<Array<OrderAlternative>>;
  count?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<MenuCourse>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  product?: Maybe<OrderProduct>;
  /** Total amount for all of this item, including any addon items. */
  totalAmount?: Maybe<Scalars['Int53']['output']>;
};

export type OrderItemInput = {
  alternatives?: InputMaybe<Array<OrderAlternativeInput>>;
  count: Scalars['Int']['input'];
  courseId?: InputMaybe<Scalars['ID']['input']>;
  holdKitchenPrint?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  product: ProductLinkInput;
};

export type OrderPage = {
  __typename?: 'OrderPage';
  edges: Array<OrderEdge>;
  pageInfo: PageInfo;
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<OrderProductProperties>;
};

export type OrderProductProperties = {
  __typename?: 'OrderProductProperties';
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  printAt?: Maybe<Array<Printer>>;
  reportGroup?: Maybe<MenuReportGroup>;
  secondaryPrinters?: Maybe<Array<Printer>>;
  stateId: Scalars['ID']['output'];
};

export type OrderSlip = {
  __typename?: 'OrderSlip';
  html?: Maybe<Scalars['String']['output']>;
  needsPrinting?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use 'printerQueue' instead */
  printer?: Maybe<Printer>;
  printerQueue?: Maybe<PrinterQueue>;
};

export enum OrderSlipLayout {
  Default = 'Default',
  Premium = 'Premium'
}

export enum OrderStatus {
  Delivered = 'Delivered',
  Failed = 'Failed',
  FailedAndRefunded = 'FailedAndRefunded',
  Paid = 'Paid',
  Pending = 'Pending',
  RefundFailed = 'RefundFailed',
  RefundPending = 'RefundPending',
  Refunded = 'Refunded'
}

/** Reference: https://docs.google.com/drawings/d/1wizYlPpTRpLbwkZboVIKQoMK7VbqqCP3TF5DbdNNic0 */
export enum OrderStatusForCustomer {
  /** The order is completed and the customer has received the products */
  Completed = 'Completed',
  /** The order is currently being delivered to the customer */
  Delivering = 'Delivering',
  /** The order has been paid for and sent to the restaurant */
  Paid = 'Paid',
  /** The kitchen is currently preparing the order */
  Preparing = 'Preparing',
  /** The customer should pick up the order from the selected serving location */
  ReadyForPickup = 'ReadyForPickup'
}

export type OrderStatusForCustomerStep = {
  __typename?: 'OrderStatusForCustomerStep';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  step?: Maybe<OrderStatusForCustomer>;
};

export type Organization = {
  __typename?: 'Organization';
  /** Required permission: OrganizationAccountingWrite */
  accountantEmail?: Maybe<Scalars['EmailAddress']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /** Required permission: SuperUser */
  fortnoxAccountingImportAccessToken?: Maybe<Scalars['String']['output']>;
  /** Required permission: OrganizationAccountingWrite */
  fortnoxAccountingImportAuthorizationUrl?: Maybe<Scalars['URL']['output']>;
  /** Required permission: OrganizationAccountingWrite */
  fortnoxAccountingImportEnabled?: Maybe<Scalars['Boolean']['output']>;
  fortnoxAccountingImportFailedVerifications?: Maybe<Array<SieVerification>>;
  /** Required permission: Authenticated */
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: OrganizationAccountingWrite */
  hasFortnoxAccountingImportAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: OrganizationAccountingWrite */
  hasFortnoxAccountingImportCredentials?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  /** Required permission: OrganizationRead */
  restaurants?: Maybe<Array<Restaurant>>;
  setupProgress?: Maybe<OrganizationSetupProgress>;
  /** Required permission: OrganizationAccountingWrite */
  sieAccounts?: Maybe<Array<SieAccount>>;
  /** Required permission: OrganizationAccountingWrite */
  sieReport?: Maybe<SieReport>;
  /** Required permission: OrganizationWrite */
  stripeConnectionUrl?: Maybe<Scalars['URL']['output']>;
  /** Required permission: OrganizationAccountingWrite */
  stripeReport?: Maybe<StripeReport>;
  /** Required permission: OrganizationAccountingWrite */
  stripeReports?: Maybe<StripeReportPage>;
  /** Required permission: OrganizationUserWrite */
  user?: Maybe<OrganizationUser>;
  /** Required permission: OrganizationUserWrite */
  users?: Maybe<Array<OrganizationUser>>;
};


export type OrganizationFortnoxAccountingImportAuthorizationUrlArgs = {
  redirectUrl: Scalars['URL']['input'];
};


export type OrganizationHasAccessArgs = {
  access: OrganizationAccess;
};


export type OrganizationSieReportArgs = {
  datePeriod: DateTimeRangeInput;
  filter?: InputMaybe<SieReportFilter>;
};


export type OrganizationStripeConnectionUrlArgs = {
  redirectUrl?: InputMaybe<Scalars['URL']['input']>;
};


export type OrganizationStripeReportArgs = {
  id: Scalars['ID']['input'];
};


export type OrganizationStripeReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationUserArgs = {
  id: Scalars['ID']['input'];
};

export enum OrganizationAccess {
  AccountingWrite = 'AccountingWrite',
  Read = 'Read',
  UserWrite = 'UserWrite',
  Write = 'Write'
}

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationFilter = {
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationInput = {
  email: Scalars['EmailAddress']['input'];
  name: Scalars['String']['input'];
  organizationNumber: Scalars['String']['input'];
};

export type OrganizationPage = {
  __typename?: 'OrganizationPage';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
};

export type OrganizationPatch = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSetupProgress = {
  __typename?: 'OrganizationSetupProgress';
  hasCompletedStripeSetup?: Maybe<Scalars['Boolean']['output']>;
  hasStripeAccount?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  hasCreateCashAdjustmentAccess?: Maybe<Scalars['Boolean']['output']>;
  hasDiscountAccess?: Maybe<Scalars['Boolean']['output']>;
  hasDiscountedCheckoutAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditMenuAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditMenuStockAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditOpeningHoursAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditOrganizationUserAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditReportsAccess?: Maybe<Scalars['Boolean']['output']>;
  hasExternalPaymentAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOpenOrderAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOpenPriceAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOrderHistoryAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOrderRefundAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOrganizationAccountingAccess?: Maybe<Scalars['Boolean']['output']>;
  hasPosAccess?: Maybe<Scalars['Boolean']['output']>;
  hasReadReportsAccess?: Maybe<Scalars['Boolean']['output']>;
  hasSettingsAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restaurantPermissions?: Maybe<Array<OrganizationUserRestaurantPermissions>>;
  user?: Maybe<User>;
  userSignupCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationUserInput = {
  email: Scalars['EmailAddress']['input'];
  hasCreateCashAdjustmentAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscountAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscountedCheckoutAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditMenuAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditMenuStockAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditOpeningHoursAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditOrganizationUserAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditReportsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasExternalPaymentAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenOrderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenPriceAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderHistoryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderRefundAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationAccountingAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasPosAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasReadReportsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSettingsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  restaurantPermissions?: InputMaybe<Array<OrganizationUserRestaurantPermissionsInput>>;
};

export type OrganizationUserPatch = {
  hasCreateCashAdjustmentAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscountAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscountedCheckoutAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditMenuAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditMenuStockAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditOpeningHoursAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditOrganizationUserAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditReportsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasExternalPaymentAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenOrderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenPriceAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderHistoryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderRefundAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationAccountingAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasPosAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasReadReportsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSettingsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  restaurantPermissions?: InputMaybe<Array<OrganizationUserRestaurantPermissionsInput>>;
};

export type OrganizationUserRestaurantPermissions = {
  __typename?: 'OrganizationUserRestaurantPermissions';
  hasCreateCashAdjustmentAccess?: Maybe<Scalars['Boolean']['output']>;
  hasDiscountAccess?: Maybe<Scalars['Boolean']['output']>;
  hasDiscountedCheckoutAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditMenuAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditMenuStockAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditOpeningHoursAccess?: Maybe<Scalars['Boolean']['output']>;
  hasEditReportsAccess?: Maybe<Scalars['Boolean']['output']>;
  hasExternalPaymentAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOpenOrderAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOpenPriceAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOrderHistoryAccess?: Maybe<Scalars['Boolean']['output']>;
  hasOrderRefundAccess?: Maybe<Scalars['Boolean']['output']>;
  hasPosAccess?: Maybe<Scalars['Boolean']['output']>;
  hasReadReportsAccess?: Maybe<Scalars['Boolean']['output']>;
  hasSettingsAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  restaurant?: Maybe<Restaurant>;
};

export type OrganizationUserRestaurantPermissionsInput = {
  hasCreateCashAdjustmentAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscountAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscountedCheckoutAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditMenuAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditMenuStockAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditOpeningHoursAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEditReportsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasExternalPaymentAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenOrderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenPriceAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderHistoryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderRefundAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasPosAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasReadReportsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSettingsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantId: Scalars['ID']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaletteColor = {
  __typename?: 'PaletteColor';
  dark: Scalars['OpaqueColor']['output'];
  light: Scalars['OpaqueColor']['output'];
  main: Scalars['OpaqueColor']['output'];
  text: TextColor;
};

export type PaletteColorInput = {
  main: Scalars['OpaqueColor']['input'];
};

export type PasswordResetRequest = {
  __typename?: 'PasswordResetRequest';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  /** For state "RequiresAction" this is the action that the user needs to perform. */
  action?: Maybe<PaymentIntentAction>;
  employee?: Maybe<Employee>;
  /** An access token that can be used to finalize the payment intent without requiring an authenticated user. */
  finalizeAccessToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Any metadata that was passed in by the client will be returned as is here. */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  orderIntent?: Maybe<OrderIntent>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentProvider?: Maybe<PaymentProvider>;
  posTerminal?: Maybe<PosTerminal>;
  /**
   * The state which this Payment Intent is currently in.
   *
   * - 'Ready' - This payment intent is ready to be finalized.
   * - 'RequiresAction' - An action is required to be performed by the user before this payment intent can progress, see the 'action' field for more info.
   * - 'Done' - This payment intent has successfully been paid.
   * - 'Failed' - The payment intent has failed and will never be paid.
   */
  state: PaymentIntentState;
  tipAmount?: Maybe<Scalars['Int53']['output']>;
  totalAmount: Scalars['Int53']['output'];
  vatAmount?: Maybe<Scalars['Int53']['output']>;
};

export type PaymentIntentAction = {
  __typename?: 'PaymentIntentAction';
  /** If this field is set, the PaymentIntent could transition into the failed state if the user does not perform the action within the given time. */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** For type "OpenSwish" this is the value of the QR code to display to the end user. */
  qrCodeValue?: Maybe<Scalars['String']['output']>;
  /**
   * For type "OpenSwish" and "UseIntegratedTerminal" this is an url which will give the current status of the payment request.
   *
   * When receiving a HTTP GET request, the response will contain a JSON document with a single field "status", which can have one of the following values:
   *
   * - 'CANCELED'
   * - 'CREATED'
   * - 'DECLINED'
   * - 'ERROR'
   * - 'PAID'
   */
  statusUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PaymentIntentActionType>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum PaymentIntentActionType {
  /** Accept cash from the customer */
  AcceptCash = 'AcceptCash',
  /** External action outside of the app */
  ExternalAction = 'ExternalAction',
  /** Open the browser at the given url */
  OpenBrowser = 'OpenBrowser',
  /** Open the Swish app, with the given url */
  OpenSwish = 'OpenSwish',
  /** Use an external terminal to accept payment */
  UseExternalTerminal = 'UseExternalTerminal',
  /** Use an integrated terminal to accept payment */
  UseIntegratedTerminal = 'UseIntegratedTerminal'
}

export type PaymentIntentInput = {
  /** If you want to have the PaymentIntent id in the callback url, you can use "{PAYMENT_INTENT_ID}" which will be replaced with the actual id. */
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  /** The location of the device that placed the order. */
  deviceLocation?: InputMaybe<CoordinatesInput>;
  /**
   * The Employee that placed the order, when placing an order from a Till while being logged in as an Employee
   *
   * Required permission: RestaurantWrite
   */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /** An idempotency key is a unique value generated by the client which the server uses to recognize subsequent retries of the same request. How you create unique keys is up to you, but we suggest using V4 UUIDs, or another random string with enough entropy to avoid collisions. */
  idempotencyKey: Scalars['String']['input'];
  /** If this payment is for some specific items, you can pass them here. */
  items?: InputMaybe<Array<PaymentIntentItemInput>>;
  /** Any data passed in here will be returned as is when querying for it later. The server never acts upon the data in here. */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** MANDATORY: This field will be mandatory in the future, so make sure that you always pass it in. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** DEPRECATED: Use the 'paymentMethodId' field instead. */
  paymentProvider?: InputMaybe<PaymentProvider>;
  /**
   * The terminal that the card payment should be made on. This is only applicable if using a payment provider that uses physical card terminals.
   *
   * Required permission: RestaurantWrite
   */
  posTerminalId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The Till this order was placed from
   *
   * Required permission: RestaurantWrite
   */
  tillId?: InputMaybe<Scalars['ID']['input']>;
  tipAmount: Scalars['Int53']['input'];
  totalAmount: Scalars['Int53']['input'];
  vatAmount: Scalars['Int53']['input'];
};

export type PaymentIntentItemInput = {
  count: Scalars['Int']['input'];
  itemId: Scalars['ID']['input'];
};

export type PaymentIntentRetryInput = {
  idempotencyKey: Scalars['String']['input'];
};

export enum PaymentIntentState {
  Done = 'Done',
  Failed = 'Failed',
  Ready = 'Ready',
  RequiresAction = 'RequiresAction'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  iconUrl?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentProvider?: Maybe<PaymentProvider>;
  /** Required permission: RestaurantReportRead */
  receiptPaymentMethodLabel?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantReportRead */
  sieAccountNumber?: Maybe<Scalars['SieAccountNumber']['output']>;
};

export type PaymentMethodInput = {
  iconUrl?: InputMaybe<Scalars['URL']['input']>;
  name: Scalars['String']['input'];
  paymentProvider: PaymentProvider;
  receiptPaymentMethodLabel: Scalars['String']['input'];
  sieAccountNumber: Scalars['SieAccountNumber']['input'];
};

export type PaymentMethodPatch = {
  iconUrl?: InputMaybe<Scalars['URL']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  receiptPaymentMethodLabel?: InputMaybe<Scalars['String']['input']>;
  sieAccountNumber?: InputMaybe<Scalars['SieAccountNumber']['input']>;
};

/** This is an open enum and new values will be added continually. Make sure that you handle any unknown cases properly. */
export enum PaymentProvider {
  Cash = 'Cash',
  DeliveryHero = 'DeliveryHero',
  External = 'External',
  Multiple = 'Multiple',
  Nets = 'Nets',
  NetsConnectCloud = 'NetsConnectCloud',
  PosTerminal = 'PosTerminal',
  Stripe = 'Stripe',
  Swish = 'Swish'
}

export type PaymentProviders = {
  __typename?: 'PaymentProviders';
  netsConnectCloud?: Maybe<Scalars['Boolean']['output']>;
  stripe?: Maybe<Scalars['Boolean']['output']>;
  swish?: Maybe<Scalars['Boolean']['output']>;
};

export enum Periodicity {
  Daily = 'Daily',
  Monthly = 'Monthly',
  None = 'None',
  WeekDays = 'WeekDays',
  WeekEnds = 'WeekEnds',
  Weekly = 'Weekly'
}

export type PeriodicityInput = {
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  periodicity?: InputMaybe<Periodicity>;
};

export type PersonalkollenCredentials = {
  token: Scalars['String']['input'];
};

export type PhysicalControlUnit = {
  __typename?: 'PhysicalControlUnit';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  outages?: Maybe<PhysicalControlUnitOutagePage>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PhysicalControlUnitOutagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PhysicalControlUnitEdge = {
  __typename?: 'PhysicalControlUnitEdge';
  cursor: Scalars['String']['output'];
  node: PhysicalControlUnit;
};

export type PhysicalControlUnitOutage = {
  __typename?: 'PhysicalControlUnitOutage';
  cashregisters?: Maybe<Array<Cashregister>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  restoredAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PhysicalControlUnitOutageEdge = {
  __typename?: 'PhysicalControlUnitOutageEdge';
  cursor: Scalars['String']['output'];
  node: PhysicalControlUnitOutage;
};

export type PhysicalControlUnitOutagePage = {
  __typename?: 'PhysicalControlUnitOutagePage';
  edges: Array<PhysicalControlUnitOutageEdge>;
  pageInfo: PageInfo;
};

export type PhysicalControlUnitOutageReport = {
  __typename?: 'PhysicalControlUnitOutageReport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  csvLink?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use csvLink instead */
  link?: Maybe<Scalars['URL']['output']>;
  status?: Maybe<PhysicalControlUnitOutageReportStatus>;
};

export enum PhysicalControlUnitOutageReportStatus {
  Available = 'Available',
  Pending = 'Pending'
}

export type PhysicalControlUnitPage = {
  __typename?: 'PhysicalControlUnitPage';
  edges: Array<PhysicalControlUnitEdge>;
  pageInfo: PageInfo;
};

export type PhysicalPrinter = {
  __typename?: 'PhysicalPrinter';
  cloudPrntServerUrl?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Status of the current identify request, if any.
   *
   * Every status has a timeout of 15 minutes, if the status is not updated within that time, it will be reset to null.
   */
  identifyStatus?: Maybe<PhysicalPrinterIdentifyStatus>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastOnlineAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  printerQueues?: Maybe<Array<PrinterQueue>>;
  restaurant?: Maybe<Restaurant>;
};

export enum PhysicalPrinterIdentifyStatus {
  Failure = 'Failure',
  Pending = 'Pending',
  Success = 'Success'
}

export type PhysicalPrinterInput = {
  name: Scalars['String']['input'];
  printerQueueIds: Array<Scalars['ID']['input']>;
};

export type PhysicalPrinterPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  printerQueueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum Platform {
  Android = 'Android',
  Web = 'Web',
  IOs = 'iOS'
}

export type PosTerminal = {
  __typename?: 'PosTerminal';
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastOnlineAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentProvider?: Maybe<PaymentProvider>;
};

export type PosTerminalPatch = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Printer = {
  __typename?: 'Printer';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PrinterJob = {
  __typename?: 'PrinterJob';
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['URL']['output']>;
  /** @deprecated Use 'printerQueue' instead */
  printer?: Maybe<Printer>;
  printerQueue?: Maybe<PrinterQueue>;
};

export type PrinterQueue = {
  __typename?: 'PrinterQueue';
  hasOverdueJobs?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  physicalPrinters?: Maybe<Array<PhysicalPrinter>>;
};

export type PrinterQueueInput = {
  name: Scalars['String']['input'];
};

export type PrinterQueuePatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductLinkInput = {
  productId: Scalars['String']['input'];
  productPrice?: InputMaybe<Scalars['Int53']['input']>;
  productStateId: Scalars['String']['input'];
};

export enum ProductVisibility {
  AlwaysVisible = 'AlwaysVisible',
  DuringDisplayHours = 'DuringDisplayHours',
  DuringOpeningHours = 'DuringOpeningHours',
  DuringOpeningHoursAndDisplayHours = 'DuringOpeningHoursAndDisplayHours'
}

export type PushTokenInput = {
  data: Scalars['String']['input'];
  type: PushTokenType;
};

export enum PushTokenType {
  Expo = 'Expo'
}

export type Query = {
  __typename?: 'Query';
  appSupportStatus?: Maybe<AppSupportStatus>;
  /** Required permission: SuperUser */
  appVersions?: Maybe<Array<AppVersion>>;
  currentTermsOfService?: Maybe<TermsOfService>;
  /** Throws an error if the discount doesn't exist, requires an authenticated user or is invalid (expired, consumed etc) */
  discount?: Maybe<Discount>;
  /**
   * Opening hours health check until regiment input contraint exists
   *
   * Required permission: SuperUser
   */
  legacyOpeningHoursErrors?: Maybe<Array<LegacyOpeningHoursError>>;
  /** Required permission: Authenticated */
  me?: Maybe<User>;
  /** Required permission: SuperUser */
  metaOrganization?: Maybe<MetaOrganization>;
  /** Required permission: SuperUser */
  metaOrganizations?: Maybe<MetaOrganizationPage>;
  /** Required permission: OrganizationRead */
  organization?: Maybe<Organization>;
  /** Required permission: SuperUser */
  organizations?: Maybe<OrganizationPage>;
  passwordResetRequest?: Maybe<PasswordResetRequest>;
  /** Required permission: SuperUser */
  physicalControlUnit?: Maybe<PhysicalControlUnit>;
  /** Required permission: SuperUser */
  physicalControlUnitOutageReport?: Maybe<PhysicalControlUnitOutageReport>;
  /** Required permission: SuperUser */
  physicalControlUnits?: Maybe<PhysicalControlUnitPage>;
  receipt?: Maybe<Receipt>;
  restaurant?: Maybe<Restaurant>;
  restaurants?: Maybe<RestaurantPage>;
  shortUrl?: Maybe<ShortUrl>;
  /** Required permission: SuperUser */
  statistics?: Maybe<GlobalStatistics>;
  /**
   * Gives you the status of "sudo mode" for the authentication token you're using.
   *
   * Required permission: Authenticated
   */
  sudoMode?: Maybe<SudoModeTicket>;
  /** Required permission: SuperUser */
  transactionChannelIncome?: Maybe<Array<TransactionChannelIncome>>;
  /** Required permission: SuperUser */
  user?: Maybe<User>;
  whiteLabel?: Maybe<WhiteLabel>;
  /** Required permission: SuperUser */
  whiteLabels?: Maybe<WhiteLabelPage>;
};


export type QueryAppSupportStatusArgs = {
  app: App;
  label: Scalars['String']['input'];
  platform: Platform;
  version: Scalars['Version']['input'];
};


export type QueryAppVersionsArgs = {
  filter?: InputMaybe<AppVersionFilter>;
};


export type QueryDiscountArgs = {
  code: Scalars['String']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type QueryMetaOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMetaOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPasswordResetRequestArgs = {
  token: Scalars['String']['input'];
};


export type QueryPhysicalControlUnitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPhysicalControlUnitOutageReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPhysicalControlUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReceiptArgs = {
  orderId: Scalars['ID']['input'];
  viewKey: Scalars['String']['input'];
};


export type QueryRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShortUrlArgs = {
  code: Scalars['String']['input'];
};


export type QueryStatisticsArgs = {
  dateTimeRange: DateTimeRangeInput;
  resolution: TimeResolution;
};


export type QueryTransactionChannelIncomeArgs = {
  dateTimeRange: DateTimeRangeInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWhiteLabelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWhiteLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum RearrangalStatus {
  Present = 'Present',
  Rearranged = 'Rearranged'
}

export type Receipt = {
  __typename?: 'Receipt';
  html?: Maybe<Scalars['String']['output']>;
  humanOrderNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  refund?: Maybe<Scalars['Boolean']['output']>;
};

export type RefundIntent = {
  __typename?: 'RefundIntent';
  /** For state "RequiresAction" this is the action that the user needs to perform. */
  action?: Maybe<RefundIntentAction>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryLocation?: Maybe<DeliveryLocation>;
  discountAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<OrderItem>>;
  /**
   * If refunding an order, this is that order.
   * If refunding an order intent, this is null.
   */
  order?: Maybe<Order>;
  /**
   * If refunding an order, this is the order intent that led to that order.
   * If refunding an order intent, this is that order intent.
   */
  orderIntent?: Maybe<OrderIntent>;
  paymentProvider?: Maybe<PaymentProvider>;
  posTerminal?: Maybe<PosTerminal>;
  receiptPrinter?: Maybe<PrinterQueue>;
  /**
   * The state which this Refund Intent is currently in.
   *
   * - 'RequiresAction' - An action is required to be performed by the user before this refund intent can progress, see the 'action' field for more info.
   * - 'Done' - This refund intent has successfully resulted in an Refund.
   * - 'Failed' - The refund intent has failed and will never result in an Refund.
   */
  state: RefundIntentState;
  tipAmount?: Maybe<Scalars['Int53']['output']>;
  totalAmountRefundable?: Maybe<Scalars['Int53']['output']>;
  totalAmountRefunded?: Maybe<Scalars['Int53']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RefundIntentAction = {
  __typename?: 'RefundIntentAction';
  /**
   * For type "UseIntegratedTerminal" this is an url which will give the current status of the payment request.
   *
   * When receiving a HTTP GET request, the response will contain a JSON document with a single field "status", which can have one of the following values:
   *
   * - 'CANCELED'
   * - 'CREATED'
   * - 'DECLINED'
   * - 'ERROR'
   * - 'PAID'
   */
  statusUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RefundIntentActionType>;
};

export enum RefundIntentActionType {
  /** External action outside of the app */
  ExternalAction = 'ExternalAction',
  /** Return cash to the customer */
  ReturnCash = 'ReturnCash',
  /** Use an external terminal to complete refund */
  UseExternalTerminal = 'UseExternalTerminal',
  /** Use an integrated terminal to complete refund */
  UseIntegratedTerminal = 'UseIntegratedTerminal',
  /** Wait until the status of the payment intent changes */
  Wait = 'Wait'
}

export type RefundIntentAlternativeInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  refundAmount: Scalars['Int53']['input'];
};

export type RefundIntentInput = {
  /** The employee authorising the refund. */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Specific items to refund. Total refund amount of all items must be equal to "refundAmount". */
  items?: InputMaybe<Array<RefundIntentItemInput>>;
  /** DEPRECATED: Pass "orderId" directly to the "createRefundIntent" mutation instead. */
  orderId?: InputMaybe<Scalars['ID']['input']>;
  /** If specified, will use this specific payment method to refund the order. Otherwise uses the same provider that was used to pay the order. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** The terminal that the card refund should be made on. This is only applicable if refunding a payment made with a physical card terminal. */
  posTerminalId?: InputMaybe<Scalars['ID']['input']>;
  /** If provided, instead of sending a digital receipt, the original receipt will be printed on the specified printer and the digital receipt will be a copy of the receipt. */
  receiptPrinterId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The total amount that should be refunded.
   *
   * Currently, the full amount of the order will be refunded if this is not provided.
   *
   * MANDATORY: This field will be made mandatory in the future.
   */
  refundAmount?: InputMaybe<Scalars['Int53']['input']>;
  /** How much of the discount that should be refunded. Should also be deducted from the total "refundAmount". */
  refundDiscountAmount?: InputMaybe<Scalars['Int53']['input']>;
  /** How much of the tip that should be refunded. Should also be included in the total "refundAmount". */
  refundTipAmount?: InputMaybe<Scalars['Int53']['input']>;
  /** The till that the refund was made from. */
  tillId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Indicates that the client supports getting back a "Wait" action. Without this support we cannot guarantee that the refund intent will be completed.
   *
   * If this is not provided, we will assume that the client does not support this.
   */
  waitActionSupported?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefundIntentItemInput = {
  alternatives?: InputMaybe<Array<RefundIntentAlternativeInput>>;
  count?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  refundAmount: Scalars['Int53']['input'];
};

export enum RefundIntentState {
  /** The refund has been finalized */
  Done = 'Done',
  /** The refund has failed and will never be finalized */
  Failed = 'Failed',
  /** The refund is ready to be finalized */
  Ready = 'Ready',
  /** An action needs to be taken before the refund can be finalized */
  RequiresAction = 'RequiresAction'
}

export enum RelocationStatus {
  Present = 'Present',
  Relocated = 'Relocated'
}

export enum RemovalStatus {
  Absent = 'Absent',
  Removed = 'Removed'
}

export type Restaurant = {
  __typename?: 'Restaurant';
  /** Required permission: SuperUser */
  activationCode?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  activeTableServiceAreasPhrase?: Maybe<Scalars['String']['output']>;
  applicationFeeCents?: Maybe<Scalars['Int53']['output']>;
  applicationFeePercentage?: Maybe<Scalars['Float']['output']>;
  /** Required permission: RestaurantWrite */
  autoAcceptDeliveryHeroOrders?: Maybe<Scalars['Boolean']['output']>;
  bookTableUrl?: Maybe<Scalars['URL']['output']>;
  /** Required permission: RestaurantCashAdjustmentWrite or RestaurantReportRead */
  cashAdjustments?: Maybe<CashAdjustmentPage>;
  /** Required permission: RestaurantRead */
  cashregister?: Maybe<Cashregister>;
  city?: Maybe<Scalars['String']['output']>;
  clientHeaderMessage?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantReportRead */
  controlUnitOutage?: Maybe<RestaurantControlUnitOutage>;
  /** Required permission: RestaurantReportRead */
  controlUnitOutageReport?: Maybe<RestaurantControlUnitOutageReport>;
  /** Required permission: RestaurantReportRead */
  controlUnitOutages?: Maybe<RestaurantControlUnitOutagePage>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dailyReconciliationTime?: Maybe<Scalars['PlainTime']['output']>;
  delivery?: Maybe<Delivery>;
  deliveryCostAreas?: Maybe<Array<DeliveryCostArea>>;
  /** Required permission: RestaurantWrite */
  deliveryHeroChainId?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantWrite */
  deliveryHeroDeliveryProduct?: Maybe<MenuAddonProduct>;
  /** Required permission: RestaurantWrite */
  deliveryHeroEnabled?: Maybe<Scalars['Boolean']['output']>;
  deliveryHeroSetupQuestionnaire?: Maybe<DeliveryHeroSetupQuestionnaire>;
  /** Required permission: RestaurantWrite */
  deliveryHeroVendorId?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantWrite */
  deliveryHeroWebhookUrl?: Maybe<Scalars['URL']['output']>;
  deliveryLocation?: Maybe<DeliveryLocation>;
  /** The "menuType" parameter is deprecated, pass in "filter" instead. */
  deliveryLocations?: Maybe<Array<DeliveryLocation>>;
  deliveryTemporarilyDisabled?: Maybe<Scalars['Boolean']['output']>;
  deliveryTimeAreas?: Maybe<Array<DeliveryTimeArea>>;
  deliveryTimeSlot?: Maybe<DeliveryTimeSlot>;
  deliveryTimeSlots?: Maybe<Array<DeliveryTimeSlot>>;
  design?: Maybe<Design>;
  /** Required permission: RestaurantDiscountWrite */
  discount?: Maybe<Discount>;
  /** Required permission: RestaurantDiscountWrite */
  discounts?: Maybe<DiscountPage>;
  discountsEnabled?: Maybe<Scalars['Boolean']['output']>;
  eatInServicePolicy?: Maybe<EatInServicePolicy>;
  eatInTemporarilyDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantPosWrite */
  employee?: Maybe<Employee>;
  /** Required permission: RestaurantPosWrite */
  employeeGroup?: Maybe<EmployeeGroup>;
  /** Required permission: RestaurantPosWrite */
  employeeGroups?: Maybe<Array<EmployeeGroup>>;
  /** Required permission: RestaurantPosWrite */
  employees?: Maybe<Array<Employee>>;
  extraDeliveryTime?: Maybe<Scalars['Duration']['output']>;
  /** Required permission: RestaurantWrite */
  failedOrderIntents?: Maybe<Array<OrderIntent>>;
  /** @deprecated Use 'featuredDiscounts' instead */
  featuredDiscount?: Maybe<Discount>;
  featuredDiscounts?: Maybe<Array<Discount>>;
  fontUrl?: Maybe<Scalars['URL']['output']>;
  giftCardTermsAccepted?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: Authenticated */
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  hasClientHeaderMessageAccess?: Maybe<Scalars['Boolean']['output']>;
  hasDeliveryHeroAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantWrite */
  hasDeliveryHeroCredentials?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantWrite */
  hasDeliveryHeroPluginSecret?: Maybe<Scalars['Boolean']['output']>;
  hasDeliveryMenu?: Maybe<Scalars['Boolean']['output']>;
  hasEatInMenu?: Maybe<Scalars['Boolean']['output']>;
  hasEnteredActivationCode?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantReportRead */
  hasNetsConnectCloudLink?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantRead */
  hasOngoingControlUnitOutage?: Maybe<Scalars['Boolean']['output']>;
  hasOrderDisplaySystemAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantWrite */
  hasPersonalkollenAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantWrite */
  hasPersonalkollenCredentials?: Maybe<Scalars['Boolean']['output']>;
  hasSkipSlipPrintOnPrinterQueuesAccess?: Maybe<Scalars['Boolean']['output']>;
  hasTakeAwayMenu?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantOpenOrderWrite */
  historicalOpenOrders?: Maybe<OpenOrderPage>;
  humanOrderNumberRange?: Maybe<HumanOrderNumberRange>;
  id: Scalars['ID']['output'];
  /** Required permission: RestaurantRead */
  incidentMessages?: Maybe<Array<IncidentMessage>>;
  /** Required permission: SuperUser */
  invoice?: Maybe<Invoice>;
  isBetaTesting?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantWrite */
  kitchenDisplay?: Maybe<KitchenDisplay>;
  /** Required permission: RestaurantWrite */
  kitchenOrderQueue?: Maybe<Array<Order>>;
  kitchenOrderQueueGrossAmount?: Maybe<Scalars['Int53']['output']>;
  kitchenOrderQueueLength?: Maybe<Scalars['Int']['output']>;
  /** Required permission: RestaurantSettingsWrite */
  kitchenOrderQueueSorting?: Maybe<KitchenOrderQueueSorting>;
  /**
   * A null value can be returned if the restaurant hasn't been active yet, or if the data is currently missing. There is currently no way to distinguish the two cases
   *
   * Required permission: SuperUser
   */
  lastActiveTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A null value can be returned if the restaurant hasn't had an order yet, or if the data is currently missing. There is currently no way to distinguish the two cases
   *
   * Required permission: RestaurantReportRead
   */
  lastOrderPlacedAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Coordinates>;
  maxDeliveryTime?: Maybe<Scalars['Duration']['output']>;
  menu?: Maybe<Menu>;
  menuSystem?: Maybe<MenuSystem>;
  name?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantReportWrite */
  netsConnectCloudUsername?: Maybe<Scalars['String']['output']>;
  nextCashregisterReportGenerationTime?: Maybe<Scalars['DateTime']['output']>;
  /** Required permission: RestaurantOpenOrderWrite */
  openOrder?: Maybe<OpenOrder>;
  /** Required permission: RestaurantOpenOrderWrite */
  openOrders?: Maybe<Array<OpenOrder>>;
  openingHours?: Maybe<OpeningHours>;
  /** Required permission: Authenticated */
  order?: Maybe<Order>;
  /** Required permission: RestaurantWrite */
  orderDisplaySystemAccentColor?: Maybe<Scalars['OpaqueColor']['output']>;
  /** Required permission: RestaurantWrite */
  orderDisplaySystemEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Required permission: RestaurantWrite */
  orderDisplaySystemLogoUrl?: Maybe<Scalars['URL']['output']>;
  /** Required permission: RestaurantWrite */
  orderDisplaySystemUrl?: Maybe<Scalars['URL']['output']>;
  /** Required permission: Authenticated */
  orderIntent?: Maybe<OrderIntent>;
  /** Required permission: RestaurantSettingsWrite */
  orderMergeThreshold?: Maybe<Scalars['Duration']['output']>;
  /** Required permission: RestaurantSettingsWrite */
  orderSlipLayout?: Maybe<OrderSlipLayout>;
  /** Required permission: RestaurantOrderRead */
  orders?: Maybe<OrderPage>;
  /** Required permission: RestaurantRead */
  organization?: Maybe<Organization>;
  /** Required permission: Authenticated */
  paymentIntent?: Maybe<PaymentIntent>;
  /** Required permission: RestaurantReportRead */
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  /** @deprecated Use 'paymentMethods' instead */
  paymentProviders?: Maybe<PaymentProviders>;
  /** Required permission: RestaurantWrite */
  personalkollenEnabled?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantSettingsWrite */
  physicalPrinter?: Maybe<PhysicalPrinter>;
  /** Required permission: RestaurantSettingsWrite */
  physicalPrinters?: Maybe<Array<PhysicalPrinter>>;
  /** Required permission: RestaurantReportRead */
  posTerminal: PosTerminal;
  /** Required permission: RestaurantReportRead */
  posTerminals?: Maybe<Array<PosTerminal>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantSettingsWrite */
  printerQueue?: Maybe<PrinterQueue>;
  /** Required permission: RestaurantSettingsWrite */
  printerQueues?: Maybe<Array<PrinterQueue>>;
  /**
   * Required permission: RestaurantSettingsWrite
   * @deprecated Use 'printerQueues' instead
   */
  printers?: Maybe<Array<Printer>>;
  queueTime?: Maybe<Scalars['Duration']['output']>;
  /** Required permission: RestaurantSettingsWrite */
  receiptLogoUrl?: Maybe<Scalars['URL']['output']>;
  /** Required permission: RestaurantSettingsWrite */
  receiptTextBottom?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantSettingsWrite */
  receiptTextTop?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantOrderRefund */
  refundIntent?: Maybe<RefundIntent>;
  /** Required permission: RestaurantRead */
  resumableOrderIntents?: Maybe<Array<OrderIntent>>;
  setupProgress?: Maybe<RestaurantSetupProgress>;
  /** Required permission: RestaurantWrite */
  slip?: Maybe<OrderSlip>;
  /** Required permission: SuperUser */
  smsCount?: Maybe<Scalars['Int']['output']>;
  /** Required permission: RestaurantReportRead */
  statistics?: Maybe<RestaurantStatistics>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  /** Required permission: RestaurantReportRead */
  swishNumber?: Maybe<Scalars['String']['output']>;
  takeAwayTemporarilyDisabled?: Maybe<Scalars['Boolean']['output']>;
  temporarilyDisabled?: Maybe<Scalars['Boolean']['output']>;
  theme?: Maybe<RestaurantTheme>;
  /** Required permission: RestaurantRead */
  till?: Maybe<Till>;
  /** Required permission: RestaurantRead */
  tills?: Maybe<Array<Till>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Required permission: RestaurantWrite */
  whiteLabels?: Maybe<Array<WhiteLabel>>;
  /** Required permission: RestaurantReportRead */
  xReport?: Maybe<XReport>;
  /** Required permission: RestaurantReportRead */
  zReport?: Maybe<ZReport>;
  /** Required permission: RestaurantReportRead */
  zReports?: Maybe<ZReportPage>;
};


export type RestaurantCashAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantControlUnitOutageArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantControlUnitOutageReportArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantControlUnitOutagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantDeliveryArgs = {
  toCoordinates?: InputMaybe<CoordinatesInput>;
};


export type RestaurantDeliveryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantDeliveryLocationsArgs = {
  filter?: InputMaybe<DeliveryLocationFilter>;
  menuType?: InputMaybe<MenuType>;
};


export type RestaurantDeliveryTimeSlotArgs = {
  id: Scalars['ID']['input'];
  toCoordinates?: InputMaybe<CoordinatesInput>;
};


export type RestaurantDeliveryTimeSlotsArgs = {
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  menuType: MenuType;
  toCoordinates?: InputMaybe<CoordinatesInput>;
};


export type RestaurantDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantEmployeeArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantEmployeeGroupArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantHasAccessArgs = {
  access: RestaurantAccess;
};


export type RestaurantHistoricalOpenOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<HistoricalOpenOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantInvoiceArgs = {
  dateTimeRange: DateTimeRangeInput;
};


export type RestaurantKitchenDisplayArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantMenuArgs = {
  filter?: InputMaybe<MenuFilter>;
};


export type RestaurantOpenOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantOrderIntentArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantPaymentIntentArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantPhysicalPrinterArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantPosTerminalArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantPrinterQueueArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantRefundIntentArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantSlipArgs = {
  isCopy?: InputMaybe<Scalars['Boolean']['input']>;
  orderIds: Array<Scalars['ID']['input']>;
  printerId?: InputMaybe<Scalars['ID']['input']>;
};


export type RestaurantSmsCountArgs = {
  dateRange: DateTimeRangeInput;
};


export type RestaurantStatisticsArgs = {
  dateTimeRange: DateTimeRangeInput;
  filter?: InputMaybe<RestaurantStatisticsFilter>;
  resolution: TimeResolution;
};


export type RestaurantTillArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantZReportArgs = {
  id: Scalars['ID']['input'];
};


export type RestaurantZReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum RestaurantAccess {
  CashAdjustmentWrite = 'CashAdjustmentWrite',
  DiscountWrite = 'DiscountWrite',
  DiscountedCheckout = 'DiscountedCheckout',
  ExternalPaymentCheckout = 'ExternalPaymentCheckout',
  MenuStockWrite = 'MenuStockWrite',
  MenuWrite = 'MenuWrite',
  OpenOrderWrite = 'OpenOrderWrite',
  OpenPriceCheckout = 'OpenPriceCheckout',
  OpeningHoursWrite = 'OpeningHoursWrite',
  OrderRead = 'OrderRead',
  OrderRefund = 'OrderRefund',
  PosWrite = 'PosWrite',
  Read = 'Read',
  ReportRead = 'ReportRead',
  ReportWrite = 'ReportWrite',
  SettingsWrite = 'SettingsWrite',
  Write = 'Write'
}

export enum RestaurantActiveFilter {
  /** Only return active restaurants, the default */
  Active = 'Active',
  /** Include restaurants with no activation code */
  All = 'All'
}

export type RestaurantControlUnitOutage = {
  __typename?: 'RestaurantControlUnitOutage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  restoredAt?: Maybe<Scalars['DateTime']['output']>;
  sieVerification?: Maybe<SieVerification>;
};

export type RestaurantControlUnitOutageEdge = {
  __typename?: 'RestaurantControlUnitOutageEdge';
  cursor: Scalars['String']['output'];
  node: RestaurantControlUnitOutage;
};

export type RestaurantControlUnitOutagePage = {
  __typename?: 'RestaurantControlUnitOutagePage';
  edges: Array<RestaurantControlUnitOutageEdge>;
  pageInfo: PageInfo;
};

export type RestaurantControlUnitOutageReport = {
  __typename?: 'RestaurantControlUnitOutageReport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  csvLink?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use csvLink instead */
  link?: Maybe<Scalars['URL']['output']>;
  sieLink?: Maybe<Scalars['URL']['output']>;
  status?: Maybe<RestaurantControlUnitOutageReportStatus>;
};

export enum RestaurantControlUnitOutageReportStatus {
  Available = 'Available',
  Pending = 'Pending'
}

export type RestaurantDeliveryLocationShortUrl = {
  __typename?: 'RestaurantDeliveryLocationShortUrl';
  deliveryLocation?: Maybe<ServingLocation>;
  menuType?: Maybe<MenuType>;
  restaurant?: Maybe<Restaurant>;
  shortUrl?: Maybe<ShortUrl>;
  whiteLabel?: Maybe<WhiteLabel>;
};

export type RestaurantEdge = {
  __typename?: 'RestaurantEdge';
  cursor: Scalars['String']['output'];
  node: Restaurant;
};

export type RestaurantFilter = {
  active?: InputMaybe<RestaurantActiveFilter>;
};

export type RestaurantInput = {
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['E164']['input'];
  postalCode: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type RestaurantOrderSalesBreakdownInput = {
  dateTimeRange: DateTimeRangeInput;
  emailAddress: Scalars['String']['input'];
  menuTypes?: InputMaybe<Array<MenuType>>;
};

export type RestaurantPage = {
  __typename?: 'RestaurantPage';
  edges: Array<RestaurantEdge>;
  pageInfo: PageInfo;
};

export type RestaurantPatch = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeTableServiceAreasPhrase?: InputMaybe<Scalars['String']['input']>;
  applicationFeeCents?: InputMaybe<Scalars['Int']['input']>;
  applicationFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  bookTableUrl?: InputMaybe<Scalars['URL']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientHeaderMessage?: InputMaybe<Scalars['String']['input']>;
  deliveryHeroEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryTemporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  design?: InputMaybe<DesignPatch>;
  discountsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eatInServicePolicy?: InputMaybe<EatInServicePolicy>;
  eatInTemporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  extraDeliveryTime?: InputMaybe<Scalars['Duration']['input']>;
  featuredDiscountCode?: InputMaybe<Scalars['String']['input']>;
  giftCardTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientHeaderMessageAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeliveryHeroAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeliveryMenu?: InputMaybe<Scalars['Boolean']['input']>;
  hasEatInMenu?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderDisplaySystemAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSkipSlipPrintOnPrinterQueuesAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasTakeAwayMenu?: InputMaybe<Scalars['Boolean']['input']>;
  humanOrderNumberRange?: InputMaybe<HumanOrderNumberRangeInput>;
  isBetaTesting?: InputMaybe<Scalars['Boolean']['input']>;
  kitchenOrderQueueSorting?: InputMaybe<KitchenOrderQueueSorting>;
  location?: InputMaybe<CoordinatesInput>;
  maxDeliveryTime?: InputMaybe<Scalars['Duration']['input']>;
  menuSystem?: InputMaybe<MenuSystem>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderDisplaySystemAccentColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  orderDisplaySystemEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderDisplaySystemLogoUrl?: InputMaybe<Scalars['URL']['input']>;
  orderMergeThreshold?: InputMaybe<Scalars['Duration']['input']>;
  orderSlipLayout?: InputMaybe<OrderSlipLayout>;
  personalkollenEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  queueTime?: InputMaybe<Scalars['Duration']['input']>;
  receiptLogoUrl?: InputMaybe<Scalars['URL']['input']>;
  receiptTextBottom?: InputMaybe<Scalars['String']['input']>;
  receiptTextTop?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  takeAwayTemporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  temporarilyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  whiteLabelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RestaurantSetupProgress = {
  __typename?: 'RestaurantSetupProgress';
  hasCashregister?: Maybe<Scalars['Boolean']['output']>;
  hasEnteredActivationCode?: Maybe<Scalars['Boolean']['output']>;
  stripeConnectionUrl?: Maybe<Scalars['URL']['output']>;
  taxAuthoritiesCashregisterRegistrationUrl?: Maybe<Scalars['URL']['output']>;
  taxAuthoritiesControlUnitRegistrationUrl?: Maybe<Scalars['URL']['output']>;
};


export type RestaurantSetupProgressStripeConnectionUrlArgs = {
  redirectUrl?: InputMaybe<Scalars['URL']['input']>;
};

export type RestaurantStatistics = {
  __typename?: 'RestaurantStatistics';
  id: Scalars['ID']['output'];
  refundsByPaymentName?: Maybe<Array<RestaurantStatisticsRefundsByPaymentName>>;
  refundsByProduct?: Maybe<Array<RestaurantStatisticsRefundsByProduct>>;
  salesByMenuType?: Maybe<Array<RestaurantStatisticsSalesByMenuType>>;
  salesByMenuTypeAndTimePeriod?: Maybe<Array<RestaurantStatisticsSalesByMenuTypeAndTimePeriod>>;
  salesByPaymentName?: Maybe<Array<RestaurantStatisticsSalesByPaymentName>>;
  salesByProduct?: Maybe<Array<RestaurantStatisticsSalesByProduct>>;
  salesByReportGroup?: Maybe<Array<RestaurantStatisticsSalesByReportGroup>>;
  salesByVatRate?: Maybe<Array<RestaurantStatisticsSalesByVatRate>>;
  totalDiscountAmount?: Maybe<Scalars['Int53']['output']>;
  totalTipAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsFilter = {
  menuTypes?: InputMaybe<Array<MenuType>>;
  transactionChannels?: InputMaybe<Array<TransactionChannel>>;
};

export type RestaurantStatisticsRefundsByPaymentName = {
  __typename?: 'RestaurantStatisticsRefundsByPaymentName';
  count?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  paymentName?: Maybe<Scalars['String']['output']>;
  tipAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsRefundsByProduct = {
  __typename?: 'RestaurantStatisticsRefundsByProduct';
  addons?: Maybe<Array<RestaurantStatisticsRefundsByProductAddon>>;
  alternativeItems?: Maybe<Array<RestaurantStatisticsRefundsByProductAlternativeItem>>;
  count?: Maybe<Scalars['Int53']['output']>;
  discountAmount?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Int53']['output']>;
  price?: Maybe<Scalars['Int53']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  vatAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsRefundsByProductAddon = {
  __typename?: 'RestaurantStatisticsRefundsByProductAddon';
  count?: Maybe<Scalars['Int53']['output']>;
  discountAmount?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Int53']['output']>;
  price?: Maybe<Scalars['Int53']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  vatAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsRefundsByProductAlternativeItem = {
  __typename?: 'RestaurantStatisticsRefundsByProductAlternativeItem';
  count?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RestaurantStatisticsSalesByMenuType = {
  __typename?: 'RestaurantStatisticsSalesByMenuType';
  count?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  menuType?: Maybe<MenuType>;
  vatAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsSalesByMenuTypeAndTimePeriod = {
  __typename?: 'RestaurantStatisticsSalesByMenuTypeAndTimePeriod';
  count?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  menuType?: Maybe<MenuType>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated This is in the restaurant local timezone, which can cause ambiguity. Use 'periodStart' instead. */
  when?: Maybe<Scalars['String']['output']>;
};

export type RestaurantStatisticsSalesByPaymentName = {
  __typename?: 'RestaurantStatisticsSalesByPaymentName';
  count?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  paymentName?: Maybe<Scalars['String']['output']>;
  tipAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsSalesByProduct = {
  __typename?: 'RestaurantStatisticsSalesByProduct';
  addons?: Maybe<Array<RestaurantStatisticsSalesByProductAddon>>;
  alternativeItems?: Maybe<Array<RestaurantStatisticsSalesByProductAlternativeItem>>;
  count?: Maybe<Scalars['Int53']['output']>;
  discountAmount?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Int53']['output']>;
  price?: Maybe<Scalars['Int53']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  vatAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsSalesByProductAddon = {
  __typename?: 'RestaurantStatisticsSalesByProductAddon';
  count?: Maybe<Scalars['Int53']['output']>;
  discountAmount?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Int53']['output']>;
  price?: Maybe<Scalars['Int53']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  vatAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsSalesByProductAlternativeItem = {
  __typename?: 'RestaurantStatisticsSalesByProductAlternativeItem';
  count?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RestaurantStatisticsSalesByReportGroup = {
  __typename?: 'RestaurantStatisticsSalesByReportGroup';
  count?: Maybe<Scalars['Int53']['output']>;
  discountAmount?: Maybe<Scalars['Int53']['output']>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  netAmount?: Maybe<Scalars['Int53']['output']>;
  reportGroupName?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Scalars['Int53']['output']>;
};

export type RestaurantStatisticsSalesByVatRate = {
  __typename?: 'RestaurantStatisticsSalesByVatRate';
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  id: Scalars['ID']['output'];
  netAmount?: Maybe<Scalars['Int53']['output']>;
  vatAmount?: Maybe<Scalars['Int53']['output']>;
  vatRate?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantTheme = {
  __typename?: 'RestaurantTheme';
  lightMode?: Maybe<LightModeRestaurantTheme>;
};

export type RestaurantThemePatch = {
  lightMode?: InputMaybe<LightModeRestaurantThemeInput>;
};

export type RetroProductButtonsColorByCategory = {
  __typename?: 'RetroProductButtonsColorByCategory';
  backgroundColor: Scalars['OpaqueColor']['output'];
  categoryId: Scalars['String']['output'];
};

export type RetroProductButtonsColorByCategoryInput = {
  backgroundColor: Scalars['OpaqueColor']['input'];
  categoryId: Scalars['String']['input'];
};

export type SieAccount = {
  __typename?: 'SIEAccount';
  defaultDescription?: Maybe<Scalars['String']['output']>;
  defaultNumber?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type SieAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
};

export type SieReport = {
  __typename?: 'SIEReport';
  datePeriod?: Maybe<DateTimeRange>;
  id: Scalars['ID']['output'];
  sieFileData?: Maybe<Scalars['Base64Data']['output']>;
  verifications?: Maybe<Array<SieVerification>>;
};

export type SieTransaction = {
  __typename?: 'SIETransaction';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int53']['output']>;
};

export type SieVerification = {
  __typename?: 'SIEVerification';
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fortnoxAccountingImportJob?: Maybe<FortnoxAccountingImportJob>;
  id: Scalars['ID']['output'];
  restaurants?: Maybe<Array<Restaurant>>;
  source?: Maybe<SieVerificationSource>;
  transactions?: Maybe<Array<SieTransaction>>;
  validationError?: Maybe<Scalars['String']['output']>;
};

export type SieVerificationSource = PhysicalControlUnitOutage | StripeReport | ZReport;

export enum SendToKitchen {
  Always = 'Always',
  Ask = 'Ask',
  Never = 'Never'
}

export type ServingLocation = {
  __typename?: 'ServingLocation';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  eatInEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  takeAwayEnabled?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<ServingLocationType>;
};

export enum ServingLocationType {
  /** A cash desk is by default used both by eat in and take away */
  CashDesk = 'CashDesk',
  /** A table is only used by eat in */
  Table = 'Table'
}

export type ShortUrl = {
  __typename?: 'ShortUrl';
  smartLink?: Maybe<Scalars['Boolean']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ShortUrlInput = {
  smartLink?: InputMaybe<Scalars['Boolean']['input']>;
  target: Scalars['String']['input'];
};

export type SieReportFilter = {
  restaurantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  verificationTypes?: InputMaybe<Array<SieVerificationType>>;
};

export enum SieVerificationType {
  PhysicalControlUnitOutage = 'PhysicalControlUnitOutage',
  StripeReport = 'StripeReport',
  ZReport = 'ZReport'
}

export type StripeCard = {
  __typename?: 'StripeCard';
  brand?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4?: Maybe<Scalars['String']['output']>;
};

export type StripeReport = {
  __typename?: 'StripeReport';
  datePeriod?: Maybe<DateTimeRange>;
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sieVerification?: Maybe<SieVerification>;
  total?: Maybe<StripeReportTotal>;
};


export type StripeReportTotalArgs = {
  currency: Currency;
};

export type StripeReportEdge = {
  __typename?: 'StripeReportEdge';
  cursor: Scalars['String']['output'];
  node: StripeReport;
};

export type StripeReportPage = {
  __typename?: 'StripeReportPage';
  edges: Array<StripeReportEdge>;
  pageInfo: PageInfo;
};

export type StripeReportTotal = {
  __typename?: 'StripeReportTotal';
  fee?: Maybe<StripeReportTotalFee>;
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
};

export type StripeReportTotalFee = {
  __typename?: 'StripeReportTotalFee';
  vatAmount?: Maybe<Scalars['Int53']['output']>;
};

export type StripeStatus = {
  __typename?: 'StripeStatus';
  outstandingChargesCount?: Maybe<Scalars['Int']['output']>;
  outstandingChargesGrossAmount?: Maybe<Scalars['Int53']['output']>;
  transactionsSinceReportCount?: Maybe<Scalars['Int']['output']>;
  transactionsSinceReportNetAmount?: Maybe<Scalars['Int53']['output']>;
};

export type SudoModeTicket = {
  __typename?: 'SudoModeTicket';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type TermsOfService = {
  __typename?: 'TermsOfService';
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TextColor = {
  __typename?: 'TextColor';
  disabled: Scalars['Color']['output'];
  primary: Scalars['Color']['output'];
  secondary: Scalars['Color']['output'];
};

export type Theme = {
  __typename?: 'Theme';
  /** The color of various backgrounds, such as background color for the screens. */
  backgroundColor: Scalars['OpaqueColor']['output'];
  /** The color of borders, e.g. header border, tab bar border etc. */
  borderColor: Scalars['OpaqueColor']['output'];
  /** The background color of card-like elements, such as headers, tab bars etc. */
  cardColor: Scalars['OpaqueColor']['output'];
  drawerBackgroundColor: Scalars['OpaqueColor']['output'];
  drawerListItemIconColor: Scalars['Color']['output'];
  drawerListItemSubtitleColor: Scalars['Color']['output'];
  drawerListItemTitleColor: Scalars['Color']['output'];
  drawerLogoImage?: Maybe<Scalars['URL']['output']>;
  drawerVersionTextColor: Scalars['Color']['output'];
  id: Scalars['ID']['output'];
  listBackgroundColor: Scalars['OpaqueColor']['output'];
  listBackgroundImage?: Maybe<Scalars['URL']['output']>;
  listClearIconColor: Scalars['Color']['output'];
  listEmptyListButtonBackgroundColor: Scalars['Color']['output'];
  listItemBackgroundColor: Scalars['Color']['output'];
  /** @deprecated Use 'listItemSeparatorColor' instead */
  listItemSeparatorBackgroundColor: Scalars['Color']['output'];
  listItemSeparatorColor: Scalars['Color']['output'];
  listItemTextColor: Scalars['Color']['output'];
  listMenuIconColor: Scalars['Color']['output'];
  listSearchIconColor: Scalars['Color']['output'];
  listTabBarActiveTextColor: Scalars['Color']['output'];
  listTabBarInactiveTextColor: Scalars['Color']['output'];
  /** @deprecated Use 'listTabBarUnderlineColor' instead */
  listTabBarUnderlineBackgroundColor: Scalars['Color']['output'];
  listTabBarUnderlineColor: Scalars['Color']['output'];
  listTextInputColor: Scalars['Color']['output'];
  listTextInputPlaceholderTextColor: Scalars['Color']['output'];
  menuTypeSelectionBackgroundColor: Scalars['OpaqueColor']['output'];
  menuTypeSelectionBackgroundImage?: Maybe<Scalars['URL']['output']>;
  menuTypeSelectionButtonBackgroundColor: Scalars['Color']['output'];
  menuTypeSelectionButtonBorderColor: Scalars['Color']['output'];
  menuTypeSelectionButtonTextColor: Scalars['Color']['output'];
  menuTypeSelectionTitleColor: Scalars['Color']['output'];
  /** The color of Tab Navigator badge. */
  notificationColor: Scalars['OpaqueColor']['output'];
  /** The primary color of the app used to tint various elements. Usually you'll want to use your brand color for this. */
  primaryColor: Scalars['OpaqueColor']['output'];
  /** The text color of various elements. */
  textColor: Scalars['OpaqueColor']['output'];
};

export type ThemePatch = {
  /** The color of various backgrounds, such as background color for the screens. */
  backgroundColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  /** The color of borders, e.g. header border, tab bar border etc. */
  borderColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  /** The background color of card-like elements, such as headers, tab bars etc. */
  cardColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  drawerBackgroundColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  drawerListItemIconColor?: InputMaybe<Scalars['Color']['input']>;
  drawerListItemSubtitleColor?: InputMaybe<Scalars['Color']['input']>;
  drawerListItemTitleColor?: InputMaybe<Scalars['Color']['input']>;
  drawerLogoImage?: InputMaybe<Scalars['URL']['input']>;
  drawerVersionTextColor?: InputMaybe<Scalars['Color']['input']>;
  listBackgroundColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  listBackgroundImage?: InputMaybe<Scalars['URL']['input']>;
  listClearIconColor?: InputMaybe<Scalars['Color']['input']>;
  listEmptyListButtonBackgroundColor?: InputMaybe<Scalars['Color']['input']>;
  listItemBackgroundColor?: InputMaybe<Scalars['Color']['input']>;
  listItemSeparatorColor?: InputMaybe<Scalars['Color']['input']>;
  listItemTextColor?: InputMaybe<Scalars['Color']['input']>;
  listMenuIconColor?: InputMaybe<Scalars['Color']['input']>;
  listSearchIconColor?: InputMaybe<Scalars['Color']['input']>;
  listTabBarActiveTextColor?: InputMaybe<Scalars['Color']['input']>;
  listTabBarInactiveTextColor?: InputMaybe<Scalars['Color']['input']>;
  listTabBarUnderlineColor?: InputMaybe<Scalars['Color']['input']>;
  listTextInputColor?: InputMaybe<Scalars['Color']['input']>;
  listTextInputPlaceholderTextColor?: InputMaybe<Scalars['Color']['input']>;
  menuTypeSelectionBackgroundColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  menuTypeSelectionBackgroundImage?: InputMaybe<Scalars['URL']['input']>;
  menuTypeSelectionButtonBackgroundColor?: InputMaybe<Scalars['Color']['input']>;
  menuTypeSelectionButtonBorderColor?: InputMaybe<Scalars['Color']['input']>;
  menuTypeSelectionButtonTextColor?: InputMaybe<Scalars['Color']['input']>;
  menuTypeSelectionTitleColor?: InputMaybe<Scalars['Color']['input']>;
  /** The color of Tab Navigator badge. */
  notificationColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  /** The primary color of the app used to tint various elements. Usually you'll want to use your brand color for this. */
  primaryColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  /** The text color of various elements. */
  textColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
};

export type Till = {
  __typename?: 'Till';
  featuredDiscounts?: Maybe<Array<Discount>>;
  fixedDeliveryLocation?: Maybe<DeliveryLocation>;
  fixedDeliveryTime?: Maybe<FixedDeliveryTime>;
  /** @deprecated Use 'fixedDeliveryTime' instead */
  fixedServingTime?: Maybe<FixedServingTime>;
  id: Scalars['ID']['output'];
  layout?: Maybe<TillLayout>;
  name?: Maybe<Scalars['String']['output']>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  posTerminals?: Maybe<Array<PosTerminal>>;
  preferredApiEnvironment?: Maybe<ApiEnvironment>;
  /** @deprecated Use 'receiptPrinterQueue' instead */
  receiptPrinter?: Maybe<Printer>;
  receiptPrinterQueue?: Maybe<PrinterQueue>;
  sendOrderToKitchen?: Maybe<SendToKitchen>;
  /** @deprecated Use 'paymentMethods' instead */
  showsCashPaymentProvider?: Maybe<Scalars['Boolean']['output']>;
  showsCategoryBar?: Maybe<Scalars['Boolean']['output']>;
  showsDiscountField?: Maybe<Scalars['Boolean']['output']>;
  showsEmptyShoppingCartButton?: Maybe<Scalars['Boolean']['output']>;
  showsHoldKitchenPrint?: Maybe<Scalars['Boolean']['output']>;
  showsLogo?: Maybe<Scalars['Boolean']['output']>;
  showsMenuCourses?: Maybe<Scalars['Boolean']['output']>;
  showsMenuType?: Maybe<MenuTypeFilter>;
  /** @deprecated Use 'paymentMethods' instead */
  showsNetsConnectCloudPaymentProvider?: Maybe<Scalars['Boolean']['output']>;
  showsOpenOrders?: Maybe<Scalars['Boolean']['output']>;
  showsOpeningStatus?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use 'paymentMethods' instead */
  showsPosTerminalPaymentProvider?: Maybe<Scalars['Boolean']['output']>;
  showsSearch?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use 'paymentMethods' instead */
  showsSwishPaymentProvider?: Maybe<Scalars['Boolean']['output']>;
  showsTip?: Maybe<Scalars['Boolean']['output']>;
  skipSlipPrintOnPrinterQueues?: Maybe<Array<PrinterQueue>>;
};

export type TillInput = {
  featuredDiscountCode?: InputMaybe<Scalars['String']['input']>;
  fixedDeliveryLocationId?: InputMaybe<Scalars['ID']['input']>;
  fixedDeliveryTime?: InputMaybe<FixedDeliveryTime>;
  layout?: InputMaybe<TillLayout>;
  name: Scalars['String']['input'];
  paymentMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  posTerminalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredApiEnvironment?: InputMaybe<ApiEnvironment>;
  receiptPrinterQueueId?: InputMaybe<Scalars['ID']['input']>;
  sendOrderToKitchen?: InputMaybe<SendToKitchen>;
  showsCategoryBar?: InputMaybe<Scalars['Boolean']['input']>;
  showsDiscountField?: InputMaybe<Scalars['Boolean']['input']>;
  showsEmptyShoppingCartButton?: InputMaybe<Scalars['Boolean']['input']>;
  showsHoldKitchenPrint?: InputMaybe<Scalars['Boolean']['input']>;
  showsLogo?: InputMaybe<Scalars['Boolean']['input']>;
  showsMenuCourses?: InputMaybe<Scalars['Boolean']['input']>;
  showsMenuType?: InputMaybe<MenuTypeFilter>;
  showsOpenOrders?: InputMaybe<Scalars['Boolean']['input']>;
  showsOpeningStatus?: InputMaybe<Scalars['Boolean']['input']>;
  showsSearch?: InputMaybe<Scalars['Boolean']['input']>;
  showsTip?: InputMaybe<Scalars['Boolean']['input']>;
  skipSlipPrintOnPrinterQueueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum TillLayout {
  List = 'List',
  Modern = 'Modern',
  Retro = 'Retro'
}

export type TillPatch = {
  featuredDiscountCode?: InputMaybe<Scalars['String']['input']>;
  fixedDeliveryLocationId?: InputMaybe<Scalars['ID']['input']>;
  fixedDeliveryTime?: InputMaybe<FixedDeliveryTime>;
  layout?: InputMaybe<TillLayout>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  posTerminalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredApiEnvironment?: InputMaybe<ApiEnvironment>;
  receiptPrinterQueueId?: InputMaybe<Scalars['ID']['input']>;
  sendOrderToKitchen?: InputMaybe<SendToKitchen>;
  showsCategoryBar?: InputMaybe<Scalars['Boolean']['input']>;
  showsDiscountField?: InputMaybe<Scalars['Boolean']['input']>;
  showsEmptyShoppingCartButton?: InputMaybe<Scalars['Boolean']['input']>;
  showsHoldKitchenPrint?: InputMaybe<Scalars['Boolean']['input']>;
  showsLogo?: InputMaybe<Scalars['Boolean']['input']>;
  showsMenuCourses?: InputMaybe<Scalars['Boolean']['input']>;
  showsMenuType?: InputMaybe<MenuTypeFilter>;
  showsOpenOrders?: InputMaybe<Scalars['Boolean']['input']>;
  showsOpeningStatus?: InputMaybe<Scalars['Boolean']['input']>;
  showsSearch?: InputMaybe<Scalars['Boolean']['input']>;
  showsTip?: InputMaybe<Scalars['Boolean']['input']>;
  skipSlipPrintOnPrinterQueueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** This is an open enum and new values might be added. Make sure that you handle any unknown cases properly. */
export enum TimeResolution {
  /** Year, month and day (0000-01-01 to 9999-12-31) */
  Day = 'Day',
  /** Year, month, day and hour (0000-01-01T00 to 9999-12-31T23) */
  Hour = 'Hour',
  /** Year and month (0000-01 to 9999-12) */
  Month = 'Month',
  /** Year and week (0000-01 to 9999-53) */
  Week = 'Week'
}

export enum TogglingStatus {
  Present = 'Present',
  Toggled = 'Toggled'
}

export enum TransactionChannel {
  DeliveryHero = 'DeliveryHero',
  Loco = 'Loco',
  Order = 'Order',
  SelfCheckout = 'SelfCheckout',
  Web = 'Web',
  WhiteLabel = 'WhiteLabel'
}

export type TransactionChannelIncome = {
  __typename?: 'TransactionChannelIncome';
  id: Scalars['ID']['output'];
  totalAmount?: Maybe<Scalars['Int53']['output']>;
  totalSales?: Maybe<Scalars['Int53']['output']>;
  transactionChannel?: Maybe<TransactionChannel>;
};

export type UpdateDeliveryHeroIntegrationSettingsInput = {
  autoAcceptDeliveryHeroOrders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isSuperUser?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Required permission: UserWrite */
  order?: Maybe<Order>;
  /** Required permission: UserWrite */
  orders?: Maybe<OrderPage>;
  /** Required permission: UserWrite */
  organizationsWithAccess?: Maybe<Array<Organization>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Required permission: UserWrite */
  restaurantsWithAccess?: Maybe<Array<Restaurant>>;
  /** Required permission: UserWrite */
  stripeCards?: Maybe<Array<StripeCard>>;
  /** Required permission: UserWrite */
  termsOfServiceAccepted?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  /** Required permission: UserWrite */
  whiteLabelsWithAccess?: Maybe<Array<WhiteLabel>>;
};


export type UserOrderArgs = {
  id: Scalars['ID']['input'];
};


export type UserOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserOrganizationsWithAccessArgs = {
  access: OrganizationAccess;
};


export type UserRestaurantsWithAccessArgs = {
  access: RestaurantAccess;
};


export type UserWhiteLabelsWithAccessArgs = {
  access: WhiteLabelAccess;
};

export type UserInput = {
  email: Scalars['EmailAddress']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['E164']['input'];
};

export type VerifyPhoneNumberMetadata = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['ID']['input']>;
};

export type VerifyPhoneNumberRequest = {
  __typename?: 'VerifyPhoneNumberRequest';
  id: Scalars['ID']['output'];
};

export enum WeekDay {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type WeekDayTime = {
  __typename?: 'WeekDayTime';
  day: WeekDay;
  time: Scalars['PlainTime']['output'];
};

export type WeekDayTimeInput = {
  day: WeekDay;
  time: Scalars['PlainTime']['input'];
};

export type WhiteLabel = {
  __typename?: 'WhiteLabel';
  /** Required permission: SuperUser */
  androidFeatureGraphicUrl?: Maybe<Scalars['URL']['output']>;
  /** Required permission: SuperUser */
  androidGoogleServices?: Maybe<Scalars['JSONObject']['output']>;
  /** Required permission: SuperUser */
  androidPackageName?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  appIconUrl?: Maybe<Scalars['URL']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  appSplashUrl?: Maybe<Scalars['URL']['output']>;
  /** Required permission: SuperUser */
  buildNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  easProjectId?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  expoSlug?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  googleMapsApiKey?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  iPadPro129Screenshots?: Maybe<Array<Scalars['URL']['output']>>;
  /** Required permission: SuperUser */
  iPhone55Screenshots?: Maybe<Array<Scalars['URL']['output']>>;
  /** Required permission: SuperUser */
  iPhone65Screenshots?: Maybe<Array<Scalars['URL']['output']>>;
  id: Scalars['ID']['output'];
  /** Required permission: SuperUser */
  iosAppstoreId?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  iosBundleIdentifier?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  iosGoogleServiceInfoPlist?: Maybe<Scalars['String']['output']>;
  /**
   * Returns true if the white label is currently being published to App Store or Play Store. While it's being published, it cannot be edited.
   *
   * Required permission: SuperUser
   */
  isPublishing?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Returns true if the white label is ready to be published to App Store and Play Store, using the 'publishWhiteLabel' mutation
   *
   * Required permission: SuperUser
   */
  isReadyForPublishing?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Returns true if the white label is set up correctly
   *
   * Required permission: SuperUser
   */
  isValid: Scalars['Boolean']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  restaurants?: Maybe<RestaurantPage>;
  /** Required permission: SuperUser */
  scheme?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** Required permission: SuperUser */
  shortUrlPrefix?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Theme>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Required permission: SuperUser */
  webFirebaseConfig?: Maybe<Scalars['JSONObject']['output']>;
};


export type WhiteLabelRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RestaurantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum WhiteLabelAccess {
  Write = 'Write'
}

export type WhiteLabelEdge = {
  __typename?: 'WhiteLabelEdge';
  cursor: Scalars['String']['output'];
  node: WhiteLabel;
};

export type WhiteLabelInput = {
  appName: Scalars['String']['input'];
};

export type WhiteLabelPage = {
  __typename?: 'WhiteLabelPage';
  edges: Array<WhiteLabelEdge>;
  pageInfo: PageInfo;
};

export type WhiteLabelPatch = {
  androidFeatureGraphicUrl?: InputMaybe<Scalars['URL']['input']>;
  androidGoogleServices?: InputMaybe<Scalars['JSONObject']['input']>;
  androidPackageName?: InputMaybe<Scalars['String']['input']>;
  appIconUrl?: InputMaybe<Scalars['URL']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appSplashUrl?: InputMaybe<Scalars['URL']['input']>;
  buildNumber?: InputMaybe<Scalars['Int']['input']>;
  deliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  easProjectId?: InputMaybe<Scalars['String']['input']>;
  expoSlug?: InputMaybe<Scalars['String']['input']>;
  googleMapsApiKey?: InputMaybe<Scalars['String']['input']>;
  iPadPro129Screenshots?: InputMaybe<Array<Scalars['URL']['input']>>;
  iPhone55Screenshots?: InputMaybe<Array<Scalars['URL']['input']>>;
  iPhone65Screenshots?: InputMaybe<Array<Scalars['URL']['input']>>;
  iosAppstoreId?: InputMaybe<Scalars['String']['input']>;
  iosBundleIdentifier?: InputMaybe<Scalars['String']['input']>;
  iosGoogleServiceInfoPlist?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortUrlPrefix?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<ThemePatch>;
  webFirebaseConfig?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type XReport = {
  __typename?: 'XReport';
  cashAmount?: Maybe<Scalars['Int53']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  net?: Maybe<XReportNet>;
};

export type XReportNet = {
  __typename?: 'XReportNet';
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
};

export type ZReport = {
  __typename?: 'ZReport';
  datePeriod?: Maybe<DateTimeRange>;
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  net?: Maybe<ZReportNet>;
  serialNumber?: Maybe<Scalars['Int']['output']>;
  sieVerification?: Maybe<SieVerification>;
};

export type ZReportEdge = {
  __typename?: 'ZReportEdge';
  cursor: Scalars['String']['output'];
  node: ZReport;
};

export type ZReportNet = {
  __typename?: 'ZReportNet';
  grossAmount?: Maybe<Scalars['Int53']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
};

export type ZReportPage = {
  __typename?: 'ZReportPage';
  edges: Array<ZReportEdge>;
  pageInfo: PageInfo;
};

export type RearrangeAddonProductsMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RearrangeAddonProductsMutation = { __typename?: 'Mutation', rearrangeMenuAddonProducts?: RearrangalStatus | null };

export type UpdateDiscountDisabledStatusMutationVariables = Exact<{
  metaOrganizationId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
  isDisabled: Scalars['Boolean']['input'];
}>;


export type UpdateDiscountDisabledStatusMutation = { __typename?: 'Mutation', updateDiscount?: { __typename?: 'Discount', id: string, isDisabled?: boolean | null } | null };

export type UpdateRestaurantDiscountDisabledStatusMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
  isDisabled: Scalars['Boolean']['input'];
}>;


export type UpdateRestaurantDiscountDisabledStatusMutation = { __typename?: 'Mutation', updateRestaurantDiscount?: { __typename?: 'Discount', id: string, isDisabled?: boolean | null } | null };

export type GenerateRestaurantOrderSalesBreakdownMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: RestaurantOrderSalesBreakdownInput;
}>;


export type GenerateRestaurantOrderSalesBreakdownMutation = { __typename?: 'Mutation', generateRestaurantOrderSalesBreakdown?: void | null };

export type CreateDeliveryCostAreaMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: DeliveryCostAreaInput;
}>;


export type CreateDeliveryCostAreaMutation = { __typename?: 'Mutation', createDeliveryCostArea?: { __typename?: 'Restaurant', id: string, deliveryCostAreas?: Array<{ __typename?: 'DeliveryCostArea', id: string, name?: string | null, geometry?: Array<{ __typename?: 'Coordinates', latitude: number, longitude: number }> | null, product?: { __typename?: 'MenuAddonProduct', id: string } | null }> | null } | null };

export type CreateDeliveryTimeAreaMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: DeliveryTimeAreaInput;
}>;


export type CreateDeliveryTimeAreaMutation = { __typename?: 'Mutation', createDeliveryTimeArea?: { __typename?: 'Restaurant', id: string, deliveryTimeAreas?: Array<{ __typename?: 'DeliveryTimeArea', id: string, name?: string | null, time?: string | null, geometry?: Array<{ __typename?: 'Coordinates', latitude: number, longitude: number }> | null }> | null } | null };

export type OrganizationPermissionsFragment = { __typename?: 'Organization', hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null };

export type RestaurantPermissionsFragment = { __typename?: 'Restaurant', hasOngoingControlUnitOutage?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDiscountWriteAccess?: boolean | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasOpeningHoursWriteAccess?: boolean | null, hasPosWriteAccess?: boolean | null, hasReportReadAccess?: boolean | null, hasReportWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, isOwner?: boolean | null };

export type RestaurantLayoutFieldsFragment = { __typename?: 'Restaurant', id: string, name?: string | null, hasOngoingControlUnitOutage?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDiscountWriteAccess?: boolean | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasOpeningHoursWriteAccess?: boolean | null, hasPosWriteAccess?: boolean | null, hasReportReadAccess?: boolean | null, hasReportWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, isOwner?: boolean | null, organization?: { __typename?: 'Organization', id: string, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasEnteredActivationCode?: boolean | null } | null };

export type OrganizationLayoutFieldsFragment = { __typename?: 'Organization', id: string, name?: string | null, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, hasOngoingControlUnitOutage?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDiscountWriteAccess?: boolean | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasOpeningHoursWriteAccess?: boolean | null, hasPosWriteAccess?: boolean | null, hasReportReadAccess?: boolean | null, hasReportWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, isOwner?: boolean | null, organization?: { __typename?: 'Organization', id: string, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasEnteredActivationCode?: boolean | null } | null }> | null };

export type GetLayoutInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  hasOrganizationId: Scalars['Boolean']['input'];
  restaurantId: Scalars['ID']['input'];
  hasRestaurantId: Scalars['Boolean']['input'];
  whiteLabelId: Scalars['ID']['input'];
  hasWhiteLabelId: Scalars['Boolean']['input'];
}>;


export type GetLayoutInfoQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, username?: string | null, isSuperUser?: boolean | null, organizationsWithAccess?: Array<{ __typename?: 'Organization', id: string, name?: string | null, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, hasOngoingControlUnitOutage?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDiscountWriteAccess?: boolean | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasOpeningHoursWriteAccess?: boolean | null, hasPosWriteAccess?: boolean | null, hasReportReadAccess?: boolean | null, hasReportWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, isOwner?: boolean | null, organization?: { __typename?: 'Organization', id: string, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasEnteredActivationCode?: boolean | null } | null }> | null }> | null, restaurantsWithAccess?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, hasOngoingControlUnitOutage?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDiscountWriteAccess?: boolean | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasOpeningHoursWriteAccess?: boolean | null, hasPosWriteAccess?: boolean | null, hasReportReadAccess?: boolean | null, hasReportWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, isOwner?: boolean | null, organization?: { __typename?: 'Organization', id: string, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasEnteredActivationCode?: boolean | null } | null }> | null, whiteLabelsWithAccess?: Array<{ __typename?: 'WhiteLabel', id: string, appName?: string | null, label: string }> | null } | null, organization?: { __typename?: 'Organization', id: string, name?: string | null, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, hasOngoingControlUnitOutage?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDiscountWriteAccess?: boolean | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasOpeningHoursWriteAccess?: boolean | null, hasPosWriteAccess?: boolean | null, hasReportReadAccess?: boolean | null, hasReportWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, isOwner?: boolean | null, organization?: { __typename?: 'Organization', id: string, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasEnteredActivationCode?: boolean | null } | null }> | null } | null, restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null, hasOngoingControlUnitOutage?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDiscountWriteAccess?: boolean | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasOpeningHoursWriteAccess?: boolean | null, hasPosWriteAccess?: boolean | null, hasReportReadAccess?: boolean | null, hasReportWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, isOwner?: boolean | null, cashregister?: { __typename?: 'Cashregister', id: string, isRegistered?: boolean | null, controlUnit?: { __typename?: 'ControlUnit', isRegistered?: boolean | null } | null } | null, organization?: { __typename?: 'Organization', id: string, name?: string | null, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, hasOngoingControlUnitOutage?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDiscountWriteAccess?: boolean | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasOpeningHoursWriteAccess?: boolean | null, hasPosWriteAccess?: boolean | null, hasReportReadAccess?: boolean | null, hasReportWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, isOwner?: boolean | null, organization?: { __typename?: 'Organization', id: string, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasEnteredActivationCode?: boolean | null } | null }> | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasEnteredActivationCode?: boolean | null } | null } | null, whiteLabel?: { __typename?: 'WhiteLabel', id: string, appName?: string | null, label: string } | null };

export type GetPrinterQueuesQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetPrinterQueuesQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null };

export type GetCoursesQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetCoursesQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', id: string, courses?: Array<{ __typename?: 'MenuCourse', id: string, name?: string | null }> | null } | null } | null };

export type EnterSudoModeMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type EnterSudoModeMutation = { __typename?: 'Mutation', enterSudoMode?: { __typename?: 'SudoModeTicket', id: string, expiresAt?: string | null } | null };

export type FullPhysicalControlUnitOutageReportFragment = { __typename?: 'PhysicalControlUnitOutageReport', id: string, link?: string | null, status?: PhysicalControlUnitOutageReportStatus | null };

export type GetPhysicalControlUnitOutageReportQueryVariables = Exact<{
  physicalControlUnitOutageReportId: Scalars['ID']['input'];
}>;


export type GetPhysicalControlUnitOutageReportQuery = { __typename?: 'Query', physicalControlUnitOutageReport?: { __typename?: 'PhysicalControlUnitOutageReport', id: string, link?: string | null, status?: PhysicalControlUnitOutageReportStatus | null } | null };

export type CreatePhysicalControlUnitOutageReportMutationVariables = Exact<{
  physicalControlUnitOutageId: Scalars['ID']['input'];
}>;


export type CreatePhysicalControlUnitOutageReportMutation = { __typename?: 'Mutation', createPhysicalControlUnitOutageReport?: { __typename?: 'PhysicalControlUnitOutageReport', id: string, link?: string | null, status?: PhysicalControlUnitOutageReportStatus | null } | null };

export type GetReceiptSummaryDataQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
}>;


export type GetReceiptSummaryDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null, timeZone?: string | null, order?: { __typename?: 'Order', id: string, createdAt?: string | null, pickedUpAt?: string | null, readyForPickupAt?: string | null, discountAmount?: number | null, grossAmount?: number | null, tipAmount?: number | null, deliveryHeroLongCode?: string | null, employeeName?: string | null, paymentProvider?: PaymentProvider | null, receiptViewKey?: string | null, status?: OrderStatus | null, transactionChannel?: TransactionChannel | null, userMessage?: string | null, items?: Array<{ __typename?: 'OrderItem', id: string, count?: number | null, totalAmount?: number | null, message?: string | null, alternatives?: Array<{ __typename?: 'OrderAlternative', id: string, count?: number | null, isChosen?: boolean | null, name?: string | null, totalAmount?: number | null, addonProduct?: { __typename?: 'OrderProduct', id: string, name?: string | null, properties?: { __typename?: 'OrderProductProperties', id: string, price?: number | null, stateId: string } | null } | null }> | null, product?: { __typename?: 'OrderProduct', id: string, name?: string | null } | null }> | null, paymentIntents?: Array<{ __typename?: 'PaymentIntent', id: string, tipAmount?: number | null, totalAmount: number, paymentMethod?: { __typename?: 'PaymentMethod', id: string, name?: string | null, receiptPaymentMethodLabel?: string | null } | null }> | null, receipt?: { __typename?: 'Receipt', id: string, humanOrderNumber?: number | null } | null, refundReceipts?: Array<{ __typename?: 'Receipt', id: string, humanOrderNumber?: number | null, refund?: boolean | null } | null> | null } | null } | null };

export type FullRestaurantControlUnitOutageReportFragment = { __typename?: 'RestaurantControlUnitOutageReport', id: string, csvLink?: string | null, sieLink?: string | null, status?: RestaurantControlUnitOutageReportStatus | null };

export type GetRestaurantControlUnitOutageReportQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  restaurantControlUnitOutageReportId: Scalars['ID']['input'];
}>;


export type GetRestaurantControlUnitOutageReportQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, controlUnitOutageReport?: { __typename?: 'RestaurantControlUnitOutageReport', id: string, csvLink?: string | null, sieLink?: string | null, status?: RestaurantControlUnitOutageReportStatus | null } | null } | null };

export type CreateRestaurantControlUnitOutageReportMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  restaurantControlUnitOutageId: Scalars['ID']['input'];
}>;


export type CreateRestaurantControlUnitOutageReportMutation = { __typename?: 'Mutation', createRestaurantControlUnitOutageReport?: { __typename?: 'RestaurantControlUnitOutageReport', id: string, csvLink?: string | null, sieLink?: string | null, status?: RestaurantControlUnitOutageReportStatus | null } | null };

export type CreateRestaurantDeliveryLocationShortUrlsMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  whiteLabelId: Scalars['ID']['input'];
}>;


export type CreateRestaurantDeliveryLocationShortUrlsMutation = { __typename?: 'Mutation', createRestaurantDeliveryLocationShortUrls?: Array<{ __typename?: 'RestaurantDeliveryLocationShortUrl', menuType?: MenuType | null, deliveryLocation?: { __typename?: 'ServingLocation', id: string, name?: string | null } | null, restaurant?: { __typename?: 'Restaurant', id: string } | null, shortUrl?: { __typename?: 'ShortUrl', smartLink?: boolean | null, target?: string | null, url?: string | null } | null, whiteLabel?: { __typename?: 'WhiteLabel', id: string, label: string } | null }> | null };

export type SetCategoryTemporarilyDisabledMutationVariables = Exact<{
  menuCategoryId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
  temporarilyDisabled: Scalars['Boolean']['input'];
}>;


export type SetCategoryTemporarilyDisabledMutation = { __typename?: 'Mutation', updateMenuCategory?: { __typename?: 'MenuCategory', id: string, temporarilyDisabled?: boolean | null } | null };

export type GetMenutypeToggleInfoQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetMenutypeToggleInfoQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, deliveryTemporarilyDisabled?: boolean | null, eatInTemporarilyDisabled?: boolean | null, takeAwayTemporarilyDisabled?: boolean | null, hasDeliveryMenu?: boolean | null, hasEatInMenu?: boolean | null, hasTakeAwayMenu?: boolean | null } | null };

export type SetMenuTypeTemporarilyDisabledMutationVariables = Exact<{
  disabled: Scalars['Boolean']['input'];
  menuType: MenuType;
  restaurantId: Scalars['ID']['input'];
}>;


export type SetMenuTypeTemporarilyDisabledMutation = { __typename?: 'Mutation', setMenuTypeTemporarilyDisabled?: TogglingStatus | null };

export type SetPageTemporarilyDisabledMutationVariables = Exact<{
  menuPageId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
  temporarilyDisabled: Scalars['Boolean']['input'];
}>;


export type SetPageTemporarilyDisabledMutation = { __typename?: 'Mutation', updateMenuPage?: { __typename?: 'MenuPage', id: string, temporarilyDisabled?: boolean | null } | null };

export type UpdateProductIsActiveMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuProductId: Scalars['ID']['input'];
  patch: MenuProductPatch;
}>;


export type UpdateProductIsActiveMutation = { __typename?: 'Mutation', updateMenuProduct?: { __typename?: 'MenuProduct', id: string } | null };

export type SetDeliveryTimeSlotDisabledMutationVariables = Exact<{
  deliveryTimeSlotId: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
  periodicityInput?: InputMaybe<PeriodicityInput>;
  restaurantId: Scalars['ID']['input'];
}>;


export type SetDeliveryTimeSlotDisabledMutation = { __typename?: 'Mutation', setDeliveryTimeSlotDisabled?: TogglingStatus | null };

export type CreateShortUrlMutationVariables = Exact<{
  whiteLabelId: Scalars['ID']['input'];
  input: ShortUrlInput;
}>;


export type CreateShortUrlMutation = { __typename?: 'Mutation', createShortUrl?: { __typename?: 'ShortUrl', smartLink?: boolean | null, target?: string | null, url?: string | null } | null };

export type DeleteWhiteLabelMutationVariables = Exact<{
  whiteLabelId: Scalars['ID']['input'];
}>;


export type DeleteWhiteLabelMutation = { __typename?: 'Mutation', deleteWhiteLabel?: void | null };

export type UpdateWhiteLabelMutationVariables = Exact<{
  whiteLabelId: Scalars['ID']['input'];
  patch: WhiteLabelPatch;
}>;


export type UpdateWhiteLabelMutation = { __typename?: 'Mutation', updateWhiteLabel?: { __typename?: 'WhiteLabel', id: string, label: string, createdAt?: string | null, updatedAt?: string | null, androidFeatureGraphicUrl?: string | null, androidGoogleServices?: {} | null, androidPackageName?: string | null, appIconUrl?: string | null, appName?: string | null, appSplashUrl?: string | null, buildNumber?: number | null, deliveryEnabled?: boolean | null, description?: string | null, googleMapsApiKey?: string | null, iosAppstoreId?: string | null, iosBundleIdentifier?: string | null, iosGoogleServiceInfoPlist?: string | null, isPublishing?: boolean | null, isReadyForPublishing?: boolean | null, iPadPro129Screenshots?: Array<string> | null, iPhone55Screenshots?: Array<string> | null, iPhone65Screenshots?: Array<string> | null, keywords?: string | null, scheme?: string | null, shortDescription?: string | null, shortUrlPrefix?: string | null, restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, name?: string | null, city?: string | null, hasEatInMenu?: boolean | null, hasDeliveryMenu?: boolean | null, hasTakeAwayMenu?: boolean | null, design?: { __typename?: 'Design', restaurantPreviewImage?: string | null } | null } }> } | null, theme?: { __typename?: 'Theme', backgroundColor: string, borderColor: string, cardColor: string, notificationColor: string, primaryColor: string, textColor: string, menuTypeSelectionTitleColor: string, menuTypeSelectionButtonBackgroundColor: string, menuTypeSelectionButtonBorderColor: string, menuTypeSelectionButtonTextColor: string, menuTypeSelectionBackgroundColor: string, menuTypeSelectionBackgroundImage?: string | null, drawerBackgroundColor: string, drawerListItemTitleColor: string, drawerListItemSubtitleColor: string, drawerListItemIconColor: string, drawerVersionTextColor: string, drawerLogoImage?: string | null, listMenuIconColor: string, listTextInputColor: string, listTextInputPlaceholderTextColor: string, listSearchIconColor: string, listClearIconColor: string, listEmptyListButtonBackgroundColor: string, listItemSeparatorColor: string, listTabBarActiveTextColor: string, listTabBarInactiveTextColor: string, listTabBarUnderlineColor: string, listItemBackgroundColor: string, listItemTextColor: string, listBackgroundColor: string, listBackgroundImage?: string | null } | null } | null };

export type PublishWhiteLabelMutationVariables = Exact<{
  whiteLabelId: Scalars['ID']['input'];
}>;


export type PublishWhiteLabelMutation = { __typename?: 'Mutation', publishWhiteLabel?: { __typename?: 'WhiteLabel', id: string, isPublishing?: boolean | null } | null };

export type FullPrinterQueueFragment = { __typename?: 'PrinterQueue', id: string, name?: string | null };

export type FullAddonProductFragment = { __typename?: 'MenuAddonProduct', id: string, isDeliveryCost?: boolean | null, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, description?: string | null, hasLegacyFormat?: boolean | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, stateId: string, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null };

export type GetAddonProductsQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetAddonProductsQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null, location?: { __typename?: 'Coordinates', latitude: number, longitude: number } | null, menu?: { __typename?: 'Menu', id: string, addonProducts?: Array<{ __typename?: 'MenuAddonProduct', id: string, isDeliveryCost?: boolean | null, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, description?: string | null, hasLegacyFormat?: boolean | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, stateId: string, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null }> | null, reportGroups?: Array<{ __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null }> | null } | null } | null };

export type EmployeeGroupFieldsFragment = { __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null };

export type EmployeeFieldsFragment = { __typename?: 'Employee', id: string, name?: string | null, pin?: string | null, groups?: Array<{ __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null }> | null };

export type GetEmployeesQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetEmployeesQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, employees?: Array<{ __typename?: 'Employee', id: string, name?: string | null, pin?: string | null, groups?: Array<{ __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null }> | null }> | null, employeeGroups?: Array<{ __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null }> | null } | null };

export type ProductOpeningHoursFragment = { __typename?: 'OpeningHours', id: string, name?: string | null, productVisibility?: ProductVisibility | null, displayHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, periods?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null };

export type GetMenuOpeningHoursQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetMenuOpeningHoursQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', productOpeningHours?: Array<{ __typename?: 'OpeningHours', id: string, name?: string | null, productVisibility?: ProductVisibility | null, displayHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, periods?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null }> | null } | null } | null };

export type MenuPageFieldsFragment = { __typename?: 'MenuPage', id: string, categoryCount?: number | null, name?: string | null, productCount?: number | null, temporarilyDisabled?: boolean | null };

export type GetMenuPagesQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetMenuPagesQuery = { __typename?: 'Query', me?: { __typename?: 'User', isSuperUser?: boolean | null } | null, restaurant?: { __typename?: 'Restaurant', id: string, clientHeaderMessage?: string | null, hasClientHeaderMessageAccess?: boolean | null, name?: string | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, menu?: { __typename?: 'Menu', id: string, pages?: Array<{ __typename?: 'MenuPage', id: string, categoryCount?: number | null, name?: string | null, productCount?: number | null, temporarilyDisabled?: boolean | null }> | null } | null } | null };

export type MenuProductPropertiesFieldsFragment = { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null };

export type MenuProductFieldsFragment = { __typename?: 'MenuProduct', id: string, name?: string | null, quantityAvailable?: number | null, defaultCourse?: { __typename?: 'MenuCourse', id: string, name?: string | null } | null, delivery?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, eatIn?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, takeAway?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null };

export type MenuCategoryFieldsFragment = { __typename?: 'MenuCategory', id: string, name?: string | null, temporarilyDisabled?: boolean | null, products?: Array<{ __typename?: 'MenuProduct', id: string, name?: string | null, quantityAvailable?: number | null, defaultCourse?: { __typename?: 'MenuCourse', id: string, name?: string | null } | null, delivery?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, eatIn?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, takeAway?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null }> | null };

export type GetPageMenuQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuPageId: Scalars['ID']['input'];
}>;


export type GetPageMenuQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menuSystem?: MenuSystem | null, name?: string | null, hasMenuStockWriteAccess?: boolean | null, hasMenuWriteAccess?: boolean | null, hasSettingsWriteAccess?: boolean | null, menu?: { __typename?: 'Menu', page?: { __typename?: 'MenuPage', id: string, name?: string | null, temporarilyDisabled?: boolean | null, categories?: Array<{ __typename?: 'MenuCategory', id: string, name?: string | null, temporarilyDisabled?: boolean | null, products?: Array<{ __typename?: 'MenuProduct', id: string, name?: string | null, quantityAvailable?: number | null, defaultCourse?: { __typename?: 'MenuCourse', id: string, name?: string | null } | null, delivery?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, eatIn?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, takeAway?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null }> | null }> | null } | null } | null } | null };

export type GetRestaurantOpeningHoursQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantOpeningHoursQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, openingHours?: { __typename?: 'OpeningHours', id: string, periods?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null } | null } | null };

export type FullPaymentMethodFragment = { __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null };

export type GetRestaurantPaymentMethodListDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantPaymentMethodListDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null }> | null } | null };

export type GetRestaurantSalesQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  dateTimeRange: DateTimeRangeInput;
  filter?: InputMaybe<RestaurantStatisticsFilter>;
  resolution: TimeResolution;
}>;


export type GetRestaurantSalesQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, statistics?: { __typename?: 'RestaurantStatistics', id: string, refundsByPaymentName?: Array<{ __typename?: 'RestaurantStatisticsRefundsByPaymentName', id: string, count?: number | null, grossAmount?: number | null, paymentName?: string | null, tipAmount?: number | null }> | null, refundsByProduct?: Array<{ __typename?: 'RestaurantStatisticsRefundsByProduct', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, name?: string | null, netAmount?: number | null, price?: number | null, productId?: string | null, vatAmount?: number | null, addons?: Array<{ __typename?: 'RestaurantStatisticsRefundsByProductAddon', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, name?: string | null, netAmount?: number | null, price?: number | null, productId?: string | null, vatAmount?: number | null }> | null, alternativeItems?: Array<{ __typename?: 'RestaurantStatisticsRefundsByProductAlternativeItem', id: string, count?: number | null, name?: string | null }> | null }> | null, salesByMenuType?: Array<{ __typename?: 'RestaurantStatisticsSalesByMenuType', id: string, count?: number | null, grossAmount?: number | null, menuType?: MenuType | null, vatAmount?: number | null }> | null, salesByMenuTypeAndTimePeriod?: Array<{ __typename?: 'RestaurantStatisticsSalesByMenuTypeAndTimePeriod', id: string, count?: number | null, grossAmount?: number | null, menuType?: MenuType | null, periodStart?: string | null }> | null, salesByPaymentName?: Array<{ __typename?: 'RestaurantStatisticsSalesByPaymentName', id: string, count?: number | null, grossAmount?: number | null, paymentName?: string | null, tipAmount?: number | null }> | null, salesByProduct?: Array<{ __typename?: 'RestaurantStatisticsSalesByProduct', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, name?: string | null, netAmount?: number | null, price?: number | null, productId?: string | null, vatAmount?: number | null, addons?: Array<{ __typename?: 'RestaurantStatisticsSalesByProductAddon', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, name?: string | null, netAmount?: number | null, price?: number | null, productId?: string | null, vatAmount?: number | null }> | null, alternativeItems?: Array<{ __typename?: 'RestaurantStatisticsSalesByProductAlternativeItem', id: string, count?: number | null, name?: string | null }> | null }> | null, salesByReportGroup?: Array<{ __typename?: 'RestaurantStatisticsSalesByReportGroup', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, netAmount?: number | null, reportGroupName?: string | null, vatAmount?: number | null }> | null } | null } | null };

export type GetRestaurantTimezoneQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantTimezoneQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, timeZone?: string | null } | null };

export type FullPosTerminalFragment = { __typename?: 'PosTerminal', id: string, description?: string | null, externalId?: string | null, isActive?: boolean | null, isOnline?: boolean | null, lastOnlineAt?: string | null, name?: string | null, paymentProvider?: PaymentProvider | null };

export type FullTillFragment = { __typename?: 'Till', id: string, fixedDeliveryTime?: FixedDeliveryTime | null, layout?: TillLayout | null, name?: string | null, preferredApiEnvironment?: ApiEnvironment | null, sendOrderToKitchen?: SendToKitchen | null, showsCategoryBar?: boolean | null, showsDiscountField?: boolean | null, showsEmptyShoppingCartButton?: boolean | null, showsHoldKitchenPrint?: boolean | null, showsLogo?: boolean | null, showsMenuType?: MenuTypeFilter | null, showsOpeningStatus?: boolean | null, showsOpenOrders?: boolean | null, showsSearch?: boolean | null, showsTip?: boolean | null, fixedDeliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, name?: string | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null }> | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string }> | null, receiptPrinterQueue?: { __typename?: 'PrinterQueue', id: string, name?: string | null } | null, skipSlipPrintOnPrinterQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null };

export type GetTillsQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetTillsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, isSuperUser?: boolean | null } | null, restaurant?: { __typename?: 'Restaurant', id: string, hasNetsConnectCloudLink?: boolean | null, hasSkipSlipPrintOnPrinterQueuesAccess?: boolean | null, isBetaTesting?: boolean | null, netsConnectCloudUsername?: string | null, orderDisplaySystemEnabled?: boolean | null, deliveryLocations?: Array<{ __typename?: 'DeliveryLocation', id: string, name?: string | null }> | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null }> | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string, description?: string | null, externalId?: string | null, isActive?: boolean | null, isOnline?: boolean | null, lastOnlineAt?: string | null, name?: string | null, paymentProvider?: PaymentProvider | null }> | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null, tills?: Array<{ __typename?: 'Till', id: string, fixedDeliveryTime?: FixedDeliveryTime | null, layout?: TillLayout | null, name?: string | null, preferredApiEnvironment?: ApiEnvironment | null, sendOrderToKitchen?: SendToKitchen | null, showsCategoryBar?: boolean | null, showsDiscountField?: boolean | null, showsEmptyShoppingCartButton?: boolean | null, showsHoldKitchenPrint?: boolean | null, showsLogo?: boolean | null, showsMenuType?: MenuTypeFilter | null, showsOpeningStatus?: boolean | null, showsOpenOrders?: boolean | null, showsSearch?: boolean | null, showsTip?: boolean | null, fixedDeliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, name?: string | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null }> | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string }> | null, receiptPrinterQueue?: { __typename?: 'PrinterQueue', id: string, name?: string | null } | null, skipSlipPrintOnPrinterQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null }> | null } | null };

export type DeliveryTimeSlotFragment = { __typename?: 'DeliveryTimeSlot', id: string, deadline?: string | null, disabled?: boolean | null, label?: string | null, value?: string | null };

export type GetTimeSlotsQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
}>;


export type GetTimeSlotsQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, hasDeliveryMenu?: boolean | null, hasEatInMenu?: boolean | null, hasTakeAwayMenu?: boolean | null, maxDeliveryTime?: string | null, queueTime?: string | null, deliveryDeliveryTimeSlots?: Array<{ __typename?: 'DeliveryTimeSlot', id: string, deadline?: string | null, disabled?: boolean | null, label?: string | null, value?: string | null }> | null, eatInDeliveryTimeSlots?: Array<{ __typename?: 'DeliveryTimeSlot', id: string, deadline?: string | null, disabled?: boolean | null, label?: string | null, value?: string | null }> | null, takeAwayDeliveryTimeSlots?: Array<{ __typename?: 'DeliveryTimeSlot', id: string, deadline?: string | null, disabled?: boolean | null, label?: string | null, value?: string | null }> | null } | null };

export type GetAccountDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountDataQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, username?: string | null, restaurantsWithAccess?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null }> | null } | null, sudoMode?: { __typename?: 'SudoModeTicket', id: string, expiresAt?: string | null } | null };

export type ListCashregisterReportsQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListCashregisterReportsQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, nextCashregisterReportGenerationTime?: string | null, timeZone?: string | null, xReport?: { __typename?: 'XReport', net?: { __typename?: 'XReportNet', grossAmount?: number | null, transactionCount?: number | null } | null } | null, zReports?: { __typename?: 'ZReportPage', edges: Array<{ __typename?: 'ZReportEdge', cursor: string, node: { __typename?: 'ZReport', id: string, serialNumber?: number | null, datePeriod?: { __typename?: 'DateTimeRange', start?: string | null, end?: string | null } | null, net?: { __typename?: 'ZReportNet', grossAmount?: number | null, transactionCount?: number | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null };

export type ScheduleCashregisterReportGenerationMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  at?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ScheduleCashregisterReportGenerationMutation = { __typename?: 'Mutation', scheduleCashregisterReportGeneration?: { __typename?: 'Restaurant', id: string, nextCashregisterReportGenerationTime?: string | null } | null };

export type CreateCashregisterReportMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type CreateCashregisterReportMutation = { __typename?: 'Mutation', createCashregisterReport?: { __typename?: 'ZReport', id: string } | null };

export type GetXReportHtmlQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetXReportHtmlQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, xReport?: { __typename?: 'XReport', id: string, html?: string | null } | null } | null };

export type GetZReportHtmlQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type GetZReportHtmlQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, zReport?: { __typename?: 'ZReport', id: string, html?: string | null } | null } | null };

export type GetCashregisterQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetCashregisterQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, hasReportReadAccess?: boolean | null, cashregister?: { __typename?: 'Cashregister', id: string, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, name?: string | null, softwareName?: string | null, softwareVersion?: string | null, controlUnit?: { __typename?: 'ControlUnit', address?: string | null, identificationNumber?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, productionNumber?: string | null, serialNumber?: string | null } | null } | null } | null };

export type FullPhysicalControlUnitOutageFragment = { __typename?: 'PhysicalControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null, cashregisters?: Array<{ __typename?: 'Cashregister', id: string }> | null };

export type FullPhysicalControlUnitFragment = { __typename?: 'PhysicalControlUnit', id: string, address?: string | null, createdAt?: string | null, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, updatedAt?: string | null, outages?: { __typename?: 'PhysicalControlUnitOutagePage', edges: Array<{ __typename?: 'PhysicalControlUnitOutageEdge', node: { __typename?: 'PhysicalControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null, cashregisters?: Array<{ __typename?: 'Cashregister', id: string }> | null } }> } | null };

export type GetControlUnitListDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetControlUnitListDataQuery = { __typename?: 'Query', physicalControlUnits?: { __typename?: 'PhysicalControlUnitPage', edges: Array<{ __typename?: 'PhysicalControlUnitEdge', node: { __typename?: 'PhysicalControlUnit', id: string, address?: string | null, createdAt?: string | null, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, updatedAt?: string | null, outages?: { __typename?: 'PhysicalControlUnitOutagePage', edges: Array<{ __typename?: 'PhysicalControlUnitOutageEdge', node: { __typename?: 'PhysicalControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null, cashregisters?: Array<{ __typename?: 'Cashregister', id: string }> | null } }> } | null } }> } | null };

export type GetControlUnitViewDataQueryVariables = Exact<{
  controlUnitId: Scalars['ID']['input'];
}>;


export type GetControlUnitViewDataQuery = { __typename?: 'Query', physicalControlUnit?: { __typename?: 'PhysicalControlUnit', id: string, address?: string | null, createdAt?: string | null, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, updatedAt?: string | null, outages?: { __typename?: 'PhysicalControlUnitOutagePage', edges: Array<{ __typename?: 'PhysicalControlUnitOutageEdge', node: { __typename?: 'PhysicalControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null } }> } | null } | null };

export type CreatePhysicalControlUnitOutageMutationVariables = Exact<{
  physicalControlUnitId: Scalars['ID']['input'];
}>;


export type CreatePhysicalControlUnitOutageMutation = { __typename?: 'Mutation', createPhysicalControlUnitOutage?: { __typename?: 'PhysicalControlUnitOutage', id: string } | null };

export type RestorePhysicalControlUnitOutageMutationVariables = Exact<{
  controlUnitOutageId: Scalars['ID']['input'];
}>;


export type RestorePhysicalControlUnitOutageMutation = { __typename?: 'Mutation', restorePhysicalControlUnitOutage?: { __typename?: 'PhysicalControlUnitOutage', id: string, restoredAt?: string | null } | null };

export type AcceptDeliveryHeroIntegrationTermsOfServiceMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: AcceptDeliveryHeroIntegrationTermsOfServiceInput;
}>;


export type AcceptDeliveryHeroIntegrationTermsOfServiceMutation = { __typename?: 'Mutation', acceptDeliveryHeroIntegrationTermsOfService?: { __typename?: 'Restaurant', id: string, hasDeliveryHeroAccess?: boolean | null, deliveryHeroSetupQuestionnaire?: { __typename?: 'DeliveryHeroSetupQuestionnaire', hasAccount?: boolean | null, isReceivingOrders?: boolean | null } | null } | null };

export type EnableDeliveryHeroIntegrationMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type EnableDeliveryHeroIntegrationMutation = { __typename?: 'Mutation', enableDeliveryHeroIntegration?: { __typename?: 'Restaurant', id: string, deliveryHeroEnabled?: boolean | null, hasDeliveryHeroAccess?: boolean | null } | null };

export type UpdateDeliveryHeroIntegrationSettingsMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: UpdateDeliveryHeroIntegrationSettingsInput;
}>;


export type UpdateDeliveryHeroIntegrationSettingsMutation = { __typename?: 'Mutation', updateDeliveryHeroIntegrationSettings?: { __typename?: 'Restaurant', id: string, autoAcceptDeliveryHeroOrders?: boolean | null } | null };

export type GetDeliveryDeliveryHeroEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetDeliveryDeliveryHeroEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, autoAcceptDeliveryHeroOrders?: boolean | null, deliveryHeroChainId?: string | null, deliveryHeroVendorId?: string | null, deliveryHeroEnabled?: boolean | null, hasDeliveryHeroAccess?: boolean | null, hasDeliveryHeroCredentials?: boolean | null, deliveryHeroSetupQuestionnaire?: { __typename?: 'DeliveryHeroSetupQuestionnaire', hasAccount?: boolean | null, isReceivingOrders?: boolean | null } | null } | null };

export type GetDeliveryHeroRestaurantIntegrationDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetDeliveryHeroRestaurantIntegrationDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null } | null };

export type ConnectDeliveryHeroIntegrationMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  accessToken: Scalars['String']['input'];
  input: ConnectDeliveryHeroIntegrationInput;
}>;


export type ConnectDeliveryHeroIntegrationMutation = { __typename?: 'Mutation', connectDeliveryHeroIntegration?: { __typename?: 'Restaurant', id: string, name?: string | null } | null };

export type CreateDeliveryLocationMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: DeliveryLocationInput;
}>;


export type CreateDeliveryLocationMutation = { __typename?: 'Mutation', createDeliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, eatInEnabled?: boolean | null, name?: string | null, takeAwayEnabled?: boolean | null, type?: DeliveryLocationType | null } | null };

export type GetDeliveryLocationQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  deliveryLocationId: Scalars['ID']['input'];
}>;


export type GetDeliveryLocationQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, deliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, eatInEnabled?: boolean | null, name?: string | null, takeAwayEnabled?: boolean | null, type?: DeliveryLocationType | null } | null } | null };

export type DeleteDeliveryLocationMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  deliveryLocationId: Scalars['ID']['input'];
}>;


export type DeleteDeliveryLocationMutation = { __typename?: 'Mutation', deleteDeliveryLocation?: DeletionStatus | null };

export type UpdateDeliveryLocationMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  deliveryLocationId: Scalars['ID']['input'];
  patch: DeliveryLocationPatch;
}>;


export type UpdateDeliveryLocationMutation = { __typename?: 'Mutation', updateDeliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, eatInEnabled?: boolean | null, name?: string | null, takeAwayEnabled?: boolean | null, type?: DeliveryLocationType | null } | null };

export type DeliveryLocationFieldsFragment = { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, eatInEnabled?: boolean | null, name?: string | null, takeAwayEnabled?: boolean | null, type?: DeliveryLocationType | null };

export type ListDeliveryLocationsQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type ListDeliveryLocationsQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, deliveryLocations?: Array<{ __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, eatInEnabled?: boolean | null, name?: string | null, takeAwayEnabled?: boolean | null, type?: DeliveryLocationType | null }> | null } | null };

export type SetDeliveryLocationDisabledMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  deliveryLocationId: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
}>;


export type SetDeliveryLocationDisabledMutation = { __typename?: 'Mutation', updateDeliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, eatInEnabled?: boolean | null, name?: string | null, takeAwayEnabled?: boolean | null, type?: DeliveryLocationType | null } | null };

export type FullDeliveryCostAreaFragment = { __typename?: 'DeliveryCostArea', id: string, name?: string | null, geometry?: Array<{ __typename?: 'Coordinates', latitude: number, longitude: number }> | null, product?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', price?: number | null } | null } | null };

export type FullDeliveryTimeAreaFragment = { __typename?: 'DeliveryTimeArea', id: string, name?: string | null, time?: string | null, geometry?: Array<{ __typename?: 'Coordinates', latitude: number, longitude: number }> | null };

export type GetDeliveryLocoEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetDeliveryLocoEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, extraDeliveryTime?: string | null, hasDeliveryMenu?: boolean | null, name?: string | null, deliveryCostAreas?: Array<{ __typename?: 'DeliveryCostArea', id: string, name?: string | null, geometry?: Array<{ __typename?: 'Coordinates', latitude: number, longitude: number }> | null, product?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', price?: number | null } | null } | null }> | null, deliveryTimeAreas?: Array<{ __typename?: 'DeliveryTimeArea', id: string, name?: string | null, time?: string | null, geometry?: Array<{ __typename?: 'Coordinates', latitude: number, longitude: number }> | null }> | null, location?: { __typename?: 'Coordinates', latitude: number, longitude: number } | null, menu?: { __typename?: 'Menu', id: string, addonProducts?: Array<{ __typename?: 'MenuAddonProduct', id: string, isDeliveryCost?: boolean | null, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, hasLegacyFormat?: boolean | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, stateId: string, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null }> | null, reportGroups?: Array<{ __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null }> | null } | null } | null };

export type DeleteDeliveryCostAreaMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  deliveryCostAreaId: Scalars['ID']['input'];
}>;


export type DeleteDeliveryCostAreaMutation = { __typename?: 'Mutation', deleteDeliveryCostArea?: { __typename?: 'Restaurant', id: string, deliveryCostAreas?: Array<{ __typename?: 'DeliveryCostArea', id: string }> | null } | null };

export type DeleteDeliveryTimeAreaMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  deliveryTimeAreaId: Scalars['ID']['input'];
}>;


export type DeleteDeliveryTimeAreaMutation = { __typename?: 'Mutation', deleteDeliveryTimeArea?: { __typename?: 'Restaurant', id: string, deliveryTimeAreas?: Array<{ __typename?: 'DeliveryTimeArea', id: string }> | null } | null };

export type UpdateDeliveryLocoEditMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  patch: RestaurantPatch;
}>;


export type UpdateDeliveryLocoEditMutation = { __typename?: 'Mutation', updateRestaurant?: { __typename?: 'Restaurant', id: string, extraDeliveryTime?: string | null } | null };

export type UpdateDeliveryLocoEnabledMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  hasDeliveryMenu: Scalars['Boolean']['input'];
}>;


export type UpdateDeliveryLocoEnabledMutation = { __typename?: 'Mutation', updateRestaurant?: { __typename?: 'Restaurant', id: string, hasDeliveryMenu?: boolean | null } | null };

export type GetUserSettingsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingsInfoQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, username?: string | null } | null, sudoMode?: { __typename?: 'SudoModeTicket', id: string, expiresAt?: string | null } | null };

export type ChangeUserEmailRequestMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  email: Scalars['EmailAddress']['input'];
}>;


export type ChangeUserEmailRequestMutation = { __typename?: 'Mutation', requestChangeUserEmail?: { __typename?: 'ChangeUserEmailRequest', id: string } | null };

export type ChangeUserEmailConfirmMutationVariables = Exact<{
  requestId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type ChangeUserEmailConfirmMutation = { __typename?: 'Mutation', confirmChangeUserEmail?: { __typename?: 'User', id: string } | null };

export type LinkFortnoxAccountingImportAccountMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  credentials: FortnoxAccountingImportCredentials;
}>;


export type LinkFortnoxAccountingImportAccountMutation = { __typename?: 'Mutation', linkFortnoxAccountingImportAccount?: { __typename?: 'Organization', id: string, hasFortnoxAccountingImportCredentials?: boolean | null } | null };

export type CreateAccessTokenMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type CreateAccessTokenMutation = { __typename?: 'Mutation', createAccessToken?: { __typename?: 'AccessToken', parseToken?: string | null } | null };

export type SendMarketingPushNotificationMutationVariables = Exact<{
  whiteLabelId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type SendMarketingPushNotificationMutation = { __typename?: 'Mutation', sendMarketingPushNotification?: { __typename?: 'MarketingPushNotification', id: string, userCount?: number | null } | null };

export type GetCreateAddonProductDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetCreateAddonProductDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', addonProducts?: Array<{ __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, stateId: string, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null }> | null, reportGroups?: Array<{ __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null }> | null } | null } | null };

export type CreateMenuAddonProductMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: MenuAddonProductInput;
}>;


export type CreateMenuAddonProductMutation = { __typename?: 'Mutation', createMenuAddonProduct?: { __typename?: 'MenuAddonProduct', id: string } | null };

export type DeleteMenuAddonProductMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuAddonProductId: Scalars['ID']['input'];
}>;


export type DeleteMenuAddonProductMutation = { __typename?: 'Mutation', deleteMenuAddonProduct?: DeletionStatus | null };

export type GetEditAddonProductDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuAddonProductId: Scalars['ID']['input'];
}>;


export type GetEditAddonProductDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', addonProduct?: { __typename?: 'MenuAddonProduct', id: string, isDeliveryCost?: boolean | null, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, stateId: string, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null } | null, reportGroups?: Array<{ __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null }> | null } | null } | null };

export type UpdateMenuAddonProductMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuAddonProductId: Scalars['ID']['input'];
  patch: MenuAddonProductPatch;
}>;


export type UpdateMenuAddonProductMutation = { __typename?: 'Mutation', updateMenuAddonProduct?: { __typename?: 'MenuAddonProduct', id: string } | null };

export type CreateAlternativeGroupMutationVariables = Exact<{
  input: MenuAlternativeGroupInput;
  restaurantId: Scalars['ID']['input'];
}>;


export type CreateAlternativeGroupMutation = { __typename?: 'Mutation', createMenuAlternativeGroup?: { __typename?: 'MenuAlternativeGroup', id: string } | null };

export type FullMenuAlternativeGroupFragment = { __typename?: 'MenuAlternativeGroup', id: string, forceChoice?: boolean | null, isCountable?: boolean | null, maxChoices?: number | null, minChoices?: number | null, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', countableUsage?: number | null, isDefault?: boolean | null, name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, stateId: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null } | null }> | null };

export type GetEditAlternativeGroupDataQueryVariables = Exact<{
  menuAlternativeGroupId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
}>;


export type GetEditAlternativeGroupDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', id: string, alternativeGroup?: { __typename?: 'MenuAlternativeGroup', id: string, forceChoice?: boolean | null, isCountable?: boolean | null, maxChoices?: number | null, minChoices?: number | null, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', countableUsage?: number | null, isDefault?: boolean | null, name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, stateId: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null } | null }> | null } | null } | null } | null };

export type DeleteAlternativeGroupMutationVariables = Exact<{
  menuAlternativeGroupId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
}>;


export type DeleteAlternativeGroupMutation = { __typename?: 'Mutation', deleteMenuAlternativeGroup?: DeletionStatus | null };

export type UpdateAlternativeGroupMutationVariables = Exact<{
  menuAlternativeGroupId: Scalars['ID']['input'];
  patch: MenuAlternativeGroupPatch;
  restaurantId: Scalars['ID']['input'];
}>;


export type UpdateAlternativeGroupMutation = { __typename?: 'Mutation', updateMenuAlternativeGroup?: { __typename?: 'MenuAlternativeGroup', id: string, forceChoice?: boolean | null, isCountable?: boolean | null, maxChoices?: number | null, minChoices?: number | null, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', countableUsage?: number | null, isDefault?: boolean | null, name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, stateId: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null } | null }> | null } | null };

export type FullAlternativeItemFragment = { __typename?: 'MenuAlternativeItem', countableUsage?: number | null, isDefault?: boolean | null, name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, stateId: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null } | null };

export type FullAlternativeGroupFragment = { __typename?: 'MenuAlternativeGroup', id: string, forceChoice?: boolean | null, isCountable?: boolean | null, maxChoices?: number | null, minChoices?: number | null, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', countableUsage?: number | null, isDefault?: boolean | null, name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, stateId: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null } | null }> | null };

export type GetMenuAlternativeGroupListDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetMenuAlternativeGroupListDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null, location?: { __typename?: 'Coordinates', latitude: number, longitude: number } | null, menu?: { __typename?: 'Menu', id: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, forceChoice?: boolean | null, isCountable?: boolean | null, maxChoices?: number | null, minChoices?: number | null, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', countableUsage?: number | null, isDefault?: boolean | null, name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, stateId: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null } | null }> | null }> | null, addonProducts?: Array<{ __typename?: 'MenuAddonProduct', id: string, isDeliveryCost?: boolean | null, name?: string | null, properties?: { __typename?: 'MenuAddonProductProperties', id: string, description?: string | null, hasLegacyFormat?: boolean | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, stateId: string, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null } | null }> | null, reportGroups?: Array<{ __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null }> | null } | null } | null };

export type RearrangeMenuAlternativeGroupsMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RearrangeMenuAlternativeGroupsMutation = { __typename?: 'Mutation', rearrangeMenuAlternativeGroups?: RearrangalStatus | null };

export type GetCreateMenuCategoryDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetCreateMenuCategoryDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', pages?: Array<{ __typename?: 'MenuPage', id: string, name?: string | null }> | null } | null } | null };

export type CreateMenuCategoryMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuPageId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateMenuCategoryMutation = { __typename?: 'Mutation', createMenuCategory?: { __typename?: 'MenuCategory', id: string } | null };

export type GetMenuCategoryEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCategoryId: Scalars['ID']['input'];
}>;


export type GetMenuCategoryEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', pages?: Array<{ __typename?: 'MenuPage', id: string, name?: string | null }> | null, category?: { __typename?: 'MenuCategory', id: string, name?: string | null, page?: { __typename?: 'MenuPage', id: string, name?: string | null } | null, products?: Array<{ __typename?: 'MenuProduct', id: string }> | null } | null } | null } | null };

export type UpdateMenuCategoryMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCategoryId: Scalars['ID']['input'];
  menuPageId: Scalars['ID']['input'];
  fromMenuPageId: Scalars['ID']['input'];
  patch: MenuCategoryPatch;
}>;


export type UpdateMenuCategoryMutation = { __typename?: 'Mutation', relocateMenuCategory?: RelocationStatus | null, updateMenuCategory?: { __typename?: 'MenuCategory', id: string } | null };

export type DeleteMenuCategoryMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCategoryId: Scalars['ID']['input'];
  recursive: Scalars['Boolean']['input'];
}>;


export type DeleteMenuCategoryMutation = { __typename?: 'Mutation', deleteMenuCategory?: DeletionStatus | null };

export type CreateMenuCourseMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: MenuCourseInput;
}>;


export type CreateMenuCourseMutation = { __typename?: 'Mutation', createMenuCourse?: { __typename?: 'MenuCourse', id: string } | null };

export type FullMenuCourseFragment = { __typename?: 'MenuCourse', id: string, name?: string | null };

export type UpdateMenuCourseMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCourseId: Scalars['ID']['input'];
  patch: MenuCoursePatch;
}>;


export type UpdateMenuCourseMutation = { __typename?: 'Mutation', updateMenuCourse?: { __typename?: 'MenuCourse', id: string, name?: string | null } | null };

export type DeleteMenuCourseMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCourseId: Scalars['ID']['input'];
}>;


export type DeleteMenuCourseMutation = { __typename?: 'Mutation', deleteMenuCourse?: void | null };

export type GetMenuCourseQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCourseId: Scalars['ID']['input'];
}>;


export type GetMenuCourseQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', course?: { __typename?: 'MenuCourse', id: string, name?: string | null } | null } | null } | null };

export type GetMenuCourseListQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetMenuCourseListQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', courses?: Array<{ __typename?: 'MenuCourse', id: string, name?: string | null }> | null } | null } | null };

export type RearrangeMenuCoursesMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RearrangeMenuCoursesMutation = { __typename?: 'Mutation', rearrangeMenuCourses?: void | null };

export type CreateOpeningHoursMutationVariables = Exact<{
  input: OpeningHoursInput;
  restaurantId: Scalars['ID']['input'];
}>;


export type CreateOpeningHoursMutation = { __typename?: 'Mutation', createOpeningHours?: { __typename?: 'OpeningHours', id: string, name?: string | null, productVisibility?: ProductVisibility | null, displayHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, periods?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null } | null };

export type UpdateOpeningHoursMutationVariables = Exact<{
  openingHoursId: Scalars['ID']['input'];
  patch: OpeningHoursPatch;
  restaurantId: Scalars['ID']['input'];
}>;


export type UpdateOpeningHoursMutation = { __typename?: 'Mutation', updateOpeningHours?: { __typename?: 'OpeningHours', id: string, name?: string | null, productVisibility?: ProductVisibility | null, displayHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, periods?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null } | null };

export type CreateMenuPageMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: MenuPageInput;
}>;


export type CreateMenuPageMutation = { __typename?: 'Mutation', createMenuPage?: { __typename?: 'MenuPage', id: string } | null };

export type GetEditPageDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuPageId: Scalars['ID']['input'];
}>;


export type GetEditPageDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', page?: { __typename?: 'MenuPage', id: string, name?: string | null, categories?: Array<{ __typename?: 'MenuCategory', id: string }> | null } | null } | null } | null };

export type UpdateMenuPageMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuPageId: Scalars['ID']['input'];
  patch: MenuPagePatch;
}>;


export type UpdateMenuPageMutation = { __typename?: 'Mutation', updateMenuPage?: { __typename?: 'MenuPage', id: string } | null };

export type DeleteMenuPageMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuPageId: Scalars['ID']['input'];
}>;


export type DeleteMenuPageMutation = { __typename?: 'Mutation', deleteMenuPage?: DeletionStatus | null };

export type RearrangeMenuCategoriesMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuPageId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RearrangeMenuCategoriesMutation = { __typename?: 'Mutation', rearrangeMenuCategories?: RearrangalStatus | null };

export type RearrangeMenuProductsMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCategoryId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RearrangeMenuProductsMutation = { __typename?: 'Mutation', rearrangeMenuProducts?: RearrangalStatus | null };

export type MenuProductVariantDefaultFieldsFragment = { __typename?: 'MenuProductVariantDefaultValues', id: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string }> | null, openingHours?: { __typename?: 'OpeningHours', id: string } | null, printAt?: Array<{ __typename?: 'Printer', id: string }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string }> | null };

export type MenuProductDefaultValuesFragment = { __typename?: 'MenuProductDefaultValues', id: string, defaultCourse?: { __typename?: 'MenuCourse', id: string } | null, delivery?: { __typename?: 'MenuProductVariantDefaultValues', id: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string }> | null, openingHours?: { __typename?: 'OpeningHours', id: string } | null, printAt?: Array<{ __typename?: 'Printer', id: string }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string }> | null } | null, eatIn?: { __typename?: 'MenuProductVariantDefaultValues', id: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string }> | null, openingHours?: { __typename?: 'OpeningHours', id: string } | null, printAt?: Array<{ __typename?: 'Printer', id: string }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string }> | null } | null, takeAway?: { __typename?: 'MenuProductVariantDefaultValues', id: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string }> | null, openingHours?: { __typename?: 'OpeningHours', id: string } | null, printAt?: Array<{ __typename?: 'Printer', id: string }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string }> | null } | null };

export type GetCreateProductDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCategoryId: Scalars['ID']['input'];
}>;


export type GetCreateProductDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menuSystem?: MenuSystem | null, hasMenuWriteAccess?: boolean | null, menu?: { __typename?: 'Menu', pages?: Array<{ __typename?: 'MenuPage', id: string, name?: string | null, categories?: Array<{ __typename?: 'MenuCategory', id: string, name?: string | null }> | null }> | null, courses?: Array<{ __typename?: 'MenuCourse', id: string, name?: string | null }> | null, productOpeningHours?: Array<{ __typename?: 'OpeningHours', id: string, name?: string | null }> | null, reportGroups?: Array<{ __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null }> | null, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null }> | null, category?: { __typename?: 'MenuCategory', id: string, name?: string | null, newProductDefaultValues?: { __typename?: 'MenuProductDefaultValues', id: string, defaultCourse?: { __typename?: 'MenuCourse', id: string } | null, delivery?: { __typename?: 'MenuProductVariantDefaultValues', id: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string }> | null, openingHours?: { __typename?: 'OpeningHours', id: string } | null, printAt?: Array<{ __typename?: 'Printer', id: string }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string }> | null } | null, eatIn?: { __typename?: 'MenuProductVariantDefaultValues', id: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string }> | null, openingHours?: { __typename?: 'OpeningHours', id: string } | null, printAt?: Array<{ __typename?: 'Printer', id: string }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string }> | null } | null, takeAway?: { __typename?: 'MenuProductVariantDefaultValues', id: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string }> | null, openingHours?: { __typename?: 'OpeningHours', id: string } | null, printAt?: Array<{ __typename?: 'Printer', id: string }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string }> | null } | null } | null, page?: { __typename?: 'MenuPage', id: string } | null } | null } | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null };

export type CreateMenuProductMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuCategoryId: Scalars['ID']['input'];
  input: MenuProductInput;
}>;


export type CreateMenuProductMutation = { __typename?: 'Mutation', createMenuProduct?: { __typename?: 'MenuProduct', id: string, category?: { __typename?: 'MenuCategory', id: string, page?: { __typename?: 'MenuPage', id: string, productCount?: number | null } | null } | null } | null };

export type GetEditProductDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuProductId: Scalars['ID']['input'];
}>;


export type GetEditProductDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menuSystem?: MenuSystem | null, hasMenuWriteAccess?: boolean | null, menu?: { __typename?: 'Menu', pages?: Array<{ __typename?: 'MenuPage', id: string, name?: string | null, categories?: Array<{ __typename?: 'MenuCategory', id: string, name?: string | null }> | null }> | null, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null }> | null, courses?: Array<{ __typename?: 'MenuCourse', id: string, name?: string | null }> | null, productOpeningHours?: Array<{ __typename?: 'OpeningHours', id: string, name?: string | null }> | null, product?: { __typename?: 'MenuProduct', id: string, name?: string | null, quantityAvailable?: number | null, category?: { __typename?: 'MenuCategory', id: string, name?: string | null, page?: { __typename?: 'MenuPage', id: string, name?: string | null } | null } | null, defaultCourse?: { __typename?: 'MenuCourse', id: string, name?: string | null } | null, delivery?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, eatIn?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, takeAway?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null } | null, reportGroups?: Array<{ __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null }> | null } | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null };

export type UpdateAndRelocateMenuProductMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuProductId: Scalars['ID']['input'];
  patch: MenuProductPatch;
  menuCategoryId: Scalars['ID']['input'];
  fromMenuCategoryId: Scalars['ID']['input'];
}>;


export type UpdateAndRelocateMenuProductMutation = { __typename?: 'Mutation', relocateMenuProduct?: RelocationStatus | null, updateMenuProduct?: { __typename?: 'MenuProduct', id: string } | null };

export type UpdateMenuProductStockMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuProductId: Scalars['ID']['input'];
  patch: MenuProductPatch;
}>;


export type UpdateMenuProductStockMutation = { __typename?: 'Mutation', updateMenuProduct?: { __typename?: 'MenuProduct', id: string } | null };

export type DeleteMenuProductMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuProductId: Scalars['ID']['input'];
}>;


export type DeleteMenuProductMutation = { __typename?: 'Mutation', deleteMenuProduct?: DeletionStatus | null };

export type RearrangeMenuPagesMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RearrangeMenuPagesMutation = { __typename?: 'Mutation', rearrangeMenuPages?: RearrangalStatus | null };

export type ImportMenuCsvDataMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  csvData: Scalars['String']['input'];
}>;


export type ImportMenuCsvDataMutation = { __typename?: 'Mutation', importMenuFromCsv?: void | null };

export type UpdateClientHeaderMessageMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  clientHeaderMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateClientHeaderMessageMutation = { __typename?: 'Mutation', updateRestaurant?: { __typename?: 'Restaurant', id: string, clientHeaderMessage?: string | null } | null };

export type GetMenuCsvDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetMenuCsvDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', menu?: { __typename?: 'Menu', csvData?: string | null } | null } | null };

export type CreateDiscountMutationVariables = Exact<{
  metaOrganizationId: Scalars['ID']['input'];
  input: DiscountInput;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount?: { __typename?: 'Discount', id: string } | null };

export type GetDiscountQueryVariables = Exact<{
  metaOrganizationId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
}>;


export type GetDiscountQuery = { __typename?: 'Query', metaOrganization?: { __typename?: 'MetaOrganization', id: string, name?: string | null, createdAt?: string | null, updatedAt?: string | null, discount?: { __typename?: 'Discount', id: string, code?: string | null, createdAt?: string | null, description?: string | null, discountAmount?: number | null, discountLimit?: number | null, discountPercentage?: number | null, isDisabled?: boolean | null, maxAmount?: number | null, menuType?: MenuType | null, minAmount?: number | null, numberOfTimesPerUser?: number | null, title?: string | null, totalDiscountAmount?: number | null, updatedAt?: string | null, usability?: DiscountUsability | null, validFrom?: string | null, validUntil?: string | null, metaOrganization?: { __typename?: 'MetaOrganization', id: string } | null, openingHours?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null, restaurant?: { __typename?: 'Restaurant', id: string } | null } | null } | null };

export type DeleteDiscountMutationVariables = Exact<{
  metaOrganizationId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
}>;


export type DeleteDiscountMutation = { __typename?: 'Mutation', deleteDiscount?: DeletionStatus | null };

export type UpdateDiscountMutationVariables = Exact<{
  metaOrganizationId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
  patch: DiscountPatch;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount?: { __typename?: 'Discount', id: string } | null };

export type CreateMetaOrganizationMutationVariables = Exact<{
  input: MetaOrganizationInput;
}>;


export type CreateMetaOrganizationMutation = { __typename?: 'Mutation', createMetaOrganization?: { __typename?: 'MetaOrganization', id: string } | null };

export type ListMetaOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMetaOrganizationsQuery = { __typename?: 'Query', metaOrganizations?: { __typename?: 'MetaOrganizationPage', edges: Array<{ __typename?: 'MetaOrganizationEdge', node: { __typename?: 'MetaOrganization', id: string, name?: string | null, createdAt?: string | null, updatedAt?: string | null } }> } | null };

export type GetMetaOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMetaOrganizationQuery = { __typename?: 'Query', metaOrganization?: { __typename?: 'MetaOrganization', id: string, name?: string | null, createdAt?: string | null, updatedAt?: string | null, discounts?: { __typename?: 'DiscountPage', edges: Array<{ __typename?: 'DiscountEdge', node: { __typename?: 'Discount', id: string, code?: string | null, createdAt?: string | null, description?: string | null, discountAmount?: number | null, discountLimit?: number | null, discountPercentage?: number | null, isDisabled?: boolean | null, maxAmount?: number | null, menuType?: MenuType | null, minAmount?: number | null, numberOfTimesPerUser?: number | null, title?: string | null, totalDiscountAmount?: number | null, updatedAt?: string | null, usability?: DiscountUsability | null, validFrom?: string | null, validUntil?: string | null, metaOrganization?: { __typename?: 'MetaOrganization', id: string } | null, openingHours?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null, restaurant?: { __typename?: 'Restaurant', id: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } | null, restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, name?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } | null } | null, restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, name?: string | null } }> } | null };

export type AddRestaurantToMetaOrganizationMutationVariables = Exact<{
  metaOrganizationId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
}>;


export type AddRestaurantToMetaOrganizationMutation = { __typename?: 'Mutation', addRestaurantToMetaOrganization?: AdditionStatus | null };

export type RemoveRestaurantFromMetaOrganizationMutationVariables = Exact<{
  metaOrganizationId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
}>;


export type RemoveRestaurantFromMetaOrganizationMutation = { __typename?: 'Mutation', removeRestaurantFromMetaOrganization?: RemovalStatus | null };

export type DeleteOpeningHoursMutationVariables = Exact<{
  openingHoursId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
}>;


export type DeleteOpeningHoursMutation = { __typename?: 'Mutation', deleteOpeningHours?: DeletionStatus | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: OrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'Organization', id: string } | null };

export type GetOrganizationFortnoxAccountingImportViewDataQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  redirectUrl: Scalars['URL']['input'];
}>;


export type GetOrganizationFortnoxAccountingImportViewDataQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, fortnoxAccountingImportEnabled?: boolean | null, fortnoxAccountingImportAuthorizationUrl?: string | null, hasFortnoxAccountingImportAccess?: boolean | null, hasFortnoxAccountingImportCredentials?: boolean | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null }> | null } | null };

export type AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation = { __typename?: 'Mutation', acceptFortnoxAccountingImportIntegrationTermsOfService?: { __typename?: 'Organization', id: string, hasFortnoxAccountingImportAccess?: boolean | null } | null };

export type UnlinkFortnoxAccountingImportAccountMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type UnlinkFortnoxAccountingImportAccountMutation = { __typename?: 'Mutation', unlinkFortnoxAccountingImportAccount?: { __typename?: 'Organization', id: string, fortnoxAccountingImportEnabled?: boolean | null, hasFortnoxAccountingImportAccess?: boolean | null, hasFortnoxAccountingImportCredentials?: boolean | null } | null };

export type GetOrganizationSelectDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationSelectDataQuery = { __typename?: 'Query', me?: { __typename?: 'User', organizationsWithAccess?: Array<{ __typename?: 'Organization', id: string, name?: string | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, cashregister?: { __typename?: 'Cashregister', id: string, isRegistered?: boolean | null, controlUnit?: { __typename?: 'ControlUnit', isRegistered?: boolean | null } | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasEnteredActivationCode?: boolean | null } | null }> | null }> | null } | null };

export type GetOrganizationUserCreateDataQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrganizationUserCreateDataQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, isOwner?: boolean | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null }> | null } | null };

export type CreateOrganizationUserMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  input: OrganizationUserInput;
}>;


export type CreateOrganizationUserMutation = { __typename?: 'Mutation', createOrganizationUser?: { __typename?: 'OrganizationUser', id: string } | null };

export type FullOrganizationUserDetailsFragment = { __typename?: 'OrganizationUser', id: string, email?: string | null, hasCreateCashAdjustmentAccess?: boolean | null, hasDiscountAccess?: boolean | null, hasDiscountedCheckoutAccess?: boolean | null, hasEditMenuAccess?: boolean | null, hasEditMenuStockAccess?: boolean | null, hasEditOpeningHoursAccess?: boolean | null, hasEditOrganizationUserAccess?: boolean | null, hasEditReportsAccess?: boolean | null, hasExternalPaymentAccess?: boolean | null, hasOpenOrderAccess?: boolean | null, hasOpenPriceAccess?: boolean | null, hasOrderHistoryAccess?: boolean | null, hasOrderRefundAccess?: boolean | null, hasOrganizationAccountingAccess?: boolean | null, hasPosAccess?: boolean | null, hasReadReportsAccess?: boolean | null, hasSettingsAccess?: boolean | null, isOwner?: boolean | null, name?: string | null, userSignupCompleted?: boolean | null, restaurantPermissions?: Array<{ __typename?: 'OrganizationUserRestaurantPermissions', id: string, hasCreateCashAdjustmentAccess?: boolean | null, hasDiscountAccess?: boolean | null, hasDiscountedCheckoutAccess?: boolean | null, hasEditMenuAccess?: boolean | null, hasEditMenuStockAccess?: boolean | null, hasEditOpeningHoursAccess?: boolean | null, hasEditReportsAccess?: boolean | null, hasExternalPaymentAccess?: boolean | null, hasOpenOrderAccess?: boolean | null, hasOpenPriceAccess?: boolean | null, hasOrderHistoryAccess?: boolean | null, hasOrderRefundAccess?: boolean | null, hasPosAccess?: boolean | null, hasReadReportsAccess?: boolean | null, hasSettingsAccess?: boolean | null, restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null } | null }> | null };

export type UpdateOrganizationUserMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  organizationUserId: Scalars['ID']['input'];
  patch: OrganizationUserPatch;
}>;


export type UpdateOrganizationUserMutation = { __typename?: 'Mutation', updateOrganizationUser?: { __typename?: 'OrganizationUser', id: string, email?: string | null, hasCreateCashAdjustmentAccess?: boolean | null, hasDiscountAccess?: boolean | null, hasDiscountedCheckoutAccess?: boolean | null, hasEditMenuAccess?: boolean | null, hasEditMenuStockAccess?: boolean | null, hasEditOpeningHoursAccess?: boolean | null, hasEditOrganizationUserAccess?: boolean | null, hasEditReportsAccess?: boolean | null, hasExternalPaymentAccess?: boolean | null, hasOpenOrderAccess?: boolean | null, hasOpenPriceAccess?: boolean | null, hasOrderHistoryAccess?: boolean | null, hasOrderRefundAccess?: boolean | null, hasOrganizationAccountingAccess?: boolean | null, hasPosAccess?: boolean | null, hasReadReportsAccess?: boolean | null, hasSettingsAccess?: boolean | null, isOwner?: boolean | null, name?: string | null, userSignupCompleted?: boolean | null, restaurantPermissions?: Array<{ __typename?: 'OrganizationUserRestaurantPermissions', id: string, hasCreateCashAdjustmentAccess?: boolean | null, hasDiscountAccess?: boolean | null, hasDiscountedCheckoutAccess?: boolean | null, hasEditMenuAccess?: boolean | null, hasEditMenuStockAccess?: boolean | null, hasEditOpeningHoursAccess?: boolean | null, hasEditReportsAccess?: boolean | null, hasExternalPaymentAccess?: boolean | null, hasOpenOrderAccess?: boolean | null, hasOpenPriceAccess?: boolean | null, hasOrderHistoryAccess?: boolean | null, hasOrderRefundAccess?: boolean | null, hasPosAccess?: boolean | null, hasReadReportsAccess?: boolean | null, hasSettingsAccess?: boolean | null, restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null } | null }> | null } | null };

export type DeleteOrganizationUserMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  organizationUserId: Scalars['ID']['input'];
}>;


export type DeleteOrganizationUserMutation = { __typename?: 'Mutation', deleteOrganizationUser?: { __typename?: 'Organization', id: string } | null };

export type ResendOrganizationUserInviteMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  organizationUserId: Scalars['ID']['input'];
}>;


export type ResendOrganizationUserInviteMutation = { __typename?: 'Mutation', resendOrganizationUserInvite?: { __typename?: 'OrganizationUser', id: string } | null };

export type GetOrganizationUserEditDataQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetOrganizationUserEditDataQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, isOwner?: boolean | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null }> | null, user?: { __typename?: 'OrganizationUser', id: string, email?: string | null, hasCreateCashAdjustmentAccess?: boolean | null, hasDiscountAccess?: boolean | null, hasDiscountedCheckoutAccess?: boolean | null, hasEditMenuAccess?: boolean | null, hasEditMenuStockAccess?: boolean | null, hasEditOpeningHoursAccess?: boolean | null, hasEditOrganizationUserAccess?: boolean | null, hasEditReportsAccess?: boolean | null, hasExternalPaymentAccess?: boolean | null, hasOpenOrderAccess?: boolean | null, hasOpenPriceAccess?: boolean | null, hasOrderHistoryAccess?: boolean | null, hasOrderRefundAccess?: boolean | null, hasOrganizationAccountingAccess?: boolean | null, hasPosAccess?: boolean | null, hasReadReportsAccess?: boolean | null, hasSettingsAccess?: boolean | null, isOwner?: boolean | null, name?: string | null, userSignupCompleted?: boolean | null, restaurantPermissions?: Array<{ __typename?: 'OrganizationUserRestaurantPermissions', id: string, hasCreateCashAdjustmentAccess?: boolean | null, hasDiscountAccess?: boolean | null, hasDiscountedCheckoutAccess?: boolean | null, hasEditMenuAccess?: boolean | null, hasEditMenuStockAccess?: boolean | null, hasEditOpeningHoursAccess?: boolean | null, hasEditReportsAccess?: boolean | null, hasExternalPaymentAccess?: boolean | null, hasOpenOrderAccess?: boolean | null, hasOpenPriceAccess?: boolean | null, hasOrderHistoryAccess?: boolean | null, hasOrderRefundAccess?: boolean | null, hasPosAccess?: boolean | null, hasReadReportsAccess?: boolean | null, hasSettingsAccess?: boolean | null, restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null } | null }> | null } | null } | null };

export type GetOrganizationUserListQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrganizationUserListQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, users?: Array<{ __typename?: 'OrganizationUser', id: string, email?: string | null, isOwner?: boolean | null, name?: string | null }> | null } | null };

export type RequestResetUserPasswordEmailMutationVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
}>;


export type RequestResetUserPasswordEmailMutation = { __typename?: 'Mutation', requestResetUserPasswordEmail?: void | null };

export type GetResetPasswordDataQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetResetPasswordDataQuery = { __typename?: 'Query', passwordResetRequest?: { __typename?: 'PasswordResetRequest', id: string, email?: string | null, expiresAt?: string | null, usedAt?: string | null } | null };

export type ResetUserPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword?: { __typename?: 'AccessToken', parseToken?: string | null } | null };

export type CreateMenuReportGroupMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: MenuReportGroupInput;
}>;


export type CreateMenuReportGroupMutation = { __typename?: 'Mutation', createMenuReportGroup?: { __typename?: 'MenuReportGroup', id: string } | null };

export type FullMenuReportGroupFragment = { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null };

export type GetReportGroupsQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetReportGroupsQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, menu?: { __typename?: 'Menu', reportGroups?: Array<{ __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null }> | null } | null } | null };

export type DeleteMenuReportGroupMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuReportGroupId: Scalars['ID']['input'];
}>;


export type DeleteMenuReportGroupMutation = { __typename?: 'Mutation', deleteMenuReportGroup?: DeletionStatus | null };

export type FullRestaurantControlUnitOutageFragment = { __typename?: 'RestaurantControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null };

export type GetRestaurantControlUnitOutageDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRestaurantControlUnitOutageDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, controlUnitOutages?: { __typename?: 'RestaurantControlUnitOutagePage', edges: Array<{ __typename?: 'RestaurantControlUnitOutageEdge', cursor: string, node: { __typename?: 'RestaurantControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null };

export type CreateRestaurantMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  input: RestaurantInput;
}>;


export type CreateRestaurantMutation = { __typename?: 'Mutation', createRestaurant?: { __typename?: 'Restaurant', id: string } | null };

export type GetRestaurantDashboardDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantDashboardDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, hasDeliveryHeroAccess?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasPersonalkollenAccess?: boolean | null, isOwner?: boolean | null } | null };

export type GetDeliveryListDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetDeliveryListDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, hasDeliveryMenu?: boolean | null, hasDeliveryHeroAccess?: boolean | null } | null };

export type FullPaletteColorFragment = { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } };

export type RestaurantDesignFieldsFragment = { __typename?: 'Restaurant', id: string, name?: string | null, receiptLogoUrl?: string | null, receiptTextBottom?: string | null, receiptTextTop?: string | null, design?: { __typename?: 'Design', adminImage?: string | null, backgroundColor: string, backgroundImage?: string | null, categoryBackgroundColor: string, categoryTextColor: string, headerTextColor: string, menuBackgroundColor: string, menuTextColor: string, productOverlayColor: string, restaurantHeaderImage?: string | null, restaurantPreviewImage?: string | null, textColor: string, background: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, error: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, primary: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, secondary: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } } } | null };

export type GetRestaurantDesignQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantDesignQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null, receiptLogoUrl?: string | null, receiptTextBottom?: string | null, receiptTextTop?: string | null, design?: { __typename?: 'Design', adminImage?: string | null, backgroundColor: string, backgroundImage?: string | null, categoryBackgroundColor: string, categoryTextColor: string, headerTextColor: string, menuBackgroundColor: string, menuTextColor: string, productOverlayColor: string, restaurantHeaderImage?: string | null, restaurantPreviewImage?: string | null, textColor: string, background: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, error: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, primary: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, secondary: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } } } | null } | null };

export type UpdateRestaurantDesignMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  patch: RestaurantPatch;
}>;


export type UpdateRestaurantDesignMutation = { __typename?: 'Mutation', updateRestaurant?: { __typename?: 'Restaurant', id: string, name?: string | null, receiptLogoUrl?: string | null, receiptTextBottom?: string | null, receiptTextTop?: string | null, design?: { __typename?: 'Design', adminImage?: string | null, backgroundColor: string, backgroundImage?: string | null, categoryBackgroundColor: string, categoryTextColor: string, headerTextColor: string, menuBackgroundColor: string, menuTextColor: string, productOverlayColor: string, restaurantHeaderImage?: string | null, restaurantPreviewImage?: string | null, textColor: string, background: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, error: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, primary: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } }, secondary: { __typename?: 'PaletteColor', dark: string, light: string, main: string, text: { __typename?: 'TextColor', disabled: string, primary: string, secondary: string } } } | null } | null };

export type CreateRestaurantDiscountMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: DiscountInput;
}>;


export type CreateRestaurantDiscountMutation = { __typename?: 'Mutation', createRestaurantDiscount?: { __typename?: 'Discount', id: string } | null };

export type GetRestaurantDiscountQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
}>;


export type GetRestaurantDiscountQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, discount?: { __typename?: 'Discount', id: string, code?: string | null, createdAt?: string | null, description?: string | null, discountAmount?: number | null, discountLimit?: number | null, discountPercentage?: number | null, isDisabled?: boolean | null, maxAmount?: number | null, menuType?: MenuType | null, minAmount?: number | null, numberOfTimesPerUser?: number | null, title?: string | null, totalDiscountAmount?: number | null, updatedAt?: string | null, usability?: DiscountUsability | null, validFrom?: string | null, validUntil?: string | null, metaOrganization?: { __typename?: 'MetaOrganization', id: string } | null, openingHours?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null, restaurant?: { __typename?: 'Restaurant', id: string } | null } | null } | null };

export type DeleteRestaurantDiscountMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
}>;


export type DeleteRestaurantDiscountMutation = { __typename?: 'Mutation', deleteRestaurantDiscount?: DeletionStatus | null };

export type UpdateRestaurantDiscountMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
  patch: DiscountPatch;
}>;


export type UpdateRestaurantDiscountMutation = { __typename?: 'Mutation', updateRestaurantDiscount?: { __typename?: 'Discount', id: string } | null };

export type FullDiscountFragment = { __typename?: 'Discount', id: string, code?: string | null, createdAt?: string | null, description?: string | null, discountAmount?: number | null, discountLimit?: number | null, discountPercentage?: number | null, isDisabled?: boolean | null, maxAmount?: number | null, menuType?: MenuType | null, minAmount?: number | null, numberOfTimesPerUser?: number | null, title?: string | null, totalDiscountAmount?: number | null, updatedAt?: string | null, usability?: DiscountUsability | null, validFrom?: string | null, validUntil?: string | null, metaOrganization?: { __typename?: 'MetaOrganization', id: string } | null, openingHours?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null, restaurant?: { __typename?: 'Restaurant', id: string } | null };

export type GetRestaurantDiscountsQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantDiscountsQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, discountsEnabled?: boolean | null, timeZone?: string | null, discounts?: { __typename?: 'DiscountPage', edges: Array<{ __typename?: 'DiscountEdge', node: { __typename?: 'Discount', id: string, code?: string | null, createdAt?: string | null, description?: string | null, discountAmount?: number | null, discountLimit?: number | null, discountPercentage?: number | null, isDisabled?: boolean | null, maxAmount?: number | null, menuType?: MenuType | null, minAmount?: number | null, numberOfTimesPerUser?: number | null, title?: string | null, totalDiscountAmount?: number | null, updatedAt?: string | null, usability?: DiscountUsability | null, validFrom?: string | null, validUntil?: string | null, metaOrganization?: { __typename?: 'MetaOrganization', id: string } | null, openingHours?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null, restaurant?: { __typename?: 'Restaurant', id: string } | null } }> } | null } | null };

export type RestaurantWhiteLabelFieldsFragment = { __typename?: 'WhiteLabel', id: string, appName?: string | null, label: string };

export type RestaurantFieldsFragment = { __typename?: 'Restaurant', id: string, active?: boolean | null, city?: string | null, createdAt?: string | null, discountsEnabled?: boolean | null, eatInServicePolicy?: EatInServicePolicy | null, isBetaTesting?: boolean | null, hasClientHeaderMessageAccess?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDeliveryMenu?: boolean | null, hasEatInMenu?: boolean | null, hasTakeAwayMenu?: boolean | null, hasSkipSlipPrintOnPrinterQueuesAccess?: boolean | null, kitchenOrderQueueSorting?: KitchenOrderQueueSorting | null, maxDeliveryTime?: string | null, menuSystem?: MenuSystem | null, name?: string | null, orderDisplaySystemEnabled?: boolean | null, orderMergeThreshold?: string | null, orderSlipLayout?: OrderSlipLayout | null, phoneNumber?: string | null, postalCode?: string | null, queueTime?: string | null, streetAddress?: string | null, temporarilyDisabled?: boolean | null, humanOrderNumberRange?: { __typename?: 'HumanOrderNumberRange', minimum: number, maximum: number } | null, organization?: { __typename?: 'Organization', id: string, createdAt?: string | null, email?: string | null, name?: string | null, organizationNumber?: string | null } | null, featuredDiscount?: { __typename?: 'Discount', id: string, code?: string | null } | null, location?: { __typename?: 'Coordinates', latitude: number, longitude: number } | null, whiteLabels?: Array<{ __typename?: 'WhiteLabel', id: string, appName?: string | null, label: string }> | null };

export type GetRestaurantSuperUserDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantSuperUserDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, activationCode?: string | null, applicationFeeCents?: number | null, applicationFeePercentage?: number | null, isBetaTesting?: boolean | null } | null, whiteLabels?: { __typename?: 'WhiteLabelPage', edges: Array<{ __typename?: 'WhiteLabelEdge', node: { __typename?: 'WhiteLabel', id: string, appName?: string | null, label: string } }> } | null };

export type GetRestaurantDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantDataQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, isSuperUser?: boolean | null } | null, restaurant?: { __typename?: 'Restaurant', id: string, active?: boolean | null, city?: string | null, createdAt?: string | null, discountsEnabled?: boolean | null, eatInServicePolicy?: EatInServicePolicy | null, isBetaTesting?: boolean | null, hasClientHeaderMessageAccess?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDeliveryMenu?: boolean | null, hasEatInMenu?: boolean | null, hasTakeAwayMenu?: boolean | null, hasSkipSlipPrintOnPrinterQueuesAccess?: boolean | null, kitchenOrderQueueSorting?: KitchenOrderQueueSorting | null, maxDeliveryTime?: string | null, menuSystem?: MenuSystem | null, name?: string | null, orderDisplaySystemEnabled?: boolean | null, orderMergeThreshold?: string | null, orderSlipLayout?: OrderSlipLayout | null, phoneNumber?: string | null, postalCode?: string | null, queueTime?: string | null, streetAddress?: string | null, temporarilyDisabled?: boolean | null, humanOrderNumberRange?: { __typename?: 'HumanOrderNumberRange', minimum: number, maximum: number } | null, organization?: { __typename?: 'Organization', id: string, createdAt?: string | null, email?: string | null, name?: string | null, organizationNumber?: string | null } | null, featuredDiscount?: { __typename?: 'Discount', id: string, code?: string | null } | null, location?: { __typename?: 'Coordinates', latitude: number, longitude: number } | null, whiteLabels?: Array<{ __typename?: 'WhiteLabel', id: string, appName?: string | null, label: string }> | null } | null };

export type DeleteRestaurantMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type DeleteRestaurantMutation = { __typename?: 'Mutation', deleteRestaurant?: void | null };

export type UpdateOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  patch: OrganizationPatch;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'Organization', id: string, name?: string | null } | null };

export type UpdateRestaurantMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  patch: RestaurantPatch;
}>;


export type UpdateRestaurantMutation = { __typename?: 'Mutation', updateRestaurant?: { __typename?: 'Restaurant', id: string, active?: boolean | null, city?: string | null, createdAt?: string | null, discountsEnabled?: boolean | null, eatInServicePolicy?: EatInServicePolicy | null, isBetaTesting?: boolean | null, hasClientHeaderMessageAccess?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, hasDeliveryMenu?: boolean | null, hasEatInMenu?: boolean | null, hasTakeAwayMenu?: boolean | null, hasSkipSlipPrintOnPrinterQueuesAccess?: boolean | null, kitchenOrderQueueSorting?: KitchenOrderQueueSorting | null, maxDeliveryTime?: string | null, menuSystem?: MenuSystem | null, name?: string | null, orderDisplaySystemEnabled?: boolean | null, orderMergeThreshold?: string | null, orderSlipLayout?: OrderSlipLayout | null, phoneNumber?: string | null, postalCode?: string | null, queueTime?: string | null, streetAddress?: string | null, temporarilyDisabled?: boolean | null, humanOrderNumberRange?: { __typename?: 'HumanOrderNumberRange', minimum: number, maximum: number } | null, organization?: { __typename?: 'Organization', id: string, createdAt?: string | null, email?: string | null, name?: string | null, organizationNumber?: string | null } | null, featuredDiscount?: { __typename?: 'Discount', id: string, code?: string | null } | null, location?: { __typename?: 'Coordinates', latitude: number, longitude: number } | null, whiteLabels?: Array<{ __typename?: 'WhiteLabel', id: string, appName?: string | null, label: string }> | null } | null };

export type GetRestaurantEmployeeCreateDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantEmployeeCreateDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, employeeGroups?: Array<{ __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null }> | null } | null };

export type CreateEmployeeMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: EmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee?: { __typename?: 'Employee', id: string, name?: string | null, pin?: string | null, groups?: Array<{ __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null }> | null } | null };

export type GetRestaurantEmployeeEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type GetRestaurantEmployeeEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, employee?: { __typename?: 'Employee', id: string, name?: string | null, pin?: string | null, groups?: Array<{ __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null }> | null } | null, employeeGroups?: Array<{ __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null }> | null } | null };

export type UpdateEmployeeMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  patch: EmployeePatch;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee?: { __typename?: 'Employee', id: string, name?: string | null, pin?: string | null, groups?: Array<{ __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null }> | null } | null };

export type DeleteEmployeeMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee?: DeletionStatus | null };

export type CreateGroupMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: EmployeeGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createEmployeeGroup?: { __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null } | null };

export type GetGroupQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  employeeGroupId: Scalars['ID']['input'];
}>;


export type GetGroupQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, employeeGroup?: { __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null } | null } | null };

export type EditGroupMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  employeeGroupId: Scalars['ID']['input'];
  patch: EmployeeGroupPatch;
}>;


export type EditGroupMutation = { __typename?: 'Mutation', updateEmployeeGroup?: { __typename?: 'EmployeeGroup', id: string, name?: string | null, canListDiscounts?: boolean | null, canListProductsWithOpenPrice?: boolean | null, canLogoutTill?: boolean | null, canMakeCashAdjustments?: boolean | null, canManageOpenOrders?: boolean | null, canRefundOrders?: boolean | null, canUpdateMenu?: boolean | null, canViewHistory?: boolean | null, canViewReceipts?: boolean | null } | null };

export type DeleteGroupMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  employeeGroupId: Scalars['ID']['input'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteEmployeeGroup?: DeletionStatus | null };

export type SetupProgressFragmentFragment = { __typename?: 'Restaurant', id: string, cashregister?: { __typename?: 'Cashregister', id: string, address?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, name?: string | null, softwareName?: string | null, softwareVersion?: string | null, controlUnit?: { __typename?: 'ControlUnit', address?: string | null, identificationNumber?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, productionNumber?: string | null, serialNumber?: string | null } | null, location?: { __typename?: 'CashregisterLocation', id: string, city?: string | null, name?: string | null, streetAddress?: string | null, zipCode?: string | null } | null } | null, organization?: { __typename?: 'Organization', id: string, setupProgress?: { __typename?: 'OrganizationSetupProgress', hasCompletedStripeSetup?: boolean | null, hasStripeAccount?: boolean | null } | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasCashregister?: boolean | null, hasEnteredActivationCode?: boolean | null, taxAuthoritiesCashregisterRegistrationUrl?: string | null, taxAuthoritiesControlUnitRegistrationUrl?: string | null } | null };

export type GetRestaurantSetupProgressQueryVariables = Exact<{
  redirectUrl?: InputMaybe<Scalars['URL']['input']>;
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantSetupProgressQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, setupProgress?: { __typename?: 'RestaurantSetupProgress', stripeConnectionUrl?: string | null, hasCashregister?: boolean | null, hasEnteredActivationCode?: boolean | null, taxAuthoritiesCashregisterRegistrationUrl?: string | null, taxAuthoritiesControlUnitRegistrationUrl?: string | null } | null, cashregister?: { __typename?: 'Cashregister', id: string, address?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, name?: string | null, softwareName?: string | null, softwareVersion?: string | null, controlUnit?: { __typename?: 'ControlUnit', address?: string | null, identificationNumber?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, productionNumber?: string | null, serialNumber?: string | null } | null, location?: { __typename?: 'CashregisterLocation', id: string, city?: string | null, name?: string | null, streetAddress?: string | null, zipCode?: string | null } | null } | null, organization?: { __typename?: 'Organization', id: string, setupProgress?: { __typename?: 'OrganizationSetupProgress', hasCompletedStripeSetup?: boolean | null, hasStripeAccount?: boolean | null } | null } | null } | null };

export type RegisterControlUnitMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  taxIdNumber: Scalars['String']['input'];
}>;


export type RegisterControlUnitMutation = { __typename?: 'Mutation', registerControlUnit?: { __typename?: 'Restaurant', id: string, cashregister?: { __typename?: 'Cashregister', id: string, address?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, name?: string | null, softwareName?: string | null, softwareVersion?: string | null, controlUnit?: { __typename?: 'ControlUnit', address?: string | null, identificationNumber?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, productionNumber?: string | null, serialNumber?: string | null } | null, location?: { __typename?: 'CashregisterLocation', id: string, city?: string | null, name?: string | null, streetAddress?: string | null, zipCode?: string | null } | null } | null, organization?: { __typename?: 'Organization', id: string, setupProgress?: { __typename?: 'OrganizationSetupProgress', hasCompletedStripeSetup?: boolean | null, hasStripeAccount?: boolean | null } | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasCashregister?: boolean | null, hasEnteredActivationCode?: boolean | null, taxAuthoritiesCashregisterRegistrationUrl?: string | null, taxAuthoritiesControlUnitRegistrationUrl?: string | null } | null } | null };

export type RegisterCashregisterMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type RegisterCashregisterMutation = { __typename?: 'Mutation', registerCashregister?: { __typename?: 'Restaurant', id: string, cashregister?: { __typename?: 'Cashregister', id: string, address?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, name?: string | null, softwareName?: string | null, softwareVersion?: string | null, controlUnit?: { __typename?: 'ControlUnit', address?: string | null, identificationNumber?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, productionNumber?: string | null, serialNumber?: string | null } | null, location?: { __typename?: 'CashregisterLocation', id: string, city?: string | null, name?: string | null, streetAddress?: string | null, zipCode?: string | null } | null } | null, organization?: { __typename?: 'Organization', id: string, setupProgress?: { __typename?: 'OrganizationSetupProgress', hasCompletedStripeSetup?: boolean | null, hasStripeAccount?: boolean | null } | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasCashregister?: boolean | null, hasEnteredActivationCode?: boolean | null, taxAuthoritiesCashregisterRegistrationUrl?: string | null, taxAuthoritiesControlUnitRegistrationUrl?: string | null } | null } | null };

export type ActivateRestaurantMutationVariables = Exact<{
  code: Scalars['String']['input'];
  restaurantId: Scalars['ID']['input'];
}>;


export type ActivateRestaurantMutation = { __typename?: 'Mutation', activateRestaurant?: { __typename?: 'Restaurant', id: string, cashregister?: { __typename?: 'Cashregister', id: string, address?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, name?: string | null, softwareName?: string | null, softwareVersion?: string | null, controlUnit?: { __typename?: 'ControlUnit', address?: string | null, identificationNumber?: string | null, isRegistered?: boolean | null, manufacturer?: string | null, model?: string | null, productionNumber?: string | null, serialNumber?: string | null } | null, location?: { __typename?: 'CashregisterLocation', id: string, city?: string | null, name?: string | null, streetAddress?: string | null, zipCode?: string | null } | null } | null, organization?: { __typename?: 'Organization', id: string, setupProgress?: { __typename?: 'OrganizationSetupProgress', hasCompletedStripeSetup?: boolean | null, hasStripeAccount?: boolean | null } | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasCashregister?: boolean | null, hasEnteredActivationCode?: boolean | null, taxAuthoritiesCashregisterRegistrationUrl?: string | null, taxAuthoritiesControlUnitRegistrationUrl?: string | null } | null } | null };

export type ListRestaurantsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRestaurantsQuery = { __typename?: 'Query', restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, hasEnteredActivationCode?: boolean | null, name?: string | null, phoneNumber?: string | null, organization?: { __typename?: 'Organization', id: string, email?: string | null } | null } }> } | null };

export type SetRestaurantOpeningHoursMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  periods: Array<OpeningHoursPeriodInput> | OpeningHoursPeriodInput;
}>;


export type SetRestaurantOpeningHoursMutation = { __typename?: 'Mutation', setRestaurantOpeningHours?: { __typename?: 'OpeningHours', id: string, periods?: Array<{ __typename?: 'OpeningHoursPeriod', open: { __typename?: 'WeekDayTime', day: WeekDay, time: string }, close?: { __typename?: 'WeekDayTime', day: WeekDay, time: string } | null }> | null } | null };

export type RestaurantFieldsForDisplaySystemFragment = { __typename?: 'Restaurant', id: string, hasClientHeaderMessageAccess?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, orderDisplaySystemAccentColor?: string | null, orderDisplaySystemEnabled?: boolean | null, orderDisplaySystemLogoUrl?: string | null, orderDisplaySystemUrl?: string | null, eatInServicePolicy?: EatInServicePolicy | null, tills?: Array<{ __typename?: 'Till', id: string, sendOrderToKitchen?: SendToKitchen | null }> | null };

export type GetRestaurantOrderDisplaySystemDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantOrderDisplaySystemDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, hasClientHeaderMessageAccess?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, orderDisplaySystemAccentColor?: string | null, orderDisplaySystemEnabled?: boolean | null, orderDisplaySystemLogoUrl?: string | null, orderDisplaySystemUrl?: string | null, eatInServicePolicy?: EatInServicePolicy | null, tills?: Array<{ __typename?: 'Till', id: string, sendOrderToKitchen?: SendToKitchen | null }> | null } | null };

export type AcceptOrderDisplaySystemTermsOfServiceMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type AcceptOrderDisplaySystemTermsOfServiceMutation = { __typename?: 'Mutation', acceptOrderDisplaySystemTermsOfService?: { __typename?: 'Restaurant', id: string, hasClientHeaderMessageAccess?: boolean | null, hasOrderDisplaySystemAccess?: boolean | null, orderDisplaySystemAccentColor?: string | null, orderDisplaySystemEnabled?: boolean | null, orderDisplaySystemLogoUrl?: string | null, orderDisplaySystemUrl?: string | null, eatInServicePolicy?: EatInServicePolicy | null, tills?: Array<{ __typename?: 'Till', id: string, sendOrderToKitchen?: SendToKitchen | null }> | null } | null };

export type UpdateRestaurantDisplaySystemMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  orderDisplaySystemAccentColor?: InputMaybe<Scalars['OpaqueColor']['input']>;
  orderDisplaySystemEnabled: Scalars['Boolean']['input'];
  orderDisplaySystemLogoUrl?: InputMaybe<Scalars['URL']['input']>;
}>;


export type UpdateRestaurantDisplaySystemMutation = { __typename?: 'Mutation', updateRestaurant?: { __typename?: 'Restaurant', id: string, orderDisplaySystemAccentColor?: string | null, orderDisplaySystemEnabled?: boolean | null, orderDisplaySystemLogoUrl?: string | null } | null };

export type CreatePaymentMethodMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: PaymentMethodInput;
}>;


export type CreatePaymentMethodMutation = { __typename?: 'Mutation', createPaymentMethod?: { __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null } | null };

export type GetRestaurantPaymentMethodEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
}>;


export type GetRestaurantPaymentMethodEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, paymentMethod?: { __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null } | null } | null };

export type DeletePaymentMethodMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod?: DeletionStatus | null };

export type EditPaymentMethodMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
  patch: PaymentMethodPatch;
}>;


export type EditPaymentMethodMutation = { __typename?: 'Mutation', updatePaymentMethod?: { __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null } | null };

export type GetRestaurantPersonalkollenDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantPersonalkollenDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, hasPersonalkollenAccess?: boolean | null, hasPersonalkollenCredentials?: boolean | null } | null };

export type AcceptPersonalkollenIntegrationTermsOfServiceMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type AcceptPersonalkollenIntegrationTermsOfServiceMutation = { __typename?: 'Mutation', acceptPersonalkollenIntegrationTermsOfService?: { __typename?: 'Restaurant', id: string, hasPersonalkollenAccess?: boolean | null } | null };

export type LinkPersonalkollenAccountMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  credentials: PersonalkollenCredentials;
}>;


export type LinkPersonalkollenAccountMutation = { __typename?: 'Mutation', linkPersonalkollenAccount?: { __typename?: 'Restaurant', id: string, hasPersonalkollenCredentials?: boolean | null } | null };

export type GetRestaurantPhysicalPrinterCreateDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantPhysicalPrinterCreateDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null };

export type CreatePhysicalPrinterMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: PhysicalPrinterInput;
}>;


export type CreatePhysicalPrinterMutation = { __typename?: 'Mutation', createPhysicalPrinter?: { __typename?: 'PhysicalPrinter', id: string, name?: string | null } | null };

export type GetRestaurantPhysicalPrinterEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  physicalPrinterId: Scalars['ID']['input'];
}>;


export type GetRestaurantPhysicalPrinterEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, physicalPrinter?: { __typename?: 'PhysicalPrinter', id: string, cloudPrntServerUrl?: string | null, name?: string | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null };

export type UpdatePhysicalPrinterMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  physicalPrinterId: Scalars['ID']['input'];
  patch: PhysicalPrinterPatch;
}>;


export type UpdatePhysicalPrinterMutation = { __typename?: 'Mutation', updatePhysicalPrinter?: { __typename?: 'PhysicalPrinter', id: string, cloudPrntServerUrl?: string | null, name?: string | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null };

export type GetPosTerminalQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  posTerminalId: Scalars['ID']['input'];
}>;


export type GetPosTerminalQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, posTerminal: { __typename?: 'PosTerminal', id: string, description?: string | null, externalId?: string | null, isActive?: boolean | null, isOnline?: boolean | null, lastOnlineAt?: string | null, name?: string | null, paymentProvider?: PaymentProvider | null } } | null };

export type UpdatePosTerminalMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  posTerminalId: Scalars['ID']['input'];
  patch: PosTerminalPatch;
}>;


export type UpdatePosTerminalMutation = { __typename?: 'Mutation', updatePosTerminal?: { __typename?: 'PosTerminal', id: string, description?: string | null, externalId?: string | null, isActive?: boolean | null, isOnline?: boolean | null, lastOnlineAt?: string | null, name?: string | null, paymentProvider?: PaymentProvider | null } | null };

export type CreatePrinterQueueMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: PrinterQueueInput;
}>;


export type CreatePrinterQueueMutation = { __typename?: 'Mutation', createPrinterQueue?: { __typename?: 'PrinterQueue', id: string, name?: string | null } | null };

export type GetRestaurantPrinterQueueEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  printerQueueId: Scalars['ID']['input'];
}>;


export type GetRestaurantPrinterQueueEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, printerQueue?: { __typename?: 'PrinterQueue', id: string, name?: string | null } | null } | null };

export type UpdatePrinterQueueMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  printerQueueId: Scalars['ID']['input'];
  patch: PrinterQueuePatch;
}>;


export type UpdatePrinterQueueMutation = { __typename?: 'Mutation', updatePrinterQueue?: { __typename?: 'PrinterQueue', id: string, name?: string | null } | null };

export type GetRestaurantPrintersViewDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantPrintersViewDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, physicalPrinters?: Array<{ __typename?: 'PhysicalPrinter', id: string, name?: string | null, identifyStatus?: PhysicalPrinterIdentifyStatus | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null }> | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, isLegacy?: boolean | null, name?: string | null }> | null } | null };

export type IdentifyPhysicalPrinterMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  physicalPrinterId: Scalars['ID']['input'];
}>;


export type IdentifyPhysicalPrinterMutation = { __typename?: 'Mutation', identifyPhysicalPrinter?: { __typename?: 'PhysicalPrinter', id: string, identifyStatus?: PhysicalPrinterIdentifyStatus | null } | null };

export type IdentifyPhysicalPrintersMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type IdentifyPhysicalPrintersMutation = { __typename?: 'Mutation', identifyPhysicalPrinters?: Array<{ __typename?: 'PhysicalPrinter', id: string, identifyStatus?: PhysicalPrinterIdentifyStatus | null }> | null };

export type RestaurantReceiptListOrderFragment = { __typename?: 'Order', id: string, status?: OrderStatus | null, grossAmount?: number | null, createdAt?: string | null, receiptViewKey?: string | null, restaurant?: { __typename?: 'Restaurant', name?: string | null } | null, receipt?: { __typename?: 'Receipt', id: string, humanOrderNumber?: number | null, refund?: boolean | null } | null, refundReceipts?: Array<{ __typename?: 'Receipt', id: string, humanOrderNumber?: number | null, refund?: boolean | null } | null> | null };

export type GetRestaurantReceiptListDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilter>;
}>;


export type GetRestaurantReceiptListDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, hasDeliveryHeroAccess?: boolean | null, timeZone?: string | null, orders?: { __typename?: 'OrderPage', edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'Order', id: string, status?: OrderStatus | null, grossAmount?: number | null, createdAt?: string | null, receiptViewKey?: string | null, restaurant?: { __typename?: 'Restaurant', name?: string | null } | null, receipt?: { __typename?: 'Receipt', id: string, humanOrderNumber?: number | null, refund?: boolean | null } | null, refundReceipts?: Array<{ __typename?: 'Receipt', id: string, humanOrderNumber?: number | null, refund?: boolean | null } | null> | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null };

export type GetRestaurantSalesReportListDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantSalesReportListDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, nextCashregisterReportGenerationTime?: string | null, timeZone?: string | null } | null };

export type GetRestaurantSalesReportViewDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  dateTimeRange: DateTimeRangeInput;
}>;


export type GetRestaurantSalesReportViewDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null, streetAddress?: string | null, timeZone?: string | null, organization?: { __typename?: 'Organization', id: string, name?: string | null, organizationNumber?: string | null } | null, statistics?: { __typename?: 'RestaurantStatistics', id: string, totalDiscountAmount?: number | null, totalTipAmount?: number | null, refundsByPaymentName?: Array<{ __typename?: 'RestaurantStatisticsRefundsByPaymentName', id: string, count?: number | null, grossAmount?: number | null, paymentName?: string | null, tipAmount?: number | null }> | null, refundsByProduct?: Array<{ __typename?: 'RestaurantStatisticsRefundsByProduct', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, name?: string | null, netAmount?: number | null, price?: number | null, productId?: string | null, vatAmount?: number | null, addons?: Array<{ __typename?: 'RestaurantStatisticsRefundsByProductAddon', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, name?: string | null, netAmount?: number | null, price?: number | null, productId?: string | null, vatAmount?: number | null }> | null, alternativeItems?: Array<{ __typename?: 'RestaurantStatisticsRefundsByProductAlternativeItem', id: string, count?: number | null, name?: string | null }> | null }> | null, salesByMenuType?: Array<{ __typename?: 'RestaurantStatisticsSalesByMenuType', id: string, count?: number | null, grossAmount?: number | null, menuType?: MenuType | null, vatAmount?: number | null }> | null, salesByMenuTypeAndTimePeriod?: Array<{ __typename?: 'RestaurantStatisticsSalesByMenuTypeAndTimePeriod', id: string, count?: number | null, grossAmount?: number | null, menuType?: MenuType | null, periodStart?: string | null }> | null, salesByPaymentName?: Array<{ __typename?: 'RestaurantStatisticsSalesByPaymentName', id: string, count?: number | null, grossAmount?: number | null, paymentName?: string | null, tipAmount?: number | null }> | null, salesByProduct?: Array<{ __typename?: 'RestaurantStatisticsSalesByProduct', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, name?: string | null, netAmount?: number | null, price?: number | null, productId?: string | null, vatAmount?: number | null, addons?: Array<{ __typename?: 'RestaurantStatisticsSalesByProductAddon', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, name?: string | null, netAmount?: number | null, price?: number | null, productId?: string | null, vatAmount?: number | null }> | null, alternativeItems?: Array<{ __typename?: 'RestaurantStatisticsSalesByProductAlternativeItem', id: string, count?: number | null, name?: string | null }> | null }> | null, salesByReportGroup?: Array<{ __typename?: 'RestaurantStatisticsSalesByReportGroup', id: string, count?: number | null, discountAmount?: number | null, grossAmount?: number | null, netAmount?: number | null, reportGroupName?: string | null, vatAmount?: number | null }> | null, salesByVatRate?: Array<{ __typename?: 'RestaurantStatisticsSalesByVatRate', id: string, grossAmount?: number | null, netAmount?: number | null, vatAmount?: number | null, vatRate?: number | null }> | null } | null } | null };

export type GetRestaurantStatisticsViewDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantStatisticsViewDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, dailyReconciliationTime?: string | null, hasDeliveryHeroAccess?: boolean | null, timeZone?: string | null } | null };

export type GetRestaurantStripeEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  redirectUrl?: InputMaybe<Scalars['URL']['input']>;
}>;


export type GetRestaurantStripeEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, organization?: { __typename?: 'Organization', id: string, setupProgress?: { __typename?: 'OrganizationSetupProgress', hasCompletedStripeSetup?: boolean | null, hasStripeAccount?: boolean | null } | null } | null, setupProgress?: { __typename?: 'RestaurantSetupProgress', hasCashregister?: boolean | null, hasEnteredActivationCode?: boolean | null, taxAuthoritiesCashregisterRegistrationUrl?: string | null, taxAuthoritiesControlUnitRegistrationUrl?: string | null, stripeConnectionUrl?: string | null } | null } | null };

export type GetRestaurantSwishEditDataQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type GetRestaurantSwishEditDataQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, swishNumber?: string | null } | null };

export type LinkSwishNumberMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  swishNumber: Scalars['String']['input'];
}>;


export type LinkSwishNumberMutation = { __typename?: 'Mutation', linkSwishNumber?: { __typename?: 'Restaurant', id: string, swishNumber?: string | null } | null };

export type UnlinkSwishNumberMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type UnlinkSwishNumberMutation = { __typename?: 'Mutation', unlinkSwishNumber?: { __typename?: 'Restaurant', id: string, swishNumber?: string | null } | null };

export type CreateTillMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  input: TillInput;
  orderDisplaySystemEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateTillMutation = { __typename?: 'Mutation', createTill?: { __typename?: 'Till', id: string, fixedDeliveryTime?: FixedDeliveryTime | null, layout?: TillLayout | null, name?: string | null, preferredApiEnvironment?: ApiEnvironment | null, sendOrderToKitchen?: SendToKitchen | null, showsCategoryBar?: boolean | null, showsDiscountField?: boolean | null, showsEmptyShoppingCartButton?: boolean | null, showsHoldKitchenPrint?: boolean | null, showsLogo?: boolean | null, showsMenuType?: MenuTypeFilter | null, showsOpeningStatus?: boolean | null, showsOpenOrders?: boolean | null, showsSearch?: boolean | null, showsTip?: boolean | null, fixedDeliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, name?: string | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null }> | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string }> | null, receiptPrinterQueue?: { __typename?: 'PrinterQueue', id: string, name?: string | null } | null, skipSlipPrintOnPrinterQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null, updateRestaurant?: { __typename?: 'Restaurant', id: string, orderDisplaySystemEnabled?: boolean | null } | null };

export type GetTillQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  tillId: Scalars['ID']['input'];
}>;


export type GetTillQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, isSuperUser?: boolean | null } | null, restaurant?: { __typename?: 'Restaurant', id: string, hasNetsConnectCloudLink?: boolean | null, hasSkipSlipPrintOnPrinterQueuesAccess?: boolean | null, isBetaTesting?: boolean | null, orderDisplaySystemEnabled?: boolean | null, deliveryLocations?: Array<{ __typename?: 'DeliveryLocation', id: string, name?: string | null }> | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null }> | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string, description?: string | null, externalId?: string | null, isActive?: boolean | null, isOnline?: boolean | null, lastOnlineAt?: string | null, name?: string | null, paymentProvider?: PaymentProvider | null }> | null, printerQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null, till?: { __typename?: 'Till', id: string, fixedDeliveryTime?: FixedDeliveryTime | null, layout?: TillLayout | null, name?: string | null, preferredApiEnvironment?: ApiEnvironment | null, sendOrderToKitchen?: SendToKitchen | null, showsCategoryBar?: boolean | null, showsDiscountField?: boolean | null, showsEmptyShoppingCartButton?: boolean | null, showsHoldKitchenPrint?: boolean | null, showsLogo?: boolean | null, showsMenuType?: MenuTypeFilter | null, showsOpeningStatus?: boolean | null, showsOpenOrders?: boolean | null, showsSearch?: boolean | null, showsTip?: boolean | null, featuredDiscounts?: Array<{ __typename?: 'Discount', id: string, code?: string | null }> | null, fixedDeliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, name?: string | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null }> | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string }> | null, receiptPrinterQueue?: { __typename?: 'PrinterQueue', id: string, name?: string | null } | null, skipSlipPrintOnPrinterQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null } | null };

export type EditTillMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  tillId: Scalars['ID']['input'];
  patch: TillPatch;
  orderDisplaySystemEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditTillMutation = { __typename?: 'Mutation', updateTill?: { __typename?: 'Till', id: string, fixedDeliveryTime?: FixedDeliveryTime | null, layout?: TillLayout | null, name?: string | null, preferredApiEnvironment?: ApiEnvironment | null, sendOrderToKitchen?: SendToKitchen | null, showsCategoryBar?: boolean | null, showsDiscountField?: boolean | null, showsEmptyShoppingCartButton?: boolean | null, showsHoldKitchenPrint?: boolean | null, showsLogo?: boolean | null, showsMenuType?: MenuTypeFilter | null, showsOpeningStatus?: boolean | null, showsOpenOrders?: boolean | null, showsSearch?: boolean | null, showsTip?: boolean | null, fixedDeliveryLocation?: { __typename?: 'DeliveryLocation', id: string, disabled?: boolean | null, name?: string | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, iconUrl?: string | null, isLegacy?: boolean | null, name?: string | null, paymentProvider?: PaymentProvider | null, receiptPaymentMethodLabel?: string | null, sieAccountNumber?: string | null }> | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string }> | null, receiptPrinterQueue?: { __typename?: 'PrinterQueue', id: string, name?: string | null } | null, skipSlipPrintOnPrinterQueues?: Array<{ __typename?: 'PrinterQueue', id: string, name?: string | null }> | null } | null, updateRestaurant?: { __typename?: 'Restaurant', id: string, orderDisplaySystemEnabled?: boolean | null } | null };

export type DeleteTillMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  tillId: Scalars['ID']['input'];
}>;


export type DeleteTillMutation = { __typename?: 'Mutation', deleteTill?: DeletionStatus | null };

export type LinkNetsConnectCloudAccountMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  credentials: NetsConnectCloudCredentials;
}>;


export type LinkNetsConnectCloudAccountMutation = { __typename?: 'Mutation', linkNetsConnectCloudAccount?: { __typename?: 'Restaurant', id: string, hasNetsConnectCloudLink?: boolean | null, netsConnectCloudUsername?: string | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string, description?: string | null, externalId?: string | null, isActive?: boolean | null, isOnline?: boolean | null, lastOnlineAt?: string | null, name?: string | null, paymentProvider?: PaymentProvider | null }> | null } | null };

export type RefreshPosTerminalsMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
}>;


export type RefreshPosTerminalsMutation = { __typename?: 'Mutation', refreshPosTerminals?: { __typename?: 'Restaurant', id: string, hasNetsConnectCloudLink?: boolean | null, netsConnectCloudUsername?: string | null, posTerminals?: Array<{ __typename?: 'PosTerminal', id: string, description?: string | null, externalId?: string | null, isActive?: boolean | null, isOnline?: boolean | null, lastOnlineAt?: string | null, name?: string | null, paymentProvider?: PaymentProvider | null }> | null } | null };

export type ListSieAccountsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ListSieAccountsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, sieAccounts?: Array<{ __typename?: 'SIEAccount', id: string, defaultDescription?: string | null, defaultNumber?: string | null, description?: string | null, key?: string | null, number?: string | null }> | null } | null };

export type SetAccountingPlanMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  accounts: Array<SieAccountInput> | SieAccountInput;
}>;


export type SetAccountingPlanMutation = { __typename?: 'Mutation', setOrganizationAccountingPlan?: { __typename?: 'Organization', id: string, sieAccounts?: Array<{ __typename?: 'SIEAccount', id: string, defaultDescription?: string | null, defaultNumber?: string | null, description?: string | null, key?: string | null, number?: string | null }> | null } | null };

type SieReportSource_PhysicalControlUnitOutage_Fragment = { __typename: 'PhysicalControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null };

type SieReportSource_StripeReport_Fragment = { __typename: 'StripeReport', id: string };

type SieReportSource_ZReport_Fragment = { __typename: 'ZReport', id: string, serialNumber?: number | null };

export type SieReportSourceFragment = SieReportSource_PhysicalControlUnitOutage_Fragment | SieReportSource_StripeReport_Fragment | SieReportSource_ZReport_Fragment;

export type LogEntriesFragment = { __typename?: 'FortnoxAccountingImportJobLogEntry', id: string, message?: string | null, timestamp?: string | null };

export type SieVerificationFragment = { __typename?: 'SIEVerification', id: string, date?: string | null, description?: string | null, validationError?: string | null, fortnoxAccountingImportJob?: { __typename?: 'FortnoxAccountingImportJob', id: string, status?: FortnoxAccountingImportJobStatus | null, logEntries?: Array<{ __typename?: 'FortnoxAccountingImportJobLogEntry', id: string, message?: string | null, timestamp?: string | null }> | null } | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, cashregister?: { __typename?: 'Cashregister', id: string, name?: string | null } | null }> | null, source?: { __typename: 'PhysicalControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null } | { __typename: 'StripeReport', id: string } | { __typename: 'ZReport', id: string, serialNumber?: number | null } | null, transactions?: Array<{ __typename?: 'SIETransaction', accountNumber?: string | null, amount?: number | null }> | null };

export type GetSieReportQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  datePeriod: DateTimeRangeInput;
  filter?: InputMaybe<SieReportFilter>;
}>;


export type GetSieReportQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name?: string | null, sieAccounts?: Array<{ __typename?: 'SIEAccount', id: string, defaultDescription?: string | null, defaultNumber?: string | null, description?: string | null, key?: string | null, number?: string | null }> | null, sieReport?: { __typename?: 'SIEReport', id: string, sieFileData?: string | null, datePeriod?: { __typename?: 'DateTimeRange', start?: string | null, end?: string | null } | null, verifications?: Array<{ __typename?: 'SIEVerification', id: string, date?: string | null, description?: string | null, validationError?: string | null, fortnoxAccountingImportJob?: { __typename?: 'FortnoxAccountingImportJob', id: string, status?: FortnoxAccountingImportJobStatus | null, logEntries?: Array<{ __typename?: 'FortnoxAccountingImportJobLogEntry', id: string, message?: string | null, timestamp?: string | null }> | null } | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, cashregister?: { __typename?: 'Cashregister', id: string, name?: string | null } | null }> | null, source?: { __typename: 'PhysicalControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null } | { __typename: 'StripeReport', id: string } | { __typename: 'ZReport', id: string, serialNumber?: number | null } | null, transactions?: Array<{ __typename?: 'SIETransaction', accountNumber?: string | null, amount?: number | null }> | null }> | null } | null } | null };

export type GetSieReportViewDataQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetSieReportViewDataQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, accountantEmail?: string | null, fortnoxAccountingImportEnabled?: boolean | null, hasFortnoxAccountingImportAccess?: boolean | null, isOwner?: boolean | null, fortnoxAccountingImportFailedVerifications?: Array<{ __typename?: 'SIEVerification', id: string, date?: string | null, description?: string | null, validationError?: string | null, fortnoxAccountingImportJob?: { __typename?: 'FortnoxAccountingImportJob', id: string, status?: FortnoxAccountingImportJobStatus | null, logEntries?: Array<{ __typename?: 'FortnoxAccountingImportJobLogEntry', id: string, message?: string | null, timestamp?: string | null }> | null } | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, cashregister?: { __typename?: 'Cashregister', id: string, name?: string | null } | null }> | null, source?: { __typename: 'PhysicalControlUnitOutage', id: string, createdAt?: string | null, restoredAt?: string | null } | { __typename: 'StripeReport', id: string } | { __typename: 'ZReport', id: string, serialNumber?: number | null } | null, transactions?: Array<{ __typename?: 'SIETransaction', accountNumber?: string | null, amount?: number | null }> | null }> | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null }> | null } | null };

export type MarkFortnoxAccountingImportAsManuallyImportedMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  sieVerificationId: Scalars['ID']['input'];
}>;


export type MarkFortnoxAccountingImportAsManuallyImportedMutation = { __typename?: 'Mutation', markFortnoxAccountingImportAsManuallyImported?: { __typename?: 'FortnoxAccountingImportJob', id: string, status?: FortnoxAccountingImportJobStatus | null, logEntries?: Array<{ __typename?: 'FortnoxAccountingImportJobLogEntry', id: string, message?: string | null, timestamp?: string | null }> | null } | null };

export type RetryFortnoxAccountingImportMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  sieVerificationId: Scalars['ID']['input'];
}>;


export type RetryFortnoxAccountingImportMutation = { __typename?: 'Mutation', retryFortnoxAccountingImport?: { __typename?: 'FortnoxAccountingImportJob', id: string, status?: FortnoxAccountingImportJobStatus | null, logEntries?: Array<{ __typename?: 'FortnoxAccountingImportJobLogEntry', id: string, message?: string | null, timestamp?: string | null }> | null } | null };

export type SetOrganizationAccountantEmailMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  email: Scalars['EmailAddress']['input'];
}>;


export type SetOrganizationAccountantEmailMutation = { __typename?: 'Mutation', setOrganizationAccountantEmail?: { __typename?: 'Organization', id: string, accountantEmail?: string | null } | null };

export type GetStatisticsOverviewDataQueryVariables = Exact<{
  dateTimeRange: DateTimeRangeInput;
  resolution: TimeResolution;
}>;


export type GetStatisticsOverviewDataQuery = { __typename?: 'Query', statistics?: { __typename?: 'GlobalStatistics', id: string, salesByMenuTypeAndTimePeriod?: Array<{ __typename?: 'GlobalStatisticsSalesByMenuTypeAndTimePeriod', id: string, count?: number | null, grossAmount?: number | null, menuType?: MenuType | null, when?: string | null }> | null, salesByRestaurant?: Array<{ __typename?: 'GlobalStatisticsSalesByRestaurant', id: string, count?: number | null, grossAmount?: number | null, restaurant?: { __typename?: 'Restaurant', id: string, name?: string | null } | null }> | null } | null };

export type FullStripeReportFragment = { __typename?: 'StripeReport', id: string, datePeriod?: { __typename?: 'DateTimeRange', start?: string | null, end?: string | null } | null, total?: { __typename?: 'StripeReportTotal', grossAmount?: number | null, transactionCount?: number | null, fee?: { __typename?: 'StripeReportTotalFee', vatAmount?: number | null } | null } | null };

export type ListStripeReportsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListStripeReportsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, stripeReports?: { __typename?: 'StripeReportPage', edges: Array<{ __typename?: 'StripeReportEdge', cursor: string, node: { __typename?: 'StripeReport', id: string, datePeriod?: { __typename?: 'DateTimeRange', start?: string | null, end?: string | null } | null, total?: { __typename?: 'StripeReportTotal', grossAmount?: number | null, transactionCount?: number | null, fee?: { __typename?: 'StripeReportTotalFee', vatAmount?: number | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null };

export type GetStripeReportHtmlQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type GetStripeReportHtmlQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, stripeReport?: { __typename?: 'StripeReport', id: string, html?: string | null } | null } | null };

export type SetStripeAccountIdMutationVariables = Exact<{
  authorizationCode: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type SetStripeAccountIdMutation = { __typename?: 'Mutation', setStripeAccountId?: { __typename?: 'Organization', id: string, setupProgress?: { __typename?: 'OrganizationSetupProgress', hasCompletedStripeSetup?: boolean | null, hasStripeAccount?: boolean | null } | null } | null };

export type GetAppVersionsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppVersionsDataQuery = { __typename?: 'Query', appVersions?: Array<{ __typename?: 'AppVersion', id: string, gitRef?: string | null, userDevicesCount?: number | null, version?: string | null }> | null };

export type GetTransactionChannelIncomeDataQueryVariables = Exact<{
  dateTimeRange: DateTimeRangeInput;
}>;


export type GetTransactionChannelIncomeDataQuery = { __typename?: 'Query', transactionChannelIncome?: Array<{ __typename?: 'TransactionChannelIncome', id: string, totalAmount?: number | null, totalSales?: number | null, transactionChannel?: TransactionChannel | null }> | null };

export type GetRestaurantsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRestaurantsStatusQuery = { __typename?: 'Query', restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, kitchenOrderQueueGrossAmount?: number | null, kitchenOrderQueueLength?: number | null, lastActiveTime?: string | null, lastOrderPlacedAt?: string | null, name?: string | null } }> } | null };

export type GetCreateUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreateUserDataQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, username?: string | null, isSuperUser?: boolean | null, organizationsWithAccess?: Array<{ __typename?: 'Organization', id: string, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null }> | null }> | null, restaurantsWithAccess?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null }> | null } | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['E164']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, username?: string | null, isSuperUser?: boolean | null, name?: string | null, phone?: string | null, city?: string | null } | null };

export type CreateWhiteLabelMutationVariables = Exact<{
  input: WhiteLabelInput;
}>;


export type CreateWhiteLabelMutation = { __typename?: 'Mutation', createWhiteLabel?: { __typename?: 'WhiteLabel', id: string, appName?: string | null, label: string } | null };

export type WhiteLabelListEntryFragment = { __typename?: 'WhiteLabel', id: string, isReadyForPublishing?: boolean | null, label: string, createdAt?: string | null, updatedAt?: string | null, appIconUrl?: string | null, appName?: string | null, buildNumber?: number | null, deliveryEnabled?: boolean | null, restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, name?: string | null } }> } | null, theme?: { __typename?: 'Theme', backgroundColor: string, borderColor: string, cardColor: string, notificationColor: string, primaryColor: string, textColor: string } | null };

export type ListWhiteLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListWhiteLabelsQuery = { __typename?: 'Query', whiteLabels?: { __typename?: 'WhiteLabelPage', edges: Array<{ __typename?: 'WhiteLabelEdge', node: { __typename?: 'WhiteLabel', id: string, isReadyForPublishing?: boolean | null, label: string, createdAt?: string | null, updatedAt?: string | null, appIconUrl?: string | null, appName?: string | null, buildNumber?: number | null, deliveryEnabled?: boolean | null, restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, name?: string | null } }> } | null, theme?: { __typename?: 'Theme', backgroundColor: string, borderColor: string, cardColor: string, notificationColor: string, primaryColor: string, textColor: string } | null } }> } | null };

export type WhiteLabelFieldsFragment = { __typename?: 'WhiteLabel', id: string, label: string, createdAt?: string | null, updatedAt?: string | null, androidFeatureGraphicUrl?: string | null, androidGoogleServices?: {} | null, androidPackageName?: string | null, appIconUrl?: string | null, appName?: string | null, appSplashUrl?: string | null, buildNumber?: number | null, deliveryEnabled?: boolean | null, description?: string | null, googleMapsApiKey?: string | null, iosAppstoreId?: string | null, iosBundleIdentifier?: string | null, iosGoogleServiceInfoPlist?: string | null, isPublishing?: boolean | null, isReadyForPublishing?: boolean | null, iPadPro129Screenshots?: Array<string> | null, iPhone55Screenshots?: Array<string> | null, iPhone65Screenshots?: Array<string> | null, keywords?: string | null, scheme?: string | null, shortDescription?: string | null, shortUrlPrefix?: string | null, restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, name?: string | null, city?: string | null, hasEatInMenu?: boolean | null, hasDeliveryMenu?: boolean | null, hasTakeAwayMenu?: boolean | null, design?: { __typename?: 'Design', restaurantPreviewImage?: string | null } | null } }> } | null, theme?: { __typename?: 'Theme', backgroundColor: string, borderColor: string, cardColor: string, notificationColor: string, primaryColor: string, textColor: string, menuTypeSelectionTitleColor: string, menuTypeSelectionButtonBackgroundColor: string, menuTypeSelectionButtonBorderColor: string, menuTypeSelectionButtonTextColor: string, menuTypeSelectionBackgroundColor: string, menuTypeSelectionBackgroundImage?: string | null, drawerBackgroundColor: string, drawerListItemTitleColor: string, drawerListItemSubtitleColor: string, drawerListItemIconColor: string, drawerVersionTextColor: string, drawerLogoImage?: string | null, listMenuIconColor: string, listTextInputColor: string, listTextInputPlaceholderTextColor: string, listSearchIconColor: string, listClearIconColor: string, listEmptyListButtonBackgroundColor: string, listItemSeparatorColor: string, listTabBarActiveTextColor: string, listTabBarInactiveTextColor: string, listTabBarUnderlineColor: string, listItemBackgroundColor: string, listItemTextColor: string, listBackgroundColor: string, listBackgroundImage?: string | null } | null };

export type GetWhiteLabelQueryVariables = Exact<{
  whiteLabelId: Scalars['ID']['input'];
}>;


export type GetWhiteLabelQuery = { __typename?: 'Query', whiteLabel?: { __typename?: 'WhiteLabel', id: string, label: string, createdAt?: string | null, updatedAt?: string | null, androidFeatureGraphicUrl?: string | null, androidGoogleServices?: {} | null, androidPackageName?: string | null, appIconUrl?: string | null, appName?: string | null, appSplashUrl?: string | null, buildNumber?: number | null, deliveryEnabled?: boolean | null, description?: string | null, googleMapsApiKey?: string | null, iosAppstoreId?: string | null, iosBundleIdentifier?: string | null, iosGoogleServiceInfoPlist?: string | null, isPublishing?: boolean | null, isReadyForPublishing?: boolean | null, iPadPro129Screenshots?: Array<string> | null, iPhone55Screenshots?: Array<string> | null, iPhone65Screenshots?: Array<string> | null, keywords?: string | null, scheme?: string | null, shortDescription?: string | null, shortUrlPrefix?: string | null, restaurants?: { __typename?: 'RestaurantPage', edges: Array<{ __typename?: 'RestaurantEdge', node: { __typename?: 'Restaurant', id: string, name?: string | null, city?: string | null, hasEatInMenu?: boolean | null, hasDeliveryMenu?: boolean | null, hasTakeAwayMenu?: boolean | null, design?: { __typename?: 'Design', restaurantPreviewImage?: string | null } | null } }> } | null, theme?: { __typename?: 'Theme', backgroundColor: string, borderColor: string, cardColor: string, notificationColor: string, primaryColor: string, textColor: string, menuTypeSelectionTitleColor: string, menuTypeSelectionButtonBackgroundColor: string, menuTypeSelectionButtonBorderColor: string, menuTypeSelectionButtonTextColor: string, menuTypeSelectionBackgroundColor: string, menuTypeSelectionBackgroundImage?: string | null, drawerBackgroundColor: string, drawerListItemTitleColor: string, drawerListItemSubtitleColor: string, drawerListItemIconColor: string, drawerVersionTextColor: string, drawerLogoImage?: string | null, listMenuIconColor: string, listTextInputColor: string, listTextInputPlaceholderTextColor: string, listSearchIconColor: string, listClearIconColor: string, listEmptyListButtonBackgroundColor: string, listItemSeparatorColor: string, listTabBarActiveTextColor: string, listTabBarInactiveTextColor: string, listTabBarUnderlineColor: string, listItemBackgroundColor: string, listItemTextColor: string, listBackgroundColor: string, listBackgroundImage?: string | null } | null } | null };

export type ExportYouniumUsageMutationVariables = Exact<{
  input: ExportYouniumUsageInput;
}>;


export type ExportYouniumUsageMutation = { __typename?: 'Mutation', exportYouniumUsage?: void | null };

export type GetRedirectToLandingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedirectToLandingDataQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, organizationsWithAccess?: Array<{ __typename?: 'Organization', id: string, hasOrganizationAccountingAccess?: boolean | null, hasUserWriteAccess?: boolean | null, isOwner?: boolean | null }> | null, restaurantsWithAccess?: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, organization?: { __typename?: 'Organization', id: string } | null }> | null } | null };

export type UpdateMenuProductMutationVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  menuProductId: Scalars['ID']['input'];
  patch: MenuProductPatch;
}>;


export type UpdateMenuProductMutation = { __typename?: 'Mutation', updateMenuProduct?: { __typename?: 'MenuProduct', id: string, name?: string | null, quantityAvailable?: number | null, defaultCourse?: { __typename?: 'MenuCourse', id: string, name?: string | null } | null, delivery?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, eatIn?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null, takeAway?: { __typename?: 'MenuProductProperties', id: string, description?: string | null, imageUrl?: string | null, isActive?: boolean | null, price?: number | null, priceIsOpen?: boolean | null, stateId: string, alternativeGroups?: Array<{ __typename?: 'MenuAlternativeGroup', id: string, name?: string | null, alternativeItems?: Array<{ __typename?: 'MenuAlternativeItem', name: string, addonProduct?: { __typename?: 'MenuAddonProduct', id: string, name?: string | null } | null }> | null }> | null, openingHours?: { __typename?: 'OpeningHours', id: string, name?: string | null } | null, printAt?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null, reportGroup?: { __typename?: 'MenuReportGroup', id: string, name?: string | null, vatRate?: number | null } | null, secondaryPrinters?: Array<{ __typename?: 'Printer', id: string, name?: string | null }> | null } | null } | null };

export const OrganizationPermissionsFragmentDoc = gql`
    fragment OrganizationPermissions on Organization {
  hasOrganizationAccountingAccess: hasAccess(access: AccountingWrite)
  hasUserWriteAccess: hasAccess(access: UserWrite)
  isOwner: hasAccess(access: Write)
}
    `;
export const RestaurantPermissionsFragmentDoc = gql`
    fragment RestaurantPermissions on Restaurant {
  hasDiscountWriteAccess: hasAccess(access: DiscountWrite)
  hasMenuStockWriteAccess: hasAccess(access: MenuStockWrite)
  hasMenuWriteAccess: hasAccess(access: MenuWrite)
  hasOngoingControlUnitOutage
  hasOpeningHoursWriteAccess: hasAccess(access: OpeningHoursWrite)
  hasOrderDisplaySystemAccess
  hasPosWriteAccess: hasAccess(access: PosWrite)
  hasReportReadAccess: hasAccess(access: ReportRead)
  hasReportWriteAccess: hasAccess(access: ReportWrite)
  hasSettingsWriteAccess: hasAccess(access: SettingsWrite)
  isOwner: hasAccess(access: Write)
}
    `;
export const RestaurantLayoutFieldsFragmentDoc = gql`
    fragment RestaurantLayoutFields on Restaurant {
  id
  name
  ...RestaurantPermissions
  organization {
    id
    ...OrganizationPermissions
  }
  setupProgress {
    hasEnteredActivationCode
  }
}
    ${RestaurantPermissionsFragmentDoc}
${OrganizationPermissionsFragmentDoc}`;
export const OrganizationLayoutFieldsFragmentDoc = gql`
    fragment OrganizationLayoutFields on Organization {
  id
  name
  ...OrganizationPermissions
  restaurants {
    ...RestaurantLayoutFields
  }
}
    ${OrganizationPermissionsFragmentDoc}
${RestaurantLayoutFieldsFragmentDoc}`;
export const FullPhysicalControlUnitOutageReportFragmentDoc = gql`
    fragment FullPhysicalControlUnitOutageReport on PhysicalControlUnitOutageReport {
  id
  link
  status
}
    `;
export const FullRestaurantControlUnitOutageReportFragmentDoc = gql`
    fragment FullRestaurantControlUnitOutageReport on RestaurantControlUnitOutageReport {
  id
  csvLink
  sieLink
  status
}
    `;
export const FullPrinterQueueFragmentDoc = gql`
    fragment FullPrinterQueue on PrinterQueue {
  id
  name
}
    `;
export const FullMenuReportGroupFragmentDoc = gql`
    fragment FullMenuReportGroup on MenuReportGroup {
  id
  name
  vatRate
}
    `;
export const FullAddonProductFragmentDoc = gql`
    fragment FullAddonProduct on MenuAddonProduct {
  id
  isDeliveryCost
  name
  properties {
    id
    description
    hasLegacyFormat
    imageUrl
    isActive
    price
    stateId
    reportGroup {
      ...FullMenuReportGroup
    }
  }
}
    ${FullMenuReportGroupFragmentDoc}`;
export const EmployeeGroupFieldsFragmentDoc = gql`
    fragment EmployeeGroupFields on EmployeeGroup {
  id
  name
  canListDiscounts
  canListProductsWithOpenPrice
  canLogoutTill
  canMakeCashAdjustments
  canManageOpenOrders
  canRefundOrders
  canUpdateMenu
  canViewHistory
  canViewReceipts
}
    `;
export const EmployeeFieldsFragmentDoc = gql`
    fragment EmployeeFields on Employee {
  id
  name
  pin
  groups {
    ...EmployeeGroupFields
  }
}
    ${EmployeeGroupFieldsFragmentDoc}`;
export const ProductOpeningHoursFragmentDoc = gql`
    fragment ProductOpeningHours on OpeningHours {
  id
  name
  productVisibility
  displayHours {
    id
    name
  }
  periods {
    open {
      day
      time
    }
    close {
      day
      time
    }
  }
}
    `;
export const MenuPageFieldsFragmentDoc = gql`
    fragment MenuPageFields on MenuPage {
  id
  categoryCount
  name
  productCount
  temporarilyDisabled
}
    `;
export const MenuProductPropertiesFieldsFragmentDoc = gql`
    fragment MenuProductPropertiesFields on MenuProductProperties {
  id
  description
  imageUrl
  isActive
  price
  priceIsOpen
  stateId
  alternativeGroups {
    id
    name
    alternativeItems {
      name
      addonProduct {
        id
        name
      }
    }
  }
  openingHours {
    id
    name
  }
  printAt {
    id
    name
  }
  reportGroup {
    ...FullMenuReportGroup
  }
  secondaryPrinters {
    id
    name
  }
}
    ${FullMenuReportGroupFragmentDoc}`;
export const MenuProductFieldsFragmentDoc = gql`
    fragment MenuProductFields on MenuProduct {
  id
  name
  quantityAvailable
  defaultCourse {
    id
    name
  }
  delivery: properties(menuType: Delivery) {
    ...MenuProductPropertiesFields
  }
  eatIn: properties(menuType: EatIn) {
    ...MenuProductPropertiesFields
  }
  takeAway: properties(menuType: TakeAway) {
    ...MenuProductPropertiesFields
  }
}
    ${MenuProductPropertiesFieldsFragmentDoc}`;
export const MenuCategoryFieldsFragmentDoc = gql`
    fragment MenuCategoryFields on MenuCategory {
  id
  name
  temporarilyDisabled
  products {
    ...MenuProductFields
  }
}
    ${MenuProductFieldsFragmentDoc}`;
export const FullPosTerminalFragmentDoc = gql`
    fragment FullPosTerminal on PosTerminal {
  id
  description
  externalId
  isActive
  isOnline
  lastOnlineAt
  name
  paymentProvider
}
    `;
export const FullPaymentMethodFragmentDoc = gql`
    fragment FullPaymentMethod on PaymentMethod {
  id
  iconUrl
  isLegacy
  name
  paymentProvider
  receiptPaymentMethodLabel
  sieAccountNumber
}
    `;
export const FullTillFragmentDoc = gql`
    fragment FullTill on Till {
  id
  fixedDeliveryTime
  layout
  name
  preferredApiEnvironment
  sendOrderToKitchen
  showsCategoryBar
  showsDiscountField
  showsEmptyShoppingCartButton
  showsHoldKitchenPrint
  showsLogo
  showsMenuType
  showsOpeningStatus
  showsOpenOrders
  showsSearch
  showsTip
  fixedDeliveryLocation {
    id
    disabled
    name
  }
  paymentMethods {
    ...FullPaymentMethod
  }
  posTerminals {
    id
  }
  receiptPrinterQueue {
    id
    name
  }
  skipSlipPrintOnPrinterQueues {
    id
    name
  }
}
    ${FullPaymentMethodFragmentDoc}`;
export const DeliveryTimeSlotFragmentDoc = gql`
    fragment DeliveryTimeSlot on DeliveryTimeSlot {
  id
  deadline
  disabled
  label
  value
}
    `;
export const FullPhysicalControlUnitOutageFragmentDoc = gql`
    fragment FullPhysicalControlUnitOutage on PhysicalControlUnitOutage {
  id
  createdAt
  restoredAt
  cashregisters {
    id
  }
}
    `;
export const FullPhysicalControlUnitFragmentDoc = gql`
    fragment FullPhysicalControlUnit on PhysicalControlUnit {
  id
  address
  createdAt
  manufacturer
  model
  serialNumber
  updatedAt
  outages {
    edges {
      node {
        ...FullPhysicalControlUnitOutage
      }
    }
  }
}
    ${FullPhysicalControlUnitOutageFragmentDoc}`;
export const DeliveryLocationFieldsFragmentDoc = gql`
    fragment DeliveryLocationFields on DeliveryLocation {
  id
  disabled
  eatInEnabled
  name
  takeAwayEnabled
  type
}
    `;
export const FullDeliveryCostAreaFragmentDoc = gql`
    fragment FullDeliveryCostArea on DeliveryCostArea {
  id
  name
  geometry {
    latitude
    longitude
  }
  product {
    id
    name
    properties {
      price
    }
  }
}
    `;
export const FullDeliveryTimeAreaFragmentDoc = gql`
    fragment FullDeliveryTimeArea on DeliveryTimeArea {
  id
  name
  time
  geometry {
    latitude
    longitude
  }
}
    `;
export const FullMenuAlternativeGroupFragmentDoc = gql`
    fragment FullMenuAlternativeGroup on MenuAlternativeGroup {
  id
  forceChoice
  isCountable
  maxChoices
  minChoices
  name
  alternativeItems {
    countableUsage
    isDefault
    name
    addonProduct {
      id
      name
      properties {
        id
        stateId
        description
        imageUrl
        isActive
        price
        reportGroup {
          ...FullMenuReportGroup
        }
      }
    }
  }
}
    ${FullMenuReportGroupFragmentDoc}`;
export const FullAlternativeItemFragmentDoc = gql`
    fragment FullAlternativeItem on MenuAlternativeItem {
  countableUsage
  isDefault
  name
  addonProduct {
    id
    name
    properties {
      id
      stateId
      description
      imageUrl
      isActive
      price
      reportGroup {
        ...FullMenuReportGroup
      }
    }
  }
}
    ${FullMenuReportGroupFragmentDoc}`;
export const FullAlternativeGroupFragmentDoc = gql`
    fragment FullAlternativeGroup on MenuAlternativeGroup {
  id
  forceChoice
  isCountable
  maxChoices
  minChoices
  name
  alternativeItems {
    ...FullAlternativeItem
  }
}
    ${FullAlternativeItemFragmentDoc}`;
export const FullMenuCourseFragmentDoc = gql`
    fragment FullMenuCourse on MenuCourse {
  id
  name
}
    `;
export const MenuProductVariantDefaultFieldsFragmentDoc = gql`
    fragment MenuProductVariantDefaultFields on MenuProductVariantDefaultValues {
  id
  alternativeGroups {
    id
  }
  openingHours {
    id
  }
  printAt {
    id
  }
  reportGroup {
    ...FullMenuReportGroup
  }
  secondaryPrinters {
    id
  }
}
    ${FullMenuReportGroupFragmentDoc}`;
export const MenuProductDefaultValuesFragmentDoc = gql`
    fragment MenuProductDefaultValues on MenuProductDefaultValues {
  id
  defaultCourse {
    id
  }
  delivery {
    ...MenuProductVariantDefaultFields
  }
  eatIn {
    ...MenuProductVariantDefaultFields
  }
  takeAway {
    ...MenuProductVariantDefaultFields
  }
}
    ${MenuProductVariantDefaultFieldsFragmentDoc}`;
export const FullOrganizationUserDetailsFragmentDoc = gql`
    fragment FullOrganizationUserDetails on OrganizationUser {
  id
  email
  hasCreateCashAdjustmentAccess
  hasDiscountAccess
  hasDiscountedCheckoutAccess
  hasEditMenuAccess
  hasEditMenuStockAccess
  hasEditOpeningHoursAccess
  hasEditOrganizationUserAccess
  hasEditReportsAccess
  hasExternalPaymentAccess
  hasOpenOrderAccess
  hasOpenPriceAccess
  hasOrderHistoryAccess
  hasOrderRefundAccess
  hasOrganizationAccountingAccess
  hasPosAccess
  hasReadReportsAccess
  hasSettingsAccess
  isOwner
  name
  userSignupCompleted
  restaurantPermissions {
    id
    hasCreateCashAdjustmentAccess
    hasDiscountAccess
    hasDiscountedCheckoutAccess
    hasEditMenuAccess
    hasEditMenuStockAccess
    hasEditOpeningHoursAccess
    hasEditReportsAccess
    hasExternalPaymentAccess
    hasOpenOrderAccess
    hasOpenPriceAccess
    hasOrderHistoryAccess
    hasOrderRefundAccess
    hasPosAccess
    hasReadReportsAccess
    hasSettingsAccess
    restaurant {
      id
      name
    }
  }
}
    `;
export const FullRestaurantControlUnitOutageFragmentDoc = gql`
    fragment FullRestaurantControlUnitOutage on RestaurantControlUnitOutage {
  id
  createdAt
  restoredAt
}
    `;
export const FullPaletteColorFragmentDoc = gql`
    fragment FullPaletteColor on PaletteColor {
  dark
  light
  main
  text {
    disabled
    primary
    secondary
  }
}
    `;
export const RestaurantDesignFieldsFragmentDoc = gql`
    fragment RestaurantDesignFields on Restaurant {
  id
  name
  receiptLogoUrl
  receiptTextBottom
  receiptTextTop
  design {
    adminImage
    backgroundColor
    backgroundImage
    categoryBackgroundColor
    categoryTextColor
    headerTextColor
    menuBackgroundColor
    menuTextColor
    productOverlayColor
    restaurantHeaderImage
    restaurantPreviewImage
    textColor
    background {
      ...FullPaletteColor
    }
    error {
      ...FullPaletteColor
    }
    primary {
      ...FullPaletteColor
    }
    secondary {
      ...FullPaletteColor
    }
  }
}
    ${FullPaletteColorFragmentDoc}`;
export const FullDiscountFragmentDoc = gql`
    fragment FullDiscount on Discount {
  id
  code
  createdAt
  description
  discountAmount
  discountLimit
  discountPercentage
  isDisabled
  maxAmount
  menuType
  minAmount
  numberOfTimesPerUser
  title
  totalDiscountAmount
  updatedAt
  usability
  validFrom
  validUntil
  metaOrganization {
    id
  }
  openingHours {
    open {
      day
      time
    }
    close {
      day
      time
    }
  }
  restaurant {
    id
  }
}
    `;
export const RestaurantWhiteLabelFieldsFragmentDoc = gql`
    fragment RestaurantWhiteLabelFields on WhiteLabel {
  id
  appName
  label
}
    `;
export const RestaurantFieldsFragmentDoc = gql`
    fragment RestaurantFields on Restaurant {
  id
  active
  city
  createdAt
  discountsEnabled
  eatInServicePolicy
  isBetaTesting
  hasClientHeaderMessageAccess
  hasOrderDisplaySystemAccess
  hasDeliveryMenu
  hasEatInMenu
  hasTakeAwayMenu
  hasSkipSlipPrintOnPrinterQueuesAccess
  humanOrderNumberRange {
    minimum
    maximum
  }
  kitchenOrderQueueSorting
  maxDeliveryTime
  menuSystem
  name
  orderDisplaySystemEnabled
  orderMergeThreshold
  orderSlipLayout
  phoneNumber
  postalCode
  queueTime
  streetAddress
  temporarilyDisabled
  organization {
    id
    createdAt
    email
    name
    organizationNumber
  }
  featuredDiscount {
    id
    code
  }
  location {
    latitude
    longitude
  }
  whiteLabels {
    ...RestaurantWhiteLabelFields
  }
}
    ${RestaurantWhiteLabelFieldsFragmentDoc}`;
export const SetupProgressFragmentFragmentDoc = gql`
    fragment SetupProgressFragment on Restaurant {
  id
  cashregister {
    id
    address
    isRegistered
    manufacturer
    model
    name
    softwareName
    softwareVersion
    controlUnit {
      address
      identificationNumber
      isRegistered
      manufacturer
      model
      productionNumber
      serialNumber
    }
    location {
      id
      city
      name
      streetAddress
      zipCode
    }
  }
  organization {
    id
    setupProgress {
      hasCompletedStripeSetup
      hasStripeAccount
    }
  }
  setupProgress {
    hasCashregister
    hasEnteredActivationCode
    taxAuthoritiesCashregisterRegistrationUrl
    taxAuthoritiesControlUnitRegistrationUrl
  }
}
    `;
export const RestaurantFieldsForDisplaySystemFragmentDoc = gql`
    fragment RestaurantFieldsForDisplaySystem on Restaurant {
  id
  hasClientHeaderMessageAccess
  hasOrderDisplaySystemAccess
  orderDisplaySystemAccentColor
  orderDisplaySystemEnabled
  orderDisplaySystemLogoUrl
  orderDisplaySystemUrl
  eatInServicePolicy
  tills {
    id
    sendOrderToKitchen
  }
}
    `;
export const RestaurantReceiptListOrderFragmentDoc = gql`
    fragment RestaurantReceiptListOrder on Order {
  id
  status
  grossAmount
  createdAt
  receiptViewKey
  restaurant {
    name
  }
  receipt {
    id
    humanOrderNumber
    refund
  }
  refundReceipts {
    id
    humanOrderNumber
    refund
  }
}
    `;
export const LogEntriesFragmentDoc = gql`
    fragment LogEntries on FortnoxAccountingImportJobLogEntry {
  id
  message
  timestamp
}
    `;
export const SieReportSourceFragmentDoc = gql`
    fragment SieReportSource on SIEVerificationSource {
  __typename
  ... on PhysicalControlUnitOutage {
    id
    createdAt
    restoredAt
  }
  ... on StripeReport {
    id
  }
  ... on ZReport {
    id
    serialNumber
  }
}
    `;
export const SieVerificationFragmentDoc = gql`
    fragment SieVerification on SIEVerification {
  id
  date
  description
  validationError
  fortnoxAccountingImportJob {
    id
    status
    logEntries {
      ...LogEntries
    }
  }
  restaurants {
    id
    name
    cashregister {
      id
      name
    }
  }
  source {
    ...SieReportSource
  }
  transactions {
    accountNumber
    amount
  }
}
    ${LogEntriesFragmentDoc}
${SieReportSourceFragmentDoc}`;
export const FullStripeReportFragmentDoc = gql`
    fragment FullStripeReport on StripeReport {
  id
  datePeriod {
    start
    end
  }
  total(currency: SEK) {
    grossAmount
    transactionCount
    fee {
      vatAmount
    }
  }
}
    `;
export const WhiteLabelListEntryFragmentDoc = gql`
    fragment WhiteLabelListEntry on WhiteLabel {
  id
  isReadyForPublishing
  label
  createdAt
  updatedAt
  restaurants(filter: {active: All}, first: 999) {
    edges {
      node {
        id
        name
      }
    }
  }
  theme {
    backgroundColor
    borderColor
    cardColor
    notificationColor
    primaryColor
    textColor
  }
  appIconUrl
  appName
  buildNumber
  deliveryEnabled
}
    `;
export const WhiteLabelFieldsFragmentDoc = gql`
    fragment WhiteLabelFields on WhiteLabel {
  id
  label
  createdAt
  updatedAt
  restaurants(filter: {active: All}, first: 999) {
    edges {
      node {
        id
        name
        city
        hasEatInMenu
        hasDeliveryMenu
        hasTakeAwayMenu
        design {
          restaurantPreviewImage
        }
      }
    }
  }
  androidFeatureGraphicUrl
  androidGoogleServices
  androidPackageName
  appIconUrl
  appName
  appSplashUrl
  buildNumber
  deliveryEnabled
  description
  googleMapsApiKey
  iosAppstoreId
  iosBundleIdentifier
  iosGoogleServiceInfoPlist
  isPublishing
  isReadyForPublishing
  iPadPro129Screenshots
  iPhone55Screenshots
  iPhone65Screenshots
  keywords
  scheme
  shortDescription
  shortUrlPrefix
  theme {
    backgroundColor
    borderColor
    cardColor
    notificationColor
    primaryColor
    textColor
    menuTypeSelectionTitleColor
    menuTypeSelectionButtonBackgroundColor
    menuTypeSelectionButtonBorderColor
    menuTypeSelectionButtonTextColor
    menuTypeSelectionBackgroundColor
    menuTypeSelectionBackgroundImage
    drawerBackgroundColor
    drawerListItemTitleColor
    drawerListItemSubtitleColor
    drawerListItemIconColor
    drawerVersionTextColor
    drawerLogoImage
    listMenuIconColor
    listTextInputColor
    listTextInputPlaceholderTextColor
    listSearchIconColor
    listClearIconColor
    listEmptyListButtonBackgroundColor
    listItemSeparatorColor
    listTabBarActiveTextColor
    listTabBarInactiveTextColor
    listTabBarUnderlineColor
    listItemBackgroundColor
    listItemTextColor
    listBackgroundColor
    listBackgroundImage
  }
}
    `;
export const RearrangeAddonProductsDocument = gql`
    mutation RearrangeAddonProducts($restaurantId: ID!, $order: [ID!]!) {
  rearrangeMenuAddonProducts(restaurantId: $restaurantId, order: $order)
}
    `;
export type RearrangeAddonProductsMutationFn = Apollo.MutationFunction<RearrangeAddonProductsMutation, RearrangeAddonProductsMutationVariables>;

/**
 * __useRearrangeAddonProductsMutation__
 *
 * To run a mutation, you first call `useRearrangeAddonProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRearrangeAddonProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rearrangeAddonProductsMutation, { data, loading, error }] = useRearrangeAddonProductsMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRearrangeAddonProductsMutation(baseOptions?: Apollo.MutationHookOptions<RearrangeAddonProductsMutation, RearrangeAddonProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RearrangeAddonProductsMutation, RearrangeAddonProductsMutationVariables>(RearrangeAddonProductsDocument, options);
      }
export type RearrangeAddonProductsMutationHookResult = ReturnType<typeof useRearrangeAddonProductsMutation>;
export type RearrangeAddonProductsMutationResult = Apollo.MutationResult<RearrangeAddonProductsMutation>;
export type RearrangeAddonProductsMutationOptions = Apollo.BaseMutationOptions<RearrangeAddonProductsMutation, RearrangeAddonProductsMutationVariables>;
export const UpdateDiscountDisabledStatusDocument = gql`
    mutation UpdateDiscountDisabledStatus($metaOrganizationId: ID!, $discountId: ID!, $isDisabled: Boolean!) {
  updateDiscount(
    metaOrganizationId: $metaOrganizationId
    discountId: $discountId
    patch: {isDisabled: $isDisabled}
  ) {
    id
    isDisabled
  }
}
    `;
export type UpdateDiscountDisabledStatusMutationFn = Apollo.MutationFunction<UpdateDiscountDisabledStatusMutation, UpdateDiscountDisabledStatusMutationVariables>;

/**
 * __useUpdateDiscountDisabledStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountDisabledStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountDisabledStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountDisabledStatusMutation, { data, loading, error }] = useUpdateDiscountDisabledStatusMutation({
 *   variables: {
 *      metaOrganizationId: // value for 'metaOrganizationId'
 *      discountId: // value for 'discountId'
 *      isDisabled: // value for 'isDisabled'
 *   },
 * });
 */
export function useUpdateDiscountDisabledStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountDisabledStatusMutation, UpdateDiscountDisabledStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountDisabledStatusMutation, UpdateDiscountDisabledStatusMutationVariables>(UpdateDiscountDisabledStatusDocument, options);
      }
export type UpdateDiscountDisabledStatusMutationHookResult = ReturnType<typeof useUpdateDiscountDisabledStatusMutation>;
export type UpdateDiscountDisabledStatusMutationResult = Apollo.MutationResult<UpdateDiscountDisabledStatusMutation>;
export type UpdateDiscountDisabledStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountDisabledStatusMutation, UpdateDiscountDisabledStatusMutationVariables>;
export const UpdateRestaurantDiscountDisabledStatusDocument = gql`
    mutation UpdateRestaurantDiscountDisabledStatus($restaurantId: ID!, $discountId: ID!, $isDisabled: Boolean!) {
  updateRestaurantDiscount(
    restaurantId: $restaurantId
    discountId: $discountId
    patch: {isDisabled: $isDisabled}
  ) {
    id
    isDisabled
  }
}
    `;
export type UpdateRestaurantDiscountDisabledStatusMutationFn = Apollo.MutationFunction<UpdateRestaurantDiscountDisabledStatusMutation, UpdateRestaurantDiscountDisabledStatusMutationVariables>;

/**
 * __useUpdateRestaurantDiscountDisabledStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRestaurantDiscountDisabledStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestaurantDiscountDisabledStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestaurantDiscountDisabledStatusMutation, { data, loading, error }] = useUpdateRestaurantDiscountDisabledStatusMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      discountId: // value for 'discountId'
 *      isDisabled: // value for 'isDisabled'
 *   },
 * });
 */
export function useUpdateRestaurantDiscountDisabledStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRestaurantDiscountDisabledStatusMutation, UpdateRestaurantDiscountDisabledStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRestaurantDiscountDisabledStatusMutation, UpdateRestaurantDiscountDisabledStatusMutationVariables>(UpdateRestaurantDiscountDisabledStatusDocument, options);
      }
export type UpdateRestaurantDiscountDisabledStatusMutationHookResult = ReturnType<typeof useUpdateRestaurantDiscountDisabledStatusMutation>;
export type UpdateRestaurantDiscountDisabledStatusMutationResult = Apollo.MutationResult<UpdateRestaurantDiscountDisabledStatusMutation>;
export type UpdateRestaurantDiscountDisabledStatusMutationOptions = Apollo.BaseMutationOptions<UpdateRestaurantDiscountDisabledStatusMutation, UpdateRestaurantDiscountDisabledStatusMutationVariables>;
export const GenerateRestaurantOrderSalesBreakdownDocument = gql`
    mutation GenerateRestaurantOrderSalesBreakdown($restaurantId: ID!, $input: RestaurantOrderSalesBreakdownInput!) {
  generateRestaurantOrderSalesBreakdown(
    restaurantId: $restaurantId
    input: $input
  )
}
    `;
export type GenerateRestaurantOrderSalesBreakdownMutationFn = Apollo.MutationFunction<GenerateRestaurantOrderSalesBreakdownMutation, GenerateRestaurantOrderSalesBreakdownMutationVariables>;

/**
 * __useGenerateRestaurantOrderSalesBreakdownMutation__
 *
 * To run a mutation, you first call `useGenerateRestaurantOrderSalesBreakdownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRestaurantOrderSalesBreakdownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRestaurantOrderSalesBreakdownMutation, { data, loading, error }] = useGenerateRestaurantOrderSalesBreakdownMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateRestaurantOrderSalesBreakdownMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRestaurantOrderSalesBreakdownMutation, GenerateRestaurantOrderSalesBreakdownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRestaurantOrderSalesBreakdownMutation, GenerateRestaurantOrderSalesBreakdownMutationVariables>(GenerateRestaurantOrderSalesBreakdownDocument, options);
      }
export type GenerateRestaurantOrderSalesBreakdownMutationHookResult = ReturnType<typeof useGenerateRestaurantOrderSalesBreakdownMutation>;
export type GenerateRestaurantOrderSalesBreakdownMutationResult = Apollo.MutationResult<GenerateRestaurantOrderSalesBreakdownMutation>;
export type GenerateRestaurantOrderSalesBreakdownMutationOptions = Apollo.BaseMutationOptions<GenerateRestaurantOrderSalesBreakdownMutation, GenerateRestaurantOrderSalesBreakdownMutationVariables>;
export const CreateDeliveryCostAreaDocument = gql`
    mutation CreateDeliveryCostArea($restaurantId: ID!, $input: DeliveryCostAreaInput!) {
  createDeliveryCostArea(restaurantId: $restaurantId, input: $input) {
    id
    deliveryCostAreas {
      id
      geometry {
        latitude
        longitude
      }
      name
      product {
        id
      }
    }
  }
}
    `;
export type CreateDeliveryCostAreaMutationFn = Apollo.MutationFunction<CreateDeliveryCostAreaMutation, CreateDeliveryCostAreaMutationVariables>;

/**
 * __useCreateDeliveryCostAreaMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryCostAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryCostAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryCostAreaMutation, { data, loading, error }] = useCreateDeliveryCostAreaMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeliveryCostAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryCostAreaMutation, CreateDeliveryCostAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryCostAreaMutation, CreateDeliveryCostAreaMutationVariables>(CreateDeliveryCostAreaDocument, options);
      }
export type CreateDeliveryCostAreaMutationHookResult = ReturnType<typeof useCreateDeliveryCostAreaMutation>;
export type CreateDeliveryCostAreaMutationResult = Apollo.MutationResult<CreateDeliveryCostAreaMutation>;
export type CreateDeliveryCostAreaMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryCostAreaMutation, CreateDeliveryCostAreaMutationVariables>;
export const CreateDeliveryTimeAreaDocument = gql`
    mutation CreateDeliveryTimeArea($restaurantId: ID!, $input: DeliveryTimeAreaInput!) {
  createDeliveryTimeArea(restaurantId: $restaurantId, input: $input) {
    id
    deliveryTimeAreas {
      id
      geometry {
        latitude
        longitude
      }
      name
      time
    }
  }
}
    `;
export type CreateDeliveryTimeAreaMutationFn = Apollo.MutationFunction<CreateDeliveryTimeAreaMutation, CreateDeliveryTimeAreaMutationVariables>;

/**
 * __useCreateDeliveryTimeAreaMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryTimeAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryTimeAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryTimeAreaMutation, { data, loading, error }] = useCreateDeliveryTimeAreaMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeliveryTimeAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryTimeAreaMutation, CreateDeliveryTimeAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryTimeAreaMutation, CreateDeliveryTimeAreaMutationVariables>(CreateDeliveryTimeAreaDocument, options);
      }
export type CreateDeliveryTimeAreaMutationHookResult = ReturnType<typeof useCreateDeliveryTimeAreaMutation>;
export type CreateDeliveryTimeAreaMutationResult = Apollo.MutationResult<CreateDeliveryTimeAreaMutation>;
export type CreateDeliveryTimeAreaMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryTimeAreaMutation, CreateDeliveryTimeAreaMutationVariables>;
export const GetLayoutInfoDocument = gql`
    query GetLayoutInfo($organizationId: ID!, $hasOrganizationId: Boolean!, $restaurantId: ID!, $hasRestaurantId: Boolean!, $whiteLabelId: ID!, $hasWhiteLabelId: Boolean!) {
  me {
    id
    username
    isSuperUser
    organizationsWithAccess(access: Read) {
      ...OrganizationLayoutFields
    }
    restaurantsWithAccess(access: Read) {
      ...RestaurantLayoutFields
    }
    whiteLabelsWithAccess(access: Write) {
      id
      appName
      label
    }
  }
  organization(id: $organizationId) @include(if: $hasOrganizationId) {
    ...OrganizationLayoutFields
  }
  restaurant(id: $restaurantId) @include(if: $hasRestaurantId) {
    id
    name
    ...RestaurantPermissions
    cashregister {
      id
      isRegistered
      controlUnit {
        isRegistered
      }
    }
    organization {
      ...OrganizationLayoutFields
    }
    setupProgress {
      hasEnteredActivationCode
    }
  }
  whiteLabel(id: $whiteLabelId) @include(if: $hasWhiteLabelId) {
    id
    appName
    label
  }
}
    ${OrganizationLayoutFieldsFragmentDoc}
${RestaurantLayoutFieldsFragmentDoc}
${RestaurantPermissionsFragmentDoc}`;

/**
 * __useGetLayoutInfoQuery__
 *
 * To run a query within a React component, call `useGetLayoutInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayoutInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayoutInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      hasOrganizationId: // value for 'hasOrganizationId'
 *      restaurantId: // value for 'restaurantId'
 *      hasRestaurantId: // value for 'hasRestaurantId'
 *      whiteLabelId: // value for 'whiteLabelId'
 *      hasWhiteLabelId: // value for 'hasWhiteLabelId'
 *   },
 * });
 */
export function useGetLayoutInfoQuery(baseOptions: Apollo.QueryHookOptions<GetLayoutInfoQuery, GetLayoutInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLayoutInfoQuery, GetLayoutInfoQueryVariables>(GetLayoutInfoDocument, options);
      }
export function useGetLayoutInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLayoutInfoQuery, GetLayoutInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLayoutInfoQuery, GetLayoutInfoQueryVariables>(GetLayoutInfoDocument, options);
        }
export type GetLayoutInfoQueryHookResult = ReturnType<typeof useGetLayoutInfoQuery>;
export type GetLayoutInfoLazyQueryHookResult = ReturnType<typeof useGetLayoutInfoLazyQuery>;
export type GetLayoutInfoQueryResult = Apollo.QueryResult<GetLayoutInfoQuery, GetLayoutInfoQueryVariables>;
export const GetPrinterQueuesDocument = gql`
    query GetPrinterQueues($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    printerQueues {
      ...FullPrinterQueue
    }
  }
}
    ${FullPrinterQueueFragmentDoc}`;

/**
 * __useGetPrinterQueuesQuery__
 *
 * To run a query within a React component, call `useGetPrinterQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrinterQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrinterQueuesQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetPrinterQueuesQuery(baseOptions: Apollo.QueryHookOptions<GetPrinterQueuesQuery, GetPrinterQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrinterQueuesQuery, GetPrinterQueuesQueryVariables>(GetPrinterQueuesDocument, options);
      }
export function useGetPrinterQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrinterQueuesQuery, GetPrinterQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrinterQueuesQuery, GetPrinterQueuesQueryVariables>(GetPrinterQueuesDocument, options);
        }
export type GetPrinterQueuesQueryHookResult = ReturnType<typeof useGetPrinterQueuesQuery>;
export type GetPrinterQueuesLazyQueryHookResult = ReturnType<typeof useGetPrinterQueuesLazyQuery>;
export type GetPrinterQueuesQueryResult = Apollo.QueryResult<GetPrinterQueuesQuery, GetPrinterQueuesQueryVariables>;
export const GetCoursesDocument = gql`
    query GetCourses($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu {
      id
      courses {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCoursesQuery__
 *
 * To run a query within a React component, call `useGetCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, options);
      }
export function useGetCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, options);
        }
export type GetCoursesQueryHookResult = ReturnType<typeof useGetCoursesQuery>;
export type GetCoursesLazyQueryHookResult = ReturnType<typeof useGetCoursesLazyQuery>;
export type GetCoursesQueryResult = Apollo.QueryResult<GetCoursesQuery, GetCoursesQueryVariables>;
export const EnterSudoModeDocument = gql`
    mutation EnterSudoMode($password: String!) {
  enterSudoMode(password: $password) {
    id
    expiresAt
  }
}
    `;
export type EnterSudoModeMutationFn = Apollo.MutationFunction<EnterSudoModeMutation, EnterSudoModeMutationVariables>;

/**
 * __useEnterSudoModeMutation__
 *
 * To run a mutation, you first call `useEnterSudoModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterSudoModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterSudoModeMutation, { data, loading, error }] = useEnterSudoModeMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useEnterSudoModeMutation(baseOptions?: Apollo.MutationHookOptions<EnterSudoModeMutation, EnterSudoModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnterSudoModeMutation, EnterSudoModeMutationVariables>(EnterSudoModeDocument, options);
      }
export type EnterSudoModeMutationHookResult = ReturnType<typeof useEnterSudoModeMutation>;
export type EnterSudoModeMutationResult = Apollo.MutationResult<EnterSudoModeMutation>;
export type EnterSudoModeMutationOptions = Apollo.BaseMutationOptions<EnterSudoModeMutation, EnterSudoModeMutationVariables>;
export const GetPhysicalControlUnitOutageReportDocument = gql`
    query GetPhysicalControlUnitOutageReport($physicalControlUnitOutageReportId: ID!) {
  physicalControlUnitOutageReport(id: $physicalControlUnitOutageReportId) {
    ...FullPhysicalControlUnitOutageReport
  }
}
    ${FullPhysicalControlUnitOutageReportFragmentDoc}`;

/**
 * __useGetPhysicalControlUnitOutageReportQuery__
 *
 * To run a query within a React component, call `useGetPhysicalControlUnitOutageReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhysicalControlUnitOutageReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhysicalControlUnitOutageReportQuery({
 *   variables: {
 *      physicalControlUnitOutageReportId: // value for 'physicalControlUnitOutageReportId'
 *   },
 * });
 */
export function useGetPhysicalControlUnitOutageReportQuery(baseOptions: Apollo.QueryHookOptions<GetPhysicalControlUnitOutageReportQuery, GetPhysicalControlUnitOutageReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhysicalControlUnitOutageReportQuery, GetPhysicalControlUnitOutageReportQueryVariables>(GetPhysicalControlUnitOutageReportDocument, options);
      }
export function useGetPhysicalControlUnitOutageReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhysicalControlUnitOutageReportQuery, GetPhysicalControlUnitOutageReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhysicalControlUnitOutageReportQuery, GetPhysicalControlUnitOutageReportQueryVariables>(GetPhysicalControlUnitOutageReportDocument, options);
        }
export type GetPhysicalControlUnitOutageReportQueryHookResult = ReturnType<typeof useGetPhysicalControlUnitOutageReportQuery>;
export type GetPhysicalControlUnitOutageReportLazyQueryHookResult = ReturnType<typeof useGetPhysicalControlUnitOutageReportLazyQuery>;
export type GetPhysicalControlUnitOutageReportQueryResult = Apollo.QueryResult<GetPhysicalControlUnitOutageReportQuery, GetPhysicalControlUnitOutageReportQueryVariables>;
export const CreatePhysicalControlUnitOutageReportDocument = gql`
    mutation CreatePhysicalControlUnitOutageReport($physicalControlUnitOutageId: ID!) {
  createPhysicalControlUnitOutageReport(
    physicalControlUnitOutageId: $physicalControlUnitOutageId
  ) {
    ...FullPhysicalControlUnitOutageReport
  }
}
    ${FullPhysicalControlUnitOutageReportFragmentDoc}`;
export type CreatePhysicalControlUnitOutageReportMutationFn = Apollo.MutationFunction<CreatePhysicalControlUnitOutageReportMutation, CreatePhysicalControlUnitOutageReportMutationVariables>;

/**
 * __useCreatePhysicalControlUnitOutageReportMutation__
 *
 * To run a mutation, you first call `useCreatePhysicalControlUnitOutageReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhysicalControlUnitOutageReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhysicalControlUnitOutageReportMutation, { data, loading, error }] = useCreatePhysicalControlUnitOutageReportMutation({
 *   variables: {
 *      physicalControlUnitOutageId: // value for 'physicalControlUnitOutageId'
 *   },
 * });
 */
export function useCreatePhysicalControlUnitOutageReportMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhysicalControlUnitOutageReportMutation, CreatePhysicalControlUnitOutageReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhysicalControlUnitOutageReportMutation, CreatePhysicalControlUnitOutageReportMutationVariables>(CreatePhysicalControlUnitOutageReportDocument, options);
      }
export type CreatePhysicalControlUnitOutageReportMutationHookResult = ReturnType<typeof useCreatePhysicalControlUnitOutageReportMutation>;
export type CreatePhysicalControlUnitOutageReportMutationResult = Apollo.MutationResult<CreatePhysicalControlUnitOutageReportMutation>;
export type CreatePhysicalControlUnitOutageReportMutationOptions = Apollo.BaseMutationOptions<CreatePhysicalControlUnitOutageReportMutation, CreatePhysicalControlUnitOutageReportMutationVariables>;
export const GetReceiptSummaryDataDocument = gql`
    query GetReceiptSummaryData($orderId: ID!, $restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    name
    timeZone
    order(id: $orderId) {
      id
      createdAt
      pickedUpAt
      readyForPickupAt
      discountAmount
      grossAmount
      tipAmount
      deliveryHeroLongCode
      employeeName
      paymentProvider
      receiptViewKey
      status
      transactionChannel
      userMessage
      items {
        id
        count
        totalAmount
        message
        alternatives {
          id
          count
          isChosen
          name
          totalAmount
          addonProduct {
            id
            name
            properties {
              id
              price
              stateId
            }
          }
        }
        product {
          id
          name
        }
      }
      paymentIntents {
        id
        tipAmount
        totalAmount
        paymentMethod {
          id
          name
          receiptPaymentMethodLabel
        }
      }
      receipt {
        id
        humanOrderNumber
      }
      refundReceipts {
        id
        humanOrderNumber
        refund
      }
    }
  }
}
    `;

/**
 * __useGetReceiptSummaryDataQuery__
 *
 * To run a query within a React component, call `useGetReceiptSummaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptSummaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptSummaryDataQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetReceiptSummaryDataQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptSummaryDataQuery, GetReceiptSummaryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiptSummaryDataQuery, GetReceiptSummaryDataQueryVariables>(GetReceiptSummaryDataDocument, options);
      }
export function useGetReceiptSummaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptSummaryDataQuery, GetReceiptSummaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiptSummaryDataQuery, GetReceiptSummaryDataQueryVariables>(GetReceiptSummaryDataDocument, options);
        }
export type GetReceiptSummaryDataQueryHookResult = ReturnType<typeof useGetReceiptSummaryDataQuery>;
export type GetReceiptSummaryDataLazyQueryHookResult = ReturnType<typeof useGetReceiptSummaryDataLazyQuery>;
export type GetReceiptSummaryDataQueryResult = Apollo.QueryResult<GetReceiptSummaryDataQuery, GetReceiptSummaryDataQueryVariables>;
export const GetRestaurantControlUnitOutageReportDocument = gql`
    query GetRestaurantControlUnitOutageReport($restaurantId: ID!, $restaurantControlUnitOutageReportId: ID!) {
  restaurant(id: $restaurantId) {
    id
    controlUnitOutageReport(id: $restaurantControlUnitOutageReportId) {
      ...FullRestaurantControlUnitOutageReport
    }
  }
}
    ${FullRestaurantControlUnitOutageReportFragmentDoc}`;

/**
 * __useGetRestaurantControlUnitOutageReportQuery__
 *
 * To run a query within a React component, call `useGetRestaurantControlUnitOutageReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantControlUnitOutageReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantControlUnitOutageReportQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      restaurantControlUnitOutageReportId: // value for 'restaurantControlUnitOutageReportId'
 *   },
 * });
 */
export function useGetRestaurantControlUnitOutageReportQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantControlUnitOutageReportQuery, GetRestaurantControlUnitOutageReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantControlUnitOutageReportQuery, GetRestaurantControlUnitOutageReportQueryVariables>(GetRestaurantControlUnitOutageReportDocument, options);
      }
export function useGetRestaurantControlUnitOutageReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantControlUnitOutageReportQuery, GetRestaurantControlUnitOutageReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantControlUnitOutageReportQuery, GetRestaurantControlUnitOutageReportQueryVariables>(GetRestaurantControlUnitOutageReportDocument, options);
        }
export type GetRestaurantControlUnitOutageReportQueryHookResult = ReturnType<typeof useGetRestaurantControlUnitOutageReportQuery>;
export type GetRestaurantControlUnitOutageReportLazyQueryHookResult = ReturnType<typeof useGetRestaurantControlUnitOutageReportLazyQuery>;
export type GetRestaurantControlUnitOutageReportQueryResult = Apollo.QueryResult<GetRestaurantControlUnitOutageReportQuery, GetRestaurantControlUnitOutageReportQueryVariables>;
export const CreateRestaurantControlUnitOutageReportDocument = gql`
    mutation CreateRestaurantControlUnitOutageReport($restaurantId: ID!, $restaurantControlUnitOutageId: ID!) {
  createRestaurantControlUnitOutageReport(
    restaurantId: $restaurantId
    restaurantControlUnitOutageId: $restaurantControlUnitOutageId
  ) {
    ...FullRestaurantControlUnitOutageReport
  }
}
    ${FullRestaurantControlUnitOutageReportFragmentDoc}`;
export type CreateRestaurantControlUnitOutageReportMutationFn = Apollo.MutationFunction<CreateRestaurantControlUnitOutageReportMutation, CreateRestaurantControlUnitOutageReportMutationVariables>;

/**
 * __useCreateRestaurantControlUnitOutageReportMutation__
 *
 * To run a mutation, you first call `useCreateRestaurantControlUnitOutageReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRestaurantControlUnitOutageReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRestaurantControlUnitOutageReportMutation, { data, loading, error }] = useCreateRestaurantControlUnitOutageReportMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      restaurantControlUnitOutageId: // value for 'restaurantControlUnitOutageId'
 *   },
 * });
 */
export function useCreateRestaurantControlUnitOutageReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateRestaurantControlUnitOutageReportMutation, CreateRestaurantControlUnitOutageReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRestaurantControlUnitOutageReportMutation, CreateRestaurantControlUnitOutageReportMutationVariables>(CreateRestaurantControlUnitOutageReportDocument, options);
      }
export type CreateRestaurantControlUnitOutageReportMutationHookResult = ReturnType<typeof useCreateRestaurantControlUnitOutageReportMutation>;
export type CreateRestaurantControlUnitOutageReportMutationResult = Apollo.MutationResult<CreateRestaurantControlUnitOutageReportMutation>;
export type CreateRestaurantControlUnitOutageReportMutationOptions = Apollo.BaseMutationOptions<CreateRestaurantControlUnitOutageReportMutation, CreateRestaurantControlUnitOutageReportMutationVariables>;
export const CreateRestaurantDeliveryLocationShortUrlsDocument = gql`
    mutation CreateRestaurantDeliveryLocationShortUrls($restaurantId: ID!, $whiteLabelId: ID!) {
  createRestaurantDeliveryLocationShortUrls(
    restaurantId: $restaurantId
    whiteLabelId: $whiteLabelId
  ) {
    menuType
    deliveryLocation {
      id
      name
    }
    restaurant {
      id
    }
    shortUrl {
      smartLink
      target
      url
    }
    whiteLabel {
      id
      label
    }
  }
}
    `;
export type CreateRestaurantDeliveryLocationShortUrlsMutationFn = Apollo.MutationFunction<CreateRestaurantDeliveryLocationShortUrlsMutation, CreateRestaurantDeliveryLocationShortUrlsMutationVariables>;

/**
 * __useCreateRestaurantDeliveryLocationShortUrlsMutation__
 *
 * To run a mutation, you first call `useCreateRestaurantDeliveryLocationShortUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRestaurantDeliveryLocationShortUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRestaurantDeliveryLocationShortUrlsMutation, { data, loading, error }] = useCreateRestaurantDeliveryLocationShortUrlsMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      whiteLabelId: // value for 'whiteLabelId'
 *   },
 * });
 */
export function useCreateRestaurantDeliveryLocationShortUrlsMutation(baseOptions?: Apollo.MutationHookOptions<CreateRestaurantDeliveryLocationShortUrlsMutation, CreateRestaurantDeliveryLocationShortUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRestaurantDeliveryLocationShortUrlsMutation, CreateRestaurantDeliveryLocationShortUrlsMutationVariables>(CreateRestaurantDeliveryLocationShortUrlsDocument, options);
      }
export type CreateRestaurantDeliveryLocationShortUrlsMutationHookResult = ReturnType<typeof useCreateRestaurantDeliveryLocationShortUrlsMutation>;
export type CreateRestaurantDeliveryLocationShortUrlsMutationResult = Apollo.MutationResult<CreateRestaurantDeliveryLocationShortUrlsMutation>;
export type CreateRestaurantDeliveryLocationShortUrlsMutationOptions = Apollo.BaseMutationOptions<CreateRestaurantDeliveryLocationShortUrlsMutation, CreateRestaurantDeliveryLocationShortUrlsMutationVariables>;
export const SetCategoryTemporarilyDisabledDocument = gql`
    mutation SetCategoryTemporarilyDisabled($menuCategoryId: ID!, $restaurantId: ID!, $temporarilyDisabled: Boolean!) {
  updateMenuCategory(
    restaurantId: $restaurantId
    menuCategoryId: $menuCategoryId
    patch: {temporarilyDisabled: $temporarilyDisabled}
  ) {
    id
    temporarilyDisabled
  }
}
    `;
export type SetCategoryTemporarilyDisabledMutationFn = Apollo.MutationFunction<SetCategoryTemporarilyDisabledMutation, SetCategoryTemporarilyDisabledMutationVariables>;

/**
 * __useSetCategoryTemporarilyDisabledMutation__
 *
 * To run a mutation, you first call `useSetCategoryTemporarilyDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCategoryTemporarilyDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCategoryTemporarilyDisabledMutation, { data, loading, error }] = useSetCategoryTemporarilyDisabledMutation({
 *   variables: {
 *      menuCategoryId: // value for 'menuCategoryId'
 *      restaurantId: // value for 'restaurantId'
 *      temporarilyDisabled: // value for 'temporarilyDisabled'
 *   },
 * });
 */
export function useSetCategoryTemporarilyDisabledMutation(baseOptions?: Apollo.MutationHookOptions<SetCategoryTemporarilyDisabledMutation, SetCategoryTemporarilyDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCategoryTemporarilyDisabledMutation, SetCategoryTemporarilyDisabledMutationVariables>(SetCategoryTemporarilyDisabledDocument, options);
      }
export type SetCategoryTemporarilyDisabledMutationHookResult = ReturnType<typeof useSetCategoryTemporarilyDisabledMutation>;
export type SetCategoryTemporarilyDisabledMutationResult = Apollo.MutationResult<SetCategoryTemporarilyDisabledMutation>;
export type SetCategoryTemporarilyDisabledMutationOptions = Apollo.BaseMutationOptions<SetCategoryTemporarilyDisabledMutation, SetCategoryTemporarilyDisabledMutationVariables>;
export const GetMenutypeToggleInfoDocument = gql`
    query GetMenutypeToggleInfo($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    deliveryTemporarilyDisabled
    eatInTemporarilyDisabled
    takeAwayTemporarilyDisabled
    hasDeliveryMenu
    hasEatInMenu
    hasTakeAwayMenu
  }
}
    `;

/**
 * __useGetMenutypeToggleInfoQuery__
 *
 * To run a query within a React component, call `useGetMenutypeToggleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenutypeToggleInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenutypeToggleInfoQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetMenutypeToggleInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMenutypeToggleInfoQuery, GetMenutypeToggleInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenutypeToggleInfoQuery, GetMenutypeToggleInfoQueryVariables>(GetMenutypeToggleInfoDocument, options);
      }
export function useGetMenutypeToggleInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenutypeToggleInfoQuery, GetMenutypeToggleInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenutypeToggleInfoQuery, GetMenutypeToggleInfoQueryVariables>(GetMenutypeToggleInfoDocument, options);
        }
export type GetMenutypeToggleInfoQueryHookResult = ReturnType<typeof useGetMenutypeToggleInfoQuery>;
export type GetMenutypeToggleInfoLazyQueryHookResult = ReturnType<typeof useGetMenutypeToggleInfoLazyQuery>;
export type GetMenutypeToggleInfoQueryResult = Apollo.QueryResult<GetMenutypeToggleInfoQuery, GetMenutypeToggleInfoQueryVariables>;
export const SetMenuTypeTemporarilyDisabledDocument = gql`
    mutation SetMenuTypeTemporarilyDisabled($disabled: Boolean!, $menuType: MenuType!, $restaurantId: ID!) {
  setMenuTypeTemporarilyDisabled(
    disabled: $disabled
    menuType: $menuType
    restaurantId: $restaurantId
  )
}
    `;
export type SetMenuTypeTemporarilyDisabledMutationFn = Apollo.MutationFunction<SetMenuTypeTemporarilyDisabledMutation, SetMenuTypeTemporarilyDisabledMutationVariables>;

/**
 * __useSetMenuTypeTemporarilyDisabledMutation__
 *
 * To run a mutation, you first call `useSetMenuTypeTemporarilyDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMenuTypeTemporarilyDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMenuTypeTemporarilyDisabledMutation, { data, loading, error }] = useSetMenuTypeTemporarilyDisabledMutation({
 *   variables: {
 *      disabled: // value for 'disabled'
 *      menuType: // value for 'menuType'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useSetMenuTypeTemporarilyDisabledMutation(baseOptions?: Apollo.MutationHookOptions<SetMenuTypeTemporarilyDisabledMutation, SetMenuTypeTemporarilyDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMenuTypeTemporarilyDisabledMutation, SetMenuTypeTemporarilyDisabledMutationVariables>(SetMenuTypeTemporarilyDisabledDocument, options);
      }
export type SetMenuTypeTemporarilyDisabledMutationHookResult = ReturnType<typeof useSetMenuTypeTemporarilyDisabledMutation>;
export type SetMenuTypeTemporarilyDisabledMutationResult = Apollo.MutationResult<SetMenuTypeTemporarilyDisabledMutation>;
export type SetMenuTypeTemporarilyDisabledMutationOptions = Apollo.BaseMutationOptions<SetMenuTypeTemporarilyDisabledMutation, SetMenuTypeTemporarilyDisabledMutationVariables>;
export const SetPageTemporarilyDisabledDocument = gql`
    mutation SetPageTemporarilyDisabled($menuPageId: ID!, $restaurantId: ID!, $temporarilyDisabled: Boolean!) {
  updateMenuPage(
    restaurantId: $restaurantId
    menuPageId: $menuPageId
    patch: {temporarilyDisabled: $temporarilyDisabled}
  ) {
    id
    temporarilyDisabled
  }
}
    `;
export type SetPageTemporarilyDisabledMutationFn = Apollo.MutationFunction<SetPageTemporarilyDisabledMutation, SetPageTemporarilyDisabledMutationVariables>;

/**
 * __useSetPageTemporarilyDisabledMutation__
 *
 * To run a mutation, you first call `useSetPageTemporarilyDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPageTemporarilyDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPageTemporarilyDisabledMutation, { data, loading, error }] = useSetPageTemporarilyDisabledMutation({
 *   variables: {
 *      menuPageId: // value for 'menuPageId'
 *      restaurantId: // value for 'restaurantId'
 *      temporarilyDisabled: // value for 'temporarilyDisabled'
 *   },
 * });
 */
export function useSetPageTemporarilyDisabledMutation(baseOptions?: Apollo.MutationHookOptions<SetPageTemporarilyDisabledMutation, SetPageTemporarilyDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPageTemporarilyDisabledMutation, SetPageTemporarilyDisabledMutationVariables>(SetPageTemporarilyDisabledDocument, options);
      }
export type SetPageTemporarilyDisabledMutationHookResult = ReturnType<typeof useSetPageTemporarilyDisabledMutation>;
export type SetPageTemporarilyDisabledMutationResult = Apollo.MutationResult<SetPageTemporarilyDisabledMutation>;
export type SetPageTemporarilyDisabledMutationOptions = Apollo.BaseMutationOptions<SetPageTemporarilyDisabledMutation, SetPageTemporarilyDisabledMutationVariables>;
export const UpdateProductIsActiveDocument = gql`
    mutation UpdateProductIsActive($restaurantId: ID!, $menuProductId: ID!, $patch: MenuProductPatch!) {
  updateMenuProduct(
    restaurantId: $restaurantId
    menuProductId: $menuProductId
    patch: $patch
  ) {
    id
  }
}
    `;
export type UpdateProductIsActiveMutationFn = Apollo.MutationFunction<UpdateProductIsActiveMutation, UpdateProductIsActiveMutationVariables>;

/**
 * __useUpdateProductIsActiveMutation__
 *
 * To run a mutation, you first call `useUpdateProductIsActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductIsActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductIsActiveMutation, { data, loading, error }] = useUpdateProductIsActiveMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuProductId: // value for 'menuProductId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateProductIsActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductIsActiveMutation, UpdateProductIsActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductIsActiveMutation, UpdateProductIsActiveMutationVariables>(UpdateProductIsActiveDocument, options);
      }
export type UpdateProductIsActiveMutationHookResult = ReturnType<typeof useUpdateProductIsActiveMutation>;
export type UpdateProductIsActiveMutationResult = Apollo.MutationResult<UpdateProductIsActiveMutation>;
export type UpdateProductIsActiveMutationOptions = Apollo.BaseMutationOptions<UpdateProductIsActiveMutation, UpdateProductIsActiveMutationVariables>;
export const SetDeliveryTimeSlotDisabledDocument = gql`
    mutation SetDeliveryTimeSlotDisabled($deliveryTimeSlotId: ID!, $disabled: Boolean!, $periodicityInput: PeriodicityInput, $restaurantId: ID!) {
  setDeliveryTimeSlotDisabled(
    deliveryTimeSlotId: $deliveryTimeSlotId
    disabled: $disabled
    periodicityInput: $periodicityInput
    restaurantId: $restaurantId
  )
}
    `;
export type SetDeliveryTimeSlotDisabledMutationFn = Apollo.MutationFunction<SetDeliveryTimeSlotDisabledMutation, SetDeliveryTimeSlotDisabledMutationVariables>;

/**
 * __useSetDeliveryTimeSlotDisabledMutation__
 *
 * To run a mutation, you first call `useSetDeliveryTimeSlotDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeliveryTimeSlotDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeliveryTimeSlotDisabledMutation, { data, loading, error }] = useSetDeliveryTimeSlotDisabledMutation({
 *   variables: {
 *      deliveryTimeSlotId: // value for 'deliveryTimeSlotId'
 *      disabled: // value for 'disabled'
 *      periodicityInput: // value for 'periodicityInput'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useSetDeliveryTimeSlotDisabledMutation(baseOptions?: Apollo.MutationHookOptions<SetDeliveryTimeSlotDisabledMutation, SetDeliveryTimeSlotDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDeliveryTimeSlotDisabledMutation, SetDeliveryTimeSlotDisabledMutationVariables>(SetDeliveryTimeSlotDisabledDocument, options);
      }
export type SetDeliveryTimeSlotDisabledMutationHookResult = ReturnType<typeof useSetDeliveryTimeSlotDisabledMutation>;
export type SetDeliveryTimeSlotDisabledMutationResult = Apollo.MutationResult<SetDeliveryTimeSlotDisabledMutation>;
export type SetDeliveryTimeSlotDisabledMutationOptions = Apollo.BaseMutationOptions<SetDeliveryTimeSlotDisabledMutation, SetDeliveryTimeSlotDisabledMutationVariables>;
export const CreateShortUrlDocument = gql`
    mutation CreateShortUrl($whiteLabelId: ID!, $input: ShortUrlInput!) {
  createShortUrl(whiteLabelId: $whiteLabelId, input: $input) {
    smartLink
    target
    url
  }
}
    `;
export type CreateShortUrlMutationFn = Apollo.MutationFunction<CreateShortUrlMutation, CreateShortUrlMutationVariables>;

/**
 * __useCreateShortUrlMutation__
 *
 * To run a mutation, you first call `useCreateShortUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShortUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShortUrlMutation, { data, loading, error }] = useCreateShortUrlMutation({
 *   variables: {
 *      whiteLabelId: // value for 'whiteLabelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShortUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateShortUrlMutation, CreateShortUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShortUrlMutation, CreateShortUrlMutationVariables>(CreateShortUrlDocument, options);
      }
export type CreateShortUrlMutationHookResult = ReturnType<typeof useCreateShortUrlMutation>;
export type CreateShortUrlMutationResult = Apollo.MutationResult<CreateShortUrlMutation>;
export type CreateShortUrlMutationOptions = Apollo.BaseMutationOptions<CreateShortUrlMutation, CreateShortUrlMutationVariables>;
export const DeleteWhiteLabelDocument = gql`
    mutation DeleteWhiteLabel($whiteLabelId: ID!) {
  deleteWhiteLabel(whiteLabelId: $whiteLabelId)
}
    `;
export type DeleteWhiteLabelMutationFn = Apollo.MutationFunction<DeleteWhiteLabelMutation, DeleteWhiteLabelMutationVariables>;

/**
 * __useDeleteWhiteLabelMutation__
 *
 * To run a mutation, you first call `useDeleteWhiteLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWhiteLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWhiteLabelMutation, { data, loading, error }] = useDeleteWhiteLabelMutation({
 *   variables: {
 *      whiteLabelId: // value for 'whiteLabelId'
 *   },
 * });
 */
export function useDeleteWhiteLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWhiteLabelMutation, DeleteWhiteLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWhiteLabelMutation, DeleteWhiteLabelMutationVariables>(DeleteWhiteLabelDocument, options);
      }
export type DeleteWhiteLabelMutationHookResult = ReturnType<typeof useDeleteWhiteLabelMutation>;
export type DeleteWhiteLabelMutationResult = Apollo.MutationResult<DeleteWhiteLabelMutation>;
export type DeleteWhiteLabelMutationOptions = Apollo.BaseMutationOptions<DeleteWhiteLabelMutation, DeleteWhiteLabelMutationVariables>;
export const UpdateWhiteLabelDocument = gql`
    mutation UpdateWhiteLabel($whiteLabelId: ID!, $patch: WhiteLabelPatch!) {
  updateWhiteLabel(whiteLabelId: $whiteLabelId, patch: $patch) {
    ...WhiteLabelFields
  }
}
    ${WhiteLabelFieldsFragmentDoc}`;
export type UpdateWhiteLabelMutationFn = Apollo.MutationFunction<UpdateWhiteLabelMutation, UpdateWhiteLabelMutationVariables>;

/**
 * __useUpdateWhiteLabelMutation__
 *
 * To run a mutation, you first call `useUpdateWhiteLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWhiteLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWhiteLabelMutation, { data, loading, error }] = useUpdateWhiteLabelMutation({
 *   variables: {
 *      whiteLabelId: // value for 'whiteLabelId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateWhiteLabelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWhiteLabelMutation, UpdateWhiteLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWhiteLabelMutation, UpdateWhiteLabelMutationVariables>(UpdateWhiteLabelDocument, options);
      }
export type UpdateWhiteLabelMutationHookResult = ReturnType<typeof useUpdateWhiteLabelMutation>;
export type UpdateWhiteLabelMutationResult = Apollo.MutationResult<UpdateWhiteLabelMutation>;
export type UpdateWhiteLabelMutationOptions = Apollo.BaseMutationOptions<UpdateWhiteLabelMutation, UpdateWhiteLabelMutationVariables>;
export const PublishWhiteLabelDocument = gql`
    mutation PublishWhiteLabel($whiteLabelId: ID!) {
  publishWhiteLabel(whiteLabelId: $whiteLabelId) {
    id
    isPublishing
  }
}
    `;
export type PublishWhiteLabelMutationFn = Apollo.MutationFunction<PublishWhiteLabelMutation, PublishWhiteLabelMutationVariables>;

/**
 * __usePublishWhiteLabelMutation__
 *
 * To run a mutation, you first call `usePublishWhiteLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWhiteLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWhiteLabelMutation, { data, loading, error }] = usePublishWhiteLabelMutation({
 *   variables: {
 *      whiteLabelId: // value for 'whiteLabelId'
 *   },
 * });
 */
export function usePublishWhiteLabelMutation(baseOptions?: Apollo.MutationHookOptions<PublishWhiteLabelMutation, PublishWhiteLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishWhiteLabelMutation, PublishWhiteLabelMutationVariables>(PublishWhiteLabelDocument, options);
      }
export type PublishWhiteLabelMutationHookResult = ReturnType<typeof usePublishWhiteLabelMutation>;
export type PublishWhiteLabelMutationResult = Apollo.MutationResult<PublishWhiteLabelMutation>;
export type PublishWhiteLabelMutationOptions = Apollo.BaseMutationOptions<PublishWhiteLabelMutation, PublishWhiteLabelMutationVariables>;
export const GetAddonProductsDocument = gql`
    query GetAddonProducts($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    name
    location {
      latitude
      longitude
    }
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      id
      addonProducts {
        ...FullAddonProduct
      }
      reportGroups {
        ...FullMenuReportGroup
      }
    }
  }
}
    ${FullAddonProductFragmentDoc}
${FullMenuReportGroupFragmentDoc}`;

/**
 * __useGetAddonProductsQuery__
 *
 * To run a query within a React component, call `useGetAddonProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddonProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddonProductsQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetAddonProductsQuery(baseOptions: Apollo.QueryHookOptions<GetAddonProductsQuery, GetAddonProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddonProductsQuery, GetAddonProductsQueryVariables>(GetAddonProductsDocument, options);
      }
export function useGetAddonProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddonProductsQuery, GetAddonProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddonProductsQuery, GetAddonProductsQueryVariables>(GetAddonProductsDocument, options);
        }
export type GetAddonProductsQueryHookResult = ReturnType<typeof useGetAddonProductsQuery>;
export type GetAddonProductsLazyQueryHookResult = ReturnType<typeof useGetAddonProductsLazyQuery>;
export type GetAddonProductsQueryResult = Apollo.QueryResult<GetAddonProductsQuery, GetAddonProductsQueryVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    employees {
      ...EmployeeFields
    }
    employeeGroups {
      ...EmployeeGroupFields
    }
  }
}
    ${EmployeeFieldsFragmentDoc}
${EmployeeGroupFieldsFragmentDoc}`;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetMenuOpeningHoursDocument = gql`
    query GetMenuOpeningHours($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu {
      productOpeningHours {
        ...ProductOpeningHours
      }
    }
  }
}
    ${ProductOpeningHoursFragmentDoc}`;

/**
 * __useGetMenuOpeningHoursQuery__
 *
 * To run a query within a React component, call `useGetMenuOpeningHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuOpeningHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuOpeningHoursQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetMenuOpeningHoursQuery(baseOptions: Apollo.QueryHookOptions<GetMenuOpeningHoursQuery, GetMenuOpeningHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuOpeningHoursQuery, GetMenuOpeningHoursQueryVariables>(GetMenuOpeningHoursDocument, options);
      }
export function useGetMenuOpeningHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuOpeningHoursQuery, GetMenuOpeningHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuOpeningHoursQuery, GetMenuOpeningHoursQueryVariables>(GetMenuOpeningHoursDocument, options);
        }
export type GetMenuOpeningHoursQueryHookResult = ReturnType<typeof useGetMenuOpeningHoursQuery>;
export type GetMenuOpeningHoursLazyQueryHookResult = ReturnType<typeof useGetMenuOpeningHoursLazyQuery>;
export type GetMenuOpeningHoursQueryResult = Apollo.QueryResult<GetMenuOpeningHoursQuery, GetMenuOpeningHoursQueryVariables>;
export const GetMenuPagesDocument = gql`
    query GetMenuPages($restaurantId: ID!) {
  me {
    isSuperUser
  }
  restaurant(id: $restaurantId) {
    id
    clientHeaderMessage
    hasClientHeaderMessageAccess
    hasMenuStockWriteAccess: hasAccess(access: MenuStockWrite)
    hasMenuWriteAccess: hasAccess(access: MenuWrite)
    hasSettingsWriteAccess: hasAccess(access: SettingsWrite)
    name
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      id
      pages {
        ...MenuPageFields
      }
    }
  }
}
    ${MenuPageFieldsFragmentDoc}`;

/**
 * __useGetMenuPagesQuery__
 *
 * To run a query within a React component, call `useGetMenuPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuPagesQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetMenuPagesQuery(baseOptions: Apollo.QueryHookOptions<GetMenuPagesQuery, GetMenuPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuPagesQuery, GetMenuPagesQueryVariables>(GetMenuPagesDocument, options);
      }
export function useGetMenuPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuPagesQuery, GetMenuPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuPagesQuery, GetMenuPagesQueryVariables>(GetMenuPagesDocument, options);
        }
export type GetMenuPagesQueryHookResult = ReturnType<typeof useGetMenuPagesQuery>;
export type GetMenuPagesLazyQueryHookResult = ReturnType<typeof useGetMenuPagesLazyQuery>;
export type GetMenuPagesQueryResult = Apollo.QueryResult<GetMenuPagesQuery, GetMenuPagesQueryVariables>;
export const GetPageMenuDocument = gql`
    query GetPageMenu($restaurantId: ID!, $menuPageId: ID!) {
  restaurant(id: $restaurantId) {
    id
    hasMenuStockWriteAccess: hasAccess(access: MenuStockWrite)
    hasMenuWriteAccess: hasAccess(access: MenuWrite)
    hasSettingsWriteAccess: hasAccess(access: SettingsWrite)
    menuSystem
    name
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      page(id: $menuPageId) {
        id
        name
        temporarilyDisabled
        categories {
          ...MenuCategoryFields
        }
      }
    }
  }
}
    ${MenuCategoryFieldsFragmentDoc}`;

/**
 * __useGetPageMenuQuery__
 *
 * To run a query within a React component, call `useGetPageMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageMenuQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuPageId: // value for 'menuPageId'
 *   },
 * });
 */
export function useGetPageMenuQuery(baseOptions: Apollo.QueryHookOptions<GetPageMenuQuery, GetPageMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageMenuQuery, GetPageMenuQueryVariables>(GetPageMenuDocument, options);
      }
export function useGetPageMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageMenuQuery, GetPageMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageMenuQuery, GetPageMenuQueryVariables>(GetPageMenuDocument, options);
        }
export type GetPageMenuQueryHookResult = ReturnType<typeof useGetPageMenuQuery>;
export type GetPageMenuLazyQueryHookResult = ReturnType<typeof useGetPageMenuLazyQuery>;
export type GetPageMenuQueryResult = Apollo.QueryResult<GetPageMenuQuery, GetPageMenuQueryVariables>;
export const GetRestaurantOpeningHoursDocument = gql`
    query GetRestaurantOpeningHours($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    openingHours {
      id
      periods {
        open {
          day
          time
        }
        close {
          day
          time
        }
      }
    }
  }
}
    `;

/**
 * __useGetRestaurantOpeningHoursQuery__
 *
 * To run a query within a React component, call `useGetRestaurantOpeningHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantOpeningHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantOpeningHoursQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantOpeningHoursQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantOpeningHoursQuery, GetRestaurantOpeningHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantOpeningHoursQuery, GetRestaurantOpeningHoursQueryVariables>(GetRestaurantOpeningHoursDocument, options);
      }
export function useGetRestaurantOpeningHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantOpeningHoursQuery, GetRestaurantOpeningHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantOpeningHoursQuery, GetRestaurantOpeningHoursQueryVariables>(GetRestaurantOpeningHoursDocument, options);
        }
export type GetRestaurantOpeningHoursQueryHookResult = ReturnType<typeof useGetRestaurantOpeningHoursQuery>;
export type GetRestaurantOpeningHoursLazyQueryHookResult = ReturnType<typeof useGetRestaurantOpeningHoursLazyQuery>;
export type GetRestaurantOpeningHoursQueryResult = Apollo.QueryResult<GetRestaurantOpeningHoursQuery, GetRestaurantOpeningHoursQueryVariables>;
export const GetRestaurantPaymentMethodListDataDocument = gql`
    query GetRestaurantPaymentMethodListData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    paymentMethods {
      ...FullPaymentMethod
    }
  }
}
    ${FullPaymentMethodFragmentDoc}`;

/**
 * __useGetRestaurantPaymentMethodListDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantPaymentMethodListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantPaymentMethodListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantPaymentMethodListDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantPaymentMethodListDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantPaymentMethodListDataQuery, GetRestaurantPaymentMethodListDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantPaymentMethodListDataQuery, GetRestaurantPaymentMethodListDataQueryVariables>(GetRestaurantPaymentMethodListDataDocument, options);
      }
export function useGetRestaurantPaymentMethodListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantPaymentMethodListDataQuery, GetRestaurantPaymentMethodListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantPaymentMethodListDataQuery, GetRestaurantPaymentMethodListDataQueryVariables>(GetRestaurantPaymentMethodListDataDocument, options);
        }
export type GetRestaurantPaymentMethodListDataQueryHookResult = ReturnType<typeof useGetRestaurantPaymentMethodListDataQuery>;
export type GetRestaurantPaymentMethodListDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantPaymentMethodListDataLazyQuery>;
export type GetRestaurantPaymentMethodListDataQueryResult = Apollo.QueryResult<GetRestaurantPaymentMethodListDataQuery, GetRestaurantPaymentMethodListDataQueryVariables>;
export const GetRestaurantSalesDocument = gql`
    query GetRestaurantSales($restaurantId: ID!, $dateTimeRange: DateTimeRangeInput!, $filter: RestaurantStatisticsFilter, $resolution: TimeResolution!) {
  restaurant(id: $restaurantId) {
    id
    statistics(
      dateTimeRange: $dateTimeRange
      filter: $filter
      resolution: $resolution
    ) {
      id
      refundsByPaymentName {
        id
        count
        grossAmount
        paymentName
        tipAmount
      }
      refundsByProduct {
        id
        count
        discountAmount
        grossAmount
        name
        netAmount
        price
        productId
        vatAmount
        addons {
          id
          count
          discountAmount
          grossAmount
          name
          netAmount
          price
          productId
          vatAmount
        }
        alternativeItems {
          id
          count
          name
        }
      }
      salesByMenuType {
        id
        count
        grossAmount
        menuType
        vatAmount
      }
      salesByMenuTypeAndTimePeriod {
        id
        count
        grossAmount
        menuType
        periodStart
      }
      salesByPaymentName {
        id
        count
        grossAmount
        paymentName
        tipAmount
      }
      salesByProduct {
        id
        count
        discountAmount
        grossAmount
        name
        netAmount
        price
        productId
        vatAmount
        addons {
          id
          count
          discountAmount
          grossAmount
          name
          netAmount
          price
          productId
          vatAmount
        }
        alternativeItems {
          id
          count
          name
        }
      }
      salesByReportGroup {
        id
        count
        discountAmount
        grossAmount
        netAmount
        reportGroupName
        vatAmount
      }
    }
  }
}
    `;

/**
 * __useGetRestaurantSalesQuery__
 *
 * To run a query within a React component, call `useGetRestaurantSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantSalesQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      dateTimeRange: // value for 'dateTimeRange'
 *      filter: // value for 'filter'
 *      resolution: // value for 'resolution'
 *   },
 * });
 */
export function useGetRestaurantSalesQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantSalesQuery, GetRestaurantSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantSalesQuery, GetRestaurantSalesQueryVariables>(GetRestaurantSalesDocument, options);
      }
export function useGetRestaurantSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantSalesQuery, GetRestaurantSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantSalesQuery, GetRestaurantSalesQueryVariables>(GetRestaurantSalesDocument, options);
        }
export type GetRestaurantSalesQueryHookResult = ReturnType<typeof useGetRestaurantSalesQuery>;
export type GetRestaurantSalesLazyQueryHookResult = ReturnType<typeof useGetRestaurantSalesLazyQuery>;
export type GetRestaurantSalesQueryResult = Apollo.QueryResult<GetRestaurantSalesQuery, GetRestaurantSalesQueryVariables>;
export const GetRestaurantTimezoneDocument = gql`
    query GetRestaurantTimezone($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    timeZone
  }
}
    `;

/**
 * __useGetRestaurantTimezoneQuery__
 *
 * To run a query within a React component, call `useGetRestaurantTimezoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantTimezoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantTimezoneQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantTimezoneQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantTimezoneQuery, GetRestaurantTimezoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantTimezoneQuery, GetRestaurantTimezoneQueryVariables>(GetRestaurantTimezoneDocument, options);
      }
export function useGetRestaurantTimezoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantTimezoneQuery, GetRestaurantTimezoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantTimezoneQuery, GetRestaurantTimezoneQueryVariables>(GetRestaurantTimezoneDocument, options);
        }
export type GetRestaurantTimezoneQueryHookResult = ReturnType<typeof useGetRestaurantTimezoneQuery>;
export type GetRestaurantTimezoneLazyQueryHookResult = ReturnType<typeof useGetRestaurantTimezoneLazyQuery>;
export type GetRestaurantTimezoneQueryResult = Apollo.QueryResult<GetRestaurantTimezoneQuery, GetRestaurantTimezoneQueryVariables>;
export const GetTillsDocument = gql`
    query GetTills($restaurantId: ID!) {
  me {
    id
    isSuperUser
  }
  restaurant(id: $restaurantId) {
    id
    hasNetsConnectCloudLink
    hasSkipSlipPrintOnPrinterQueuesAccess
    isBetaTesting
    netsConnectCloudUsername
    orderDisplaySystemEnabled
    deliveryLocations {
      id
      name
    }
    paymentMethods {
      ...FullPaymentMethod
    }
    posTerminals {
      ...FullPosTerminal
    }
    printerQueues {
      id
      name
    }
    tills {
      ...FullTill
    }
  }
}
    ${FullPaymentMethodFragmentDoc}
${FullPosTerminalFragmentDoc}
${FullTillFragmentDoc}`;

/**
 * __useGetTillsQuery__
 *
 * To run a query within a React component, call `useGetTillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTillsQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetTillsQuery(baseOptions: Apollo.QueryHookOptions<GetTillsQuery, GetTillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTillsQuery, GetTillsQueryVariables>(GetTillsDocument, options);
      }
export function useGetTillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTillsQuery, GetTillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTillsQuery, GetTillsQueryVariables>(GetTillsDocument, options);
        }
export type GetTillsQueryHookResult = ReturnType<typeof useGetTillsQuery>;
export type GetTillsLazyQueryHookResult = ReturnType<typeof useGetTillsLazyQuery>;
export type GetTillsQueryResult = Apollo.QueryResult<GetTillsQuery, GetTillsQueryVariables>;
export const GetTimeSlotsDocument = gql`
    query GetTimeSlots($restaurantId: ID!, $dateTimeRange: DateTimeRangeInput) {
  restaurant(id: $restaurantId) {
    id
    hasDeliveryMenu
    hasEatInMenu
    hasTakeAwayMenu
    maxDeliveryTime
    queueTime
    deliveryDeliveryTimeSlots: deliveryTimeSlots(
      menuType: Delivery
      dateTimeRange: $dateTimeRange
    ) {
      ...DeliveryTimeSlot
    }
    eatInDeliveryTimeSlots: deliveryTimeSlots(
      menuType: EatIn
      dateTimeRange: $dateTimeRange
    ) {
      ...DeliveryTimeSlot
    }
    takeAwayDeliveryTimeSlots: deliveryTimeSlots(
      menuType: TakeAway
      dateTimeRange: $dateTimeRange
    ) {
      ...DeliveryTimeSlot
    }
  }
}
    ${DeliveryTimeSlotFragmentDoc}`;

/**
 * __useGetTimeSlotsQuery__
 *
 * To run a query within a React component, call `useGetTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeSlotsQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      dateTimeRange: // value for 'dateTimeRange'
 *   },
 * });
 */
export function useGetTimeSlotsQuery(baseOptions: Apollo.QueryHookOptions<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>(GetTimeSlotsDocument, options);
      }
export function useGetTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>(GetTimeSlotsDocument, options);
        }
export type GetTimeSlotsQueryHookResult = ReturnType<typeof useGetTimeSlotsQuery>;
export type GetTimeSlotsLazyQueryHookResult = ReturnType<typeof useGetTimeSlotsLazyQuery>;
export type GetTimeSlotsQueryResult = Apollo.QueryResult<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>;
export const GetAccountDataDocument = gql`
    query GetAccountData {
  me {
    id
    username
    restaurantsWithAccess(access: Write) {
      id
      name
    }
  }
  sudoMode {
    id
    expiresAt
  }
}
    `;

/**
 * __useGetAccountDataQuery__
 *
 * To run a query within a React component, call `useGetAccountDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountDataQuery, GetAccountDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountDataQuery, GetAccountDataQueryVariables>(GetAccountDataDocument, options);
      }
export function useGetAccountDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountDataQuery, GetAccountDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountDataQuery, GetAccountDataQueryVariables>(GetAccountDataDocument, options);
        }
export type GetAccountDataQueryHookResult = ReturnType<typeof useGetAccountDataQuery>;
export type GetAccountDataLazyQueryHookResult = ReturnType<typeof useGetAccountDataLazyQuery>;
export type GetAccountDataQueryResult = Apollo.QueryResult<GetAccountDataQuery, GetAccountDataQueryVariables>;
export const ListCashregisterReportsDocument = gql`
    query ListCashregisterReports($restaurantId: ID!, $cursor: String) {
  restaurant(id: $restaurantId) {
    id
    nextCashregisterReportGenerationTime
    timeZone
    xReport {
      net {
        grossAmount
        transactionCount
      }
    }
    zReports(first: 25, after: $cursor) {
      edges {
        cursor
        node {
          id
          serialNumber
          datePeriod {
            start
            end
          }
          net {
            grossAmount
            transactionCount
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useListCashregisterReportsQuery__
 *
 * To run a query within a React component, call `useListCashregisterReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCashregisterReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCashregisterReportsQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListCashregisterReportsQuery(baseOptions: Apollo.QueryHookOptions<ListCashregisterReportsQuery, ListCashregisterReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCashregisterReportsQuery, ListCashregisterReportsQueryVariables>(ListCashregisterReportsDocument, options);
      }
export function useListCashregisterReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCashregisterReportsQuery, ListCashregisterReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCashregisterReportsQuery, ListCashregisterReportsQueryVariables>(ListCashregisterReportsDocument, options);
        }
export type ListCashregisterReportsQueryHookResult = ReturnType<typeof useListCashregisterReportsQuery>;
export type ListCashregisterReportsLazyQueryHookResult = ReturnType<typeof useListCashregisterReportsLazyQuery>;
export type ListCashregisterReportsQueryResult = Apollo.QueryResult<ListCashregisterReportsQuery, ListCashregisterReportsQueryVariables>;
export const ScheduleCashregisterReportGenerationDocument = gql`
    mutation ScheduleCashregisterReportGeneration($restaurantId: ID!, $at: DateTime) {
  scheduleCashregisterReportGeneration(restaurantId: $restaurantId, at: $at) {
    id
    nextCashregisterReportGenerationTime
  }
}
    `;
export type ScheduleCashregisterReportGenerationMutationFn = Apollo.MutationFunction<ScheduleCashregisterReportGenerationMutation, ScheduleCashregisterReportGenerationMutationVariables>;

/**
 * __useScheduleCashregisterReportGenerationMutation__
 *
 * To run a mutation, you first call `useScheduleCashregisterReportGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleCashregisterReportGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleCashregisterReportGenerationMutation, { data, loading, error }] = useScheduleCashregisterReportGenerationMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      at: // value for 'at'
 *   },
 * });
 */
export function useScheduleCashregisterReportGenerationMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleCashregisterReportGenerationMutation, ScheduleCashregisterReportGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleCashregisterReportGenerationMutation, ScheduleCashregisterReportGenerationMutationVariables>(ScheduleCashregisterReportGenerationDocument, options);
      }
export type ScheduleCashregisterReportGenerationMutationHookResult = ReturnType<typeof useScheduleCashregisterReportGenerationMutation>;
export type ScheduleCashregisterReportGenerationMutationResult = Apollo.MutationResult<ScheduleCashregisterReportGenerationMutation>;
export type ScheduleCashregisterReportGenerationMutationOptions = Apollo.BaseMutationOptions<ScheduleCashregisterReportGenerationMutation, ScheduleCashregisterReportGenerationMutationVariables>;
export const CreateCashregisterReportDocument = gql`
    mutation CreateCashregisterReport($restaurantId: ID!) {
  createCashregisterReport(restaurantId: $restaurantId) {
    id
  }
}
    `;
export type CreateCashregisterReportMutationFn = Apollo.MutationFunction<CreateCashregisterReportMutation, CreateCashregisterReportMutationVariables>;

/**
 * __useCreateCashregisterReportMutation__
 *
 * To run a mutation, you first call `useCreateCashregisterReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashregisterReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashregisterReportMutation, { data, loading, error }] = useCreateCashregisterReportMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useCreateCashregisterReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashregisterReportMutation, CreateCashregisterReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashregisterReportMutation, CreateCashregisterReportMutationVariables>(CreateCashregisterReportDocument, options);
      }
export type CreateCashregisterReportMutationHookResult = ReturnType<typeof useCreateCashregisterReportMutation>;
export type CreateCashregisterReportMutationResult = Apollo.MutationResult<CreateCashregisterReportMutation>;
export type CreateCashregisterReportMutationOptions = Apollo.BaseMutationOptions<CreateCashregisterReportMutation, CreateCashregisterReportMutationVariables>;
export const GetXReportHtmlDocument = gql`
    query GetXReportHtml($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    xReport {
      id
      html
    }
  }
}
    `;

/**
 * __useGetXReportHtmlQuery__
 *
 * To run a query within a React component, call `useGetXReportHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetXReportHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXReportHtmlQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetXReportHtmlQuery(baseOptions: Apollo.QueryHookOptions<GetXReportHtmlQuery, GetXReportHtmlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetXReportHtmlQuery, GetXReportHtmlQueryVariables>(GetXReportHtmlDocument, options);
      }
export function useGetXReportHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetXReportHtmlQuery, GetXReportHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetXReportHtmlQuery, GetXReportHtmlQueryVariables>(GetXReportHtmlDocument, options);
        }
export type GetXReportHtmlQueryHookResult = ReturnType<typeof useGetXReportHtmlQuery>;
export type GetXReportHtmlLazyQueryHookResult = ReturnType<typeof useGetXReportHtmlLazyQuery>;
export type GetXReportHtmlQueryResult = Apollo.QueryResult<GetXReportHtmlQuery, GetXReportHtmlQueryVariables>;
export const GetZReportHtmlDocument = gql`
    query GetZReportHtml($restaurantId: ID!, $reportId: ID!) {
  restaurant(id: $restaurantId) {
    id
    zReport(id: $reportId) {
      id
      html
    }
  }
}
    `;

/**
 * __useGetZReportHtmlQuery__
 *
 * To run a query within a React component, call `useGetZReportHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZReportHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZReportHtmlQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetZReportHtmlQuery(baseOptions: Apollo.QueryHookOptions<GetZReportHtmlQuery, GetZReportHtmlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZReportHtmlQuery, GetZReportHtmlQueryVariables>(GetZReportHtmlDocument, options);
      }
export function useGetZReportHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZReportHtmlQuery, GetZReportHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZReportHtmlQuery, GetZReportHtmlQueryVariables>(GetZReportHtmlDocument, options);
        }
export type GetZReportHtmlQueryHookResult = ReturnType<typeof useGetZReportHtmlQuery>;
export type GetZReportHtmlLazyQueryHookResult = ReturnType<typeof useGetZReportHtmlLazyQuery>;
export type GetZReportHtmlQueryResult = Apollo.QueryResult<GetZReportHtmlQuery, GetZReportHtmlQueryVariables>;
export const GetCashregisterDocument = gql`
    query GetCashregister($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    hasReportReadAccess: hasAccess(access: ReportRead)
    cashregister {
      id
      isRegistered
      manufacturer
      model
      name
      softwareName
      softwareVersion
      controlUnit {
        address
        identificationNumber
        isRegistered
        manufacturer
        model
        productionNumber
        serialNumber
      }
    }
  }
}
    `;

/**
 * __useGetCashregisterQuery__
 *
 * To run a query within a React component, call `useGetCashregisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashregisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashregisterQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetCashregisterQuery(baseOptions: Apollo.QueryHookOptions<GetCashregisterQuery, GetCashregisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCashregisterQuery, GetCashregisterQueryVariables>(GetCashregisterDocument, options);
      }
export function useGetCashregisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCashregisterQuery, GetCashregisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCashregisterQuery, GetCashregisterQueryVariables>(GetCashregisterDocument, options);
        }
export type GetCashregisterQueryHookResult = ReturnType<typeof useGetCashregisterQuery>;
export type GetCashregisterLazyQueryHookResult = ReturnType<typeof useGetCashregisterLazyQuery>;
export type GetCashregisterQueryResult = Apollo.QueryResult<GetCashregisterQuery, GetCashregisterQueryVariables>;
export const GetControlUnitListDataDocument = gql`
    query GetControlUnitListData {
  physicalControlUnits {
    edges {
      node {
        ...FullPhysicalControlUnit
      }
    }
  }
}
    ${FullPhysicalControlUnitFragmentDoc}`;

/**
 * __useGetControlUnitListDataQuery__
 *
 * To run a query within a React component, call `useGetControlUnitListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetControlUnitListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetControlUnitListDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetControlUnitListDataQuery(baseOptions?: Apollo.QueryHookOptions<GetControlUnitListDataQuery, GetControlUnitListDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetControlUnitListDataQuery, GetControlUnitListDataQueryVariables>(GetControlUnitListDataDocument, options);
      }
export function useGetControlUnitListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetControlUnitListDataQuery, GetControlUnitListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetControlUnitListDataQuery, GetControlUnitListDataQueryVariables>(GetControlUnitListDataDocument, options);
        }
export type GetControlUnitListDataQueryHookResult = ReturnType<typeof useGetControlUnitListDataQuery>;
export type GetControlUnitListDataLazyQueryHookResult = ReturnType<typeof useGetControlUnitListDataLazyQuery>;
export type GetControlUnitListDataQueryResult = Apollo.QueryResult<GetControlUnitListDataQuery, GetControlUnitListDataQueryVariables>;
export const GetControlUnitViewDataDocument = gql`
    query GetControlUnitViewData($controlUnitId: ID!) {
  physicalControlUnit(id: $controlUnitId) {
    id
    address
    createdAt
    manufacturer
    model
    serialNumber
    updatedAt
    outages(first: 999) {
      edges {
        node {
          id
          createdAt
          restoredAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetControlUnitViewDataQuery__
 *
 * To run a query within a React component, call `useGetControlUnitViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetControlUnitViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetControlUnitViewDataQuery({
 *   variables: {
 *      controlUnitId: // value for 'controlUnitId'
 *   },
 * });
 */
export function useGetControlUnitViewDataQuery(baseOptions: Apollo.QueryHookOptions<GetControlUnitViewDataQuery, GetControlUnitViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetControlUnitViewDataQuery, GetControlUnitViewDataQueryVariables>(GetControlUnitViewDataDocument, options);
      }
export function useGetControlUnitViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetControlUnitViewDataQuery, GetControlUnitViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetControlUnitViewDataQuery, GetControlUnitViewDataQueryVariables>(GetControlUnitViewDataDocument, options);
        }
export type GetControlUnitViewDataQueryHookResult = ReturnType<typeof useGetControlUnitViewDataQuery>;
export type GetControlUnitViewDataLazyQueryHookResult = ReturnType<typeof useGetControlUnitViewDataLazyQuery>;
export type GetControlUnitViewDataQueryResult = Apollo.QueryResult<GetControlUnitViewDataQuery, GetControlUnitViewDataQueryVariables>;
export const CreatePhysicalControlUnitOutageDocument = gql`
    mutation CreatePhysicalControlUnitOutage($physicalControlUnitId: ID!) {
  createPhysicalControlUnitOutage(physicalControlUnitId: $physicalControlUnitId) {
    id
  }
}
    `;
export type CreatePhysicalControlUnitOutageMutationFn = Apollo.MutationFunction<CreatePhysicalControlUnitOutageMutation, CreatePhysicalControlUnitOutageMutationVariables>;

/**
 * __useCreatePhysicalControlUnitOutageMutation__
 *
 * To run a mutation, you first call `useCreatePhysicalControlUnitOutageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhysicalControlUnitOutageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhysicalControlUnitOutageMutation, { data, loading, error }] = useCreatePhysicalControlUnitOutageMutation({
 *   variables: {
 *      physicalControlUnitId: // value for 'physicalControlUnitId'
 *   },
 * });
 */
export function useCreatePhysicalControlUnitOutageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhysicalControlUnitOutageMutation, CreatePhysicalControlUnitOutageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhysicalControlUnitOutageMutation, CreatePhysicalControlUnitOutageMutationVariables>(CreatePhysicalControlUnitOutageDocument, options);
      }
export type CreatePhysicalControlUnitOutageMutationHookResult = ReturnType<typeof useCreatePhysicalControlUnitOutageMutation>;
export type CreatePhysicalControlUnitOutageMutationResult = Apollo.MutationResult<CreatePhysicalControlUnitOutageMutation>;
export type CreatePhysicalControlUnitOutageMutationOptions = Apollo.BaseMutationOptions<CreatePhysicalControlUnitOutageMutation, CreatePhysicalControlUnitOutageMutationVariables>;
export const RestorePhysicalControlUnitOutageDocument = gql`
    mutation RestorePhysicalControlUnitOutage($controlUnitOutageId: ID!) {
  restorePhysicalControlUnitOutage(controlUnitOutageId: $controlUnitOutageId) {
    id
    restoredAt
  }
}
    `;
export type RestorePhysicalControlUnitOutageMutationFn = Apollo.MutationFunction<RestorePhysicalControlUnitOutageMutation, RestorePhysicalControlUnitOutageMutationVariables>;

/**
 * __useRestorePhysicalControlUnitOutageMutation__
 *
 * To run a mutation, you first call `useRestorePhysicalControlUnitOutageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePhysicalControlUnitOutageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePhysicalControlUnitOutageMutation, { data, loading, error }] = useRestorePhysicalControlUnitOutageMutation({
 *   variables: {
 *      controlUnitOutageId: // value for 'controlUnitOutageId'
 *   },
 * });
 */
export function useRestorePhysicalControlUnitOutageMutation(baseOptions?: Apollo.MutationHookOptions<RestorePhysicalControlUnitOutageMutation, RestorePhysicalControlUnitOutageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestorePhysicalControlUnitOutageMutation, RestorePhysicalControlUnitOutageMutationVariables>(RestorePhysicalControlUnitOutageDocument, options);
      }
export type RestorePhysicalControlUnitOutageMutationHookResult = ReturnType<typeof useRestorePhysicalControlUnitOutageMutation>;
export type RestorePhysicalControlUnitOutageMutationResult = Apollo.MutationResult<RestorePhysicalControlUnitOutageMutation>;
export type RestorePhysicalControlUnitOutageMutationOptions = Apollo.BaseMutationOptions<RestorePhysicalControlUnitOutageMutation, RestorePhysicalControlUnitOutageMutationVariables>;
export const AcceptDeliveryHeroIntegrationTermsOfServiceDocument = gql`
    mutation AcceptDeliveryHeroIntegrationTermsOfService($restaurantId: ID!, $input: AcceptDeliveryHeroIntegrationTermsOfServiceInput!) {
  acceptDeliveryHeroIntegrationTermsOfService(
    restaurantId: $restaurantId
    input: $input
  ) {
    id
    hasDeliveryHeroAccess
    deliveryHeroSetupQuestionnaire {
      hasAccount
      isReceivingOrders
    }
  }
}
    `;
export type AcceptDeliveryHeroIntegrationTermsOfServiceMutationFn = Apollo.MutationFunction<AcceptDeliveryHeroIntegrationTermsOfServiceMutation, AcceptDeliveryHeroIntegrationTermsOfServiceMutationVariables>;

/**
 * __useAcceptDeliveryHeroIntegrationTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcceptDeliveryHeroIntegrationTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDeliveryHeroIntegrationTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDeliveryHeroIntegrationTermsOfServiceMutation, { data, loading, error }] = useAcceptDeliveryHeroIntegrationTermsOfServiceMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptDeliveryHeroIntegrationTermsOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<AcceptDeliveryHeroIntegrationTermsOfServiceMutation, AcceptDeliveryHeroIntegrationTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptDeliveryHeroIntegrationTermsOfServiceMutation, AcceptDeliveryHeroIntegrationTermsOfServiceMutationVariables>(AcceptDeliveryHeroIntegrationTermsOfServiceDocument, options);
      }
export type AcceptDeliveryHeroIntegrationTermsOfServiceMutationHookResult = ReturnType<typeof useAcceptDeliveryHeroIntegrationTermsOfServiceMutation>;
export type AcceptDeliveryHeroIntegrationTermsOfServiceMutationResult = Apollo.MutationResult<AcceptDeliveryHeroIntegrationTermsOfServiceMutation>;
export type AcceptDeliveryHeroIntegrationTermsOfServiceMutationOptions = Apollo.BaseMutationOptions<AcceptDeliveryHeroIntegrationTermsOfServiceMutation, AcceptDeliveryHeroIntegrationTermsOfServiceMutationVariables>;
export const EnableDeliveryHeroIntegrationDocument = gql`
    mutation EnableDeliveryHeroIntegration($restaurantId: ID!) {
  enableDeliveryHeroIntegration(restaurantId: $restaurantId) {
    id
    deliveryHeroEnabled
    hasDeliveryHeroAccess
  }
}
    `;
export type EnableDeliveryHeroIntegrationMutationFn = Apollo.MutationFunction<EnableDeliveryHeroIntegrationMutation, EnableDeliveryHeroIntegrationMutationVariables>;

/**
 * __useEnableDeliveryHeroIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableDeliveryHeroIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableDeliveryHeroIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableDeliveryHeroIntegrationMutation, { data, loading, error }] = useEnableDeliveryHeroIntegrationMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useEnableDeliveryHeroIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<EnableDeliveryHeroIntegrationMutation, EnableDeliveryHeroIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableDeliveryHeroIntegrationMutation, EnableDeliveryHeroIntegrationMutationVariables>(EnableDeliveryHeroIntegrationDocument, options);
      }
export type EnableDeliveryHeroIntegrationMutationHookResult = ReturnType<typeof useEnableDeliveryHeroIntegrationMutation>;
export type EnableDeliveryHeroIntegrationMutationResult = Apollo.MutationResult<EnableDeliveryHeroIntegrationMutation>;
export type EnableDeliveryHeroIntegrationMutationOptions = Apollo.BaseMutationOptions<EnableDeliveryHeroIntegrationMutation, EnableDeliveryHeroIntegrationMutationVariables>;
export const UpdateDeliveryHeroIntegrationSettingsDocument = gql`
    mutation UpdateDeliveryHeroIntegrationSettings($restaurantId: ID!, $input: UpdateDeliveryHeroIntegrationSettingsInput!) {
  updateDeliveryHeroIntegrationSettings(
    restaurantId: $restaurantId
    input: $input
  ) {
    id
    autoAcceptDeliveryHeroOrders
  }
}
    `;
export type UpdateDeliveryHeroIntegrationSettingsMutationFn = Apollo.MutationFunction<UpdateDeliveryHeroIntegrationSettingsMutation, UpdateDeliveryHeroIntegrationSettingsMutationVariables>;

/**
 * __useUpdateDeliveryHeroIntegrationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryHeroIntegrationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryHeroIntegrationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryHeroIntegrationSettingsMutation, { data, loading, error }] = useUpdateDeliveryHeroIntegrationSettingsMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryHeroIntegrationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryHeroIntegrationSettingsMutation, UpdateDeliveryHeroIntegrationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryHeroIntegrationSettingsMutation, UpdateDeliveryHeroIntegrationSettingsMutationVariables>(UpdateDeliveryHeroIntegrationSettingsDocument, options);
      }
export type UpdateDeliveryHeroIntegrationSettingsMutationHookResult = ReturnType<typeof useUpdateDeliveryHeroIntegrationSettingsMutation>;
export type UpdateDeliveryHeroIntegrationSettingsMutationResult = Apollo.MutationResult<UpdateDeliveryHeroIntegrationSettingsMutation>;
export type UpdateDeliveryHeroIntegrationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryHeroIntegrationSettingsMutation, UpdateDeliveryHeroIntegrationSettingsMutationVariables>;
export const GetDeliveryDeliveryHeroEditDataDocument = gql`
    query GetDeliveryDeliveryHeroEditData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    autoAcceptDeliveryHeroOrders
    deliveryHeroChainId
    deliveryHeroVendorId
    deliveryHeroEnabled
    hasDeliveryHeroAccess
    hasDeliveryHeroCredentials
    deliveryHeroSetupQuestionnaire {
      hasAccount
      isReceivingOrders
    }
  }
}
    `;

/**
 * __useGetDeliveryDeliveryHeroEditDataQuery__
 *
 * To run a query within a React component, call `useGetDeliveryDeliveryHeroEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryDeliveryHeroEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryDeliveryHeroEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetDeliveryDeliveryHeroEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryDeliveryHeroEditDataQuery, GetDeliveryDeliveryHeroEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryDeliveryHeroEditDataQuery, GetDeliveryDeliveryHeroEditDataQueryVariables>(GetDeliveryDeliveryHeroEditDataDocument, options);
      }
export function useGetDeliveryDeliveryHeroEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryDeliveryHeroEditDataQuery, GetDeliveryDeliveryHeroEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryDeliveryHeroEditDataQuery, GetDeliveryDeliveryHeroEditDataQueryVariables>(GetDeliveryDeliveryHeroEditDataDocument, options);
        }
export type GetDeliveryDeliveryHeroEditDataQueryHookResult = ReturnType<typeof useGetDeliveryDeliveryHeroEditDataQuery>;
export type GetDeliveryDeliveryHeroEditDataLazyQueryHookResult = ReturnType<typeof useGetDeliveryDeliveryHeroEditDataLazyQuery>;
export type GetDeliveryDeliveryHeroEditDataQueryResult = Apollo.QueryResult<GetDeliveryDeliveryHeroEditDataQuery, GetDeliveryDeliveryHeroEditDataQueryVariables>;
export const GetDeliveryHeroRestaurantIntegrationDataDocument = gql`
    query GetDeliveryHeroRestaurantIntegrationData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    name
  }
}
    `;

/**
 * __useGetDeliveryHeroRestaurantIntegrationDataQuery__
 *
 * To run a query within a React component, call `useGetDeliveryHeroRestaurantIntegrationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryHeroRestaurantIntegrationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryHeroRestaurantIntegrationDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetDeliveryHeroRestaurantIntegrationDataQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryHeroRestaurantIntegrationDataQuery, GetDeliveryHeroRestaurantIntegrationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryHeroRestaurantIntegrationDataQuery, GetDeliveryHeroRestaurantIntegrationDataQueryVariables>(GetDeliveryHeroRestaurantIntegrationDataDocument, options);
      }
export function useGetDeliveryHeroRestaurantIntegrationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryHeroRestaurantIntegrationDataQuery, GetDeliveryHeroRestaurantIntegrationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryHeroRestaurantIntegrationDataQuery, GetDeliveryHeroRestaurantIntegrationDataQueryVariables>(GetDeliveryHeroRestaurantIntegrationDataDocument, options);
        }
export type GetDeliveryHeroRestaurantIntegrationDataQueryHookResult = ReturnType<typeof useGetDeliveryHeroRestaurantIntegrationDataQuery>;
export type GetDeliveryHeroRestaurantIntegrationDataLazyQueryHookResult = ReturnType<typeof useGetDeliveryHeroRestaurantIntegrationDataLazyQuery>;
export type GetDeliveryHeroRestaurantIntegrationDataQueryResult = Apollo.QueryResult<GetDeliveryHeroRestaurantIntegrationDataQuery, GetDeliveryHeroRestaurantIntegrationDataQueryVariables>;
export const ConnectDeliveryHeroIntegrationDocument = gql`
    mutation ConnectDeliveryHeroIntegration($restaurantId: ID!, $accessToken: String!, $input: ConnectDeliveryHeroIntegrationInput!) {
  connectDeliveryHeroIntegration(
    restaurantId: $restaurantId
    accessToken: $accessToken
    input: $input
  ) {
    id
    name
  }
}
    `;
export type ConnectDeliveryHeroIntegrationMutationFn = Apollo.MutationFunction<ConnectDeliveryHeroIntegrationMutation, ConnectDeliveryHeroIntegrationMutationVariables>;

/**
 * __useConnectDeliveryHeroIntegrationMutation__
 *
 * To run a mutation, you first call `useConnectDeliveryHeroIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectDeliveryHeroIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectDeliveryHeroIntegrationMutation, { data, loading, error }] = useConnectDeliveryHeroIntegrationMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      accessToken: // value for 'accessToken'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectDeliveryHeroIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<ConnectDeliveryHeroIntegrationMutation, ConnectDeliveryHeroIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectDeliveryHeroIntegrationMutation, ConnectDeliveryHeroIntegrationMutationVariables>(ConnectDeliveryHeroIntegrationDocument, options);
      }
export type ConnectDeliveryHeroIntegrationMutationHookResult = ReturnType<typeof useConnectDeliveryHeroIntegrationMutation>;
export type ConnectDeliveryHeroIntegrationMutationResult = Apollo.MutationResult<ConnectDeliveryHeroIntegrationMutation>;
export type ConnectDeliveryHeroIntegrationMutationOptions = Apollo.BaseMutationOptions<ConnectDeliveryHeroIntegrationMutation, ConnectDeliveryHeroIntegrationMutationVariables>;
export const CreateDeliveryLocationDocument = gql`
    mutation CreateDeliveryLocation($restaurantId: ID!, $input: DeliveryLocationInput!) {
  createDeliveryLocation(restaurantId: $restaurantId, input: $input) {
    ...DeliveryLocationFields
  }
}
    ${DeliveryLocationFieldsFragmentDoc}`;
export type CreateDeliveryLocationMutationFn = Apollo.MutationFunction<CreateDeliveryLocationMutation, CreateDeliveryLocationMutationVariables>;

/**
 * __useCreateDeliveryLocationMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryLocationMutation, { data, loading, error }] = useCreateDeliveryLocationMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeliveryLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryLocationMutation, CreateDeliveryLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryLocationMutation, CreateDeliveryLocationMutationVariables>(CreateDeliveryLocationDocument, options);
      }
export type CreateDeliveryLocationMutationHookResult = ReturnType<typeof useCreateDeliveryLocationMutation>;
export type CreateDeliveryLocationMutationResult = Apollo.MutationResult<CreateDeliveryLocationMutation>;
export type CreateDeliveryLocationMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryLocationMutation, CreateDeliveryLocationMutationVariables>;
export const GetDeliveryLocationDocument = gql`
    query GetDeliveryLocation($restaurantId: ID!, $deliveryLocationId: ID!) {
  restaurant(id: $restaurantId) {
    id
    deliveryLocation(id: $deliveryLocationId) {
      ...DeliveryLocationFields
    }
  }
}
    ${DeliveryLocationFieldsFragmentDoc}`;

/**
 * __useGetDeliveryLocationQuery__
 *
 * To run a query within a React component, call `useGetDeliveryLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryLocationQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      deliveryLocationId: // value for 'deliveryLocationId'
 *   },
 * });
 */
export function useGetDeliveryLocationQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryLocationQuery, GetDeliveryLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryLocationQuery, GetDeliveryLocationQueryVariables>(GetDeliveryLocationDocument, options);
      }
export function useGetDeliveryLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryLocationQuery, GetDeliveryLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryLocationQuery, GetDeliveryLocationQueryVariables>(GetDeliveryLocationDocument, options);
        }
export type GetDeliveryLocationQueryHookResult = ReturnType<typeof useGetDeliveryLocationQuery>;
export type GetDeliveryLocationLazyQueryHookResult = ReturnType<typeof useGetDeliveryLocationLazyQuery>;
export type GetDeliveryLocationQueryResult = Apollo.QueryResult<GetDeliveryLocationQuery, GetDeliveryLocationQueryVariables>;
export const DeleteDeliveryLocationDocument = gql`
    mutation DeleteDeliveryLocation($restaurantId: ID!, $deliveryLocationId: ID!) {
  deleteDeliveryLocation(
    restaurantId: $restaurantId
    deliveryLocationId: $deliveryLocationId
  )
}
    `;
export type DeleteDeliveryLocationMutationFn = Apollo.MutationFunction<DeleteDeliveryLocationMutation, DeleteDeliveryLocationMutationVariables>;

/**
 * __useDeleteDeliveryLocationMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryLocationMutation, { data, loading, error }] = useDeleteDeliveryLocationMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      deliveryLocationId: // value for 'deliveryLocationId'
 *   },
 * });
 */
export function useDeleteDeliveryLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryLocationMutation, DeleteDeliveryLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryLocationMutation, DeleteDeliveryLocationMutationVariables>(DeleteDeliveryLocationDocument, options);
      }
export type DeleteDeliveryLocationMutationHookResult = ReturnType<typeof useDeleteDeliveryLocationMutation>;
export type DeleteDeliveryLocationMutationResult = Apollo.MutationResult<DeleteDeliveryLocationMutation>;
export type DeleteDeliveryLocationMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryLocationMutation, DeleteDeliveryLocationMutationVariables>;
export const UpdateDeliveryLocationDocument = gql`
    mutation UpdateDeliveryLocation($restaurantId: ID!, $deliveryLocationId: ID!, $patch: DeliveryLocationPatch!) {
  updateDeliveryLocation(
    restaurantId: $restaurantId
    deliveryLocationId: $deliveryLocationId
    patch: $patch
  ) {
    ...DeliveryLocationFields
  }
}
    ${DeliveryLocationFieldsFragmentDoc}`;
export type UpdateDeliveryLocationMutationFn = Apollo.MutationFunction<UpdateDeliveryLocationMutation, UpdateDeliveryLocationMutationVariables>;

/**
 * __useUpdateDeliveryLocationMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryLocationMutation, { data, loading, error }] = useUpdateDeliveryLocationMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      deliveryLocationId: // value for 'deliveryLocationId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateDeliveryLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryLocationMutation, UpdateDeliveryLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryLocationMutation, UpdateDeliveryLocationMutationVariables>(UpdateDeliveryLocationDocument, options);
      }
export type UpdateDeliveryLocationMutationHookResult = ReturnType<typeof useUpdateDeliveryLocationMutation>;
export type UpdateDeliveryLocationMutationResult = Apollo.MutationResult<UpdateDeliveryLocationMutation>;
export type UpdateDeliveryLocationMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryLocationMutation, UpdateDeliveryLocationMutationVariables>;
export const ListDeliveryLocationsDocument = gql`
    query ListDeliveryLocations($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    deliveryLocations(filter: {active: All}) {
      ...DeliveryLocationFields
    }
  }
}
    ${DeliveryLocationFieldsFragmentDoc}`;

/**
 * __useListDeliveryLocationsQuery__
 *
 * To run a query within a React component, call `useListDeliveryLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDeliveryLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeliveryLocationsQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useListDeliveryLocationsQuery(baseOptions: Apollo.QueryHookOptions<ListDeliveryLocationsQuery, ListDeliveryLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDeliveryLocationsQuery, ListDeliveryLocationsQueryVariables>(ListDeliveryLocationsDocument, options);
      }
export function useListDeliveryLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDeliveryLocationsQuery, ListDeliveryLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDeliveryLocationsQuery, ListDeliveryLocationsQueryVariables>(ListDeliveryLocationsDocument, options);
        }
export type ListDeliveryLocationsQueryHookResult = ReturnType<typeof useListDeliveryLocationsQuery>;
export type ListDeliveryLocationsLazyQueryHookResult = ReturnType<typeof useListDeliveryLocationsLazyQuery>;
export type ListDeliveryLocationsQueryResult = Apollo.QueryResult<ListDeliveryLocationsQuery, ListDeliveryLocationsQueryVariables>;
export const SetDeliveryLocationDisabledDocument = gql`
    mutation SetDeliveryLocationDisabled($restaurantId: ID!, $deliveryLocationId: ID!, $disabled: Boolean!) {
  updateDeliveryLocation(
    restaurantId: $restaurantId
    deliveryLocationId: $deliveryLocationId
    patch: {disabled: $disabled}
  ) {
    ...DeliveryLocationFields
  }
}
    ${DeliveryLocationFieldsFragmentDoc}`;
export type SetDeliveryLocationDisabledMutationFn = Apollo.MutationFunction<SetDeliveryLocationDisabledMutation, SetDeliveryLocationDisabledMutationVariables>;

/**
 * __useSetDeliveryLocationDisabledMutation__
 *
 * To run a mutation, you first call `useSetDeliveryLocationDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeliveryLocationDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeliveryLocationDisabledMutation, { data, loading, error }] = useSetDeliveryLocationDisabledMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      deliveryLocationId: // value for 'deliveryLocationId'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useSetDeliveryLocationDisabledMutation(baseOptions?: Apollo.MutationHookOptions<SetDeliveryLocationDisabledMutation, SetDeliveryLocationDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDeliveryLocationDisabledMutation, SetDeliveryLocationDisabledMutationVariables>(SetDeliveryLocationDisabledDocument, options);
      }
export type SetDeliveryLocationDisabledMutationHookResult = ReturnType<typeof useSetDeliveryLocationDisabledMutation>;
export type SetDeliveryLocationDisabledMutationResult = Apollo.MutationResult<SetDeliveryLocationDisabledMutation>;
export type SetDeliveryLocationDisabledMutationOptions = Apollo.BaseMutationOptions<SetDeliveryLocationDisabledMutation, SetDeliveryLocationDisabledMutationVariables>;
export const GetDeliveryLocoEditDataDocument = gql`
    query GetDeliveryLocoEditData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    extraDeliveryTime
    hasDeliveryMenu
    name
    deliveryCostAreas {
      ...FullDeliveryCostArea
    }
    deliveryTimeAreas {
      ...FullDeliveryTimeArea
    }
    location {
      latitude
      longitude
    }
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      id
      addonProducts {
        id
        isDeliveryCost
        name
        properties {
          id
          hasLegacyFormat
          imageUrl
          isActive
          price
          stateId
          reportGroup {
            ...FullMenuReportGroup
          }
        }
      }
      reportGroups {
        ...FullMenuReportGroup
      }
    }
  }
}
    ${FullDeliveryCostAreaFragmentDoc}
${FullDeliveryTimeAreaFragmentDoc}
${FullMenuReportGroupFragmentDoc}`;

/**
 * __useGetDeliveryLocoEditDataQuery__
 *
 * To run a query within a React component, call `useGetDeliveryLocoEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryLocoEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryLocoEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetDeliveryLocoEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryLocoEditDataQuery, GetDeliveryLocoEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryLocoEditDataQuery, GetDeliveryLocoEditDataQueryVariables>(GetDeliveryLocoEditDataDocument, options);
      }
export function useGetDeliveryLocoEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryLocoEditDataQuery, GetDeliveryLocoEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryLocoEditDataQuery, GetDeliveryLocoEditDataQueryVariables>(GetDeliveryLocoEditDataDocument, options);
        }
export type GetDeliveryLocoEditDataQueryHookResult = ReturnType<typeof useGetDeliveryLocoEditDataQuery>;
export type GetDeliveryLocoEditDataLazyQueryHookResult = ReturnType<typeof useGetDeliveryLocoEditDataLazyQuery>;
export type GetDeliveryLocoEditDataQueryResult = Apollo.QueryResult<GetDeliveryLocoEditDataQuery, GetDeliveryLocoEditDataQueryVariables>;
export const DeleteDeliveryCostAreaDocument = gql`
    mutation DeleteDeliveryCostArea($restaurantId: ID!, $deliveryCostAreaId: ID!) {
  deleteDeliveryCostArea(
    restaurantId: $restaurantId
    deliveryCostAreaId: $deliveryCostAreaId
  ) {
    id
    deliveryCostAreas {
      id
    }
  }
}
    `;
export type DeleteDeliveryCostAreaMutationFn = Apollo.MutationFunction<DeleteDeliveryCostAreaMutation, DeleteDeliveryCostAreaMutationVariables>;

/**
 * __useDeleteDeliveryCostAreaMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryCostAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryCostAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryCostAreaMutation, { data, loading, error }] = useDeleteDeliveryCostAreaMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      deliveryCostAreaId: // value for 'deliveryCostAreaId'
 *   },
 * });
 */
export function useDeleteDeliveryCostAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryCostAreaMutation, DeleteDeliveryCostAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryCostAreaMutation, DeleteDeliveryCostAreaMutationVariables>(DeleteDeliveryCostAreaDocument, options);
      }
export type DeleteDeliveryCostAreaMutationHookResult = ReturnType<typeof useDeleteDeliveryCostAreaMutation>;
export type DeleteDeliveryCostAreaMutationResult = Apollo.MutationResult<DeleteDeliveryCostAreaMutation>;
export type DeleteDeliveryCostAreaMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryCostAreaMutation, DeleteDeliveryCostAreaMutationVariables>;
export const DeleteDeliveryTimeAreaDocument = gql`
    mutation DeleteDeliveryTimeArea($restaurantId: ID!, $deliveryTimeAreaId: ID!) {
  deleteDeliveryTimeArea(
    restaurantId: $restaurantId
    deliveryTimeAreaId: $deliveryTimeAreaId
  ) {
    id
    deliveryTimeAreas {
      id
    }
  }
}
    `;
export type DeleteDeliveryTimeAreaMutationFn = Apollo.MutationFunction<DeleteDeliveryTimeAreaMutation, DeleteDeliveryTimeAreaMutationVariables>;

/**
 * __useDeleteDeliveryTimeAreaMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryTimeAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryTimeAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryTimeAreaMutation, { data, loading, error }] = useDeleteDeliveryTimeAreaMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      deliveryTimeAreaId: // value for 'deliveryTimeAreaId'
 *   },
 * });
 */
export function useDeleteDeliveryTimeAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryTimeAreaMutation, DeleteDeliveryTimeAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryTimeAreaMutation, DeleteDeliveryTimeAreaMutationVariables>(DeleteDeliveryTimeAreaDocument, options);
      }
export type DeleteDeliveryTimeAreaMutationHookResult = ReturnType<typeof useDeleteDeliveryTimeAreaMutation>;
export type DeleteDeliveryTimeAreaMutationResult = Apollo.MutationResult<DeleteDeliveryTimeAreaMutation>;
export type DeleteDeliveryTimeAreaMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryTimeAreaMutation, DeleteDeliveryTimeAreaMutationVariables>;
export const UpdateDeliveryLocoEditDocument = gql`
    mutation UpdateDeliveryLocoEdit($restaurantId: ID!, $patch: RestaurantPatch!) {
  updateRestaurant(restaurantId: $restaurantId, patch: $patch) {
    id
    extraDeliveryTime
  }
}
    `;
export type UpdateDeliveryLocoEditMutationFn = Apollo.MutationFunction<UpdateDeliveryLocoEditMutation, UpdateDeliveryLocoEditMutationVariables>;

/**
 * __useUpdateDeliveryLocoEditMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryLocoEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryLocoEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryLocoEditMutation, { data, loading, error }] = useUpdateDeliveryLocoEditMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateDeliveryLocoEditMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryLocoEditMutation, UpdateDeliveryLocoEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryLocoEditMutation, UpdateDeliveryLocoEditMutationVariables>(UpdateDeliveryLocoEditDocument, options);
      }
export type UpdateDeliveryLocoEditMutationHookResult = ReturnType<typeof useUpdateDeliveryLocoEditMutation>;
export type UpdateDeliveryLocoEditMutationResult = Apollo.MutationResult<UpdateDeliveryLocoEditMutation>;
export type UpdateDeliveryLocoEditMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryLocoEditMutation, UpdateDeliveryLocoEditMutationVariables>;
export const UpdateDeliveryLocoEnabledDocument = gql`
    mutation UpdateDeliveryLocoEnabled($restaurantId: ID!, $hasDeliveryMenu: Boolean!) {
  updateRestaurant(
    restaurantId: $restaurantId
    patch: {hasDeliveryMenu: $hasDeliveryMenu}
  ) {
    id
    hasDeliveryMenu
  }
}
    `;
export type UpdateDeliveryLocoEnabledMutationFn = Apollo.MutationFunction<UpdateDeliveryLocoEnabledMutation, UpdateDeliveryLocoEnabledMutationVariables>;

/**
 * __useUpdateDeliveryLocoEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryLocoEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryLocoEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryLocoEnabledMutation, { data, loading, error }] = useUpdateDeliveryLocoEnabledMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      hasDeliveryMenu: // value for 'hasDeliveryMenu'
 *   },
 * });
 */
export function useUpdateDeliveryLocoEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryLocoEnabledMutation, UpdateDeliveryLocoEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryLocoEnabledMutation, UpdateDeliveryLocoEnabledMutationVariables>(UpdateDeliveryLocoEnabledDocument, options);
      }
export type UpdateDeliveryLocoEnabledMutationHookResult = ReturnType<typeof useUpdateDeliveryLocoEnabledMutation>;
export type UpdateDeliveryLocoEnabledMutationResult = Apollo.MutationResult<UpdateDeliveryLocoEnabledMutation>;
export type UpdateDeliveryLocoEnabledMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryLocoEnabledMutation, UpdateDeliveryLocoEnabledMutationVariables>;
export const GetUserSettingsInfoDocument = gql`
    query GetUserSettingsInfo {
  me {
    id
    username
  }
  sudoMode {
    id
    expiresAt
  }
}
    `;

/**
 * __useGetUserSettingsInfoQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSettingsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetUserSettingsInfoQuery, GetUserSettingsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSettingsInfoQuery, GetUserSettingsInfoQueryVariables>(GetUserSettingsInfoDocument, options);
      }
export function useGetUserSettingsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSettingsInfoQuery, GetUserSettingsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSettingsInfoQuery, GetUserSettingsInfoQueryVariables>(GetUserSettingsInfoDocument, options);
        }
export type GetUserSettingsInfoQueryHookResult = ReturnType<typeof useGetUserSettingsInfoQuery>;
export type GetUserSettingsInfoLazyQueryHookResult = ReturnType<typeof useGetUserSettingsInfoLazyQuery>;
export type GetUserSettingsInfoQueryResult = Apollo.QueryResult<GetUserSettingsInfoQuery, GetUserSettingsInfoQueryVariables>;
export const ChangeUserEmailRequestDocument = gql`
    mutation ChangeUserEmailRequest($userId: ID!, $email: EmailAddress!) {
  requestChangeUserEmail(userId: $userId, email: $email) {
    id
  }
}
    `;
export type ChangeUserEmailRequestMutationFn = Apollo.MutationFunction<ChangeUserEmailRequestMutation, ChangeUserEmailRequestMutationVariables>;

/**
 * __useChangeUserEmailRequestMutation__
 *
 * To run a mutation, you first call `useChangeUserEmailRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserEmailRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserEmailRequestMutation, { data, loading, error }] = useChangeUserEmailRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeUserEmailRequestMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserEmailRequestMutation, ChangeUserEmailRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserEmailRequestMutation, ChangeUserEmailRequestMutationVariables>(ChangeUserEmailRequestDocument, options);
      }
export type ChangeUserEmailRequestMutationHookResult = ReturnType<typeof useChangeUserEmailRequestMutation>;
export type ChangeUserEmailRequestMutationResult = Apollo.MutationResult<ChangeUserEmailRequestMutation>;
export type ChangeUserEmailRequestMutationOptions = Apollo.BaseMutationOptions<ChangeUserEmailRequestMutation, ChangeUserEmailRequestMutationVariables>;
export const ChangeUserEmailConfirmDocument = gql`
    mutation ChangeUserEmailConfirm($requestId: ID!, $code: String!) {
  confirmChangeUserEmail(requestId: $requestId, code: $code) {
    id
  }
}
    `;
export type ChangeUserEmailConfirmMutationFn = Apollo.MutationFunction<ChangeUserEmailConfirmMutation, ChangeUserEmailConfirmMutationVariables>;

/**
 * __useChangeUserEmailConfirmMutation__
 *
 * To run a mutation, you first call `useChangeUserEmailConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserEmailConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserEmailConfirmMutation, { data, loading, error }] = useChangeUserEmailConfirmMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useChangeUserEmailConfirmMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserEmailConfirmMutation, ChangeUserEmailConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserEmailConfirmMutation, ChangeUserEmailConfirmMutationVariables>(ChangeUserEmailConfirmDocument, options);
      }
export type ChangeUserEmailConfirmMutationHookResult = ReturnType<typeof useChangeUserEmailConfirmMutation>;
export type ChangeUserEmailConfirmMutationResult = Apollo.MutationResult<ChangeUserEmailConfirmMutation>;
export type ChangeUserEmailConfirmMutationOptions = Apollo.BaseMutationOptions<ChangeUserEmailConfirmMutation, ChangeUserEmailConfirmMutationVariables>;
export const LinkFortnoxAccountingImportAccountDocument = gql`
    mutation LinkFortnoxAccountingImportAccount($organizationId: ID!, $credentials: FortnoxAccountingImportCredentials!) {
  linkFortnoxAccountingImportAccount(
    organizationId: $organizationId
    credentials: $credentials
  ) {
    id
    hasFortnoxAccountingImportCredentials
  }
}
    `;
export type LinkFortnoxAccountingImportAccountMutationFn = Apollo.MutationFunction<LinkFortnoxAccountingImportAccountMutation, LinkFortnoxAccountingImportAccountMutationVariables>;

/**
 * __useLinkFortnoxAccountingImportAccountMutation__
 *
 * To run a mutation, you first call `useLinkFortnoxAccountingImportAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkFortnoxAccountingImportAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkFortnoxAccountingImportAccountMutation, { data, loading, error }] = useLinkFortnoxAccountingImportAccountMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useLinkFortnoxAccountingImportAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkFortnoxAccountingImportAccountMutation, LinkFortnoxAccountingImportAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkFortnoxAccountingImportAccountMutation, LinkFortnoxAccountingImportAccountMutationVariables>(LinkFortnoxAccountingImportAccountDocument, options);
      }
export type LinkFortnoxAccountingImportAccountMutationHookResult = ReturnType<typeof useLinkFortnoxAccountingImportAccountMutation>;
export type LinkFortnoxAccountingImportAccountMutationResult = Apollo.MutationResult<LinkFortnoxAccountingImportAccountMutation>;
export type LinkFortnoxAccountingImportAccountMutationOptions = Apollo.BaseMutationOptions<LinkFortnoxAccountingImportAccountMutation, LinkFortnoxAccountingImportAccountMutationVariables>;
export const CreateAccessTokenDocument = gql`
    mutation CreateAccessToken($username: String!, $password: String!) {
  createAccessToken(username: $username, password: $password) {
    parseToken
  }
}
    `;
export type CreateAccessTokenMutationFn = Apollo.MutationFunction<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>;

/**
 * __useCreateAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessTokenMutation, { data, loading, error }] = useCreateAccessTokenMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>(CreateAccessTokenDocument, options);
      }
export type CreateAccessTokenMutationHookResult = ReturnType<typeof useCreateAccessTokenMutation>;
export type CreateAccessTokenMutationResult = Apollo.MutationResult<CreateAccessTokenMutation>;
export type CreateAccessTokenMutationOptions = Apollo.BaseMutationOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>;
export const SendMarketingPushNotificationDocument = gql`
    mutation SendMarketingPushNotification($whiteLabelId: ID!, $message: String!) {
  sendMarketingPushNotification(whiteLabelId: $whiteLabelId, message: $message) {
    id
    userCount
  }
}
    `;
export type SendMarketingPushNotificationMutationFn = Apollo.MutationFunction<SendMarketingPushNotificationMutation, SendMarketingPushNotificationMutationVariables>;

/**
 * __useSendMarketingPushNotificationMutation__
 *
 * To run a mutation, you first call `useSendMarketingPushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMarketingPushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMarketingPushNotificationMutation, { data, loading, error }] = useSendMarketingPushNotificationMutation({
 *   variables: {
 *      whiteLabelId: // value for 'whiteLabelId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendMarketingPushNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendMarketingPushNotificationMutation, SendMarketingPushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMarketingPushNotificationMutation, SendMarketingPushNotificationMutationVariables>(SendMarketingPushNotificationDocument, options);
      }
export type SendMarketingPushNotificationMutationHookResult = ReturnType<typeof useSendMarketingPushNotificationMutation>;
export type SendMarketingPushNotificationMutationResult = Apollo.MutationResult<SendMarketingPushNotificationMutation>;
export type SendMarketingPushNotificationMutationOptions = Apollo.BaseMutationOptions<SendMarketingPushNotificationMutation, SendMarketingPushNotificationMutationVariables>;
export const GetCreateAddonProductDataDocument = gql`
    query GetCreateAddonProductData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      addonProducts {
        id
        name
        properties {
          id
          description
          imageUrl
          isActive
          price
          stateId
          reportGroup {
            ...FullMenuReportGroup
          }
        }
      }
      reportGroups {
        ...FullMenuReportGroup
      }
    }
  }
}
    ${FullMenuReportGroupFragmentDoc}`;

/**
 * __useGetCreateAddonProductDataQuery__
 *
 * To run a query within a React component, call `useGetCreateAddonProductDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateAddonProductDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateAddonProductDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetCreateAddonProductDataQuery(baseOptions: Apollo.QueryHookOptions<GetCreateAddonProductDataQuery, GetCreateAddonProductDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateAddonProductDataQuery, GetCreateAddonProductDataQueryVariables>(GetCreateAddonProductDataDocument, options);
      }
export function useGetCreateAddonProductDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateAddonProductDataQuery, GetCreateAddonProductDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateAddonProductDataQuery, GetCreateAddonProductDataQueryVariables>(GetCreateAddonProductDataDocument, options);
        }
export type GetCreateAddonProductDataQueryHookResult = ReturnType<typeof useGetCreateAddonProductDataQuery>;
export type GetCreateAddonProductDataLazyQueryHookResult = ReturnType<typeof useGetCreateAddonProductDataLazyQuery>;
export type GetCreateAddonProductDataQueryResult = Apollo.QueryResult<GetCreateAddonProductDataQuery, GetCreateAddonProductDataQueryVariables>;
export const CreateMenuAddonProductDocument = gql`
    mutation CreateMenuAddonProduct($restaurantId: ID!, $input: MenuAddonProductInput!) {
  createMenuAddonProduct(restaurantId: $restaurantId, input: $input) {
    id
  }
}
    `;
export type CreateMenuAddonProductMutationFn = Apollo.MutationFunction<CreateMenuAddonProductMutation, CreateMenuAddonProductMutationVariables>;

/**
 * __useCreateMenuAddonProductMutation__
 *
 * To run a mutation, you first call `useCreateMenuAddonProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuAddonProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuAddonProductMutation, { data, loading, error }] = useCreateMenuAddonProductMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMenuAddonProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuAddonProductMutation, CreateMenuAddonProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuAddonProductMutation, CreateMenuAddonProductMutationVariables>(CreateMenuAddonProductDocument, options);
      }
export type CreateMenuAddonProductMutationHookResult = ReturnType<typeof useCreateMenuAddonProductMutation>;
export type CreateMenuAddonProductMutationResult = Apollo.MutationResult<CreateMenuAddonProductMutation>;
export type CreateMenuAddonProductMutationOptions = Apollo.BaseMutationOptions<CreateMenuAddonProductMutation, CreateMenuAddonProductMutationVariables>;
export const DeleteMenuAddonProductDocument = gql`
    mutation DeleteMenuAddonProduct($restaurantId: ID!, $menuAddonProductId: ID!) {
  deleteMenuAddonProduct(
    restaurantId: $restaurantId
    menuAddonProductId: $menuAddonProductId
  )
}
    `;
export type DeleteMenuAddonProductMutationFn = Apollo.MutationFunction<DeleteMenuAddonProductMutation, DeleteMenuAddonProductMutationVariables>;

/**
 * __useDeleteMenuAddonProductMutation__
 *
 * To run a mutation, you first call `useDeleteMenuAddonProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuAddonProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuAddonProductMutation, { data, loading, error }] = useDeleteMenuAddonProductMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuAddonProductId: // value for 'menuAddonProductId'
 *   },
 * });
 */
export function useDeleteMenuAddonProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuAddonProductMutation, DeleteMenuAddonProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuAddonProductMutation, DeleteMenuAddonProductMutationVariables>(DeleteMenuAddonProductDocument, options);
      }
export type DeleteMenuAddonProductMutationHookResult = ReturnType<typeof useDeleteMenuAddonProductMutation>;
export type DeleteMenuAddonProductMutationResult = Apollo.MutationResult<DeleteMenuAddonProductMutation>;
export type DeleteMenuAddonProductMutationOptions = Apollo.BaseMutationOptions<DeleteMenuAddonProductMutation, DeleteMenuAddonProductMutationVariables>;
export const GetEditAddonProductDataDocument = gql`
    query GetEditAddonProductData($restaurantId: ID!, $menuAddonProductId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      addonProduct(id: $menuAddonProductId) {
        id
        isDeliveryCost
        name
        properties {
          id
          description
          imageUrl
          isActive
          price
          stateId
          reportGroup {
            ...FullMenuReportGroup
          }
        }
      }
      reportGroups {
        ...FullMenuReportGroup
      }
    }
  }
}
    ${FullMenuReportGroupFragmentDoc}`;

/**
 * __useGetEditAddonProductDataQuery__
 *
 * To run a query within a React component, call `useGetEditAddonProductDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditAddonProductDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditAddonProductDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuAddonProductId: // value for 'menuAddonProductId'
 *   },
 * });
 */
export function useGetEditAddonProductDataQuery(baseOptions: Apollo.QueryHookOptions<GetEditAddonProductDataQuery, GetEditAddonProductDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditAddonProductDataQuery, GetEditAddonProductDataQueryVariables>(GetEditAddonProductDataDocument, options);
      }
export function useGetEditAddonProductDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditAddonProductDataQuery, GetEditAddonProductDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditAddonProductDataQuery, GetEditAddonProductDataQueryVariables>(GetEditAddonProductDataDocument, options);
        }
export type GetEditAddonProductDataQueryHookResult = ReturnType<typeof useGetEditAddonProductDataQuery>;
export type GetEditAddonProductDataLazyQueryHookResult = ReturnType<typeof useGetEditAddonProductDataLazyQuery>;
export type GetEditAddonProductDataQueryResult = Apollo.QueryResult<GetEditAddonProductDataQuery, GetEditAddonProductDataQueryVariables>;
export const UpdateMenuAddonProductDocument = gql`
    mutation UpdateMenuAddonProduct($restaurantId: ID!, $menuAddonProductId: ID!, $patch: MenuAddonProductPatch!) {
  updateMenuAddonProduct(
    restaurantId: $restaurantId
    menuAddonProductId: $menuAddonProductId
    patch: $patch
  ) {
    id
  }
}
    `;
export type UpdateMenuAddonProductMutationFn = Apollo.MutationFunction<UpdateMenuAddonProductMutation, UpdateMenuAddonProductMutationVariables>;

/**
 * __useUpdateMenuAddonProductMutation__
 *
 * To run a mutation, you first call `useUpdateMenuAddonProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuAddonProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuAddonProductMutation, { data, loading, error }] = useUpdateMenuAddonProductMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuAddonProductId: // value for 'menuAddonProductId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateMenuAddonProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuAddonProductMutation, UpdateMenuAddonProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuAddonProductMutation, UpdateMenuAddonProductMutationVariables>(UpdateMenuAddonProductDocument, options);
      }
export type UpdateMenuAddonProductMutationHookResult = ReturnType<typeof useUpdateMenuAddonProductMutation>;
export type UpdateMenuAddonProductMutationResult = Apollo.MutationResult<UpdateMenuAddonProductMutation>;
export type UpdateMenuAddonProductMutationOptions = Apollo.BaseMutationOptions<UpdateMenuAddonProductMutation, UpdateMenuAddonProductMutationVariables>;
export const CreateAlternativeGroupDocument = gql`
    mutation CreateAlternativeGroup($input: MenuAlternativeGroupInput!, $restaurantId: ID!) {
  createMenuAlternativeGroup(input: $input, restaurantId: $restaurantId) {
    id
  }
}
    `;
export type CreateAlternativeGroupMutationFn = Apollo.MutationFunction<CreateAlternativeGroupMutation, CreateAlternativeGroupMutationVariables>;

/**
 * __useCreateAlternativeGroupMutation__
 *
 * To run a mutation, you first call `useCreateAlternativeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlternativeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlternativeGroupMutation, { data, loading, error }] = useCreateAlternativeGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useCreateAlternativeGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlternativeGroupMutation, CreateAlternativeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlternativeGroupMutation, CreateAlternativeGroupMutationVariables>(CreateAlternativeGroupDocument, options);
      }
export type CreateAlternativeGroupMutationHookResult = ReturnType<typeof useCreateAlternativeGroupMutation>;
export type CreateAlternativeGroupMutationResult = Apollo.MutationResult<CreateAlternativeGroupMutation>;
export type CreateAlternativeGroupMutationOptions = Apollo.BaseMutationOptions<CreateAlternativeGroupMutation, CreateAlternativeGroupMutationVariables>;
export const GetEditAlternativeGroupDataDocument = gql`
    query GetEditAlternativeGroupData($menuAlternativeGroupId: ID!, $restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      id
      alternativeGroup(id: $menuAlternativeGroupId) {
        ...FullMenuAlternativeGroup
      }
    }
  }
}
    ${FullMenuAlternativeGroupFragmentDoc}`;

/**
 * __useGetEditAlternativeGroupDataQuery__
 *
 * To run a query within a React component, call `useGetEditAlternativeGroupDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditAlternativeGroupDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditAlternativeGroupDataQuery({
 *   variables: {
 *      menuAlternativeGroupId: // value for 'menuAlternativeGroupId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetEditAlternativeGroupDataQuery(baseOptions: Apollo.QueryHookOptions<GetEditAlternativeGroupDataQuery, GetEditAlternativeGroupDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditAlternativeGroupDataQuery, GetEditAlternativeGroupDataQueryVariables>(GetEditAlternativeGroupDataDocument, options);
      }
export function useGetEditAlternativeGroupDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditAlternativeGroupDataQuery, GetEditAlternativeGroupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditAlternativeGroupDataQuery, GetEditAlternativeGroupDataQueryVariables>(GetEditAlternativeGroupDataDocument, options);
        }
export type GetEditAlternativeGroupDataQueryHookResult = ReturnType<typeof useGetEditAlternativeGroupDataQuery>;
export type GetEditAlternativeGroupDataLazyQueryHookResult = ReturnType<typeof useGetEditAlternativeGroupDataLazyQuery>;
export type GetEditAlternativeGroupDataQueryResult = Apollo.QueryResult<GetEditAlternativeGroupDataQuery, GetEditAlternativeGroupDataQueryVariables>;
export const DeleteAlternativeGroupDocument = gql`
    mutation DeleteAlternativeGroup($menuAlternativeGroupId: ID!, $restaurantId: ID!) {
  deleteMenuAlternativeGroup(
    menuAlternativeGroupId: $menuAlternativeGroupId
    restaurantId: $restaurantId
  )
}
    `;
export type DeleteAlternativeGroupMutationFn = Apollo.MutationFunction<DeleteAlternativeGroupMutation, DeleteAlternativeGroupMutationVariables>;

/**
 * __useDeleteAlternativeGroupMutation__
 *
 * To run a mutation, you first call `useDeleteAlternativeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlternativeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlternativeGroupMutation, { data, loading, error }] = useDeleteAlternativeGroupMutation({
 *   variables: {
 *      menuAlternativeGroupId: // value for 'menuAlternativeGroupId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useDeleteAlternativeGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlternativeGroupMutation, DeleteAlternativeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlternativeGroupMutation, DeleteAlternativeGroupMutationVariables>(DeleteAlternativeGroupDocument, options);
      }
export type DeleteAlternativeGroupMutationHookResult = ReturnType<typeof useDeleteAlternativeGroupMutation>;
export type DeleteAlternativeGroupMutationResult = Apollo.MutationResult<DeleteAlternativeGroupMutation>;
export type DeleteAlternativeGroupMutationOptions = Apollo.BaseMutationOptions<DeleteAlternativeGroupMutation, DeleteAlternativeGroupMutationVariables>;
export const UpdateAlternativeGroupDocument = gql`
    mutation UpdateAlternativeGroup($menuAlternativeGroupId: ID!, $patch: MenuAlternativeGroupPatch!, $restaurantId: ID!) {
  updateMenuAlternativeGroup(
    menuAlternativeGroupId: $menuAlternativeGroupId
    patch: $patch
    restaurantId: $restaurantId
  ) {
    ...FullMenuAlternativeGroup
  }
}
    ${FullMenuAlternativeGroupFragmentDoc}`;
export type UpdateAlternativeGroupMutationFn = Apollo.MutationFunction<UpdateAlternativeGroupMutation, UpdateAlternativeGroupMutationVariables>;

/**
 * __useUpdateAlternativeGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAlternativeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlternativeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlternativeGroupMutation, { data, loading, error }] = useUpdateAlternativeGroupMutation({
 *   variables: {
 *      menuAlternativeGroupId: // value for 'menuAlternativeGroupId'
 *      patch: // value for 'patch'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useUpdateAlternativeGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlternativeGroupMutation, UpdateAlternativeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlternativeGroupMutation, UpdateAlternativeGroupMutationVariables>(UpdateAlternativeGroupDocument, options);
      }
export type UpdateAlternativeGroupMutationHookResult = ReturnType<typeof useUpdateAlternativeGroupMutation>;
export type UpdateAlternativeGroupMutationResult = Apollo.MutationResult<UpdateAlternativeGroupMutation>;
export type UpdateAlternativeGroupMutationOptions = Apollo.BaseMutationOptions<UpdateAlternativeGroupMutation, UpdateAlternativeGroupMutationVariables>;
export const GetMenuAlternativeGroupListDataDocument = gql`
    query GetMenuAlternativeGroupListData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    name
    location {
      latitude
      longitude
    }
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      id
      alternativeGroups {
        ...FullAlternativeGroup
      }
      addonProducts {
        ...FullAddonProduct
      }
      reportGroups {
        ...FullMenuReportGroup
      }
    }
  }
}
    ${FullAlternativeGroupFragmentDoc}
${FullAddonProductFragmentDoc}
${FullMenuReportGroupFragmentDoc}`;

/**
 * __useGetMenuAlternativeGroupListDataQuery__
 *
 * To run a query within a React component, call `useGetMenuAlternativeGroupListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuAlternativeGroupListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuAlternativeGroupListDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetMenuAlternativeGroupListDataQuery(baseOptions: Apollo.QueryHookOptions<GetMenuAlternativeGroupListDataQuery, GetMenuAlternativeGroupListDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuAlternativeGroupListDataQuery, GetMenuAlternativeGroupListDataQueryVariables>(GetMenuAlternativeGroupListDataDocument, options);
      }
export function useGetMenuAlternativeGroupListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuAlternativeGroupListDataQuery, GetMenuAlternativeGroupListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuAlternativeGroupListDataQuery, GetMenuAlternativeGroupListDataQueryVariables>(GetMenuAlternativeGroupListDataDocument, options);
        }
export type GetMenuAlternativeGroupListDataQueryHookResult = ReturnType<typeof useGetMenuAlternativeGroupListDataQuery>;
export type GetMenuAlternativeGroupListDataLazyQueryHookResult = ReturnType<typeof useGetMenuAlternativeGroupListDataLazyQuery>;
export type GetMenuAlternativeGroupListDataQueryResult = Apollo.QueryResult<GetMenuAlternativeGroupListDataQuery, GetMenuAlternativeGroupListDataQueryVariables>;
export const RearrangeMenuAlternativeGroupsDocument = gql`
    mutation RearrangeMenuAlternativeGroups($restaurantId: ID!, $order: [ID!]!) {
  rearrangeMenuAlternativeGroups(restaurantId: $restaurantId, order: $order)
}
    `;
export type RearrangeMenuAlternativeGroupsMutationFn = Apollo.MutationFunction<RearrangeMenuAlternativeGroupsMutation, RearrangeMenuAlternativeGroupsMutationVariables>;

/**
 * __useRearrangeMenuAlternativeGroupsMutation__
 *
 * To run a mutation, you first call `useRearrangeMenuAlternativeGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRearrangeMenuAlternativeGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rearrangeMenuAlternativeGroupsMutation, { data, loading, error }] = useRearrangeMenuAlternativeGroupsMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRearrangeMenuAlternativeGroupsMutation(baseOptions?: Apollo.MutationHookOptions<RearrangeMenuAlternativeGroupsMutation, RearrangeMenuAlternativeGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RearrangeMenuAlternativeGroupsMutation, RearrangeMenuAlternativeGroupsMutationVariables>(RearrangeMenuAlternativeGroupsDocument, options);
      }
export type RearrangeMenuAlternativeGroupsMutationHookResult = ReturnType<typeof useRearrangeMenuAlternativeGroupsMutation>;
export type RearrangeMenuAlternativeGroupsMutationResult = Apollo.MutationResult<RearrangeMenuAlternativeGroupsMutation>;
export type RearrangeMenuAlternativeGroupsMutationOptions = Apollo.BaseMutationOptions<RearrangeMenuAlternativeGroupsMutation, RearrangeMenuAlternativeGroupsMutationVariables>;
export const GetCreateMenuCategoryDataDocument = gql`
    query GetCreateMenuCategoryData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      pages {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCreateMenuCategoryDataQuery__
 *
 * To run a query within a React component, call `useGetCreateMenuCategoryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateMenuCategoryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateMenuCategoryDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetCreateMenuCategoryDataQuery(baseOptions: Apollo.QueryHookOptions<GetCreateMenuCategoryDataQuery, GetCreateMenuCategoryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateMenuCategoryDataQuery, GetCreateMenuCategoryDataQueryVariables>(GetCreateMenuCategoryDataDocument, options);
      }
export function useGetCreateMenuCategoryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateMenuCategoryDataQuery, GetCreateMenuCategoryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateMenuCategoryDataQuery, GetCreateMenuCategoryDataQueryVariables>(GetCreateMenuCategoryDataDocument, options);
        }
export type GetCreateMenuCategoryDataQueryHookResult = ReturnType<typeof useGetCreateMenuCategoryDataQuery>;
export type GetCreateMenuCategoryDataLazyQueryHookResult = ReturnType<typeof useGetCreateMenuCategoryDataLazyQuery>;
export type GetCreateMenuCategoryDataQueryResult = Apollo.QueryResult<GetCreateMenuCategoryDataQuery, GetCreateMenuCategoryDataQueryVariables>;
export const CreateMenuCategoryDocument = gql`
    mutation CreateMenuCategory($restaurantId: ID!, $menuPageId: ID!, $name: String!) {
  createMenuCategory(
    restaurantId: $restaurantId
    menuPageId: $menuPageId
    input: {name: $name}
  ) {
    id
  }
}
    `;
export type CreateMenuCategoryMutationFn = Apollo.MutationFunction<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>;

/**
 * __useCreateMenuCategoryMutation__
 *
 * To run a mutation, you first call `useCreateMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuCategoryMutation, { data, loading, error }] = useCreateMenuCategoryMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuPageId: // value for 'menuPageId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>(CreateMenuCategoryDocument, options);
      }
export type CreateMenuCategoryMutationHookResult = ReturnType<typeof useCreateMenuCategoryMutation>;
export type CreateMenuCategoryMutationResult = Apollo.MutationResult<CreateMenuCategoryMutation>;
export type CreateMenuCategoryMutationOptions = Apollo.BaseMutationOptions<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>;
export const GetMenuCategoryEditDataDocument = gql`
    query GetMenuCategoryEditData($restaurantId: ID!, $menuCategoryId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      pages {
        id
        name
      }
      category(id: $menuCategoryId) {
        id
        name
        page {
          id
          name
        }
        products {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuCategoryEditDataQuery__
 *
 * To run a query within a React component, call `useGetMenuCategoryEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCategoryEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCategoryEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCategoryId: // value for 'menuCategoryId'
 *   },
 * });
 */
export function useGetMenuCategoryEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCategoryEditDataQuery, GetMenuCategoryEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCategoryEditDataQuery, GetMenuCategoryEditDataQueryVariables>(GetMenuCategoryEditDataDocument, options);
      }
export function useGetMenuCategoryEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCategoryEditDataQuery, GetMenuCategoryEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCategoryEditDataQuery, GetMenuCategoryEditDataQueryVariables>(GetMenuCategoryEditDataDocument, options);
        }
export type GetMenuCategoryEditDataQueryHookResult = ReturnType<typeof useGetMenuCategoryEditDataQuery>;
export type GetMenuCategoryEditDataLazyQueryHookResult = ReturnType<typeof useGetMenuCategoryEditDataLazyQuery>;
export type GetMenuCategoryEditDataQueryResult = Apollo.QueryResult<GetMenuCategoryEditDataQuery, GetMenuCategoryEditDataQueryVariables>;
export const UpdateMenuCategoryDocument = gql`
    mutation UpdateMenuCategory($restaurantId: ID!, $menuCategoryId: ID!, $menuPageId: ID!, $fromMenuPageId: ID!, $patch: MenuCategoryPatch!) {
  updateMenuCategory(
    restaurantId: $restaurantId
    menuCategoryId: $menuCategoryId
    patch: $patch
  ) {
    id
  }
  relocateMenuCategory(
    restaurantId: $restaurantId
    menuCategoryId: $menuCategoryId
    fromMenuPageId: $fromMenuPageId
    toMenuPageId: $menuPageId
  )
}
    `;
export type UpdateMenuCategoryMutationFn = Apollo.MutationFunction<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>;

/**
 * __useUpdateMenuCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuCategoryMutation, { data, loading, error }] = useUpdateMenuCategoryMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCategoryId: // value for 'menuCategoryId'
 *      menuPageId: // value for 'menuPageId'
 *      fromMenuPageId: // value for 'fromMenuPageId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>(UpdateMenuCategoryDocument, options);
      }
export type UpdateMenuCategoryMutationHookResult = ReturnType<typeof useUpdateMenuCategoryMutation>;
export type UpdateMenuCategoryMutationResult = Apollo.MutationResult<UpdateMenuCategoryMutation>;
export type UpdateMenuCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>;
export const DeleteMenuCategoryDocument = gql`
    mutation DeleteMenuCategory($restaurantId: ID!, $menuCategoryId: ID!, $recursive: Boolean!) {
  deleteMenuCategory(
    restaurantId: $restaurantId
    menuCategoryId: $menuCategoryId
    recursive: $recursive
  )
}
    `;
export type DeleteMenuCategoryMutationFn = Apollo.MutationFunction<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>;

/**
 * __useDeleteMenuCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuCategoryMutation, { data, loading, error }] = useDeleteMenuCategoryMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCategoryId: // value for 'menuCategoryId'
 *      recursive: // value for 'recursive'
 *   },
 * });
 */
export function useDeleteMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>(DeleteMenuCategoryDocument, options);
      }
export type DeleteMenuCategoryMutationHookResult = ReturnType<typeof useDeleteMenuCategoryMutation>;
export type DeleteMenuCategoryMutationResult = Apollo.MutationResult<DeleteMenuCategoryMutation>;
export type DeleteMenuCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>;
export const CreateMenuCourseDocument = gql`
    mutation CreateMenuCourse($restaurantId: ID!, $input: MenuCourseInput!) {
  createMenuCourse(restaurantId: $restaurantId, input: $input) {
    id
  }
}
    `;
export type CreateMenuCourseMutationFn = Apollo.MutationFunction<CreateMenuCourseMutation, CreateMenuCourseMutationVariables>;

/**
 * __useCreateMenuCourseMutation__
 *
 * To run a mutation, you first call `useCreateMenuCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuCourseMutation, { data, loading, error }] = useCreateMenuCourseMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMenuCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuCourseMutation, CreateMenuCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuCourseMutation, CreateMenuCourseMutationVariables>(CreateMenuCourseDocument, options);
      }
export type CreateMenuCourseMutationHookResult = ReturnType<typeof useCreateMenuCourseMutation>;
export type CreateMenuCourseMutationResult = Apollo.MutationResult<CreateMenuCourseMutation>;
export type CreateMenuCourseMutationOptions = Apollo.BaseMutationOptions<CreateMenuCourseMutation, CreateMenuCourseMutationVariables>;
export const UpdateMenuCourseDocument = gql`
    mutation UpdateMenuCourse($restaurantId: ID!, $menuCourseId: ID!, $patch: MenuCoursePatch!) {
  updateMenuCourse(
    restaurantId: $restaurantId
    menuCourseId: $menuCourseId
    patch: $patch
  ) {
    ...FullMenuCourse
  }
}
    ${FullMenuCourseFragmentDoc}`;
export type UpdateMenuCourseMutationFn = Apollo.MutationFunction<UpdateMenuCourseMutation, UpdateMenuCourseMutationVariables>;

/**
 * __useUpdateMenuCourseMutation__
 *
 * To run a mutation, you first call `useUpdateMenuCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuCourseMutation, { data, loading, error }] = useUpdateMenuCourseMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCourseId: // value for 'menuCourseId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateMenuCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuCourseMutation, UpdateMenuCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuCourseMutation, UpdateMenuCourseMutationVariables>(UpdateMenuCourseDocument, options);
      }
export type UpdateMenuCourseMutationHookResult = ReturnType<typeof useUpdateMenuCourseMutation>;
export type UpdateMenuCourseMutationResult = Apollo.MutationResult<UpdateMenuCourseMutation>;
export type UpdateMenuCourseMutationOptions = Apollo.BaseMutationOptions<UpdateMenuCourseMutation, UpdateMenuCourseMutationVariables>;
export const DeleteMenuCourseDocument = gql`
    mutation DeleteMenuCourse($restaurantId: ID!, $menuCourseId: ID!) {
  deleteMenuCourse(restaurantId: $restaurantId, menuCourseId: $menuCourseId)
}
    `;
export type DeleteMenuCourseMutationFn = Apollo.MutationFunction<DeleteMenuCourseMutation, DeleteMenuCourseMutationVariables>;

/**
 * __useDeleteMenuCourseMutation__
 *
 * To run a mutation, you first call `useDeleteMenuCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuCourseMutation, { data, loading, error }] = useDeleteMenuCourseMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCourseId: // value for 'menuCourseId'
 *   },
 * });
 */
export function useDeleteMenuCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuCourseMutation, DeleteMenuCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuCourseMutation, DeleteMenuCourseMutationVariables>(DeleteMenuCourseDocument, options);
      }
export type DeleteMenuCourseMutationHookResult = ReturnType<typeof useDeleteMenuCourseMutation>;
export type DeleteMenuCourseMutationResult = Apollo.MutationResult<DeleteMenuCourseMutation>;
export type DeleteMenuCourseMutationOptions = Apollo.BaseMutationOptions<DeleteMenuCourseMutation, DeleteMenuCourseMutationVariables>;
export const GetMenuCourseDocument = gql`
    query GetMenuCourse($restaurantId: ID!, $menuCourseId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu {
      course(id: $menuCourseId) {
        ...FullMenuCourse
      }
    }
  }
}
    ${FullMenuCourseFragmentDoc}`;

/**
 * __useGetMenuCourseQuery__
 *
 * To run a query within a React component, call `useGetMenuCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCourseQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCourseId: // value for 'menuCourseId'
 *   },
 * });
 */
export function useGetMenuCourseQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCourseQuery, GetMenuCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCourseQuery, GetMenuCourseQueryVariables>(GetMenuCourseDocument, options);
      }
export function useGetMenuCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCourseQuery, GetMenuCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCourseQuery, GetMenuCourseQueryVariables>(GetMenuCourseDocument, options);
        }
export type GetMenuCourseQueryHookResult = ReturnType<typeof useGetMenuCourseQuery>;
export type GetMenuCourseLazyQueryHookResult = ReturnType<typeof useGetMenuCourseLazyQuery>;
export type GetMenuCourseQueryResult = Apollo.QueryResult<GetMenuCourseQuery, GetMenuCourseQueryVariables>;
export const GetMenuCourseListDocument = gql`
    query GetMenuCourseList($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu {
      courses {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetMenuCourseListQuery__
 *
 * To run a query within a React component, call `useGetMenuCourseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCourseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCourseListQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetMenuCourseListQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCourseListQuery, GetMenuCourseListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCourseListQuery, GetMenuCourseListQueryVariables>(GetMenuCourseListDocument, options);
      }
export function useGetMenuCourseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCourseListQuery, GetMenuCourseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCourseListQuery, GetMenuCourseListQueryVariables>(GetMenuCourseListDocument, options);
        }
export type GetMenuCourseListQueryHookResult = ReturnType<typeof useGetMenuCourseListQuery>;
export type GetMenuCourseListLazyQueryHookResult = ReturnType<typeof useGetMenuCourseListLazyQuery>;
export type GetMenuCourseListQueryResult = Apollo.QueryResult<GetMenuCourseListQuery, GetMenuCourseListQueryVariables>;
export const RearrangeMenuCoursesDocument = gql`
    mutation RearrangeMenuCourses($restaurantId: ID!, $order: [ID!]!) {
  rearrangeMenuCourses(restaurantId: $restaurantId, order: $order)
}
    `;
export type RearrangeMenuCoursesMutationFn = Apollo.MutationFunction<RearrangeMenuCoursesMutation, RearrangeMenuCoursesMutationVariables>;

/**
 * __useRearrangeMenuCoursesMutation__
 *
 * To run a mutation, you first call `useRearrangeMenuCoursesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRearrangeMenuCoursesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rearrangeMenuCoursesMutation, { data, loading, error }] = useRearrangeMenuCoursesMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRearrangeMenuCoursesMutation(baseOptions?: Apollo.MutationHookOptions<RearrangeMenuCoursesMutation, RearrangeMenuCoursesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RearrangeMenuCoursesMutation, RearrangeMenuCoursesMutationVariables>(RearrangeMenuCoursesDocument, options);
      }
export type RearrangeMenuCoursesMutationHookResult = ReturnType<typeof useRearrangeMenuCoursesMutation>;
export type RearrangeMenuCoursesMutationResult = Apollo.MutationResult<RearrangeMenuCoursesMutation>;
export type RearrangeMenuCoursesMutationOptions = Apollo.BaseMutationOptions<RearrangeMenuCoursesMutation, RearrangeMenuCoursesMutationVariables>;
export const CreateOpeningHoursDocument = gql`
    mutation CreateOpeningHours($input: OpeningHoursInput!, $restaurantId: ID!) {
  createOpeningHours(input: $input, restaurantId: $restaurantId) {
    id
    displayHours {
      id
      name
    }
    name
    productVisibility
    periods {
      open {
        day
        time
      }
      close {
        day
        time
      }
    }
  }
}
    `;
export type CreateOpeningHoursMutationFn = Apollo.MutationFunction<CreateOpeningHoursMutation, CreateOpeningHoursMutationVariables>;

/**
 * __useCreateOpeningHoursMutation__
 *
 * To run a mutation, you first call `useCreateOpeningHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpeningHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpeningHoursMutation, { data, loading, error }] = useCreateOpeningHoursMutation({
 *   variables: {
 *      input: // value for 'input'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useCreateOpeningHoursMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpeningHoursMutation, CreateOpeningHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpeningHoursMutation, CreateOpeningHoursMutationVariables>(CreateOpeningHoursDocument, options);
      }
export type CreateOpeningHoursMutationHookResult = ReturnType<typeof useCreateOpeningHoursMutation>;
export type CreateOpeningHoursMutationResult = Apollo.MutationResult<CreateOpeningHoursMutation>;
export type CreateOpeningHoursMutationOptions = Apollo.BaseMutationOptions<CreateOpeningHoursMutation, CreateOpeningHoursMutationVariables>;
export const UpdateOpeningHoursDocument = gql`
    mutation UpdateOpeningHours($openingHoursId: ID!, $patch: OpeningHoursPatch!, $restaurantId: ID!) {
  updateOpeningHours(
    openingHoursId: $openingHoursId
    patch: $patch
    restaurantId: $restaurantId
  ) {
    id
    displayHours {
      id
      name
    }
    name
    productVisibility
    periods {
      open {
        day
        time
      }
      close {
        day
        time
      }
    }
  }
}
    `;
export type UpdateOpeningHoursMutationFn = Apollo.MutationFunction<UpdateOpeningHoursMutation, UpdateOpeningHoursMutationVariables>;

/**
 * __useUpdateOpeningHoursMutation__
 *
 * To run a mutation, you first call `useUpdateOpeningHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpeningHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpeningHoursMutation, { data, loading, error }] = useUpdateOpeningHoursMutation({
 *   variables: {
 *      openingHoursId: // value for 'openingHoursId'
 *      patch: // value for 'patch'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useUpdateOpeningHoursMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpeningHoursMutation, UpdateOpeningHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpeningHoursMutation, UpdateOpeningHoursMutationVariables>(UpdateOpeningHoursDocument, options);
      }
export type UpdateOpeningHoursMutationHookResult = ReturnType<typeof useUpdateOpeningHoursMutation>;
export type UpdateOpeningHoursMutationResult = Apollo.MutationResult<UpdateOpeningHoursMutation>;
export type UpdateOpeningHoursMutationOptions = Apollo.BaseMutationOptions<UpdateOpeningHoursMutation, UpdateOpeningHoursMutationVariables>;
export const CreateMenuPageDocument = gql`
    mutation CreateMenuPage($restaurantId: ID!, $input: MenuPageInput!) {
  createMenuPage(restaurantId: $restaurantId, input: $input) {
    id
  }
}
    `;
export type CreateMenuPageMutationFn = Apollo.MutationFunction<CreateMenuPageMutation, CreateMenuPageMutationVariables>;

/**
 * __useCreateMenuPageMutation__
 *
 * To run a mutation, you first call `useCreateMenuPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuPageMutation, { data, loading, error }] = useCreateMenuPageMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMenuPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuPageMutation, CreateMenuPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuPageMutation, CreateMenuPageMutationVariables>(CreateMenuPageDocument, options);
      }
export type CreateMenuPageMutationHookResult = ReturnType<typeof useCreateMenuPageMutation>;
export type CreateMenuPageMutationResult = Apollo.MutationResult<CreateMenuPageMutation>;
export type CreateMenuPageMutationOptions = Apollo.BaseMutationOptions<CreateMenuPageMutation, CreateMenuPageMutationVariables>;
export const GetEditPageDataDocument = gql`
    query GetEditPageData($restaurantId: ID!, $menuPageId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      page(id: $menuPageId) {
        id
        name
        categories {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetEditPageDataQuery__
 *
 * To run a query within a React component, call `useGetEditPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPageDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuPageId: // value for 'menuPageId'
 *   },
 * });
 */
export function useGetEditPageDataQuery(baseOptions: Apollo.QueryHookOptions<GetEditPageDataQuery, GetEditPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPageDataQuery, GetEditPageDataQueryVariables>(GetEditPageDataDocument, options);
      }
export function useGetEditPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPageDataQuery, GetEditPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPageDataQuery, GetEditPageDataQueryVariables>(GetEditPageDataDocument, options);
        }
export type GetEditPageDataQueryHookResult = ReturnType<typeof useGetEditPageDataQuery>;
export type GetEditPageDataLazyQueryHookResult = ReturnType<typeof useGetEditPageDataLazyQuery>;
export type GetEditPageDataQueryResult = Apollo.QueryResult<GetEditPageDataQuery, GetEditPageDataQueryVariables>;
export const UpdateMenuPageDocument = gql`
    mutation UpdateMenuPage($restaurantId: ID!, $menuPageId: ID!, $patch: MenuPagePatch!) {
  updateMenuPage(
    restaurantId: $restaurantId
    menuPageId: $menuPageId
    patch: $patch
  ) {
    id
  }
}
    `;
export type UpdateMenuPageMutationFn = Apollo.MutationFunction<UpdateMenuPageMutation, UpdateMenuPageMutationVariables>;

/**
 * __useUpdateMenuPageMutation__
 *
 * To run a mutation, you first call `useUpdateMenuPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuPageMutation, { data, loading, error }] = useUpdateMenuPageMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuPageId: // value for 'menuPageId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateMenuPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuPageMutation, UpdateMenuPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuPageMutation, UpdateMenuPageMutationVariables>(UpdateMenuPageDocument, options);
      }
export type UpdateMenuPageMutationHookResult = ReturnType<typeof useUpdateMenuPageMutation>;
export type UpdateMenuPageMutationResult = Apollo.MutationResult<UpdateMenuPageMutation>;
export type UpdateMenuPageMutationOptions = Apollo.BaseMutationOptions<UpdateMenuPageMutation, UpdateMenuPageMutationVariables>;
export const DeleteMenuPageDocument = gql`
    mutation DeleteMenuPage($restaurantId: ID!, $menuPageId: ID!) {
  deleteMenuPage(restaurantId: $restaurantId, menuPageId: $menuPageId)
}
    `;
export type DeleteMenuPageMutationFn = Apollo.MutationFunction<DeleteMenuPageMutation, DeleteMenuPageMutationVariables>;

/**
 * __useDeleteMenuPageMutation__
 *
 * To run a mutation, you first call `useDeleteMenuPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuPageMutation, { data, loading, error }] = useDeleteMenuPageMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuPageId: // value for 'menuPageId'
 *   },
 * });
 */
export function useDeleteMenuPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuPageMutation, DeleteMenuPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuPageMutation, DeleteMenuPageMutationVariables>(DeleteMenuPageDocument, options);
      }
export type DeleteMenuPageMutationHookResult = ReturnType<typeof useDeleteMenuPageMutation>;
export type DeleteMenuPageMutationResult = Apollo.MutationResult<DeleteMenuPageMutation>;
export type DeleteMenuPageMutationOptions = Apollo.BaseMutationOptions<DeleteMenuPageMutation, DeleteMenuPageMutationVariables>;
export const RearrangeMenuCategoriesDocument = gql`
    mutation RearrangeMenuCategories($restaurantId: ID!, $menuPageId: ID!, $order: [ID!]!) {
  rearrangeMenuCategories(
    restaurantId: $restaurantId
    menuPageId: $menuPageId
    order: $order
  )
}
    `;
export type RearrangeMenuCategoriesMutationFn = Apollo.MutationFunction<RearrangeMenuCategoriesMutation, RearrangeMenuCategoriesMutationVariables>;

/**
 * __useRearrangeMenuCategoriesMutation__
 *
 * To run a mutation, you first call `useRearrangeMenuCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRearrangeMenuCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rearrangeMenuCategoriesMutation, { data, loading, error }] = useRearrangeMenuCategoriesMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuPageId: // value for 'menuPageId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRearrangeMenuCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<RearrangeMenuCategoriesMutation, RearrangeMenuCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RearrangeMenuCategoriesMutation, RearrangeMenuCategoriesMutationVariables>(RearrangeMenuCategoriesDocument, options);
      }
export type RearrangeMenuCategoriesMutationHookResult = ReturnType<typeof useRearrangeMenuCategoriesMutation>;
export type RearrangeMenuCategoriesMutationResult = Apollo.MutationResult<RearrangeMenuCategoriesMutation>;
export type RearrangeMenuCategoriesMutationOptions = Apollo.BaseMutationOptions<RearrangeMenuCategoriesMutation, RearrangeMenuCategoriesMutationVariables>;
export const RearrangeMenuProductsDocument = gql`
    mutation RearrangeMenuProducts($restaurantId: ID!, $menuCategoryId: ID!, $order: [ID!]!) {
  rearrangeMenuProducts(
    restaurantId: $restaurantId
    menuCategoryId: $menuCategoryId
    order: $order
  )
}
    `;
export type RearrangeMenuProductsMutationFn = Apollo.MutationFunction<RearrangeMenuProductsMutation, RearrangeMenuProductsMutationVariables>;

/**
 * __useRearrangeMenuProductsMutation__
 *
 * To run a mutation, you first call `useRearrangeMenuProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRearrangeMenuProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rearrangeMenuProductsMutation, { data, loading, error }] = useRearrangeMenuProductsMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCategoryId: // value for 'menuCategoryId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRearrangeMenuProductsMutation(baseOptions?: Apollo.MutationHookOptions<RearrangeMenuProductsMutation, RearrangeMenuProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RearrangeMenuProductsMutation, RearrangeMenuProductsMutationVariables>(RearrangeMenuProductsDocument, options);
      }
export type RearrangeMenuProductsMutationHookResult = ReturnType<typeof useRearrangeMenuProductsMutation>;
export type RearrangeMenuProductsMutationResult = Apollo.MutationResult<RearrangeMenuProductsMutation>;
export type RearrangeMenuProductsMutationOptions = Apollo.BaseMutationOptions<RearrangeMenuProductsMutation, RearrangeMenuProductsMutationVariables>;
export const GetCreateProductDataDocument = gql`
    query GetCreateProductData($restaurantId: ID!, $menuCategoryId: ID!) {
  restaurant(id: $restaurantId) {
    id
    hasMenuWriteAccess: hasAccess(access: MenuWrite)
    menuSystem
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      pages {
        id
        name
        categories {
          id
          name
        }
      }
      courses {
        id
        name
      }
      productOpeningHours {
        id
        name
      }
      reportGroups {
        ...FullMenuReportGroup
      }
      alternativeGroups {
        id
        name
      }
      category(id: $menuCategoryId) {
        id
        name
        newProductDefaultValues {
          ...MenuProductDefaultValues
        }
        page {
          id
        }
      }
    }
    printerQueues {
      id
      name
    }
  }
}
    ${FullMenuReportGroupFragmentDoc}
${MenuProductDefaultValuesFragmentDoc}`;

/**
 * __useGetCreateProductDataQuery__
 *
 * To run a query within a React component, call `useGetCreateProductDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateProductDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateProductDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCategoryId: // value for 'menuCategoryId'
 *   },
 * });
 */
export function useGetCreateProductDataQuery(baseOptions: Apollo.QueryHookOptions<GetCreateProductDataQuery, GetCreateProductDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateProductDataQuery, GetCreateProductDataQueryVariables>(GetCreateProductDataDocument, options);
      }
export function useGetCreateProductDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateProductDataQuery, GetCreateProductDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateProductDataQuery, GetCreateProductDataQueryVariables>(GetCreateProductDataDocument, options);
        }
export type GetCreateProductDataQueryHookResult = ReturnType<typeof useGetCreateProductDataQuery>;
export type GetCreateProductDataLazyQueryHookResult = ReturnType<typeof useGetCreateProductDataLazyQuery>;
export type GetCreateProductDataQueryResult = Apollo.QueryResult<GetCreateProductDataQuery, GetCreateProductDataQueryVariables>;
export const CreateMenuProductDocument = gql`
    mutation CreateMenuProduct($restaurantId: ID!, $menuCategoryId: ID!, $input: MenuProductInput!) {
  createMenuProduct(
    restaurantId: $restaurantId
    menuCategoryId: $menuCategoryId
    input: $input
  ) {
    id
    category {
      id
      page {
        id
        productCount
      }
    }
  }
}
    `;
export type CreateMenuProductMutationFn = Apollo.MutationFunction<CreateMenuProductMutation, CreateMenuProductMutationVariables>;

/**
 * __useCreateMenuProductMutation__
 *
 * To run a mutation, you first call `useCreateMenuProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuProductMutation, { data, loading, error }] = useCreateMenuProductMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuCategoryId: // value for 'menuCategoryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMenuProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuProductMutation, CreateMenuProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuProductMutation, CreateMenuProductMutationVariables>(CreateMenuProductDocument, options);
      }
export type CreateMenuProductMutationHookResult = ReturnType<typeof useCreateMenuProductMutation>;
export type CreateMenuProductMutationResult = Apollo.MutationResult<CreateMenuProductMutation>;
export type CreateMenuProductMutationOptions = Apollo.BaseMutationOptions<CreateMenuProductMutation, CreateMenuProductMutationVariables>;
export const GetEditProductDataDocument = gql`
    query GetEditProductData($restaurantId: ID!, $menuProductId: ID!) {
  restaurant(id: $restaurantId) {
    id
    hasMenuWriteAccess: hasAccess(access: MenuWrite)
    menuSystem
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      pages {
        id
        name
        categories {
          id
          name
        }
      }
      alternativeGroups {
        id
        name
      }
      courses {
        id
        name
      }
      productOpeningHours {
        id
        name
      }
      product(id: $menuProductId) {
        ...MenuProductFields
        category {
          id
          name
          page {
            id
            name
          }
        }
      }
      reportGroups {
        ...FullMenuReportGroup
      }
    }
    printerQueues {
      id
      name
    }
  }
}
    ${MenuProductFieldsFragmentDoc}
${FullMenuReportGroupFragmentDoc}`;

/**
 * __useGetEditProductDataQuery__
 *
 * To run a query within a React component, call `useGetEditProductDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditProductDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditProductDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuProductId: // value for 'menuProductId'
 *   },
 * });
 */
export function useGetEditProductDataQuery(baseOptions: Apollo.QueryHookOptions<GetEditProductDataQuery, GetEditProductDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditProductDataQuery, GetEditProductDataQueryVariables>(GetEditProductDataDocument, options);
      }
export function useGetEditProductDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditProductDataQuery, GetEditProductDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditProductDataQuery, GetEditProductDataQueryVariables>(GetEditProductDataDocument, options);
        }
export type GetEditProductDataQueryHookResult = ReturnType<typeof useGetEditProductDataQuery>;
export type GetEditProductDataLazyQueryHookResult = ReturnType<typeof useGetEditProductDataLazyQuery>;
export type GetEditProductDataQueryResult = Apollo.QueryResult<GetEditProductDataQuery, GetEditProductDataQueryVariables>;
export const UpdateAndRelocateMenuProductDocument = gql`
    mutation UpdateAndRelocateMenuProduct($restaurantId: ID!, $menuProductId: ID!, $patch: MenuProductPatch!, $menuCategoryId: ID!, $fromMenuCategoryId: ID!) {
  updateMenuProduct(
    restaurantId: $restaurantId
    menuProductId: $menuProductId
    patch: $patch
  ) {
    id
  }
  relocateMenuProduct(
    restaurantId: $restaurantId
    menuProductId: $menuProductId
    fromMenuCategoryId: $fromMenuCategoryId
    toMenuCategoryId: $menuCategoryId
  )
}
    `;
export type UpdateAndRelocateMenuProductMutationFn = Apollo.MutationFunction<UpdateAndRelocateMenuProductMutation, UpdateAndRelocateMenuProductMutationVariables>;

/**
 * __useUpdateAndRelocateMenuProductMutation__
 *
 * To run a mutation, you first call `useUpdateAndRelocateMenuProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAndRelocateMenuProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAndRelocateMenuProductMutation, { data, loading, error }] = useUpdateAndRelocateMenuProductMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuProductId: // value for 'menuProductId'
 *      patch: // value for 'patch'
 *      menuCategoryId: // value for 'menuCategoryId'
 *      fromMenuCategoryId: // value for 'fromMenuCategoryId'
 *   },
 * });
 */
export function useUpdateAndRelocateMenuProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAndRelocateMenuProductMutation, UpdateAndRelocateMenuProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAndRelocateMenuProductMutation, UpdateAndRelocateMenuProductMutationVariables>(UpdateAndRelocateMenuProductDocument, options);
      }
export type UpdateAndRelocateMenuProductMutationHookResult = ReturnType<typeof useUpdateAndRelocateMenuProductMutation>;
export type UpdateAndRelocateMenuProductMutationResult = Apollo.MutationResult<UpdateAndRelocateMenuProductMutation>;
export type UpdateAndRelocateMenuProductMutationOptions = Apollo.BaseMutationOptions<UpdateAndRelocateMenuProductMutation, UpdateAndRelocateMenuProductMutationVariables>;
export const UpdateMenuProductStockDocument = gql`
    mutation UpdateMenuProductStock($restaurantId: ID!, $menuProductId: ID!, $patch: MenuProductPatch!) {
  updateMenuProduct(
    restaurantId: $restaurantId
    menuProductId: $menuProductId
    patch: $patch
  ) {
    id
  }
}
    `;
export type UpdateMenuProductStockMutationFn = Apollo.MutationFunction<UpdateMenuProductStockMutation, UpdateMenuProductStockMutationVariables>;

/**
 * __useUpdateMenuProductStockMutation__
 *
 * To run a mutation, you first call `useUpdateMenuProductStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuProductStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuProductStockMutation, { data, loading, error }] = useUpdateMenuProductStockMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuProductId: // value for 'menuProductId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateMenuProductStockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuProductStockMutation, UpdateMenuProductStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuProductStockMutation, UpdateMenuProductStockMutationVariables>(UpdateMenuProductStockDocument, options);
      }
export type UpdateMenuProductStockMutationHookResult = ReturnType<typeof useUpdateMenuProductStockMutation>;
export type UpdateMenuProductStockMutationResult = Apollo.MutationResult<UpdateMenuProductStockMutation>;
export type UpdateMenuProductStockMutationOptions = Apollo.BaseMutationOptions<UpdateMenuProductStockMutation, UpdateMenuProductStockMutationVariables>;
export const DeleteMenuProductDocument = gql`
    mutation DeleteMenuProduct($restaurantId: ID!, $menuProductId: ID!) {
  deleteMenuProduct(restaurantId: $restaurantId, menuProductId: $menuProductId)
}
    `;
export type DeleteMenuProductMutationFn = Apollo.MutationFunction<DeleteMenuProductMutation, DeleteMenuProductMutationVariables>;

/**
 * __useDeleteMenuProductMutation__
 *
 * To run a mutation, you first call `useDeleteMenuProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuProductMutation, { data, loading, error }] = useDeleteMenuProductMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuProductId: // value for 'menuProductId'
 *   },
 * });
 */
export function useDeleteMenuProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuProductMutation, DeleteMenuProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuProductMutation, DeleteMenuProductMutationVariables>(DeleteMenuProductDocument, options);
      }
export type DeleteMenuProductMutationHookResult = ReturnType<typeof useDeleteMenuProductMutation>;
export type DeleteMenuProductMutationResult = Apollo.MutationResult<DeleteMenuProductMutation>;
export type DeleteMenuProductMutationOptions = Apollo.BaseMutationOptions<DeleteMenuProductMutation, DeleteMenuProductMutationVariables>;
export const RearrangeMenuPagesDocument = gql`
    mutation RearrangeMenuPages($restaurantId: ID!, $order: [ID!]!) {
  rearrangeMenuPages(restaurantId: $restaurantId, order: $order)
}
    `;
export type RearrangeMenuPagesMutationFn = Apollo.MutationFunction<RearrangeMenuPagesMutation, RearrangeMenuPagesMutationVariables>;

/**
 * __useRearrangeMenuPagesMutation__
 *
 * To run a mutation, you first call `useRearrangeMenuPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRearrangeMenuPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rearrangeMenuPagesMutation, { data, loading, error }] = useRearrangeMenuPagesMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRearrangeMenuPagesMutation(baseOptions?: Apollo.MutationHookOptions<RearrangeMenuPagesMutation, RearrangeMenuPagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RearrangeMenuPagesMutation, RearrangeMenuPagesMutationVariables>(RearrangeMenuPagesDocument, options);
      }
export type RearrangeMenuPagesMutationHookResult = ReturnType<typeof useRearrangeMenuPagesMutation>;
export type RearrangeMenuPagesMutationResult = Apollo.MutationResult<RearrangeMenuPagesMutation>;
export type RearrangeMenuPagesMutationOptions = Apollo.BaseMutationOptions<RearrangeMenuPagesMutation, RearrangeMenuPagesMutationVariables>;
export const ImportMenuCsvDataDocument = gql`
    mutation ImportMenuCsvData($restaurantId: ID!, $csvData: String!) {
  importMenuFromCsv(restaurantId: $restaurantId, csvData: $csvData)
}
    `;
export type ImportMenuCsvDataMutationFn = Apollo.MutationFunction<ImportMenuCsvDataMutation, ImportMenuCsvDataMutationVariables>;

/**
 * __useImportMenuCsvDataMutation__
 *
 * To run a mutation, you first call `useImportMenuCsvDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMenuCsvDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMenuCsvDataMutation, { data, loading, error }] = useImportMenuCsvDataMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      csvData: // value for 'csvData'
 *   },
 * });
 */
export function useImportMenuCsvDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportMenuCsvDataMutation, ImportMenuCsvDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportMenuCsvDataMutation, ImportMenuCsvDataMutationVariables>(ImportMenuCsvDataDocument, options);
      }
export type ImportMenuCsvDataMutationHookResult = ReturnType<typeof useImportMenuCsvDataMutation>;
export type ImportMenuCsvDataMutationResult = Apollo.MutationResult<ImportMenuCsvDataMutation>;
export type ImportMenuCsvDataMutationOptions = Apollo.BaseMutationOptions<ImportMenuCsvDataMutation, ImportMenuCsvDataMutationVariables>;
export const UpdateClientHeaderMessageDocument = gql`
    mutation UpdateClientHeaderMessage($restaurantId: ID!, $clientHeaderMessage: String) {
  updateRestaurant(
    restaurantId: $restaurantId
    patch: {clientHeaderMessage: $clientHeaderMessage}
  ) {
    id
    clientHeaderMessage
  }
}
    `;
export type UpdateClientHeaderMessageMutationFn = Apollo.MutationFunction<UpdateClientHeaderMessageMutation, UpdateClientHeaderMessageMutationVariables>;

/**
 * __useUpdateClientHeaderMessageMutation__
 *
 * To run a mutation, you first call `useUpdateClientHeaderMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientHeaderMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientHeaderMessageMutation, { data, loading, error }] = useUpdateClientHeaderMessageMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      clientHeaderMessage: // value for 'clientHeaderMessage'
 *   },
 * });
 */
export function useUpdateClientHeaderMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientHeaderMessageMutation, UpdateClientHeaderMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientHeaderMessageMutation, UpdateClientHeaderMessageMutationVariables>(UpdateClientHeaderMessageDocument, options);
      }
export type UpdateClientHeaderMessageMutationHookResult = ReturnType<typeof useUpdateClientHeaderMessageMutation>;
export type UpdateClientHeaderMessageMutationResult = Apollo.MutationResult<UpdateClientHeaderMessageMutation>;
export type UpdateClientHeaderMessageMutationOptions = Apollo.BaseMutationOptions<UpdateClientHeaderMessageMutation, UpdateClientHeaderMessageMutationVariables>;
export const GetMenuCsvDataDocument = gql`
    query GetMenuCsvData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      csvData
    }
  }
}
    `;

/**
 * __useGetMenuCsvDataQuery__
 *
 * To run a query within a React component, call `useGetMenuCsvDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCsvDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCsvDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetMenuCsvDataQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCsvDataQuery, GetMenuCsvDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCsvDataQuery, GetMenuCsvDataQueryVariables>(GetMenuCsvDataDocument, options);
      }
export function useGetMenuCsvDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCsvDataQuery, GetMenuCsvDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCsvDataQuery, GetMenuCsvDataQueryVariables>(GetMenuCsvDataDocument, options);
        }
export type GetMenuCsvDataQueryHookResult = ReturnType<typeof useGetMenuCsvDataQuery>;
export type GetMenuCsvDataLazyQueryHookResult = ReturnType<typeof useGetMenuCsvDataLazyQuery>;
export type GetMenuCsvDataQueryResult = Apollo.QueryResult<GetMenuCsvDataQuery, GetMenuCsvDataQueryVariables>;
export const CreateDiscountDocument = gql`
    mutation CreateDiscount($metaOrganizationId: ID!, $input: DiscountInput!) {
  createDiscount(metaOrganizationId: $metaOrganizationId, input: $input) {
    id
  }
}
    `;
export type CreateDiscountMutationFn = Apollo.MutationFunction<CreateDiscountMutation, CreateDiscountMutationVariables>;

/**
 * __useCreateDiscountMutation__
 *
 * To run a mutation, you first call `useCreateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountMutation, { data, loading, error }] = useCreateDiscountMutation({
 *   variables: {
 *      metaOrganizationId: // value for 'metaOrganizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountMutation, CreateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountMutation, CreateDiscountMutationVariables>(CreateDiscountDocument, options);
      }
export type CreateDiscountMutationHookResult = ReturnType<typeof useCreateDiscountMutation>;
export type CreateDiscountMutationResult = Apollo.MutationResult<CreateDiscountMutation>;
export type CreateDiscountMutationOptions = Apollo.BaseMutationOptions<CreateDiscountMutation, CreateDiscountMutationVariables>;
export const GetDiscountDocument = gql`
    query GetDiscount($metaOrganizationId: ID!, $discountId: ID!) {
  metaOrganization(id: $metaOrganizationId) {
    id
    name
    createdAt
    updatedAt
    discount(id: $discountId) {
      ...FullDiscount
    }
  }
}
    ${FullDiscountFragmentDoc}`;

/**
 * __useGetDiscountQuery__
 *
 * To run a query within a React component, call `useGetDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountQuery({
 *   variables: {
 *      metaOrganizationId: // value for 'metaOrganizationId'
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useGetDiscountQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
      }
export function useGetDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
        }
export type GetDiscountQueryHookResult = ReturnType<typeof useGetDiscountQuery>;
export type GetDiscountLazyQueryHookResult = ReturnType<typeof useGetDiscountLazyQuery>;
export type GetDiscountQueryResult = Apollo.QueryResult<GetDiscountQuery, GetDiscountQueryVariables>;
export const DeleteDiscountDocument = gql`
    mutation DeleteDiscount($metaOrganizationId: ID!, $discountId: ID!) {
  deleteDiscount(metaOrganizationId: $metaOrganizationId, discountId: $discountId)
}
    `;
export type DeleteDiscountMutationFn = Apollo.MutationFunction<DeleteDiscountMutation, DeleteDiscountMutationVariables>;

/**
 * __useDeleteDiscountMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountMutation, { data, loading, error }] = useDeleteDiscountMutation({
 *   variables: {
 *      metaOrganizationId: // value for 'metaOrganizationId'
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useDeleteDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscountMutation, DeleteDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscountMutation, DeleteDiscountMutationVariables>(DeleteDiscountDocument, options);
      }
export type DeleteDiscountMutationHookResult = ReturnType<typeof useDeleteDiscountMutation>;
export type DeleteDiscountMutationResult = Apollo.MutationResult<DeleteDiscountMutation>;
export type DeleteDiscountMutationOptions = Apollo.BaseMutationOptions<DeleteDiscountMutation, DeleteDiscountMutationVariables>;
export const UpdateDiscountDocument = gql`
    mutation UpdateDiscount($metaOrganizationId: ID!, $discountId: ID!, $patch: DiscountPatch!) {
  updateDiscount(
    metaOrganizationId: $metaOrganizationId
    discountId: $discountId
    patch: $patch
  ) {
    id
  }
}
    `;
export type UpdateDiscountMutationFn = Apollo.MutationFunction<UpdateDiscountMutation, UpdateDiscountMutationVariables>;

/**
 * __useUpdateDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountMutation, { data, loading, error }] = useUpdateDiscountMutation({
 *   variables: {
 *      metaOrganizationId: // value for 'metaOrganizationId'
 *      discountId: // value for 'discountId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountMutation, UpdateDiscountMutationVariables>(UpdateDiscountDocument, options);
      }
export type UpdateDiscountMutationHookResult = ReturnType<typeof useUpdateDiscountMutation>;
export type UpdateDiscountMutationResult = Apollo.MutationResult<UpdateDiscountMutation>;
export type UpdateDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const CreateMetaOrganizationDocument = gql`
    mutation CreateMetaOrganization($input: MetaOrganizationInput!) {
  createMetaOrganization(input: $input) {
    id
  }
}
    `;
export type CreateMetaOrganizationMutationFn = Apollo.MutationFunction<CreateMetaOrganizationMutation, CreateMetaOrganizationMutationVariables>;

/**
 * __useCreateMetaOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateMetaOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetaOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetaOrganizationMutation, { data, loading, error }] = useCreateMetaOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMetaOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetaOrganizationMutation, CreateMetaOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetaOrganizationMutation, CreateMetaOrganizationMutationVariables>(CreateMetaOrganizationDocument, options);
      }
export type CreateMetaOrganizationMutationHookResult = ReturnType<typeof useCreateMetaOrganizationMutation>;
export type CreateMetaOrganizationMutationResult = Apollo.MutationResult<CreateMetaOrganizationMutation>;
export type CreateMetaOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateMetaOrganizationMutation, CreateMetaOrganizationMutationVariables>;
export const ListMetaOrganizationsDocument = gql`
    query ListMetaOrganizations {
  metaOrganizations(first: 10000) {
    edges {
      node {
        id
        name
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useListMetaOrganizationsQuery__
 *
 * To run a query within a React component, call `useListMetaOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetaOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMetaOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListMetaOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<ListMetaOrganizationsQuery, ListMetaOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMetaOrganizationsQuery, ListMetaOrganizationsQueryVariables>(ListMetaOrganizationsDocument, options);
      }
export function useListMetaOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMetaOrganizationsQuery, ListMetaOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMetaOrganizationsQuery, ListMetaOrganizationsQueryVariables>(ListMetaOrganizationsDocument, options);
        }
export type ListMetaOrganizationsQueryHookResult = ReturnType<typeof useListMetaOrganizationsQuery>;
export type ListMetaOrganizationsLazyQueryHookResult = ReturnType<typeof useListMetaOrganizationsLazyQuery>;
export type ListMetaOrganizationsQueryResult = Apollo.QueryResult<ListMetaOrganizationsQuery, ListMetaOrganizationsQueryVariables>;
export const GetMetaOrganizationDocument = gql`
    query GetMetaOrganization($id: ID!) {
  metaOrganization(id: $id) {
    id
    name
    createdAt
    updatedAt
    discounts(first: 1000) {
      edges {
        node {
          ...FullDiscount
        }
      }
      pageInfo {
        hasNextPage
      }
    }
    restaurants(first: 1000) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
  restaurants(first: 1000) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    ${FullDiscountFragmentDoc}`;

/**
 * __useGetMetaOrganizationQuery__
 *
 * To run a query within a React component, call `useGetMetaOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetaOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetaOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMetaOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetMetaOrganizationQuery, GetMetaOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetaOrganizationQuery, GetMetaOrganizationQueryVariables>(GetMetaOrganizationDocument, options);
      }
export function useGetMetaOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetaOrganizationQuery, GetMetaOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetaOrganizationQuery, GetMetaOrganizationQueryVariables>(GetMetaOrganizationDocument, options);
        }
export type GetMetaOrganizationQueryHookResult = ReturnType<typeof useGetMetaOrganizationQuery>;
export type GetMetaOrganizationLazyQueryHookResult = ReturnType<typeof useGetMetaOrganizationLazyQuery>;
export type GetMetaOrganizationQueryResult = Apollo.QueryResult<GetMetaOrganizationQuery, GetMetaOrganizationQueryVariables>;
export const AddRestaurantToMetaOrganizationDocument = gql`
    mutation AddRestaurantToMetaOrganization($metaOrganizationId: ID!, $restaurantId: ID!) {
  addRestaurantToMetaOrganization(
    metaOrganizationId: $metaOrganizationId
    restaurantId: $restaurantId
  )
}
    `;
export type AddRestaurantToMetaOrganizationMutationFn = Apollo.MutationFunction<AddRestaurantToMetaOrganizationMutation, AddRestaurantToMetaOrganizationMutationVariables>;

/**
 * __useAddRestaurantToMetaOrganizationMutation__
 *
 * To run a mutation, you first call `useAddRestaurantToMetaOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRestaurantToMetaOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRestaurantToMetaOrganizationMutation, { data, loading, error }] = useAddRestaurantToMetaOrganizationMutation({
 *   variables: {
 *      metaOrganizationId: // value for 'metaOrganizationId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useAddRestaurantToMetaOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddRestaurantToMetaOrganizationMutation, AddRestaurantToMetaOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRestaurantToMetaOrganizationMutation, AddRestaurantToMetaOrganizationMutationVariables>(AddRestaurantToMetaOrganizationDocument, options);
      }
export type AddRestaurantToMetaOrganizationMutationHookResult = ReturnType<typeof useAddRestaurantToMetaOrganizationMutation>;
export type AddRestaurantToMetaOrganizationMutationResult = Apollo.MutationResult<AddRestaurantToMetaOrganizationMutation>;
export type AddRestaurantToMetaOrganizationMutationOptions = Apollo.BaseMutationOptions<AddRestaurantToMetaOrganizationMutation, AddRestaurantToMetaOrganizationMutationVariables>;
export const RemoveRestaurantFromMetaOrganizationDocument = gql`
    mutation RemoveRestaurantFromMetaOrganization($metaOrganizationId: ID!, $restaurantId: ID!) {
  removeRestaurantFromMetaOrganization(
    metaOrganizationId: $metaOrganizationId
    restaurantId: $restaurantId
  )
}
    `;
export type RemoveRestaurantFromMetaOrganizationMutationFn = Apollo.MutationFunction<RemoveRestaurantFromMetaOrganizationMutation, RemoveRestaurantFromMetaOrganizationMutationVariables>;

/**
 * __useRemoveRestaurantFromMetaOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveRestaurantFromMetaOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRestaurantFromMetaOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRestaurantFromMetaOrganizationMutation, { data, loading, error }] = useRemoveRestaurantFromMetaOrganizationMutation({
 *   variables: {
 *      metaOrganizationId: // value for 'metaOrganizationId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useRemoveRestaurantFromMetaOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRestaurantFromMetaOrganizationMutation, RemoveRestaurantFromMetaOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRestaurantFromMetaOrganizationMutation, RemoveRestaurantFromMetaOrganizationMutationVariables>(RemoveRestaurantFromMetaOrganizationDocument, options);
      }
export type RemoveRestaurantFromMetaOrganizationMutationHookResult = ReturnType<typeof useRemoveRestaurantFromMetaOrganizationMutation>;
export type RemoveRestaurantFromMetaOrganizationMutationResult = Apollo.MutationResult<RemoveRestaurantFromMetaOrganizationMutation>;
export type RemoveRestaurantFromMetaOrganizationMutationOptions = Apollo.BaseMutationOptions<RemoveRestaurantFromMetaOrganizationMutation, RemoveRestaurantFromMetaOrganizationMutationVariables>;
export const DeleteOpeningHoursDocument = gql`
    mutation DeleteOpeningHours($openingHoursId: ID!, $restaurantId: ID!) {
  deleteOpeningHours(openingHoursId: $openingHoursId, restaurantId: $restaurantId)
}
    `;
export type DeleteOpeningHoursMutationFn = Apollo.MutationFunction<DeleteOpeningHoursMutation, DeleteOpeningHoursMutationVariables>;

/**
 * __useDeleteOpeningHoursMutation__
 *
 * To run a mutation, you first call `useDeleteOpeningHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpeningHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpeningHoursMutation, { data, loading, error }] = useDeleteOpeningHoursMutation({
 *   variables: {
 *      openingHoursId: // value for 'openingHoursId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useDeleteOpeningHoursMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOpeningHoursMutation, DeleteOpeningHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOpeningHoursMutation, DeleteOpeningHoursMutationVariables>(DeleteOpeningHoursDocument, options);
      }
export type DeleteOpeningHoursMutationHookResult = ReturnType<typeof useDeleteOpeningHoursMutation>;
export type DeleteOpeningHoursMutationResult = Apollo.MutationResult<DeleteOpeningHoursMutation>;
export type DeleteOpeningHoursMutationOptions = Apollo.BaseMutationOptions<DeleteOpeningHoursMutation, DeleteOpeningHoursMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: OrganizationInput!) {
  createOrganization(input: $input) {
    id
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const GetOrganizationFortnoxAccountingImportViewDataDocument = gql`
    query GetOrganizationFortnoxAccountingImportViewData($organizationId: ID!, $redirectUrl: URL!) {
  organization(id: $organizationId) {
    id
    fortnoxAccountingImportEnabled
    fortnoxAccountingImportAuthorizationUrl(redirectUrl: $redirectUrl)
    hasFortnoxAccountingImportAccess
    hasFortnoxAccountingImportCredentials
    restaurants {
      id
      name
    }
  }
}
    `;

/**
 * __useGetOrganizationFortnoxAccountingImportViewDataQuery__
 *
 * To run a query within a React component, call `useGetOrganizationFortnoxAccountingImportViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationFortnoxAccountingImportViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationFortnoxAccountingImportViewDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useGetOrganizationFortnoxAccountingImportViewDataQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationFortnoxAccountingImportViewDataQuery, GetOrganizationFortnoxAccountingImportViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationFortnoxAccountingImportViewDataQuery, GetOrganizationFortnoxAccountingImportViewDataQueryVariables>(GetOrganizationFortnoxAccountingImportViewDataDocument, options);
      }
export function useGetOrganizationFortnoxAccountingImportViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationFortnoxAccountingImportViewDataQuery, GetOrganizationFortnoxAccountingImportViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationFortnoxAccountingImportViewDataQuery, GetOrganizationFortnoxAccountingImportViewDataQueryVariables>(GetOrganizationFortnoxAccountingImportViewDataDocument, options);
        }
export type GetOrganizationFortnoxAccountingImportViewDataQueryHookResult = ReturnType<typeof useGetOrganizationFortnoxAccountingImportViewDataQuery>;
export type GetOrganizationFortnoxAccountingImportViewDataLazyQueryHookResult = ReturnType<typeof useGetOrganizationFortnoxAccountingImportViewDataLazyQuery>;
export type GetOrganizationFortnoxAccountingImportViewDataQueryResult = Apollo.QueryResult<GetOrganizationFortnoxAccountingImportViewDataQuery, GetOrganizationFortnoxAccountingImportViewDataQueryVariables>;
export const AcceptFortnoxAccountingImportIntegrationTermsOfServiceDocument = gql`
    mutation AcceptFortnoxAccountingImportIntegrationTermsOfService($organizationId: ID!) {
  acceptFortnoxAccountingImportIntegrationTermsOfService(
    organizationId: $organizationId
  ) {
    id
    hasFortnoxAccountingImportAccess
  }
}
    `;
export type AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationFn = Apollo.MutationFunction<AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation, AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationVariables>;

/**
 * __useAcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptFortnoxAccountingImportIntegrationTermsOfServiceMutation, { data, loading, error }] = useAcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation, AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation, AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationVariables>(AcceptFortnoxAccountingImportIntegrationTermsOfServiceDocument, options);
      }
export type AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationHookResult = ReturnType<typeof useAcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation>;
export type AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationResult = Apollo.MutationResult<AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation>;
export type AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationOptions = Apollo.BaseMutationOptions<AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutation, AcceptFortnoxAccountingImportIntegrationTermsOfServiceMutationVariables>;
export const UnlinkFortnoxAccountingImportAccountDocument = gql`
    mutation UnlinkFortnoxAccountingImportAccount($organizationId: ID!) {
  unlinkFortnoxAccountingImportAccount(organizationId: $organizationId) {
    id
    fortnoxAccountingImportEnabled
    hasFortnoxAccountingImportAccess
    hasFortnoxAccountingImportCredentials
  }
}
    `;
export type UnlinkFortnoxAccountingImportAccountMutationFn = Apollo.MutationFunction<UnlinkFortnoxAccountingImportAccountMutation, UnlinkFortnoxAccountingImportAccountMutationVariables>;

/**
 * __useUnlinkFortnoxAccountingImportAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkFortnoxAccountingImportAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkFortnoxAccountingImportAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkFortnoxAccountingImportAccountMutation, { data, loading, error }] = useUnlinkFortnoxAccountingImportAccountMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUnlinkFortnoxAccountingImportAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkFortnoxAccountingImportAccountMutation, UnlinkFortnoxAccountingImportAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkFortnoxAccountingImportAccountMutation, UnlinkFortnoxAccountingImportAccountMutationVariables>(UnlinkFortnoxAccountingImportAccountDocument, options);
      }
export type UnlinkFortnoxAccountingImportAccountMutationHookResult = ReturnType<typeof useUnlinkFortnoxAccountingImportAccountMutation>;
export type UnlinkFortnoxAccountingImportAccountMutationResult = Apollo.MutationResult<UnlinkFortnoxAccountingImportAccountMutation>;
export type UnlinkFortnoxAccountingImportAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkFortnoxAccountingImportAccountMutation, UnlinkFortnoxAccountingImportAccountMutationVariables>;
export const GetOrganizationSelectDataDocument = gql`
    query GetOrganizationSelectData {
  me {
    organizationsWithAccess(access: Read) {
      id
      name
      restaurants {
        id
        name
        cashregister {
          id
          isRegistered
          controlUnit {
            isRegistered
          }
        }
        setupProgress {
          hasEnteredActivationCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationSelectDataQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSelectDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSelectDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSelectDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationSelectDataQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationSelectDataQuery, GetOrganizationSelectDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSelectDataQuery, GetOrganizationSelectDataQueryVariables>(GetOrganizationSelectDataDocument, options);
      }
export function useGetOrganizationSelectDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSelectDataQuery, GetOrganizationSelectDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSelectDataQuery, GetOrganizationSelectDataQueryVariables>(GetOrganizationSelectDataDocument, options);
        }
export type GetOrganizationSelectDataQueryHookResult = ReturnType<typeof useGetOrganizationSelectDataQuery>;
export type GetOrganizationSelectDataLazyQueryHookResult = ReturnType<typeof useGetOrganizationSelectDataLazyQuery>;
export type GetOrganizationSelectDataQueryResult = Apollo.QueryResult<GetOrganizationSelectDataQuery, GetOrganizationSelectDataQueryVariables>;
export const GetOrganizationUserCreateDataDocument = gql`
    query GetOrganizationUserCreateData($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    isOwner: hasAccess(access: Write)
    restaurants {
      id
      name
    }
  }
}
    `;

/**
 * __useGetOrganizationUserCreateDataQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserCreateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserCreateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserCreateDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationUserCreateDataQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUserCreateDataQuery, GetOrganizationUserCreateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUserCreateDataQuery, GetOrganizationUserCreateDataQueryVariables>(GetOrganizationUserCreateDataDocument, options);
      }
export function useGetOrganizationUserCreateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUserCreateDataQuery, GetOrganizationUserCreateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUserCreateDataQuery, GetOrganizationUserCreateDataQueryVariables>(GetOrganizationUserCreateDataDocument, options);
        }
export type GetOrganizationUserCreateDataQueryHookResult = ReturnType<typeof useGetOrganizationUserCreateDataQuery>;
export type GetOrganizationUserCreateDataLazyQueryHookResult = ReturnType<typeof useGetOrganizationUserCreateDataLazyQuery>;
export type GetOrganizationUserCreateDataQueryResult = Apollo.QueryResult<GetOrganizationUserCreateDataQuery, GetOrganizationUserCreateDataQueryVariables>;
export const CreateOrganizationUserDocument = gql`
    mutation CreateOrganizationUser($organizationId: ID!, $input: OrganizationUserInput!) {
  createOrganizationUser(organizationId: $organizationId, input: $input) {
    id
  }
}
    `;
export type CreateOrganizationUserMutationFn = Apollo.MutationFunction<CreateOrganizationUserMutation, CreateOrganizationUserMutationVariables>;

/**
 * __useCreateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationUserMutation, { data, loading, error }] = useCreateOrganizationUserMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationUserMutation, CreateOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationUserMutation, CreateOrganizationUserMutationVariables>(CreateOrganizationUserDocument, options);
      }
export type CreateOrganizationUserMutationHookResult = ReturnType<typeof useCreateOrganizationUserMutation>;
export type CreateOrganizationUserMutationResult = Apollo.MutationResult<CreateOrganizationUserMutation>;
export type CreateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationUserMutation, CreateOrganizationUserMutationVariables>;
export const UpdateOrganizationUserDocument = gql`
    mutation UpdateOrganizationUser($organizationId: ID!, $organizationUserId: ID!, $patch: OrganizationUserPatch!) {
  updateOrganizationUser(
    organizationId: $organizationId
    organizationUserId: $organizationUserId
    patch: $patch
  ) {
    ...FullOrganizationUserDetails
  }
}
    ${FullOrganizationUserDetailsFragmentDoc}`;
export type UpdateOrganizationUserMutationFn = Apollo.MutationFunction<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;

/**
 * __useUpdateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserMutation, { data, loading, error }] = useUpdateOrganizationUserMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationUserId: // value for 'organizationUserId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>(UpdateOrganizationUserDocument, options);
      }
export type UpdateOrganizationUserMutationHookResult = ReturnType<typeof useUpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationResult = Apollo.MutationResult<UpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;
export const DeleteOrganizationUserDocument = gql`
    mutation DeleteOrganizationUser($organizationId: ID!, $organizationUserId: ID!) {
  deleteOrganizationUser(
    organizationId: $organizationId
    organizationUserId: $organizationUserId
  ) {
    id
  }
}
    `;
export type DeleteOrganizationUserMutationFn = Apollo.MutationFunction<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>;

/**
 * __useDeleteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserMutation, { data, loading, error }] = useDeleteOrganizationUserMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useDeleteOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>(DeleteOrganizationUserDocument, options);
      }
export type DeleteOrganizationUserMutationHookResult = ReturnType<typeof useDeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationResult = Apollo.MutationResult<DeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>;
export const ResendOrganizationUserInviteDocument = gql`
    mutation ResendOrganizationUserInvite($organizationId: ID!, $organizationUserId: ID!) {
  resendOrganizationUserInvite(
    organizationId: $organizationId
    organizationUserId: $organizationUserId
  ) {
    id
  }
}
    `;
export type ResendOrganizationUserInviteMutationFn = Apollo.MutationFunction<ResendOrganizationUserInviteMutation, ResendOrganizationUserInviteMutationVariables>;

/**
 * __useResendOrganizationUserInviteMutation__
 *
 * To run a mutation, you first call `useResendOrganizationUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOrganizationUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOrganizationUserInviteMutation, { data, loading, error }] = useResendOrganizationUserInviteMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useResendOrganizationUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendOrganizationUserInviteMutation, ResendOrganizationUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOrganizationUserInviteMutation, ResendOrganizationUserInviteMutationVariables>(ResendOrganizationUserInviteDocument, options);
      }
export type ResendOrganizationUserInviteMutationHookResult = ReturnType<typeof useResendOrganizationUserInviteMutation>;
export type ResendOrganizationUserInviteMutationResult = Apollo.MutationResult<ResendOrganizationUserInviteMutation>;
export type ResendOrganizationUserInviteMutationOptions = Apollo.BaseMutationOptions<ResendOrganizationUserInviteMutation, ResendOrganizationUserInviteMutationVariables>;
export const GetOrganizationUserEditDataDocument = gql`
    query GetOrganizationUserEditData($organizationId: ID!, $userId: ID!) {
  organization(id: $organizationId) {
    id
    isOwner: hasAccess(access: Write)
    restaurants {
      id
      name
    }
    user(id: $userId) {
      ...FullOrganizationUserDetails
    }
  }
}
    ${FullOrganizationUserDetailsFragmentDoc}`;

/**
 * __useGetOrganizationUserEditDataQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserEditDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOrganizationUserEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUserEditDataQuery, GetOrganizationUserEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUserEditDataQuery, GetOrganizationUserEditDataQueryVariables>(GetOrganizationUserEditDataDocument, options);
      }
export function useGetOrganizationUserEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUserEditDataQuery, GetOrganizationUserEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUserEditDataQuery, GetOrganizationUserEditDataQueryVariables>(GetOrganizationUserEditDataDocument, options);
        }
export type GetOrganizationUserEditDataQueryHookResult = ReturnType<typeof useGetOrganizationUserEditDataQuery>;
export type GetOrganizationUserEditDataLazyQueryHookResult = ReturnType<typeof useGetOrganizationUserEditDataLazyQuery>;
export type GetOrganizationUserEditDataQueryResult = Apollo.QueryResult<GetOrganizationUserEditDataQuery, GetOrganizationUserEditDataQueryVariables>;
export const GetOrganizationUserListDocument = gql`
    query GetOrganizationUserList($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    users {
      id
      email
      isOwner
      name
    }
  }
}
    `;

/**
 * __useGetOrganizationUserListQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationUserListQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUserListQuery, GetOrganizationUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUserListQuery, GetOrganizationUserListQueryVariables>(GetOrganizationUserListDocument, options);
      }
export function useGetOrganizationUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUserListQuery, GetOrganizationUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUserListQuery, GetOrganizationUserListQueryVariables>(GetOrganizationUserListDocument, options);
        }
export type GetOrganizationUserListQueryHookResult = ReturnType<typeof useGetOrganizationUserListQuery>;
export type GetOrganizationUserListLazyQueryHookResult = ReturnType<typeof useGetOrganizationUserListLazyQuery>;
export type GetOrganizationUserListQueryResult = Apollo.QueryResult<GetOrganizationUserListQuery, GetOrganizationUserListQueryVariables>;
export const RequestResetUserPasswordEmailDocument = gql`
    mutation RequestResetUserPasswordEmail($email: EmailAddress!) {
  requestResetUserPasswordEmail(email: $email)
}
    `;
export type RequestResetUserPasswordEmailMutationFn = Apollo.MutationFunction<RequestResetUserPasswordEmailMutation, RequestResetUserPasswordEmailMutationVariables>;

/**
 * __useRequestResetUserPasswordEmailMutation__
 *
 * To run a mutation, you first call `useRequestResetUserPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetUserPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetUserPasswordEmailMutation, { data, loading, error }] = useRequestResetUserPasswordEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestResetUserPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetUserPasswordEmailMutation, RequestResetUserPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetUserPasswordEmailMutation, RequestResetUserPasswordEmailMutationVariables>(RequestResetUserPasswordEmailDocument, options);
      }
export type RequestResetUserPasswordEmailMutationHookResult = ReturnType<typeof useRequestResetUserPasswordEmailMutation>;
export type RequestResetUserPasswordEmailMutationResult = Apollo.MutationResult<RequestResetUserPasswordEmailMutation>;
export type RequestResetUserPasswordEmailMutationOptions = Apollo.BaseMutationOptions<RequestResetUserPasswordEmailMutation, RequestResetUserPasswordEmailMutationVariables>;
export const GetResetPasswordDataDocument = gql`
    query GetResetPasswordData($token: String!) {
  passwordResetRequest(token: $token) {
    id
    email
    expiresAt
    usedAt
  }
}
    `;

/**
 * __useGetResetPasswordDataQuery__
 *
 * To run a query within a React component, call `useGetResetPasswordDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResetPasswordDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResetPasswordDataQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetResetPasswordDataQuery(baseOptions: Apollo.QueryHookOptions<GetResetPasswordDataQuery, GetResetPasswordDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResetPasswordDataQuery, GetResetPasswordDataQueryVariables>(GetResetPasswordDataDocument, options);
      }
export function useGetResetPasswordDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResetPasswordDataQuery, GetResetPasswordDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResetPasswordDataQuery, GetResetPasswordDataQueryVariables>(GetResetPasswordDataDocument, options);
        }
export type GetResetPasswordDataQueryHookResult = ReturnType<typeof useGetResetPasswordDataQuery>;
export type GetResetPasswordDataLazyQueryHookResult = ReturnType<typeof useGetResetPasswordDataLazyQuery>;
export type GetResetPasswordDataQueryResult = Apollo.QueryResult<GetResetPasswordDataQuery, GetResetPasswordDataQueryVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($password: String!, $token: String!) {
  resetUserPassword(password: $password, token: $token) {
    parseToken
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const CreateMenuReportGroupDocument = gql`
    mutation CreateMenuReportGroup($restaurantId: ID!, $input: MenuReportGroupInput!) {
  createMenuReportGroup(restaurantId: $restaurantId, input: $input) {
    id
  }
}
    `;
export type CreateMenuReportGroupMutationFn = Apollo.MutationFunction<CreateMenuReportGroupMutation, CreateMenuReportGroupMutationVariables>;

/**
 * __useCreateMenuReportGroupMutation__
 *
 * To run a mutation, you first call `useCreateMenuReportGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuReportGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuReportGroupMutation, { data, loading, error }] = useCreateMenuReportGroupMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMenuReportGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuReportGroupMutation, CreateMenuReportGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuReportGroupMutation, CreateMenuReportGroupMutationVariables>(CreateMenuReportGroupDocument, options);
      }
export type CreateMenuReportGroupMutationHookResult = ReturnType<typeof useCreateMenuReportGroupMutation>;
export type CreateMenuReportGroupMutationResult = Apollo.MutationResult<CreateMenuReportGroupMutation>;
export type CreateMenuReportGroupMutationOptions = Apollo.BaseMutationOptions<CreateMenuReportGroupMutation, CreateMenuReportGroupMutationVariables>;
export const GetReportGroupsDocument = gql`
    query GetReportGroups($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    menu(filter: {active: All, includeProductsWithOpenPrice: true}) {
      reportGroups {
        ...FullMenuReportGroup
      }
    }
  }
}
    ${FullMenuReportGroupFragmentDoc}`;

/**
 * __useGetReportGroupsQuery__
 *
 * To run a query within a React component, call `useGetReportGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportGroupsQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetReportGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetReportGroupsQuery, GetReportGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportGroupsQuery, GetReportGroupsQueryVariables>(GetReportGroupsDocument, options);
      }
export function useGetReportGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportGroupsQuery, GetReportGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportGroupsQuery, GetReportGroupsQueryVariables>(GetReportGroupsDocument, options);
        }
export type GetReportGroupsQueryHookResult = ReturnType<typeof useGetReportGroupsQuery>;
export type GetReportGroupsLazyQueryHookResult = ReturnType<typeof useGetReportGroupsLazyQuery>;
export type GetReportGroupsQueryResult = Apollo.QueryResult<GetReportGroupsQuery, GetReportGroupsQueryVariables>;
export const DeleteMenuReportGroupDocument = gql`
    mutation DeleteMenuReportGroup($restaurantId: ID!, $menuReportGroupId: ID!) {
  deleteMenuReportGroup(
    restaurantId: $restaurantId
    menuReportGroupId: $menuReportGroupId
  )
}
    `;
export type DeleteMenuReportGroupMutationFn = Apollo.MutationFunction<DeleteMenuReportGroupMutation, DeleteMenuReportGroupMutationVariables>;

/**
 * __useDeleteMenuReportGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMenuReportGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuReportGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuReportGroupMutation, { data, loading, error }] = useDeleteMenuReportGroupMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuReportGroupId: // value for 'menuReportGroupId'
 *   },
 * });
 */
export function useDeleteMenuReportGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuReportGroupMutation, DeleteMenuReportGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuReportGroupMutation, DeleteMenuReportGroupMutationVariables>(DeleteMenuReportGroupDocument, options);
      }
export type DeleteMenuReportGroupMutationHookResult = ReturnType<typeof useDeleteMenuReportGroupMutation>;
export type DeleteMenuReportGroupMutationResult = Apollo.MutationResult<DeleteMenuReportGroupMutation>;
export type DeleteMenuReportGroupMutationOptions = Apollo.BaseMutationOptions<DeleteMenuReportGroupMutation, DeleteMenuReportGroupMutationVariables>;
export const GetRestaurantControlUnitOutageDataDocument = gql`
    query GetRestaurantControlUnitOutageData($restaurantId: ID!, $cursor: String) {
  restaurant(id: $restaurantId) {
    id
    controlUnitOutages(first: 5, after: $cursor) {
      edges {
        cursor
        node {
          ...FullRestaurantControlUnitOutage
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${FullRestaurantControlUnitOutageFragmentDoc}`;

/**
 * __useGetRestaurantControlUnitOutageDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantControlUnitOutageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantControlUnitOutageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantControlUnitOutageDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetRestaurantControlUnitOutageDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantControlUnitOutageDataQuery, GetRestaurantControlUnitOutageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantControlUnitOutageDataQuery, GetRestaurantControlUnitOutageDataQueryVariables>(GetRestaurantControlUnitOutageDataDocument, options);
      }
export function useGetRestaurantControlUnitOutageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantControlUnitOutageDataQuery, GetRestaurantControlUnitOutageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantControlUnitOutageDataQuery, GetRestaurantControlUnitOutageDataQueryVariables>(GetRestaurantControlUnitOutageDataDocument, options);
        }
export type GetRestaurantControlUnitOutageDataQueryHookResult = ReturnType<typeof useGetRestaurantControlUnitOutageDataQuery>;
export type GetRestaurantControlUnitOutageDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantControlUnitOutageDataLazyQuery>;
export type GetRestaurantControlUnitOutageDataQueryResult = Apollo.QueryResult<GetRestaurantControlUnitOutageDataQuery, GetRestaurantControlUnitOutageDataQueryVariables>;
export const CreateRestaurantDocument = gql`
    mutation CreateRestaurant($organizationId: ID!, $input: RestaurantInput!) {
  createRestaurant(organizationId: $organizationId, input: $input) {
    id
  }
}
    `;
export type CreateRestaurantMutationFn = Apollo.MutationFunction<CreateRestaurantMutation, CreateRestaurantMutationVariables>;

/**
 * __useCreateRestaurantMutation__
 *
 * To run a mutation, you first call `useCreateRestaurantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRestaurantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRestaurantMutation, { data, loading, error }] = useCreateRestaurantMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRestaurantMutation(baseOptions?: Apollo.MutationHookOptions<CreateRestaurantMutation, CreateRestaurantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRestaurantMutation, CreateRestaurantMutationVariables>(CreateRestaurantDocument, options);
      }
export type CreateRestaurantMutationHookResult = ReturnType<typeof useCreateRestaurantMutation>;
export type CreateRestaurantMutationResult = Apollo.MutationResult<CreateRestaurantMutation>;
export type CreateRestaurantMutationOptions = Apollo.BaseMutationOptions<CreateRestaurantMutation, CreateRestaurantMutationVariables>;
export const GetRestaurantDashboardDataDocument = gql`
    query GetRestaurantDashboardData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    hasDeliveryHeroAccess
    hasOrderDisplaySystemAccess
    hasPersonalkollenAccess
    isOwner: hasAccess(access: Write)
  }
}
    `;

/**
 * __useGetRestaurantDashboardDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantDashboardDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantDashboardDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantDashboardDataQuery, GetRestaurantDashboardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantDashboardDataQuery, GetRestaurantDashboardDataQueryVariables>(GetRestaurantDashboardDataDocument, options);
      }
export function useGetRestaurantDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantDashboardDataQuery, GetRestaurantDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantDashboardDataQuery, GetRestaurantDashboardDataQueryVariables>(GetRestaurantDashboardDataDocument, options);
        }
export type GetRestaurantDashboardDataQueryHookResult = ReturnType<typeof useGetRestaurantDashboardDataQuery>;
export type GetRestaurantDashboardDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantDashboardDataLazyQuery>;
export type GetRestaurantDashboardDataQueryResult = Apollo.QueryResult<GetRestaurantDashboardDataQuery, GetRestaurantDashboardDataQueryVariables>;
export const GetDeliveryListDataDocument = gql`
    query GetDeliveryListData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    hasDeliveryMenu
    hasDeliveryHeroAccess
  }
}
    `;

/**
 * __useGetDeliveryListDataQuery__
 *
 * To run a query within a React component, call `useGetDeliveryListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryListDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetDeliveryListDataQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryListDataQuery, GetDeliveryListDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryListDataQuery, GetDeliveryListDataQueryVariables>(GetDeliveryListDataDocument, options);
      }
export function useGetDeliveryListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryListDataQuery, GetDeliveryListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryListDataQuery, GetDeliveryListDataQueryVariables>(GetDeliveryListDataDocument, options);
        }
export type GetDeliveryListDataQueryHookResult = ReturnType<typeof useGetDeliveryListDataQuery>;
export type GetDeliveryListDataLazyQueryHookResult = ReturnType<typeof useGetDeliveryListDataLazyQuery>;
export type GetDeliveryListDataQueryResult = Apollo.QueryResult<GetDeliveryListDataQuery, GetDeliveryListDataQueryVariables>;
export const GetRestaurantDesignDocument = gql`
    query GetRestaurantDesign($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    ...RestaurantDesignFields
  }
}
    ${RestaurantDesignFieldsFragmentDoc}`;

/**
 * __useGetRestaurantDesignQuery__
 *
 * To run a query within a React component, call `useGetRestaurantDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantDesignQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantDesignQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantDesignQuery, GetRestaurantDesignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantDesignQuery, GetRestaurantDesignQueryVariables>(GetRestaurantDesignDocument, options);
      }
export function useGetRestaurantDesignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantDesignQuery, GetRestaurantDesignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantDesignQuery, GetRestaurantDesignQueryVariables>(GetRestaurantDesignDocument, options);
        }
export type GetRestaurantDesignQueryHookResult = ReturnType<typeof useGetRestaurantDesignQuery>;
export type GetRestaurantDesignLazyQueryHookResult = ReturnType<typeof useGetRestaurantDesignLazyQuery>;
export type GetRestaurantDesignQueryResult = Apollo.QueryResult<GetRestaurantDesignQuery, GetRestaurantDesignQueryVariables>;
export const UpdateRestaurantDesignDocument = gql`
    mutation UpdateRestaurantDesign($restaurantId: ID!, $patch: RestaurantPatch!) {
  updateRestaurant(restaurantId: $restaurantId, patch: $patch) {
    ...RestaurantDesignFields
  }
}
    ${RestaurantDesignFieldsFragmentDoc}`;
export type UpdateRestaurantDesignMutationFn = Apollo.MutationFunction<UpdateRestaurantDesignMutation, UpdateRestaurantDesignMutationVariables>;

/**
 * __useUpdateRestaurantDesignMutation__
 *
 * To run a mutation, you first call `useUpdateRestaurantDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestaurantDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestaurantDesignMutation, { data, loading, error }] = useUpdateRestaurantDesignMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateRestaurantDesignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRestaurantDesignMutation, UpdateRestaurantDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRestaurantDesignMutation, UpdateRestaurantDesignMutationVariables>(UpdateRestaurantDesignDocument, options);
      }
export type UpdateRestaurantDesignMutationHookResult = ReturnType<typeof useUpdateRestaurantDesignMutation>;
export type UpdateRestaurantDesignMutationResult = Apollo.MutationResult<UpdateRestaurantDesignMutation>;
export type UpdateRestaurantDesignMutationOptions = Apollo.BaseMutationOptions<UpdateRestaurantDesignMutation, UpdateRestaurantDesignMutationVariables>;
export const CreateRestaurantDiscountDocument = gql`
    mutation CreateRestaurantDiscount($restaurantId: ID!, $input: DiscountInput!) {
  createRestaurantDiscount(restaurantId: $restaurantId, input: $input) {
    id
  }
}
    `;
export type CreateRestaurantDiscountMutationFn = Apollo.MutationFunction<CreateRestaurantDiscountMutation, CreateRestaurantDiscountMutationVariables>;

/**
 * __useCreateRestaurantDiscountMutation__
 *
 * To run a mutation, you first call `useCreateRestaurantDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRestaurantDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRestaurantDiscountMutation, { data, loading, error }] = useCreateRestaurantDiscountMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRestaurantDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateRestaurantDiscountMutation, CreateRestaurantDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRestaurantDiscountMutation, CreateRestaurantDiscountMutationVariables>(CreateRestaurantDiscountDocument, options);
      }
export type CreateRestaurantDiscountMutationHookResult = ReturnType<typeof useCreateRestaurantDiscountMutation>;
export type CreateRestaurantDiscountMutationResult = Apollo.MutationResult<CreateRestaurantDiscountMutation>;
export type CreateRestaurantDiscountMutationOptions = Apollo.BaseMutationOptions<CreateRestaurantDiscountMutation, CreateRestaurantDiscountMutationVariables>;
export const GetRestaurantDiscountDocument = gql`
    query GetRestaurantDiscount($restaurantId: ID!, $discountId: ID!) {
  restaurant(id: $restaurantId) {
    id
    discount(id: $discountId) {
      ...FullDiscount
    }
  }
}
    ${FullDiscountFragmentDoc}`;

/**
 * __useGetRestaurantDiscountQuery__
 *
 * To run a query within a React component, call `useGetRestaurantDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantDiscountQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useGetRestaurantDiscountQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantDiscountQuery, GetRestaurantDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantDiscountQuery, GetRestaurantDiscountQueryVariables>(GetRestaurantDiscountDocument, options);
      }
export function useGetRestaurantDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantDiscountQuery, GetRestaurantDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantDiscountQuery, GetRestaurantDiscountQueryVariables>(GetRestaurantDiscountDocument, options);
        }
export type GetRestaurantDiscountQueryHookResult = ReturnType<typeof useGetRestaurantDiscountQuery>;
export type GetRestaurantDiscountLazyQueryHookResult = ReturnType<typeof useGetRestaurantDiscountLazyQuery>;
export type GetRestaurantDiscountQueryResult = Apollo.QueryResult<GetRestaurantDiscountQuery, GetRestaurantDiscountQueryVariables>;
export const DeleteRestaurantDiscountDocument = gql`
    mutation DeleteRestaurantDiscount($restaurantId: ID!, $discountId: ID!) {
  deleteRestaurantDiscount(restaurantId: $restaurantId, discountId: $discountId)
}
    `;
export type DeleteRestaurantDiscountMutationFn = Apollo.MutationFunction<DeleteRestaurantDiscountMutation, DeleteRestaurantDiscountMutationVariables>;

/**
 * __useDeleteRestaurantDiscountMutation__
 *
 * To run a mutation, you first call `useDeleteRestaurantDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRestaurantDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRestaurantDiscountMutation, { data, loading, error }] = useDeleteRestaurantDiscountMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useDeleteRestaurantDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRestaurantDiscountMutation, DeleteRestaurantDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRestaurantDiscountMutation, DeleteRestaurantDiscountMutationVariables>(DeleteRestaurantDiscountDocument, options);
      }
export type DeleteRestaurantDiscountMutationHookResult = ReturnType<typeof useDeleteRestaurantDiscountMutation>;
export type DeleteRestaurantDiscountMutationResult = Apollo.MutationResult<DeleteRestaurantDiscountMutation>;
export type DeleteRestaurantDiscountMutationOptions = Apollo.BaseMutationOptions<DeleteRestaurantDiscountMutation, DeleteRestaurantDiscountMutationVariables>;
export const UpdateRestaurantDiscountDocument = gql`
    mutation UpdateRestaurantDiscount($restaurantId: ID!, $discountId: ID!, $patch: DiscountPatch!) {
  updateRestaurantDiscount(
    restaurantId: $restaurantId
    discountId: $discountId
    patch: $patch
  ) {
    id
  }
}
    `;
export type UpdateRestaurantDiscountMutationFn = Apollo.MutationFunction<UpdateRestaurantDiscountMutation, UpdateRestaurantDiscountMutationVariables>;

/**
 * __useUpdateRestaurantDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateRestaurantDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestaurantDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestaurantDiscountMutation, { data, loading, error }] = useUpdateRestaurantDiscountMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      discountId: // value for 'discountId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateRestaurantDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRestaurantDiscountMutation, UpdateRestaurantDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRestaurantDiscountMutation, UpdateRestaurantDiscountMutationVariables>(UpdateRestaurantDiscountDocument, options);
      }
export type UpdateRestaurantDiscountMutationHookResult = ReturnType<typeof useUpdateRestaurantDiscountMutation>;
export type UpdateRestaurantDiscountMutationResult = Apollo.MutationResult<UpdateRestaurantDiscountMutation>;
export type UpdateRestaurantDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateRestaurantDiscountMutation, UpdateRestaurantDiscountMutationVariables>;
export const GetRestaurantDiscountsDocument = gql`
    query GetRestaurantDiscounts($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    discountsEnabled
    timeZone
    discounts(first: 1000) {
      edges {
        node {
          ...FullDiscount
        }
      }
    }
  }
}
    ${FullDiscountFragmentDoc}`;

/**
 * __useGetRestaurantDiscountsQuery__
 *
 * To run a query within a React component, call `useGetRestaurantDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantDiscountsQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantDiscountsQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantDiscountsQuery, GetRestaurantDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantDiscountsQuery, GetRestaurantDiscountsQueryVariables>(GetRestaurantDiscountsDocument, options);
      }
export function useGetRestaurantDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantDiscountsQuery, GetRestaurantDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantDiscountsQuery, GetRestaurantDiscountsQueryVariables>(GetRestaurantDiscountsDocument, options);
        }
export type GetRestaurantDiscountsQueryHookResult = ReturnType<typeof useGetRestaurantDiscountsQuery>;
export type GetRestaurantDiscountsLazyQueryHookResult = ReturnType<typeof useGetRestaurantDiscountsLazyQuery>;
export type GetRestaurantDiscountsQueryResult = Apollo.QueryResult<GetRestaurantDiscountsQuery, GetRestaurantDiscountsQueryVariables>;
export const GetRestaurantSuperUserDataDocument = gql`
    query GetRestaurantSuperUserData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    activationCode
    applicationFeeCents
    applicationFeePercentage
    isBetaTesting
  }
  whiteLabels(first: 999) {
    edges {
      node {
        id
        appName
        label
      }
    }
  }
}
    `;

/**
 * __useGetRestaurantSuperUserDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantSuperUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantSuperUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantSuperUserDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantSuperUserDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantSuperUserDataQuery, GetRestaurantSuperUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantSuperUserDataQuery, GetRestaurantSuperUserDataQueryVariables>(GetRestaurantSuperUserDataDocument, options);
      }
export function useGetRestaurantSuperUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantSuperUserDataQuery, GetRestaurantSuperUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantSuperUserDataQuery, GetRestaurantSuperUserDataQueryVariables>(GetRestaurantSuperUserDataDocument, options);
        }
export type GetRestaurantSuperUserDataQueryHookResult = ReturnType<typeof useGetRestaurantSuperUserDataQuery>;
export type GetRestaurantSuperUserDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantSuperUserDataLazyQuery>;
export type GetRestaurantSuperUserDataQueryResult = Apollo.QueryResult<GetRestaurantSuperUserDataQuery, GetRestaurantSuperUserDataQueryVariables>;
export const GetRestaurantDataDocument = gql`
    query GetRestaurantData($restaurantId: ID!) {
  me {
    id
    isSuperUser
  }
  restaurant(id: $restaurantId) {
    ...RestaurantFields
  }
}
    ${RestaurantFieldsFragmentDoc}`;

/**
 * __useGetRestaurantDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantDataQuery, GetRestaurantDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantDataQuery, GetRestaurantDataQueryVariables>(GetRestaurantDataDocument, options);
      }
export function useGetRestaurantDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantDataQuery, GetRestaurantDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantDataQuery, GetRestaurantDataQueryVariables>(GetRestaurantDataDocument, options);
        }
export type GetRestaurantDataQueryHookResult = ReturnType<typeof useGetRestaurantDataQuery>;
export type GetRestaurantDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantDataLazyQuery>;
export type GetRestaurantDataQueryResult = Apollo.QueryResult<GetRestaurantDataQuery, GetRestaurantDataQueryVariables>;
export const DeleteRestaurantDocument = gql`
    mutation DeleteRestaurant($restaurantId: ID!) {
  deleteRestaurant(restaurantId: $restaurantId)
}
    `;
export type DeleteRestaurantMutationFn = Apollo.MutationFunction<DeleteRestaurantMutation, DeleteRestaurantMutationVariables>;

/**
 * __useDeleteRestaurantMutation__
 *
 * To run a mutation, you first call `useDeleteRestaurantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRestaurantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRestaurantMutation, { data, loading, error }] = useDeleteRestaurantMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useDeleteRestaurantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRestaurantMutation, DeleteRestaurantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRestaurantMutation, DeleteRestaurantMutationVariables>(DeleteRestaurantDocument, options);
      }
export type DeleteRestaurantMutationHookResult = ReturnType<typeof useDeleteRestaurantMutation>;
export type DeleteRestaurantMutationResult = Apollo.MutationResult<DeleteRestaurantMutation>;
export type DeleteRestaurantMutationOptions = Apollo.BaseMutationOptions<DeleteRestaurantMutation, DeleteRestaurantMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($organizationId: ID!, $patch: OrganizationPatch!) {
  updateOrganization(organizationId: $organizationId, patch: $patch) {
    id
    name
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateRestaurantDocument = gql`
    mutation UpdateRestaurant($restaurantId: ID!, $patch: RestaurantPatch!) {
  updateRestaurant(restaurantId: $restaurantId, patch: $patch) {
    ...RestaurantFields
  }
}
    ${RestaurantFieldsFragmentDoc}`;
export type UpdateRestaurantMutationFn = Apollo.MutationFunction<UpdateRestaurantMutation, UpdateRestaurantMutationVariables>;

/**
 * __useUpdateRestaurantMutation__
 *
 * To run a mutation, you first call `useUpdateRestaurantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestaurantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestaurantMutation, { data, loading, error }] = useUpdateRestaurantMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateRestaurantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRestaurantMutation, UpdateRestaurantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRestaurantMutation, UpdateRestaurantMutationVariables>(UpdateRestaurantDocument, options);
      }
export type UpdateRestaurantMutationHookResult = ReturnType<typeof useUpdateRestaurantMutation>;
export type UpdateRestaurantMutationResult = Apollo.MutationResult<UpdateRestaurantMutation>;
export type UpdateRestaurantMutationOptions = Apollo.BaseMutationOptions<UpdateRestaurantMutation, UpdateRestaurantMutationVariables>;
export const GetRestaurantEmployeeCreateDataDocument = gql`
    query GetRestaurantEmployeeCreateData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    employeeGroups {
      ...EmployeeGroupFields
    }
  }
}
    ${EmployeeGroupFieldsFragmentDoc}`;

/**
 * __useGetRestaurantEmployeeCreateDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantEmployeeCreateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantEmployeeCreateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantEmployeeCreateDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantEmployeeCreateDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantEmployeeCreateDataQuery, GetRestaurantEmployeeCreateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantEmployeeCreateDataQuery, GetRestaurantEmployeeCreateDataQueryVariables>(GetRestaurantEmployeeCreateDataDocument, options);
      }
export function useGetRestaurantEmployeeCreateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantEmployeeCreateDataQuery, GetRestaurantEmployeeCreateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantEmployeeCreateDataQuery, GetRestaurantEmployeeCreateDataQueryVariables>(GetRestaurantEmployeeCreateDataDocument, options);
        }
export type GetRestaurantEmployeeCreateDataQueryHookResult = ReturnType<typeof useGetRestaurantEmployeeCreateDataQuery>;
export type GetRestaurantEmployeeCreateDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantEmployeeCreateDataLazyQuery>;
export type GetRestaurantEmployeeCreateDataQueryResult = Apollo.QueryResult<GetRestaurantEmployeeCreateDataQuery, GetRestaurantEmployeeCreateDataQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($restaurantId: ID!, $input: EmployeeInput!) {
  createEmployee(restaurantId: $restaurantId, input: $input) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const GetRestaurantEmployeeEditDataDocument = gql`
    query GetRestaurantEmployeeEditData($restaurantId: ID!, $employeeId: ID!) {
  restaurant(id: $restaurantId) {
    id
    employee(id: $employeeId) {
      ...EmployeeFields
    }
    employeeGroups {
      ...EmployeeGroupFields
    }
  }
}
    ${EmployeeFieldsFragmentDoc}
${EmployeeGroupFieldsFragmentDoc}`;

/**
 * __useGetRestaurantEmployeeEditDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantEmployeeEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantEmployeeEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantEmployeeEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetRestaurantEmployeeEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantEmployeeEditDataQuery, GetRestaurantEmployeeEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantEmployeeEditDataQuery, GetRestaurantEmployeeEditDataQueryVariables>(GetRestaurantEmployeeEditDataDocument, options);
      }
export function useGetRestaurantEmployeeEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantEmployeeEditDataQuery, GetRestaurantEmployeeEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantEmployeeEditDataQuery, GetRestaurantEmployeeEditDataQueryVariables>(GetRestaurantEmployeeEditDataDocument, options);
        }
export type GetRestaurantEmployeeEditDataQueryHookResult = ReturnType<typeof useGetRestaurantEmployeeEditDataQuery>;
export type GetRestaurantEmployeeEditDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantEmployeeEditDataLazyQuery>;
export type GetRestaurantEmployeeEditDataQueryResult = Apollo.QueryResult<GetRestaurantEmployeeEditDataQuery, GetRestaurantEmployeeEditDataQueryVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($restaurantId: ID!, $employeeId: ID!, $patch: EmployeePatch!) {
  updateEmployee(
    restaurantId: $restaurantId
    employeeId: $employeeId
    patch: $patch
  ) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      employeeId: // value for 'employeeId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($restaurantId: ID!, $employeeId: ID!) {
  deleteEmployee(restaurantId: $restaurantId, employeeId: $employeeId)
}
    `;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($restaurantId: ID!, $input: EmployeeGroupInput!) {
  createEmployeeGroup(restaurantId: $restaurantId, input: $input) {
    ...EmployeeGroupFields
  }
}
    ${EmployeeGroupFieldsFragmentDoc}`;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const GetGroupDocument = gql`
    query GetGroup($restaurantId: ID!, $employeeGroupId: ID!) {
  restaurant(id: $restaurantId) {
    id
    employeeGroup(id: $employeeGroupId) {
      ...EmployeeGroupFields
    }
  }
}
    ${EmployeeGroupFieldsFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      employeeGroupId: // value for 'employeeGroupId'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const EditGroupDocument = gql`
    mutation EditGroup($restaurantId: ID!, $employeeGroupId: ID!, $patch: EmployeeGroupPatch!) {
  updateEmployeeGroup(
    restaurantId: $restaurantId
    employeeGroupId: $employeeGroupId
    patch: $patch
  ) {
    ...EmployeeGroupFields
  }
}
    ${EmployeeGroupFieldsFragmentDoc}`;
export type EditGroupMutationFn = Apollo.MutationFunction<EditGroupMutation, EditGroupMutationVariables>;

/**
 * __useEditGroupMutation__
 *
 * To run a mutation, you first call `useEditGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGroupMutation, { data, loading, error }] = useEditGroupMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      employeeGroupId: // value for 'employeeGroupId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useEditGroupMutation(baseOptions?: Apollo.MutationHookOptions<EditGroupMutation, EditGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGroupMutation, EditGroupMutationVariables>(EditGroupDocument, options);
      }
export type EditGroupMutationHookResult = ReturnType<typeof useEditGroupMutation>;
export type EditGroupMutationResult = Apollo.MutationResult<EditGroupMutation>;
export type EditGroupMutationOptions = Apollo.BaseMutationOptions<EditGroupMutation, EditGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($restaurantId: ID!, $employeeGroupId: ID!) {
  deleteEmployeeGroup(
    restaurantId: $restaurantId
    employeeGroupId: $employeeGroupId
  )
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      employeeGroupId: // value for 'employeeGroupId'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const GetRestaurantSetupProgressDocument = gql`
    query GetRestaurantSetupProgress($redirectUrl: URL, $restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    ...SetupProgressFragment
    setupProgress {
      stripeConnectionUrl(redirectUrl: $redirectUrl)
    }
  }
}
    ${SetupProgressFragmentFragmentDoc}`;

/**
 * __useGetRestaurantSetupProgressQuery__
 *
 * To run a query within a React component, call `useGetRestaurantSetupProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantSetupProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantSetupProgressQuery({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantSetupProgressQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantSetupProgressQuery, GetRestaurantSetupProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantSetupProgressQuery, GetRestaurantSetupProgressQueryVariables>(GetRestaurantSetupProgressDocument, options);
      }
export function useGetRestaurantSetupProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantSetupProgressQuery, GetRestaurantSetupProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantSetupProgressQuery, GetRestaurantSetupProgressQueryVariables>(GetRestaurantSetupProgressDocument, options);
        }
export type GetRestaurantSetupProgressQueryHookResult = ReturnType<typeof useGetRestaurantSetupProgressQuery>;
export type GetRestaurantSetupProgressLazyQueryHookResult = ReturnType<typeof useGetRestaurantSetupProgressLazyQuery>;
export type GetRestaurantSetupProgressQueryResult = Apollo.QueryResult<GetRestaurantSetupProgressQuery, GetRestaurantSetupProgressQueryVariables>;
export const RegisterControlUnitDocument = gql`
    mutation RegisterControlUnit($restaurantId: ID!, $taxIdNumber: String!) {
  registerControlUnit(restaurantId: $restaurantId, taxIdNumber: $taxIdNumber) {
    ...SetupProgressFragment
  }
}
    ${SetupProgressFragmentFragmentDoc}`;
export type RegisterControlUnitMutationFn = Apollo.MutationFunction<RegisterControlUnitMutation, RegisterControlUnitMutationVariables>;

/**
 * __useRegisterControlUnitMutation__
 *
 * To run a mutation, you first call `useRegisterControlUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterControlUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerControlUnitMutation, { data, loading, error }] = useRegisterControlUnitMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      taxIdNumber: // value for 'taxIdNumber'
 *   },
 * });
 */
export function useRegisterControlUnitMutation(baseOptions?: Apollo.MutationHookOptions<RegisterControlUnitMutation, RegisterControlUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterControlUnitMutation, RegisterControlUnitMutationVariables>(RegisterControlUnitDocument, options);
      }
export type RegisterControlUnitMutationHookResult = ReturnType<typeof useRegisterControlUnitMutation>;
export type RegisterControlUnitMutationResult = Apollo.MutationResult<RegisterControlUnitMutation>;
export type RegisterControlUnitMutationOptions = Apollo.BaseMutationOptions<RegisterControlUnitMutation, RegisterControlUnitMutationVariables>;
export const RegisterCashregisterDocument = gql`
    mutation RegisterCashregister($restaurantId: ID!) {
  registerCashregister(restaurantId: $restaurantId) {
    ...SetupProgressFragment
  }
}
    ${SetupProgressFragmentFragmentDoc}`;
export type RegisterCashregisterMutationFn = Apollo.MutationFunction<RegisterCashregisterMutation, RegisterCashregisterMutationVariables>;

/**
 * __useRegisterCashregisterMutation__
 *
 * To run a mutation, you first call `useRegisterCashregisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCashregisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCashregisterMutation, { data, loading, error }] = useRegisterCashregisterMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useRegisterCashregisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterCashregisterMutation, RegisterCashregisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterCashregisterMutation, RegisterCashregisterMutationVariables>(RegisterCashregisterDocument, options);
      }
export type RegisterCashregisterMutationHookResult = ReturnType<typeof useRegisterCashregisterMutation>;
export type RegisterCashregisterMutationResult = Apollo.MutationResult<RegisterCashregisterMutation>;
export type RegisterCashregisterMutationOptions = Apollo.BaseMutationOptions<RegisterCashregisterMutation, RegisterCashregisterMutationVariables>;
export const ActivateRestaurantDocument = gql`
    mutation ActivateRestaurant($code: String!, $restaurantId: ID!) {
  activateRestaurant(code: $code, restaurantId: $restaurantId) {
    ...SetupProgressFragment
  }
}
    ${SetupProgressFragmentFragmentDoc}`;
export type ActivateRestaurantMutationFn = Apollo.MutationFunction<ActivateRestaurantMutation, ActivateRestaurantMutationVariables>;

/**
 * __useActivateRestaurantMutation__
 *
 * To run a mutation, you first call `useActivateRestaurantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateRestaurantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateRestaurantMutation, { data, loading, error }] = useActivateRestaurantMutation({
 *   variables: {
 *      code: // value for 'code'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useActivateRestaurantMutation(baseOptions?: Apollo.MutationHookOptions<ActivateRestaurantMutation, ActivateRestaurantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateRestaurantMutation, ActivateRestaurantMutationVariables>(ActivateRestaurantDocument, options);
      }
export type ActivateRestaurantMutationHookResult = ReturnType<typeof useActivateRestaurantMutation>;
export type ActivateRestaurantMutationResult = Apollo.MutationResult<ActivateRestaurantMutation>;
export type ActivateRestaurantMutationOptions = Apollo.BaseMutationOptions<ActivateRestaurantMutation, ActivateRestaurantMutationVariables>;
export const ListRestaurantsDocument = gql`
    query ListRestaurants {
  restaurants(first: 999) {
    edges {
      node {
        id
        hasEnteredActivationCode
        name
        phoneNumber
        organization {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __useListRestaurantsQuery__
 *
 * To run a query within a React component, call `useListRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRestaurantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRestaurantsQuery(baseOptions?: Apollo.QueryHookOptions<ListRestaurantsQuery, ListRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRestaurantsQuery, ListRestaurantsQueryVariables>(ListRestaurantsDocument, options);
      }
export function useListRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRestaurantsQuery, ListRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRestaurantsQuery, ListRestaurantsQueryVariables>(ListRestaurantsDocument, options);
        }
export type ListRestaurantsQueryHookResult = ReturnType<typeof useListRestaurantsQuery>;
export type ListRestaurantsLazyQueryHookResult = ReturnType<typeof useListRestaurantsLazyQuery>;
export type ListRestaurantsQueryResult = Apollo.QueryResult<ListRestaurantsQuery, ListRestaurantsQueryVariables>;
export const SetRestaurantOpeningHoursDocument = gql`
    mutation SetRestaurantOpeningHours($restaurantId: ID!, $periods: [OpeningHoursPeriodInput!]!) {
  setRestaurantOpeningHours(restaurantId: $restaurantId, periods: $periods) {
    id
    periods {
      open {
        day
        time
      }
      close {
        day
        time
      }
    }
  }
}
    `;
export type SetRestaurantOpeningHoursMutationFn = Apollo.MutationFunction<SetRestaurantOpeningHoursMutation, SetRestaurantOpeningHoursMutationVariables>;

/**
 * __useSetRestaurantOpeningHoursMutation__
 *
 * To run a mutation, you first call `useSetRestaurantOpeningHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRestaurantOpeningHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRestaurantOpeningHoursMutation, { data, loading, error }] = useSetRestaurantOpeningHoursMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useSetRestaurantOpeningHoursMutation(baseOptions?: Apollo.MutationHookOptions<SetRestaurantOpeningHoursMutation, SetRestaurantOpeningHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRestaurantOpeningHoursMutation, SetRestaurantOpeningHoursMutationVariables>(SetRestaurantOpeningHoursDocument, options);
      }
export type SetRestaurantOpeningHoursMutationHookResult = ReturnType<typeof useSetRestaurantOpeningHoursMutation>;
export type SetRestaurantOpeningHoursMutationResult = Apollo.MutationResult<SetRestaurantOpeningHoursMutation>;
export type SetRestaurantOpeningHoursMutationOptions = Apollo.BaseMutationOptions<SetRestaurantOpeningHoursMutation, SetRestaurantOpeningHoursMutationVariables>;
export const GetRestaurantOrderDisplaySystemDataDocument = gql`
    query GetRestaurantOrderDisplaySystemData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    ...RestaurantFieldsForDisplaySystem
  }
}
    ${RestaurantFieldsForDisplaySystemFragmentDoc}`;

/**
 * __useGetRestaurantOrderDisplaySystemDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantOrderDisplaySystemDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantOrderDisplaySystemDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantOrderDisplaySystemDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantOrderDisplaySystemDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantOrderDisplaySystemDataQuery, GetRestaurantOrderDisplaySystemDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantOrderDisplaySystemDataQuery, GetRestaurantOrderDisplaySystemDataQueryVariables>(GetRestaurantOrderDisplaySystemDataDocument, options);
      }
export function useGetRestaurantOrderDisplaySystemDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantOrderDisplaySystemDataQuery, GetRestaurantOrderDisplaySystemDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantOrderDisplaySystemDataQuery, GetRestaurantOrderDisplaySystemDataQueryVariables>(GetRestaurantOrderDisplaySystemDataDocument, options);
        }
export type GetRestaurantOrderDisplaySystemDataQueryHookResult = ReturnType<typeof useGetRestaurantOrderDisplaySystemDataQuery>;
export type GetRestaurantOrderDisplaySystemDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantOrderDisplaySystemDataLazyQuery>;
export type GetRestaurantOrderDisplaySystemDataQueryResult = Apollo.QueryResult<GetRestaurantOrderDisplaySystemDataQuery, GetRestaurantOrderDisplaySystemDataQueryVariables>;
export const AcceptOrderDisplaySystemTermsOfServiceDocument = gql`
    mutation AcceptOrderDisplaySystemTermsOfService($restaurantId: ID!) {
  acceptOrderDisplaySystemTermsOfService(restaurantId: $restaurantId) {
    id
    ...RestaurantFieldsForDisplaySystem
  }
}
    ${RestaurantFieldsForDisplaySystemFragmentDoc}`;
export type AcceptOrderDisplaySystemTermsOfServiceMutationFn = Apollo.MutationFunction<AcceptOrderDisplaySystemTermsOfServiceMutation, AcceptOrderDisplaySystemTermsOfServiceMutationVariables>;

/**
 * __useAcceptOrderDisplaySystemTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcceptOrderDisplaySystemTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrderDisplaySystemTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrderDisplaySystemTermsOfServiceMutation, { data, loading, error }] = useAcceptOrderDisplaySystemTermsOfServiceMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useAcceptOrderDisplaySystemTermsOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOrderDisplaySystemTermsOfServiceMutation, AcceptOrderDisplaySystemTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOrderDisplaySystemTermsOfServiceMutation, AcceptOrderDisplaySystemTermsOfServiceMutationVariables>(AcceptOrderDisplaySystemTermsOfServiceDocument, options);
      }
export type AcceptOrderDisplaySystemTermsOfServiceMutationHookResult = ReturnType<typeof useAcceptOrderDisplaySystemTermsOfServiceMutation>;
export type AcceptOrderDisplaySystemTermsOfServiceMutationResult = Apollo.MutationResult<AcceptOrderDisplaySystemTermsOfServiceMutation>;
export type AcceptOrderDisplaySystemTermsOfServiceMutationOptions = Apollo.BaseMutationOptions<AcceptOrderDisplaySystemTermsOfServiceMutation, AcceptOrderDisplaySystemTermsOfServiceMutationVariables>;
export const UpdateRestaurantDisplaySystemDocument = gql`
    mutation UpdateRestaurantDisplaySystem($restaurantId: ID!, $orderDisplaySystemAccentColor: OpaqueColor, $orderDisplaySystemEnabled: Boolean!, $orderDisplaySystemLogoUrl: URL) {
  updateRestaurant(
    restaurantId: $restaurantId
    patch: {orderDisplaySystemEnabled: $orderDisplaySystemEnabled, orderDisplaySystemAccentColor: $orderDisplaySystemAccentColor, orderDisplaySystemLogoUrl: $orderDisplaySystemLogoUrl}
  ) {
    id
    orderDisplaySystemAccentColor
    orderDisplaySystemEnabled
    orderDisplaySystemLogoUrl
  }
}
    `;
export type UpdateRestaurantDisplaySystemMutationFn = Apollo.MutationFunction<UpdateRestaurantDisplaySystemMutation, UpdateRestaurantDisplaySystemMutationVariables>;

/**
 * __useUpdateRestaurantDisplaySystemMutation__
 *
 * To run a mutation, you first call `useUpdateRestaurantDisplaySystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestaurantDisplaySystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestaurantDisplaySystemMutation, { data, loading, error }] = useUpdateRestaurantDisplaySystemMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      orderDisplaySystemAccentColor: // value for 'orderDisplaySystemAccentColor'
 *      orderDisplaySystemEnabled: // value for 'orderDisplaySystemEnabled'
 *      orderDisplaySystemLogoUrl: // value for 'orderDisplaySystemLogoUrl'
 *   },
 * });
 */
export function useUpdateRestaurantDisplaySystemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRestaurantDisplaySystemMutation, UpdateRestaurantDisplaySystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRestaurantDisplaySystemMutation, UpdateRestaurantDisplaySystemMutationVariables>(UpdateRestaurantDisplaySystemDocument, options);
      }
export type UpdateRestaurantDisplaySystemMutationHookResult = ReturnType<typeof useUpdateRestaurantDisplaySystemMutation>;
export type UpdateRestaurantDisplaySystemMutationResult = Apollo.MutationResult<UpdateRestaurantDisplaySystemMutation>;
export type UpdateRestaurantDisplaySystemMutationOptions = Apollo.BaseMutationOptions<UpdateRestaurantDisplaySystemMutation, UpdateRestaurantDisplaySystemMutationVariables>;
export const CreatePaymentMethodDocument = gql`
    mutation CreatePaymentMethod($restaurantId: ID!, $input: PaymentMethodInput!) {
  createPaymentMethod(restaurantId: $restaurantId, input: $input) {
    ...FullPaymentMethod
  }
}
    ${FullPaymentMethodFragmentDoc}`;
export type CreatePaymentMethodMutationFn = Apollo.MutationFunction<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;

/**
 * __useCreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMethodMutation, { data, loading, error }] = useCreatePaymentMethodMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodDocument, options);
      }
export type CreatePaymentMethodMutationHookResult = ReturnType<typeof useCreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationResult = Apollo.MutationResult<CreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;
export const GetRestaurantPaymentMethodEditDataDocument = gql`
    query GetRestaurantPaymentMethodEditData($restaurantId: ID!, $paymentMethodId: ID!) {
  restaurant(id: $restaurantId) {
    id
    paymentMethod(id: $paymentMethodId) {
      ...FullPaymentMethod
    }
  }
}
    ${FullPaymentMethodFragmentDoc}`;

/**
 * __useGetRestaurantPaymentMethodEditDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantPaymentMethodEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantPaymentMethodEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantPaymentMethodEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useGetRestaurantPaymentMethodEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantPaymentMethodEditDataQuery, GetRestaurantPaymentMethodEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantPaymentMethodEditDataQuery, GetRestaurantPaymentMethodEditDataQueryVariables>(GetRestaurantPaymentMethodEditDataDocument, options);
      }
export function useGetRestaurantPaymentMethodEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantPaymentMethodEditDataQuery, GetRestaurantPaymentMethodEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantPaymentMethodEditDataQuery, GetRestaurantPaymentMethodEditDataQueryVariables>(GetRestaurantPaymentMethodEditDataDocument, options);
        }
export type GetRestaurantPaymentMethodEditDataQueryHookResult = ReturnType<typeof useGetRestaurantPaymentMethodEditDataQuery>;
export type GetRestaurantPaymentMethodEditDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantPaymentMethodEditDataLazyQuery>;
export type GetRestaurantPaymentMethodEditDataQueryResult = Apollo.QueryResult<GetRestaurantPaymentMethodEditDataQuery, GetRestaurantPaymentMethodEditDataQueryVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation DeletePaymentMethod($restaurantId: ID!, $paymentMethodId: ID!) {
  deletePaymentMethod(
    restaurantId: $restaurantId
    paymentMethodId: $paymentMethodId
  )
}
    `;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const EditPaymentMethodDocument = gql`
    mutation EditPaymentMethod($restaurantId: ID!, $paymentMethodId: ID!, $patch: PaymentMethodPatch!) {
  updatePaymentMethod(
    restaurantId: $restaurantId
    paymentMethodId: $paymentMethodId
    patch: $patch
  ) {
    ...FullPaymentMethod
  }
}
    ${FullPaymentMethodFragmentDoc}`;
export type EditPaymentMethodMutationFn = Apollo.MutationFunction<EditPaymentMethodMutation, EditPaymentMethodMutationVariables>;

/**
 * __useEditPaymentMethodMutation__
 *
 * To run a mutation, you first call `useEditPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaymentMethodMutation, { data, loading, error }] = useEditPaymentMethodMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useEditPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<EditPaymentMethodMutation, EditPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPaymentMethodMutation, EditPaymentMethodMutationVariables>(EditPaymentMethodDocument, options);
      }
export type EditPaymentMethodMutationHookResult = ReturnType<typeof useEditPaymentMethodMutation>;
export type EditPaymentMethodMutationResult = Apollo.MutationResult<EditPaymentMethodMutation>;
export type EditPaymentMethodMutationOptions = Apollo.BaseMutationOptions<EditPaymentMethodMutation, EditPaymentMethodMutationVariables>;
export const GetRestaurantPersonalkollenDataDocument = gql`
    query GetRestaurantPersonalkollenData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    hasPersonalkollenAccess
    hasPersonalkollenCredentials
  }
}
    `;

/**
 * __useGetRestaurantPersonalkollenDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantPersonalkollenDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantPersonalkollenDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantPersonalkollenDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantPersonalkollenDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantPersonalkollenDataQuery, GetRestaurantPersonalkollenDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantPersonalkollenDataQuery, GetRestaurantPersonalkollenDataQueryVariables>(GetRestaurantPersonalkollenDataDocument, options);
      }
export function useGetRestaurantPersonalkollenDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantPersonalkollenDataQuery, GetRestaurantPersonalkollenDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantPersonalkollenDataQuery, GetRestaurantPersonalkollenDataQueryVariables>(GetRestaurantPersonalkollenDataDocument, options);
        }
export type GetRestaurantPersonalkollenDataQueryHookResult = ReturnType<typeof useGetRestaurantPersonalkollenDataQuery>;
export type GetRestaurantPersonalkollenDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantPersonalkollenDataLazyQuery>;
export type GetRestaurantPersonalkollenDataQueryResult = Apollo.QueryResult<GetRestaurantPersonalkollenDataQuery, GetRestaurantPersonalkollenDataQueryVariables>;
export const AcceptPersonalkollenIntegrationTermsOfServiceDocument = gql`
    mutation AcceptPersonalkollenIntegrationTermsOfService($restaurantId: ID!) {
  acceptPersonalkollenIntegrationTermsOfService(restaurantId: $restaurantId) {
    id
    hasPersonalkollenAccess
  }
}
    `;
export type AcceptPersonalkollenIntegrationTermsOfServiceMutationFn = Apollo.MutationFunction<AcceptPersonalkollenIntegrationTermsOfServiceMutation, AcceptPersonalkollenIntegrationTermsOfServiceMutationVariables>;

/**
 * __useAcceptPersonalkollenIntegrationTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcceptPersonalkollenIntegrationTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPersonalkollenIntegrationTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPersonalkollenIntegrationTermsOfServiceMutation, { data, loading, error }] = useAcceptPersonalkollenIntegrationTermsOfServiceMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useAcceptPersonalkollenIntegrationTermsOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPersonalkollenIntegrationTermsOfServiceMutation, AcceptPersonalkollenIntegrationTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPersonalkollenIntegrationTermsOfServiceMutation, AcceptPersonalkollenIntegrationTermsOfServiceMutationVariables>(AcceptPersonalkollenIntegrationTermsOfServiceDocument, options);
      }
export type AcceptPersonalkollenIntegrationTermsOfServiceMutationHookResult = ReturnType<typeof useAcceptPersonalkollenIntegrationTermsOfServiceMutation>;
export type AcceptPersonalkollenIntegrationTermsOfServiceMutationResult = Apollo.MutationResult<AcceptPersonalkollenIntegrationTermsOfServiceMutation>;
export type AcceptPersonalkollenIntegrationTermsOfServiceMutationOptions = Apollo.BaseMutationOptions<AcceptPersonalkollenIntegrationTermsOfServiceMutation, AcceptPersonalkollenIntegrationTermsOfServiceMutationVariables>;
export const LinkPersonalkollenAccountDocument = gql`
    mutation LinkPersonalkollenAccount($restaurantId: ID!, $credentials: PersonalkollenCredentials!) {
  linkPersonalkollenAccount(
    restaurantId: $restaurantId
    credentials: $credentials
  ) {
    id
    hasPersonalkollenCredentials
  }
}
    `;
export type LinkPersonalkollenAccountMutationFn = Apollo.MutationFunction<LinkPersonalkollenAccountMutation, LinkPersonalkollenAccountMutationVariables>;

/**
 * __useLinkPersonalkollenAccountMutation__
 *
 * To run a mutation, you first call `useLinkPersonalkollenAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkPersonalkollenAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkPersonalkollenAccountMutation, { data, loading, error }] = useLinkPersonalkollenAccountMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useLinkPersonalkollenAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkPersonalkollenAccountMutation, LinkPersonalkollenAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkPersonalkollenAccountMutation, LinkPersonalkollenAccountMutationVariables>(LinkPersonalkollenAccountDocument, options);
      }
export type LinkPersonalkollenAccountMutationHookResult = ReturnType<typeof useLinkPersonalkollenAccountMutation>;
export type LinkPersonalkollenAccountMutationResult = Apollo.MutationResult<LinkPersonalkollenAccountMutation>;
export type LinkPersonalkollenAccountMutationOptions = Apollo.BaseMutationOptions<LinkPersonalkollenAccountMutation, LinkPersonalkollenAccountMutationVariables>;
export const GetRestaurantPhysicalPrinterCreateDataDocument = gql`
    query GetRestaurantPhysicalPrinterCreateData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    printerQueues {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRestaurantPhysicalPrinterCreateDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantPhysicalPrinterCreateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantPhysicalPrinterCreateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantPhysicalPrinterCreateDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantPhysicalPrinterCreateDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantPhysicalPrinterCreateDataQuery, GetRestaurantPhysicalPrinterCreateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantPhysicalPrinterCreateDataQuery, GetRestaurantPhysicalPrinterCreateDataQueryVariables>(GetRestaurantPhysicalPrinterCreateDataDocument, options);
      }
export function useGetRestaurantPhysicalPrinterCreateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantPhysicalPrinterCreateDataQuery, GetRestaurantPhysicalPrinterCreateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantPhysicalPrinterCreateDataQuery, GetRestaurantPhysicalPrinterCreateDataQueryVariables>(GetRestaurantPhysicalPrinterCreateDataDocument, options);
        }
export type GetRestaurantPhysicalPrinterCreateDataQueryHookResult = ReturnType<typeof useGetRestaurantPhysicalPrinterCreateDataQuery>;
export type GetRestaurantPhysicalPrinterCreateDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantPhysicalPrinterCreateDataLazyQuery>;
export type GetRestaurantPhysicalPrinterCreateDataQueryResult = Apollo.QueryResult<GetRestaurantPhysicalPrinterCreateDataQuery, GetRestaurantPhysicalPrinterCreateDataQueryVariables>;
export const CreatePhysicalPrinterDocument = gql`
    mutation CreatePhysicalPrinter($restaurantId: ID!, $input: PhysicalPrinterInput!) {
  createPhysicalPrinter(restaurantId: $restaurantId, input: $input) {
    id
    name
  }
}
    `;
export type CreatePhysicalPrinterMutationFn = Apollo.MutationFunction<CreatePhysicalPrinterMutation, CreatePhysicalPrinterMutationVariables>;

/**
 * __useCreatePhysicalPrinterMutation__
 *
 * To run a mutation, you first call `useCreatePhysicalPrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhysicalPrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhysicalPrinterMutation, { data, loading, error }] = useCreatePhysicalPrinterMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePhysicalPrinterMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhysicalPrinterMutation, CreatePhysicalPrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhysicalPrinterMutation, CreatePhysicalPrinterMutationVariables>(CreatePhysicalPrinterDocument, options);
      }
export type CreatePhysicalPrinterMutationHookResult = ReturnType<typeof useCreatePhysicalPrinterMutation>;
export type CreatePhysicalPrinterMutationResult = Apollo.MutationResult<CreatePhysicalPrinterMutation>;
export type CreatePhysicalPrinterMutationOptions = Apollo.BaseMutationOptions<CreatePhysicalPrinterMutation, CreatePhysicalPrinterMutationVariables>;
export const GetRestaurantPhysicalPrinterEditDataDocument = gql`
    query GetRestaurantPhysicalPrinterEditData($restaurantId: ID!, $physicalPrinterId: ID!) {
  restaurant(id: $restaurantId) {
    id
    physicalPrinter(id: $physicalPrinterId) {
      id
      cloudPrntServerUrl
      name
      printerQueues {
        id
        name
      }
    }
    printerQueues {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRestaurantPhysicalPrinterEditDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantPhysicalPrinterEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantPhysicalPrinterEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantPhysicalPrinterEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      physicalPrinterId: // value for 'physicalPrinterId'
 *   },
 * });
 */
export function useGetRestaurantPhysicalPrinterEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantPhysicalPrinterEditDataQuery, GetRestaurantPhysicalPrinterEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantPhysicalPrinterEditDataQuery, GetRestaurantPhysicalPrinterEditDataQueryVariables>(GetRestaurantPhysicalPrinterEditDataDocument, options);
      }
export function useGetRestaurantPhysicalPrinterEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantPhysicalPrinterEditDataQuery, GetRestaurantPhysicalPrinterEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantPhysicalPrinterEditDataQuery, GetRestaurantPhysicalPrinterEditDataQueryVariables>(GetRestaurantPhysicalPrinterEditDataDocument, options);
        }
export type GetRestaurantPhysicalPrinterEditDataQueryHookResult = ReturnType<typeof useGetRestaurantPhysicalPrinterEditDataQuery>;
export type GetRestaurantPhysicalPrinterEditDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantPhysicalPrinterEditDataLazyQuery>;
export type GetRestaurantPhysicalPrinterEditDataQueryResult = Apollo.QueryResult<GetRestaurantPhysicalPrinterEditDataQuery, GetRestaurantPhysicalPrinterEditDataQueryVariables>;
export const UpdatePhysicalPrinterDocument = gql`
    mutation UpdatePhysicalPrinter($restaurantId: ID!, $physicalPrinterId: ID!, $patch: PhysicalPrinterPatch!) {
  updatePhysicalPrinter(
    restaurantId: $restaurantId
    physicalPrinterId: $physicalPrinterId
    patch: $patch
  ) {
    id
    cloudPrntServerUrl
    name
    printerQueues {
      id
      name
    }
  }
}
    `;
export type UpdatePhysicalPrinterMutationFn = Apollo.MutationFunction<UpdatePhysicalPrinterMutation, UpdatePhysicalPrinterMutationVariables>;

/**
 * __useUpdatePhysicalPrinterMutation__
 *
 * To run a mutation, you first call `useUpdatePhysicalPrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhysicalPrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhysicalPrinterMutation, { data, loading, error }] = useUpdatePhysicalPrinterMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      physicalPrinterId: // value for 'physicalPrinterId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdatePhysicalPrinterMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhysicalPrinterMutation, UpdatePhysicalPrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhysicalPrinterMutation, UpdatePhysicalPrinterMutationVariables>(UpdatePhysicalPrinterDocument, options);
      }
export type UpdatePhysicalPrinterMutationHookResult = ReturnType<typeof useUpdatePhysicalPrinterMutation>;
export type UpdatePhysicalPrinterMutationResult = Apollo.MutationResult<UpdatePhysicalPrinterMutation>;
export type UpdatePhysicalPrinterMutationOptions = Apollo.BaseMutationOptions<UpdatePhysicalPrinterMutation, UpdatePhysicalPrinterMutationVariables>;
export const GetPosTerminalDocument = gql`
    query GetPosTerminal($restaurantId: ID!, $posTerminalId: ID!) {
  restaurant(id: $restaurantId) {
    id
    posTerminal(id: $posTerminalId) {
      ...FullPosTerminal
    }
  }
}
    ${FullPosTerminalFragmentDoc}`;

/**
 * __useGetPosTerminalQuery__
 *
 * To run a query within a React component, call `useGetPosTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosTerminalQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      posTerminalId: // value for 'posTerminalId'
 *   },
 * });
 */
export function useGetPosTerminalQuery(baseOptions: Apollo.QueryHookOptions<GetPosTerminalQuery, GetPosTerminalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosTerminalQuery, GetPosTerminalQueryVariables>(GetPosTerminalDocument, options);
      }
export function useGetPosTerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosTerminalQuery, GetPosTerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosTerminalQuery, GetPosTerminalQueryVariables>(GetPosTerminalDocument, options);
        }
export type GetPosTerminalQueryHookResult = ReturnType<typeof useGetPosTerminalQuery>;
export type GetPosTerminalLazyQueryHookResult = ReturnType<typeof useGetPosTerminalLazyQuery>;
export type GetPosTerminalQueryResult = Apollo.QueryResult<GetPosTerminalQuery, GetPosTerminalQueryVariables>;
export const UpdatePosTerminalDocument = gql`
    mutation UpdatePosTerminal($restaurantId: ID!, $posTerminalId: ID!, $patch: PosTerminalPatch!) {
  updatePosTerminal(
    restaurantId: $restaurantId
    posTerminalId: $posTerminalId
    patch: $patch
  ) {
    ...FullPosTerminal
  }
}
    ${FullPosTerminalFragmentDoc}`;
export type UpdatePosTerminalMutationFn = Apollo.MutationFunction<UpdatePosTerminalMutation, UpdatePosTerminalMutationVariables>;

/**
 * __useUpdatePosTerminalMutation__
 *
 * To run a mutation, you first call `useUpdatePosTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePosTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePosTerminalMutation, { data, loading, error }] = useUpdatePosTerminalMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      posTerminalId: // value for 'posTerminalId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdatePosTerminalMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePosTerminalMutation, UpdatePosTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePosTerminalMutation, UpdatePosTerminalMutationVariables>(UpdatePosTerminalDocument, options);
      }
export type UpdatePosTerminalMutationHookResult = ReturnType<typeof useUpdatePosTerminalMutation>;
export type UpdatePosTerminalMutationResult = Apollo.MutationResult<UpdatePosTerminalMutation>;
export type UpdatePosTerminalMutationOptions = Apollo.BaseMutationOptions<UpdatePosTerminalMutation, UpdatePosTerminalMutationVariables>;
export const CreatePrinterQueueDocument = gql`
    mutation CreatePrinterQueue($restaurantId: ID!, $input: PrinterQueueInput!) {
  createPrinterQueue(restaurantId: $restaurantId, input: $input) {
    id
    name
  }
}
    `;
export type CreatePrinterQueueMutationFn = Apollo.MutationFunction<CreatePrinterQueueMutation, CreatePrinterQueueMutationVariables>;

/**
 * __useCreatePrinterQueueMutation__
 *
 * To run a mutation, you first call `useCreatePrinterQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrinterQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrinterQueueMutation, { data, loading, error }] = useCreatePrinterQueueMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrinterQueueMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrinterQueueMutation, CreatePrinterQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrinterQueueMutation, CreatePrinterQueueMutationVariables>(CreatePrinterQueueDocument, options);
      }
export type CreatePrinterQueueMutationHookResult = ReturnType<typeof useCreatePrinterQueueMutation>;
export type CreatePrinterQueueMutationResult = Apollo.MutationResult<CreatePrinterQueueMutation>;
export type CreatePrinterQueueMutationOptions = Apollo.BaseMutationOptions<CreatePrinterQueueMutation, CreatePrinterQueueMutationVariables>;
export const GetRestaurantPrinterQueueEditDataDocument = gql`
    query GetRestaurantPrinterQueueEditData($restaurantId: ID!, $printerQueueId: ID!) {
  restaurant(id: $restaurantId) {
    id
    printerQueue(id: $printerQueueId) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRestaurantPrinterQueueEditDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantPrinterQueueEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantPrinterQueueEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantPrinterQueueEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      printerQueueId: // value for 'printerQueueId'
 *   },
 * });
 */
export function useGetRestaurantPrinterQueueEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantPrinterQueueEditDataQuery, GetRestaurantPrinterQueueEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantPrinterQueueEditDataQuery, GetRestaurantPrinterQueueEditDataQueryVariables>(GetRestaurantPrinterQueueEditDataDocument, options);
      }
export function useGetRestaurantPrinterQueueEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantPrinterQueueEditDataQuery, GetRestaurantPrinterQueueEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantPrinterQueueEditDataQuery, GetRestaurantPrinterQueueEditDataQueryVariables>(GetRestaurantPrinterQueueEditDataDocument, options);
        }
export type GetRestaurantPrinterQueueEditDataQueryHookResult = ReturnType<typeof useGetRestaurantPrinterQueueEditDataQuery>;
export type GetRestaurantPrinterQueueEditDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantPrinterQueueEditDataLazyQuery>;
export type GetRestaurantPrinterQueueEditDataQueryResult = Apollo.QueryResult<GetRestaurantPrinterQueueEditDataQuery, GetRestaurantPrinterQueueEditDataQueryVariables>;
export const UpdatePrinterQueueDocument = gql`
    mutation UpdatePrinterQueue($restaurantId: ID!, $printerQueueId: ID!, $patch: PrinterQueuePatch!) {
  updatePrinterQueue(
    restaurantId: $restaurantId
    printerQueueId: $printerQueueId
    patch: $patch
  ) {
    id
    name
  }
}
    `;
export type UpdatePrinterQueueMutationFn = Apollo.MutationFunction<UpdatePrinterQueueMutation, UpdatePrinterQueueMutationVariables>;

/**
 * __useUpdatePrinterQueueMutation__
 *
 * To run a mutation, you first call `useUpdatePrinterQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrinterQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrinterQueueMutation, { data, loading, error }] = useUpdatePrinterQueueMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      printerQueueId: // value for 'printerQueueId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdatePrinterQueueMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrinterQueueMutation, UpdatePrinterQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrinterQueueMutation, UpdatePrinterQueueMutationVariables>(UpdatePrinterQueueDocument, options);
      }
export type UpdatePrinterQueueMutationHookResult = ReturnType<typeof useUpdatePrinterQueueMutation>;
export type UpdatePrinterQueueMutationResult = Apollo.MutationResult<UpdatePrinterQueueMutation>;
export type UpdatePrinterQueueMutationOptions = Apollo.BaseMutationOptions<UpdatePrinterQueueMutation, UpdatePrinterQueueMutationVariables>;
export const GetRestaurantPrintersViewDataDocument = gql`
    query GetRestaurantPrintersViewData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    physicalPrinters {
      id
      name
      identifyStatus
      printerQueues {
        id
        name
      }
    }
    printerQueues {
      id
      isLegacy
      name
    }
  }
}
    `;

/**
 * __useGetRestaurantPrintersViewDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantPrintersViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantPrintersViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantPrintersViewDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantPrintersViewDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantPrintersViewDataQuery, GetRestaurantPrintersViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantPrintersViewDataQuery, GetRestaurantPrintersViewDataQueryVariables>(GetRestaurantPrintersViewDataDocument, options);
      }
export function useGetRestaurantPrintersViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantPrintersViewDataQuery, GetRestaurantPrintersViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantPrintersViewDataQuery, GetRestaurantPrintersViewDataQueryVariables>(GetRestaurantPrintersViewDataDocument, options);
        }
export type GetRestaurantPrintersViewDataQueryHookResult = ReturnType<typeof useGetRestaurantPrintersViewDataQuery>;
export type GetRestaurantPrintersViewDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantPrintersViewDataLazyQuery>;
export type GetRestaurantPrintersViewDataQueryResult = Apollo.QueryResult<GetRestaurantPrintersViewDataQuery, GetRestaurantPrintersViewDataQueryVariables>;
export const IdentifyPhysicalPrinterDocument = gql`
    mutation IdentifyPhysicalPrinter($restaurantId: ID!, $physicalPrinterId: ID!) {
  identifyPhysicalPrinter(
    restaurantId: $restaurantId
    physicalPrinterId: $physicalPrinterId
  ) {
    id
    identifyStatus
  }
}
    `;
export type IdentifyPhysicalPrinterMutationFn = Apollo.MutationFunction<IdentifyPhysicalPrinterMutation, IdentifyPhysicalPrinterMutationVariables>;

/**
 * __useIdentifyPhysicalPrinterMutation__
 *
 * To run a mutation, you first call `useIdentifyPhysicalPrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdentifyPhysicalPrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [identifyPhysicalPrinterMutation, { data, loading, error }] = useIdentifyPhysicalPrinterMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      physicalPrinterId: // value for 'physicalPrinterId'
 *   },
 * });
 */
export function useIdentifyPhysicalPrinterMutation(baseOptions?: Apollo.MutationHookOptions<IdentifyPhysicalPrinterMutation, IdentifyPhysicalPrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdentifyPhysicalPrinterMutation, IdentifyPhysicalPrinterMutationVariables>(IdentifyPhysicalPrinterDocument, options);
      }
export type IdentifyPhysicalPrinterMutationHookResult = ReturnType<typeof useIdentifyPhysicalPrinterMutation>;
export type IdentifyPhysicalPrinterMutationResult = Apollo.MutationResult<IdentifyPhysicalPrinterMutation>;
export type IdentifyPhysicalPrinterMutationOptions = Apollo.BaseMutationOptions<IdentifyPhysicalPrinterMutation, IdentifyPhysicalPrinterMutationVariables>;
export const IdentifyPhysicalPrintersDocument = gql`
    mutation IdentifyPhysicalPrinters($restaurantId: ID!) {
  identifyPhysicalPrinters(restaurantId: $restaurantId) {
    id
    identifyStatus
  }
}
    `;
export type IdentifyPhysicalPrintersMutationFn = Apollo.MutationFunction<IdentifyPhysicalPrintersMutation, IdentifyPhysicalPrintersMutationVariables>;

/**
 * __useIdentifyPhysicalPrintersMutation__
 *
 * To run a mutation, you first call `useIdentifyPhysicalPrintersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdentifyPhysicalPrintersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [identifyPhysicalPrintersMutation, { data, loading, error }] = useIdentifyPhysicalPrintersMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useIdentifyPhysicalPrintersMutation(baseOptions?: Apollo.MutationHookOptions<IdentifyPhysicalPrintersMutation, IdentifyPhysicalPrintersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdentifyPhysicalPrintersMutation, IdentifyPhysicalPrintersMutationVariables>(IdentifyPhysicalPrintersDocument, options);
      }
export type IdentifyPhysicalPrintersMutationHookResult = ReturnType<typeof useIdentifyPhysicalPrintersMutation>;
export type IdentifyPhysicalPrintersMutationResult = Apollo.MutationResult<IdentifyPhysicalPrintersMutation>;
export type IdentifyPhysicalPrintersMutationOptions = Apollo.BaseMutationOptions<IdentifyPhysicalPrintersMutation, IdentifyPhysicalPrintersMutationVariables>;
export const GetRestaurantReceiptListDataDocument = gql`
    query GetRestaurantReceiptListData($restaurantId: ID!, $cursor: String, $filter: OrderFilter) {
  restaurant(id: $restaurantId) {
    id
    hasDeliveryHeroAccess
    timeZone
    orders(first: 25, after: $cursor, filter: $filter) {
      edges {
        node {
          ...RestaurantReceiptListOrder
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${RestaurantReceiptListOrderFragmentDoc}`;

/**
 * __useGetRestaurantReceiptListDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantReceiptListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantReceiptListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantReceiptListDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRestaurantReceiptListDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantReceiptListDataQuery, GetRestaurantReceiptListDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantReceiptListDataQuery, GetRestaurantReceiptListDataQueryVariables>(GetRestaurantReceiptListDataDocument, options);
      }
export function useGetRestaurantReceiptListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantReceiptListDataQuery, GetRestaurantReceiptListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantReceiptListDataQuery, GetRestaurantReceiptListDataQueryVariables>(GetRestaurantReceiptListDataDocument, options);
        }
export type GetRestaurantReceiptListDataQueryHookResult = ReturnType<typeof useGetRestaurantReceiptListDataQuery>;
export type GetRestaurantReceiptListDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantReceiptListDataLazyQuery>;
export type GetRestaurantReceiptListDataQueryResult = Apollo.QueryResult<GetRestaurantReceiptListDataQuery, GetRestaurantReceiptListDataQueryVariables>;
export const GetRestaurantSalesReportListDataDocument = gql`
    query GetRestaurantSalesReportListData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    nextCashregisterReportGenerationTime
    timeZone
  }
}
    `;

/**
 * __useGetRestaurantSalesReportListDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantSalesReportListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantSalesReportListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantSalesReportListDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantSalesReportListDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantSalesReportListDataQuery, GetRestaurantSalesReportListDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantSalesReportListDataQuery, GetRestaurantSalesReportListDataQueryVariables>(GetRestaurantSalesReportListDataDocument, options);
      }
export function useGetRestaurantSalesReportListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantSalesReportListDataQuery, GetRestaurantSalesReportListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantSalesReportListDataQuery, GetRestaurantSalesReportListDataQueryVariables>(GetRestaurantSalesReportListDataDocument, options);
        }
export type GetRestaurantSalesReportListDataQueryHookResult = ReturnType<typeof useGetRestaurantSalesReportListDataQuery>;
export type GetRestaurantSalesReportListDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantSalesReportListDataLazyQuery>;
export type GetRestaurantSalesReportListDataQueryResult = Apollo.QueryResult<GetRestaurantSalesReportListDataQuery, GetRestaurantSalesReportListDataQueryVariables>;
export const GetRestaurantSalesReportViewDataDocument = gql`
    query GetRestaurantSalesReportViewData($restaurantId: ID!, $dateTimeRange: DateTimeRangeInput!) {
  restaurant(id: $restaurantId) {
    id
    name
    streetAddress
    timeZone
    organization {
      id
      name
      organizationNumber
    }
    statistics(dateTimeRange: $dateTimeRange, resolution: Day) {
      id
      totalDiscountAmount
      totalTipAmount
      refundsByPaymentName {
        id
        count
        grossAmount
        paymentName
        tipAmount
      }
      refundsByProduct {
        id
        count
        discountAmount
        grossAmount
        name
        netAmount
        price
        productId
        vatAmount
        addons {
          id
          count
          discountAmount
          grossAmount
          name
          netAmount
          price
          productId
          vatAmount
        }
        alternativeItems {
          id
          count
          name
        }
      }
      salesByMenuType {
        id
        count
        grossAmount
        menuType
        vatAmount
      }
      salesByMenuTypeAndTimePeriod {
        id
        count
        grossAmount
        menuType
        periodStart
      }
      salesByPaymentName {
        id
        count
        grossAmount
        paymentName
        tipAmount
      }
      salesByProduct {
        id
        count
        discountAmount
        grossAmount
        name
        netAmount
        price
        productId
        vatAmount
        addons {
          id
          count
          discountAmount
          grossAmount
          name
          netAmount
          price
          productId
          vatAmount
        }
        alternativeItems {
          id
          count
          name
        }
      }
      salesByReportGroup {
        id
        count
        discountAmount
        grossAmount
        netAmount
        reportGroupName
        vatAmount
      }
      salesByVatRate {
        id
        grossAmount
        netAmount
        vatAmount
        vatRate
      }
    }
  }
}
    `;

/**
 * __useGetRestaurantSalesReportViewDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantSalesReportViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantSalesReportViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantSalesReportViewDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      dateTimeRange: // value for 'dateTimeRange'
 *   },
 * });
 */
export function useGetRestaurantSalesReportViewDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantSalesReportViewDataQuery, GetRestaurantSalesReportViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantSalesReportViewDataQuery, GetRestaurantSalesReportViewDataQueryVariables>(GetRestaurantSalesReportViewDataDocument, options);
      }
export function useGetRestaurantSalesReportViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantSalesReportViewDataQuery, GetRestaurantSalesReportViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantSalesReportViewDataQuery, GetRestaurantSalesReportViewDataQueryVariables>(GetRestaurantSalesReportViewDataDocument, options);
        }
export type GetRestaurantSalesReportViewDataQueryHookResult = ReturnType<typeof useGetRestaurantSalesReportViewDataQuery>;
export type GetRestaurantSalesReportViewDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantSalesReportViewDataLazyQuery>;
export type GetRestaurantSalesReportViewDataQueryResult = Apollo.QueryResult<GetRestaurantSalesReportViewDataQuery, GetRestaurantSalesReportViewDataQueryVariables>;
export const GetRestaurantStatisticsViewDataDocument = gql`
    query GetRestaurantStatisticsViewData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    dailyReconciliationTime
    hasDeliveryHeroAccess
    timeZone
  }
}
    `;

/**
 * __useGetRestaurantStatisticsViewDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantStatisticsViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantStatisticsViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantStatisticsViewDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantStatisticsViewDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantStatisticsViewDataQuery, GetRestaurantStatisticsViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantStatisticsViewDataQuery, GetRestaurantStatisticsViewDataQueryVariables>(GetRestaurantStatisticsViewDataDocument, options);
      }
export function useGetRestaurantStatisticsViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantStatisticsViewDataQuery, GetRestaurantStatisticsViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantStatisticsViewDataQuery, GetRestaurantStatisticsViewDataQueryVariables>(GetRestaurantStatisticsViewDataDocument, options);
        }
export type GetRestaurantStatisticsViewDataQueryHookResult = ReturnType<typeof useGetRestaurantStatisticsViewDataQuery>;
export type GetRestaurantStatisticsViewDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantStatisticsViewDataLazyQuery>;
export type GetRestaurantStatisticsViewDataQueryResult = Apollo.QueryResult<GetRestaurantStatisticsViewDataQuery, GetRestaurantStatisticsViewDataQueryVariables>;
export const GetRestaurantStripeEditDataDocument = gql`
    query GetRestaurantStripeEditData($restaurantId: ID!, $redirectUrl: URL) {
  restaurant(id: $restaurantId) {
    id
    organization {
      id
      setupProgress {
        hasCompletedStripeSetup
        hasStripeAccount
      }
    }
    setupProgress {
      hasCashregister
      hasEnteredActivationCode
      taxAuthoritiesCashregisterRegistrationUrl
      taxAuthoritiesControlUnitRegistrationUrl
      stripeConnectionUrl(redirectUrl: $redirectUrl)
    }
  }
}
    `;

/**
 * __useGetRestaurantStripeEditDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantStripeEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantStripeEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantStripeEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useGetRestaurantStripeEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantStripeEditDataQuery, GetRestaurantStripeEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantStripeEditDataQuery, GetRestaurantStripeEditDataQueryVariables>(GetRestaurantStripeEditDataDocument, options);
      }
export function useGetRestaurantStripeEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantStripeEditDataQuery, GetRestaurantStripeEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantStripeEditDataQuery, GetRestaurantStripeEditDataQueryVariables>(GetRestaurantStripeEditDataDocument, options);
        }
export type GetRestaurantStripeEditDataQueryHookResult = ReturnType<typeof useGetRestaurantStripeEditDataQuery>;
export type GetRestaurantStripeEditDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantStripeEditDataLazyQuery>;
export type GetRestaurantStripeEditDataQueryResult = Apollo.QueryResult<GetRestaurantStripeEditDataQuery, GetRestaurantStripeEditDataQueryVariables>;
export const GetRestaurantSwishEditDataDocument = gql`
    query GetRestaurantSwishEditData($restaurantId: ID!) {
  restaurant(id: $restaurantId) {
    id
    swishNumber
  }
}
    `;

/**
 * __useGetRestaurantSwishEditDataQuery__
 *
 * To run a query within a React component, call `useGetRestaurantSwishEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantSwishEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantSwishEditDataQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantSwishEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantSwishEditDataQuery, GetRestaurantSwishEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantSwishEditDataQuery, GetRestaurantSwishEditDataQueryVariables>(GetRestaurantSwishEditDataDocument, options);
      }
export function useGetRestaurantSwishEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantSwishEditDataQuery, GetRestaurantSwishEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantSwishEditDataQuery, GetRestaurantSwishEditDataQueryVariables>(GetRestaurantSwishEditDataDocument, options);
        }
export type GetRestaurantSwishEditDataQueryHookResult = ReturnType<typeof useGetRestaurantSwishEditDataQuery>;
export type GetRestaurantSwishEditDataLazyQueryHookResult = ReturnType<typeof useGetRestaurantSwishEditDataLazyQuery>;
export type GetRestaurantSwishEditDataQueryResult = Apollo.QueryResult<GetRestaurantSwishEditDataQuery, GetRestaurantSwishEditDataQueryVariables>;
export const LinkSwishNumberDocument = gql`
    mutation LinkSwishNumber($restaurantId: ID!, $swishNumber: String!) {
  linkSwishNumber(restaurantId: $restaurantId, swishNumber: $swishNumber) {
    id
    swishNumber
  }
}
    `;
export type LinkSwishNumberMutationFn = Apollo.MutationFunction<LinkSwishNumberMutation, LinkSwishNumberMutationVariables>;

/**
 * __useLinkSwishNumberMutation__
 *
 * To run a mutation, you first call `useLinkSwishNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkSwishNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkSwishNumberMutation, { data, loading, error }] = useLinkSwishNumberMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      swishNumber: // value for 'swishNumber'
 *   },
 * });
 */
export function useLinkSwishNumberMutation(baseOptions?: Apollo.MutationHookOptions<LinkSwishNumberMutation, LinkSwishNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkSwishNumberMutation, LinkSwishNumberMutationVariables>(LinkSwishNumberDocument, options);
      }
export type LinkSwishNumberMutationHookResult = ReturnType<typeof useLinkSwishNumberMutation>;
export type LinkSwishNumberMutationResult = Apollo.MutationResult<LinkSwishNumberMutation>;
export type LinkSwishNumberMutationOptions = Apollo.BaseMutationOptions<LinkSwishNumberMutation, LinkSwishNumberMutationVariables>;
export const UnlinkSwishNumberDocument = gql`
    mutation UnlinkSwishNumber($restaurantId: ID!) {
  unlinkSwishNumber(restaurantId: $restaurantId) {
    id
    swishNumber
  }
}
    `;
export type UnlinkSwishNumberMutationFn = Apollo.MutationFunction<UnlinkSwishNumberMutation, UnlinkSwishNumberMutationVariables>;

/**
 * __useUnlinkSwishNumberMutation__
 *
 * To run a mutation, you first call `useUnlinkSwishNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkSwishNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkSwishNumberMutation, { data, loading, error }] = useUnlinkSwishNumberMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useUnlinkSwishNumberMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkSwishNumberMutation, UnlinkSwishNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkSwishNumberMutation, UnlinkSwishNumberMutationVariables>(UnlinkSwishNumberDocument, options);
      }
export type UnlinkSwishNumberMutationHookResult = ReturnType<typeof useUnlinkSwishNumberMutation>;
export type UnlinkSwishNumberMutationResult = Apollo.MutationResult<UnlinkSwishNumberMutation>;
export type UnlinkSwishNumberMutationOptions = Apollo.BaseMutationOptions<UnlinkSwishNumberMutation, UnlinkSwishNumberMutationVariables>;
export const CreateTillDocument = gql`
    mutation CreateTill($restaurantId: ID!, $input: TillInput!, $orderDisplaySystemEnabled: Boolean) {
  createTill(restaurantId: $restaurantId, input: $input) {
    ...FullTill
  }
  updateRestaurant(
    restaurantId: $restaurantId
    patch: {orderDisplaySystemEnabled: $orderDisplaySystemEnabled}
  ) {
    id
    orderDisplaySystemEnabled
  }
}
    ${FullTillFragmentDoc}`;
export type CreateTillMutationFn = Apollo.MutationFunction<CreateTillMutation, CreateTillMutationVariables>;

/**
 * __useCreateTillMutation__
 *
 * To run a mutation, you first call `useCreateTillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTillMutation, { data, loading, error }] = useCreateTillMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      input: // value for 'input'
 *      orderDisplaySystemEnabled: // value for 'orderDisplaySystemEnabled'
 *   },
 * });
 */
export function useCreateTillMutation(baseOptions?: Apollo.MutationHookOptions<CreateTillMutation, CreateTillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTillMutation, CreateTillMutationVariables>(CreateTillDocument, options);
      }
export type CreateTillMutationHookResult = ReturnType<typeof useCreateTillMutation>;
export type CreateTillMutationResult = Apollo.MutationResult<CreateTillMutation>;
export type CreateTillMutationOptions = Apollo.BaseMutationOptions<CreateTillMutation, CreateTillMutationVariables>;
export const GetTillDocument = gql`
    query GetTill($restaurantId: ID!, $tillId: ID!) {
  me {
    id
    isSuperUser
  }
  restaurant(id: $restaurantId) {
    id
    hasNetsConnectCloudLink
    hasSkipSlipPrintOnPrinterQueuesAccess
    isBetaTesting
    orderDisplaySystemEnabled
    deliveryLocations {
      id
      name
    }
    paymentMethods {
      ...FullPaymentMethod
    }
    posTerminals {
      ...FullPosTerminal
    }
    printerQueues {
      id
      name
    }
    till(id: $tillId) {
      ...FullTill
      featuredDiscounts {
        id
        code
      }
    }
  }
}
    ${FullPaymentMethodFragmentDoc}
${FullPosTerminalFragmentDoc}
${FullTillFragmentDoc}`;

/**
 * __useGetTillQuery__
 *
 * To run a query within a React component, call `useGetTillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTillQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      tillId: // value for 'tillId'
 *   },
 * });
 */
export function useGetTillQuery(baseOptions: Apollo.QueryHookOptions<GetTillQuery, GetTillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTillQuery, GetTillQueryVariables>(GetTillDocument, options);
      }
export function useGetTillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTillQuery, GetTillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTillQuery, GetTillQueryVariables>(GetTillDocument, options);
        }
export type GetTillQueryHookResult = ReturnType<typeof useGetTillQuery>;
export type GetTillLazyQueryHookResult = ReturnType<typeof useGetTillLazyQuery>;
export type GetTillQueryResult = Apollo.QueryResult<GetTillQuery, GetTillQueryVariables>;
export const EditTillDocument = gql`
    mutation EditTill($restaurantId: ID!, $tillId: ID!, $patch: TillPatch!, $orderDisplaySystemEnabled: Boolean) {
  updateTill(restaurantId: $restaurantId, tillId: $tillId, patch: $patch) {
    ...FullTill
  }
  updateRestaurant(
    restaurantId: $restaurantId
    patch: {orderDisplaySystemEnabled: $orderDisplaySystemEnabled}
  ) {
    id
    orderDisplaySystemEnabled
  }
}
    ${FullTillFragmentDoc}`;
export type EditTillMutationFn = Apollo.MutationFunction<EditTillMutation, EditTillMutationVariables>;

/**
 * __useEditTillMutation__
 *
 * To run a mutation, you first call `useEditTillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTillMutation, { data, loading, error }] = useEditTillMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      tillId: // value for 'tillId'
 *      patch: // value for 'patch'
 *      orderDisplaySystemEnabled: // value for 'orderDisplaySystemEnabled'
 *   },
 * });
 */
export function useEditTillMutation(baseOptions?: Apollo.MutationHookOptions<EditTillMutation, EditTillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTillMutation, EditTillMutationVariables>(EditTillDocument, options);
      }
export type EditTillMutationHookResult = ReturnType<typeof useEditTillMutation>;
export type EditTillMutationResult = Apollo.MutationResult<EditTillMutation>;
export type EditTillMutationOptions = Apollo.BaseMutationOptions<EditTillMutation, EditTillMutationVariables>;
export const DeleteTillDocument = gql`
    mutation DeleteTill($restaurantId: ID!, $tillId: ID!) {
  deleteTill(restaurantId: $restaurantId, tillId: $tillId)
}
    `;
export type DeleteTillMutationFn = Apollo.MutationFunction<DeleteTillMutation, DeleteTillMutationVariables>;

/**
 * __useDeleteTillMutation__
 *
 * To run a mutation, you first call `useDeleteTillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTillMutation, { data, loading, error }] = useDeleteTillMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      tillId: // value for 'tillId'
 *   },
 * });
 */
export function useDeleteTillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTillMutation, DeleteTillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTillMutation, DeleteTillMutationVariables>(DeleteTillDocument, options);
      }
export type DeleteTillMutationHookResult = ReturnType<typeof useDeleteTillMutation>;
export type DeleteTillMutationResult = Apollo.MutationResult<DeleteTillMutation>;
export type DeleteTillMutationOptions = Apollo.BaseMutationOptions<DeleteTillMutation, DeleteTillMutationVariables>;
export const LinkNetsConnectCloudAccountDocument = gql`
    mutation LinkNetsConnectCloudAccount($restaurantId: ID!, $credentials: NetsConnectCloudCredentials!) {
  linkNetsConnectCloudAccount(
    restaurantId: $restaurantId
    credentials: $credentials
  ) {
    id
    hasNetsConnectCloudLink
    netsConnectCloudUsername
    posTerminals {
      ...FullPosTerminal
    }
  }
}
    ${FullPosTerminalFragmentDoc}`;
export type LinkNetsConnectCloudAccountMutationFn = Apollo.MutationFunction<LinkNetsConnectCloudAccountMutation, LinkNetsConnectCloudAccountMutationVariables>;

/**
 * __useLinkNetsConnectCloudAccountMutation__
 *
 * To run a mutation, you first call `useLinkNetsConnectCloudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkNetsConnectCloudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkNetsConnectCloudAccountMutation, { data, loading, error }] = useLinkNetsConnectCloudAccountMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useLinkNetsConnectCloudAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkNetsConnectCloudAccountMutation, LinkNetsConnectCloudAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkNetsConnectCloudAccountMutation, LinkNetsConnectCloudAccountMutationVariables>(LinkNetsConnectCloudAccountDocument, options);
      }
export type LinkNetsConnectCloudAccountMutationHookResult = ReturnType<typeof useLinkNetsConnectCloudAccountMutation>;
export type LinkNetsConnectCloudAccountMutationResult = Apollo.MutationResult<LinkNetsConnectCloudAccountMutation>;
export type LinkNetsConnectCloudAccountMutationOptions = Apollo.BaseMutationOptions<LinkNetsConnectCloudAccountMutation, LinkNetsConnectCloudAccountMutationVariables>;
export const RefreshPosTerminalsDocument = gql`
    mutation RefreshPosTerminals($restaurantId: ID!) {
  refreshPosTerminals(restaurantId: $restaurantId) {
    id
    hasNetsConnectCloudLink
    netsConnectCloudUsername
    posTerminals {
      ...FullPosTerminal
    }
  }
}
    ${FullPosTerminalFragmentDoc}`;
export type RefreshPosTerminalsMutationFn = Apollo.MutationFunction<RefreshPosTerminalsMutation, RefreshPosTerminalsMutationVariables>;

/**
 * __useRefreshPosTerminalsMutation__
 *
 * To run a mutation, you first call `useRefreshPosTerminalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPosTerminalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPosTerminalsMutation, { data, loading, error }] = useRefreshPosTerminalsMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useRefreshPosTerminalsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshPosTerminalsMutation, RefreshPosTerminalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshPosTerminalsMutation, RefreshPosTerminalsMutationVariables>(RefreshPosTerminalsDocument, options);
      }
export type RefreshPosTerminalsMutationHookResult = ReturnType<typeof useRefreshPosTerminalsMutation>;
export type RefreshPosTerminalsMutationResult = Apollo.MutationResult<RefreshPosTerminalsMutation>;
export type RefreshPosTerminalsMutationOptions = Apollo.BaseMutationOptions<RefreshPosTerminalsMutation, RefreshPosTerminalsMutationVariables>;
export const ListSieAccountsDocument = gql`
    query ListSIEAccounts($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    sieAccounts {
      id
      defaultDescription
      defaultNumber
      description
      key
      number
    }
  }
}
    `;

/**
 * __useListSieAccountsQuery__
 *
 * To run a query within a React component, call `useListSieAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSieAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSieAccountsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListSieAccountsQuery(baseOptions: Apollo.QueryHookOptions<ListSieAccountsQuery, ListSieAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSieAccountsQuery, ListSieAccountsQueryVariables>(ListSieAccountsDocument, options);
      }
export function useListSieAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSieAccountsQuery, ListSieAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSieAccountsQuery, ListSieAccountsQueryVariables>(ListSieAccountsDocument, options);
        }
export type ListSieAccountsQueryHookResult = ReturnType<typeof useListSieAccountsQuery>;
export type ListSieAccountsLazyQueryHookResult = ReturnType<typeof useListSieAccountsLazyQuery>;
export type ListSieAccountsQueryResult = Apollo.QueryResult<ListSieAccountsQuery, ListSieAccountsQueryVariables>;
export const SetAccountingPlanDocument = gql`
    mutation SetAccountingPlan($organizationId: ID!, $accounts: [SIEAccountInput!]!) {
  setOrganizationAccountingPlan(
    organizationId: $organizationId
    accounts: $accounts
  ) {
    id
    sieAccounts {
      id
      defaultDescription
      defaultNumber
      description
      key
      number
    }
  }
}
    `;
export type SetAccountingPlanMutationFn = Apollo.MutationFunction<SetAccountingPlanMutation, SetAccountingPlanMutationVariables>;

/**
 * __useSetAccountingPlanMutation__
 *
 * To run a mutation, you first call `useSetAccountingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountingPlanMutation, { data, loading, error }] = useSetAccountingPlanMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useSetAccountingPlanMutation(baseOptions?: Apollo.MutationHookOptions<SetAccountingPlanMutation, SetAccountingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccountingPlanMutation, SetAccountingPlanMutationVariables>(SetAccountingPlanDocument, options);
      }
export type SetAccountingPlanMutationHookResult = ReturnType<typeof useSetAccountingPlanMutation>;
export type SetAccountingPlanMutationResult = Apollo.MutationResult<SetAccountingPlanMutation>;
export type SetAccountingPlanMutationOptions = Apollo.BaseMutationOptions<SetAccountingPlanMutation, SetAccountingPlanMutationVariables>;
export const GetSieReportDocument = gql`
    query GetSIEReport($organizationId: ID!, $datePeriod: DateTimeRangeInput!, $filter: SieReportFilter) {
  organization(id: $organizationId) {
    id
    name
    sieAccounts {
      id
      defaultDescription
      defaultNumber
      description
      key
      number
    }
    sieReport(datePeriod: $datePeriod, filter: $filter) {
      id
      sieFileData
      datePeriod {
        start
        end
      }
      verifications {
        ...SieVerification
      }
    }
  }
}
    ${SieVerificationFragmentDoc}`;

/**
 * __useGetSieReportQuery__
 *
 * To run a query within a React component, call `useGetSieReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSieReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSieReportQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      datePeriod: // value for 'datePeriod'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSieReportQuery(baseOptions: Apollo.QueryHookOptions<GetSieReportQuery, GetSieReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSieReportQuery, GetSieReportQueryVariables>(GetSieReportDocument, options);
      }
export function useGetSieReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSieReportQuery, GetSieReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSieReportQuery, GetSieReportQueryVariables>(GetSieReportDocument, options);
        }
export type GetSieReportQueryHookResult = ReturnType<typeof useGetSieReportQuery>;
export type GetSieReportLazyQueryHookResult = ReturnType<typeof useGetSieReportLazyQuery>;
export type GetSieReportQueryResult = Apollo.QueryResult<GetSieReportQuery, GetSieReportQueryVariables>;
export const GetSieReportViewDataDocument = gql`
    query GetSieReportViewData($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    accountantEmail
    fortnoxAccountingImportEnabled
    hasFortnoxAccountingImportAccess
    isOwner: hasAccess(access: Write)
    fortnoxAccountingImportFailedVerifications {
      ...SieVerification
    }
    restaurants {
      id
      name
    }
  }
}
    ${SieVerificationFragmentDoc}`;

/**
 * __useGetSieReportViewDataQuery__
 *
 * To run a query within a React component, call `useGetSieReportViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSieReportViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSieReportViewDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetSieReportViewDataQuery(baseOptions: Apollo.QueryHookOptions<GetSieReportViewDataQuery, GetSieReportViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSieReportViewDataQuery, GetSieReportViewDataQueryVariables>(GetSieReportViewDataDocument, options);
      }
export function useGetSieReportViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSieReportViewDataQuery, GetSieReportViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSieReportViewDataQuery, GetSieReportViewDataQueryVariables>(GetSieReportViewDataDocument, options);
        }
export type GetSieReportViewDataQueryHookResult = ReturnType<typeof useGetSieReportViewDataQuery>;
export type GetSieReportViewDataLazyQueryHookResult = ReturnType<typeof useGetSieReportViewDataLazyQuery>;
export type GetSieReportViewDataQueryResult = Apollo.QueryResult<GetSieReportViewDataQuery, GetSieReportViewDataQueryVariables>;
export const MarkFortnoxAccountingImportAsManuallyImportedDocument = gql`
    mutation MarkFortnoxAccountingImportAsManuallyImported($organizationId: ID!, $sieVerificationId: ID!) {
  markFortnoxAccountingImportAsManuallyImported(
    organizationId: $organizationId
    sieVerificationId: $sieVerificationId
  ) {
    id
    status
    logEntries {
      ...LogEntries
    }
  }
}
    ${LogEntriesFragmentDoc}`;
export type MarkFortnoxAccountingImportAsManuallyImportedMutationFn = Apollo.MutationFunction<MarkFortnoxAccountingImportAsManuallyImportedMutation, MarkFortnoxAccountingImportAsManuallyImportedMutationVariables>;

/**
 * __useMarkFortnoxAccountingImportAsManuallyImportedMutation__
 *
 * To run a mutation, you first call `useMarkFortnoxAccountingImportAsManuallyImportedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFortnoxAccountingImportAsManuallyImportedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFortnoxAccountingImportAsManuallyImportedMutation, { data, loading, error }] = useMarkFortnoxAccountingImportAsManuallyImportedMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sieVerificationId: // value for 'sieVerificationId'
 *   },
 * });
 */
export function useMarkFortnoxAccountingImportAsManuallyImportedMutation(baseOptions?: Apollo.MutationHookOptions<MarkFortnoxAccountingImportAsManuallyImportedMutation, MarkFortnoxAccountingImportAsManuallyImportedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFortnoxAccountingImportAsManuallyImportedMutation, MarkFortnoxAccountingImportAsManuallyImportedMutationVariables>(MarkFortnoxAccountingImportAsManuallyImportedDocument, options);
      }
export type MarkFortnoxAccountingImportAsManuallyImportedMutationHookResult = ReturnType<typeof useMarkFortnoxAccountingImportAsManuallyImportedMutation>;
export type MarkFortnoxAccountingImportAsManuallyImportedMutationResult = Apollo.MutationResult<MarkFortnoxAccountingImportAsManuallyImportedMutation>;
export type MarkFortnoxAccountingImportAsManuallyImportedMutationOptions = Apollo.BaseMutationOptions<MarkFortnoxAccountingImportAsManuallyImportedMutation, MarkFortnoxAccountingImportAsManuallyImportedMutationVariables>;
export const RetryFortnoxAccountingImportDocument = gql`
    mutation RetryFortnoxAccountingImport($organizationId: ID!, $sieVerificationId: ID!) {
  retryFortnoxAccountingImport(
    organizationId: $organizationId
    sieVerificationId: $sieVerificationId
  ) {
    id
    status
    logEntries {
      ...LogEntries
    }
  }
}
    ${LogEntriesFragmentDoc}`;
export type RetryFortnoxAccountingImportMutationFn = Apollo.MutationFunction<RetryFortnoxAccountingImportMutation, RetryFortnoxAccountingImportMutationVariables>;

/**
 * __useRetryFortnoxAccountingImportMutation__
 *
 * To run a mutation, you first call `useRetryFortnoxAccountingImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFortnoxAccountingImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFortnoxAccountingImportMutation, { data, loading, error }] = useRetryFortnoxAccountingImportMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sieVerificationId: // value for 'sieVerificationId'
 *   },
 * });
 */
export function useRetryFortnoxAccountingImportMutation(baseOptions?: Apollo.MutationHookOptions<RetryFortnoxAccountingImportMutation, RetryFortnoxAccountingImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryFortnoxAccountingImportMutation, RetryFortnoxAccountingImportMutationVariables>(RetryFortnoxAccountingImportDocument, options);
      }
export type RetryFortnoxAccountingImportMutationHookResult = ReturnType<typeof useRetryFortnoxAccountingImportMutation>;
export type RetryFortnoxAccountingImportMutationResult = Apollo.MutationResult<RetryFortnoxAccountingImportMutation>;
export type RetryFortnoxAccountingImportMutationOptions = Apollo.BaseMutationOptions<RetryFortnoxAccountingImportMutation, RetryFortnoxAccountingImportMutationVariables>;
export const SetOrganizationAccountantEmailDocument = gql`
    mutation SetOrganizationAccountantEmail($organizationId: ID!, $email: EmailAddress!) {
  setOrganizationAccountantEmail(organizationId: $organizationId, email: $email) {
    id
    accountantEmail
  }
}
    `;
export type SetOrganizationAccountantEmailMutationFn = Apollo.MutationFunction<SetOrganizationAccountantEmailMutation, SetOrganizationAccountantEmailMutationVariables>;

/**
 * __useSetOrganizationAccountantEmailMutation__
 *
 * To run a mutation, you first call `useSetOrganizationAccountantEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationAccountantEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationAccountantEmailMutation, { data, loading, error }] = useSetOrganizationAccountantEmailMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSetOrganizationAccountantEmailMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationAccountantEmailMutation, SetOrganizationAccountantEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganizationAccountantEmailMutation, SetOrganizationAccountantEmailMutationVariables>(SetOrganizationAccountantEmailDocument, options);
      }
export type SetOrganizationAccountantEmailMutationHookResult = ReturnType<typeof useSetOrganizationAccountantEmailMutation>;
export type SetOrganizationAccountantEmailMutationResult = Apollo.MutationResult<SetOrganizationAccountantEmailMutation>;
export type SetOrganizationAccountantEmailMutationOptions = Apollo.BaseMutationOptions<SetOrganizationAccountantEmailMutation, SetOrganizationAccountantEmailMutationVariables>;
export const GetStatisticsOverviewDataDocument = gql`
    query GetStatisticsOverviewData($dateTimeRange: DateTimeRangeInput!, $resolution: TimeResolution!) {
  statistics(dateTimeRange: $dateTimeRange, resolution: $resolution) {
    id
    salesByMenuTypeAndTimePeriod {
      id
      count
      grossAmount
      menuType
      when
    }
    salesByRestaurant {
      id
      count
      grossAmount
      restaurant {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetStatisticsOverviewDataQuery__
 *
 * To run a query within a React component, call `useGetStatisticsOverviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticsOverviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticsOverviewDataQuery({
 *   variables: {
 *      dateTimeRange: // value for 'dateTimeRange'
 *      resolution: // value for 'resolution'
 *   },
 * });
 */
export function useGetStatisticsOverviewDataQuery(baseOptions: Apollo.QueryHookOptions<GetStatisticsOverviewDataQuery, GetStatisticsOverviewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatisticsOverviewDataQuery, GetStatisticsOverviewDataQueryVariables>(GetStatisticsOverviewDataDocument, options);
      }
export function useGetStatisticsOverviewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatisticsOverviewDataQuery, GetStatisticsOverviewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatisticsOverviewDataQuery, GetStatisticsOverviewDataQueryVariables>(GetStatisticsOverviewDataDocument, options);
        }
export type GetStatisticsOverviewDataQueryHookResult = ReturnType<typeof useGetStatisticsOverviewDataQuery>;
export type GetStatisticsOverviewDataLazyQueryHookResult = ReturnType<typeof useGetStatisticsOverviewDataLazyQuery>;
export type GetStatisticsOverviewDataQueryResult = Apollo.QueryResult<GetStatisticsOverviewDataQuery, GetStatisticsOverviewDataQueryVariables>;
export const ListStripeReportsDocument = gql`
    query ListStripeReports($organizationId: ID!, $cursor: String) {
  organization(id: $organizationId) {
    id
    stripeReports(first: 25, after: $cursor) {
      edges {
        cursor
        node {
          ...FullStripeReport
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${FullStripeReportFragmentDoc}`;

/**
 * __useListStripeReportsQuery__
 *
 * To run a query within a React component, call `useListStripeReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStripeReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStripeReportsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListStripeReportsQuery(baseOptions: Apollo.QueryHookOptions<ListStripeReportsQuery, ListStripeReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListStripeReportsQuery, ListStripeReportsQueryVariables>(ListStripeReportsDocument, options);
      }
export function useListStripeReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListStripeReportsQuery, ListStripeReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListStripeReportsQuery, ListStripeReportsQueryVariables>(ListStripeReportsDocument, options);
        }
export type ListStripeReportsQueryHookResult = ReturnType<typeof useListStripeReportsQuery>;
export type ListStripeReportsLazyQueryHookResult = ReturnType<typeof useListStripeReportsLazyQuery>;
export type ListStripeReportsQueryResult = Apollo.QueryResult<ListStripeReportsQuery, ListStripeReportsQueryVariables>;
export const GetStripeReportHtmlDocument = gql`
    query GetStripeReportHtml($organizationId: ID!, $reportId: ID!) {
  organization(id: $organizationId) {
    id
    stripeReport(id: $reportId) {
      id
      html
    }
  }
}
    `;

/**
 * __useGetStripeReportHtmlQuery__
 *
 * To run a query within a React component, call `useGetStripeReportHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeReportHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeReportHtmlQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetStripeReportHtmlQuery(baseOptions: Apollo.QueryHookOptions<GetStripeReportHtmlQuery, GetStripeReportHtmlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeReportHtmlQuery, GetStripeReportHtmlQueryVariables>(GetStripeReportHtmlDocument, options);
      }
export function useGetStripeReportHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeReportHtmlQuery, GetStripeReportHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeReportHtmlQuery, GetStripeReportHtmlQueryVariables>(GetStripeReportHtmlDocument, options);
        }
export type GetStripeReportHtmlQueryHookResult = ReturnType<typeof useGetStripeReportHtmlQuery>;
export type GetStripeReportHtmlLazyQueryHookResult = ReturnType<typeof useGetStripeReportHtmlLazyQuery>;
export type GetStripeReportHtmlQueryResult = Apollo.QueryResult<GetStripeReportHtmlQuery, GetStripeReportHtmlQueryVariables>;
export const SetStripeAccountIdDocument = gql`
    mutation SetStripeAccountId($authorizationCode: String!, $organizationId: ID!) {
  setStripeAccountId(
    authorizationCode: $authorizationCode
    organizationId: $organizationId
  ) {
    id
    setupProgress {
      hasCompletedStripeSetup
      hasStripeAccount
    }
  }
}
    `;
export type SetStripeAccountIdMutationFn = Apollo.MutationFunction<SetStripeAccountIdMutation, SetStripeAccountIdMutationVariables>;

/**
 * __useSetStripeAccountIdMutation__
 *
 * To run a mutation, you first call `useSetStripeAccountIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStripeAccountIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStripeAccountIdMutation, { data, loading, error }] = useSetStripeAccountIdMutation({
 *   variables: {
 *      authorizationCode: // value for 'authorizationCode'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSetStripeAccountIdMutation(baseOptions?: Apollo.MutationHookOptions<SetStripeAccountIdMutation, SetStripeAccountIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStripeAccountIdMutation, SetStripeAccountIdMutationVariables>(SetStripeAccountIdDocument, options);
      }
export type SetStripeAccountIdMutationHookResult = ReturnType<typeof useSetStripeAccountIdMutation>;
export type SetStripeAccountIdMutationResult = Apollo.MutationResult<SetStripeAccountIdMutation>;
export type SetStripeAccountIdMutationOptions = Apollo.BaseMutationOptions<SetStripeAccountIdMutation, SetStripeAccountIdMutationVariables>;
export const GetAppVersionsDataDocument = gql`
    query GetAppVersionsData {
  appVersions(filter: {app: Order}) {
    id
    gitRef
    userDevicesCount
    version
  }
}
    `;

/**
 * __useGetAppVersionsDataQuery__
 *
 * To run a query within a React component, call `useGetAppVersionsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppVersionsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppVersionsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppVersionsDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAppVersionsDataQuery, GetAppVersionsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppVersionsDataQuery, GetAppVersionsDataQueryVariables>(GetAppVersionsDataDocument, options);
      }
export function useGetAppVersionsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppVersionsDataQuery, GetAppVersionsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppVersionsDataQuery, GetAppVersionsDataQueryVariables>(GetAppVersionsDataDocument, options);
        }
export type GetAppVersionsDataQueryHookResult = ReturnType<typeof useGetAppVersionsDataQuery>;
export type GetAppVersionsDataLazyQueryHookResult = ReturnType<typeof useGetAppVersionsDataLazyQuery>;
export type GetAppVersionsDataQueryResult = Apollo.QueryResult<GetAppVersionsDataQuery, GetAppVersionsDataQueryVariables>;
export const GetTransactionChannelIncomeDataDocument = gql`
    query GetTransactionChannelIncomeData($dateTimeRange: DateTimeRangeInput!) {
  transactionChannelIncome(dateTimeRange: $dateTimeRange) {
    id
    totalAmount
    totalSales
    transactionChannel
  }
}
    `;

/**
 * __useGetTransactionChannelIncomeDataQuery__
 *
 * To run a query within a React component, call `useGetTransactionChannelIncomeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionChannelIncomeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionChannelIncomeDataQuery({
 *   variables: {
 *      dateTimeRange: // value for 'dateTimeRange'
 *   },
 * });
 */
export function useGetTransactionChannelIncomeDataQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionChannelIncomeDataQuery, GetTransactionChannelIncomeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionChannelIncomeDataQuery, GetTransactionChannelIncomeDataQueryVariables>(GetTransactionChannelIncomeDataDocument, options);
      }
export function useGetTransactionChannelIncomeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionChannelIncomeDataQuery, GetTransactionChannelIncomeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionChannelIncomeDataQuery, GetTransactionChannelIncomeDataQueryVariables>(GetTransactionChannelIncomeDataDocument, options);
        }
export type GetTransactionChannelIncomeDataQueryHookResult = ReturnType<typeof useGetTransactionChannelIncomeDataQuery>;
export type GetTransactionChannelIncomeDataLazyQueryHookResult = ReturnType<typeof useGetTransactionChannelIncomeDataLazyQuery>;
export type GetTransactionChannelIncomeDataQueryResult = Apollo.QueryResult<GetTransactionChannelIncomeDataQuery, GetTransactionChannelIncomeDataQueryVariables>;
export const GetRestaurantsStatusDocument = gql`
    query GetRestaurantsStatus {
  restaurants(first: 100000) {
    edges {
      node {
        id
        kitchenOrderQueueGrossAmount
        kitchenOrderQueueLength
        lastActiveTime
        lastOrderPlacedAt
        name
      }
    }
  }
}
    `;

/**
 * __useGetRestaurantsStatusQuery__
 *
 * To run a query within a React component, call `useGetRestaurantsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRestaurantsStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetRestaurantsStatusQuery, GetRestaurantsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantsStatusQuery, GetRestaurantsStatusQueryVariables>(GetRestaurantsStatusDocument, options);
      }
export function useGetRestaurantsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantsStatusQuery, GetRestaurantsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantsStatusQuery, GetRestaurantsStatusQueryVariables>(GetRestaurantsStatusDocument, options);
        }
export type GetRestaurantsStatusQueryHookResult = ReturnType<typeof useGetRestaurantsStatusQuery>;
export type GetRestaurantsStatusLazyQueryHookResult = ReturnType<typeof useGetRestaurantsStatusLazyQuery>;
export type GetRestaurantsStatusQueryResult = Apollo.QueryResult<GetRestaurantsStatusQuery, GetRestaurantsStatusQueryVariables>;
export const GetCreateUserDataDocument = gql`
    query GetCreateUserData {
  me {
    id
    username
    isSuperUser
    organizationsWithAccess(access: Read) {
      id
      restaurants {
        id
        name
      }
    }
    restaurantsWithAccess(access: Write) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCreateUserDataQuery__
 *
 * To run a query within a React component, call `useGetCreateUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreateUserDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCreateUserDataQuery, GetCreateUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateUserDataQuery, GetCreateUserDataQueryVariables>(GetCreateUserDataDocument, options);
      }
export function useGetCreateUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateUserDataQuery, GetCreateUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateUserDataQuery, GetCreateUserDataQueryVariables>(GetCreateUserDataDocument, options);
        }
export type GetCreateUserDataQueryHookResult = ReturnType<typeof useGetCreateUserDataQuery>;
export type GetCreateUserDataLazyQueryHookResult = ReturnType<typeof useGetCreateUserDataLazyQuery>;
export type GetCreateUserDataQueryResult = Apollo.QueryResult<GetCreateUserDataQuery, GetCreateUserDataQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($email: EmailAddress!, $name: String!, $password: String!, $phoneNumber: E164!) {
  createUser(
    input: {email: $email, name: $name, password: $password, phoneNumber: $phoneNumber}
  ) {
    id
    username
    isSuperUser
    name
    phone
    city
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      password: // value for 'password'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateWhiteLabelDocument = gql`
    mutation CreateWhiteLabel($input: WhiteLabelInput!) {
  createWhiteLabel(input: $input) {
    id
    appName
    label
  }
}
    `;
export type CreateWhiteLabelMutationFn = Apollo.MutationFunction<CreateWhiteLabelMutation, CreateWhiteLabelMutationVariables>;

/**
 * __useCreateWhiteLabelMutation__
 *
 * To run a mutation, you first call `useCreateWhiteLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWhiteLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWhiteLabelMutation, { data, loading, error }] = useCreateWhiteLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWhiteLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateWhiteLabelMutation, CreateWhiteLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWhiteLabelMutation, CreateWhiteLabelMutationVariables>(CreateWhiteLabelDocument, options);
      }
export type CreateWhiteLabelMutationHookResult = ReturnType<typeof useCreateWhiteLabelMutation>;
export type CreateWhiteLabelMutationResult = Apollo.MutationResult<CreateWhiteLabelMutation>;
export type CreateWhiteLabelMutationOptions = Apollo.BaseMutationOptions<CreateWhiteLabelMutation, CreateWhiteLabelMutationVariables>;
export const ListWhiteLabelsDocument = gql`
    query ListWhiteLabels {
  whiteLabels(first: 999) {
    edges {
      node {
        ...WhiteLabelListEntry
      }
    }
  }
}
    ${WhiteLabelListEntryFragmentDoc}`;

/**
 * __useListWhiteLabelsQuery__
 *
 * To run a query within a React component, call `useListWhiteLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWhiteLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWhiteLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListWhiteLabelsQuery(baseOptions?: Apollo.QueryHookOptions<ListWhiteLabelsQuery, ListWhiteLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWhiteLabelsQuery, ListWhiteLabelsQueryVariables>(ListWhiteLabelsDocument, options);
      }
export function useListWhiteLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWhiteLabelsQuery, ListWhiteLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWhiteLabelsQuery, ListWhiteLabelsQueryVariables>(ListWhiteLabelsDocument, options);
        }
export type ListWhiteLabelsQueryHookResult = ReturnType<typeof useListWhiteLabelsQuery>;
export type ListWhiteLabelsLazyQueryHookResult = ReturnType<typeof useListWhiteLabelsLazyQuery>;
export type ListWhiteLabelsQueryResult = Apollo.QueryResult<ListWhiteLabelsQuery, ListWhiteLabelsQueryVariables>;
export const GetWhiteLabelDocument = gql`
    query GetWhiteLabel($whiteLabelId: ID!) {
  whiteLabel(id: $whiteLabelId) {
    ...WhiteLabelFields
  }
}
    ${WhiteLabelFieldsFragmentDoc}`;

/**
 * __useGetWhiteLabelQuery__
 *
 * To run a query within a React component, call `useGetWhiteLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWhiteLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWhiteLabelQuery({
 *   variables: {
 *      whiteLabelId: // value for 'whiteLabelId'
 *   },
 * });
 */
export function useGetWhiteLabelQuery(baseOptions: Apollo.QueryHookOptions<GetWhiteLabelQuery, GetWhiteLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWhiteLabelQuery, GetWhiteLabelQueryVariables>(GetWhiteLabelDocument, options);
      }
export function useGetWhiteLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWhiteLabelQuery, GetWhiteLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWhiteLabelQuery, GetWhiteLabelQueryVariables>(GetWhiteLabelDocument, options);
        }
export type GetWhiteLabelQueryHookResult = ReturnType<typeof useGetWhiteLabelQuery>;
export type GetWhiteLabelLazyQueryHookResult = ReturnType<typeof useGetWhiteLabelLazyQuery>;
export type GetWhiteLabelQueryResult = Apollo.QueryResult<GetWhiteLabelQuery, GetWhiteLabelQueryVariables>;
export const ExportYouniumUsageDocument = gql`
    mutation ExportYouniumUsage($input: ExportYouniumUsageInput!) {
  exportYouniumUsage(input: $input)
}
    `;
export type ExportYouniumUsageMutationFn = Apollo.MutationFunction<ExportYouniumUsageMutation, ExportYouniumUsageMutationVariables>;

/**
 * __useExportYouniumUsageMutation__
 *
 * To run a mutation, you first call `useExportYouniumUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportYouniumUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportYouniumUsageMutation, { data, loading, error }] = useExportYouniumUsageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportYouniumUsageMutation(baseOptions?: Apollo.MutationHookOptions<ExportYouniumUsageMutation, ExportYouniumUsageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportYouniumUsageMutation, ExportYouniumUsageMutationVariables>(ExportYouniumUsageDocument, options);
      }
export type ExportYouniumUsageMutationHookResult = ReturnType<typeof useExportYouniumUsageMutation>;
export type ExportYouniumUsageMutationResult = Apollo.MutationResult<ExportYouniumUsageMutation>;
export type ExportYouniumUsageMutationOptions = Apollo.BaseMutationOptions<ExportYouniumUsageMutation, ExportYouniumUsageMutationVariables>;
export const GetRedirectToLandingDataDocument = gql`
    query GetRedirectToLandingData {
  me {
    id
    organizationsWithAccess(access: Read) {
      id
      ...OrganizationPermissions
    }
    restaurantsWithAccess(access: Read) {
      id
      name
      organization {
        id
      }
    }
  }
}
    ${OrganizationPermissionsFragmentDoc}`;

/**
 * __useGetRedirectToLandingDataQuery__
 *
 * To run a query within a React component, call `useGetRedirectToLandingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedirectToLandingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedirectToLandingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRedirectToLandingDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRedirectToLandingDataQuery, GetRedirectToLandingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedirectToLandingDataQuery, GetRedirectToLandingDataQueryVariables>(GetRedirectToLandingDataDocument, options);
      }
export function useGetRedirectToLandingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedirectToLandingDataQuery, GetRedirectToLandingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedirectToLandingDataQuery, GetRedirectToLandingDataQueryVariables>(GetRedirectToLandingDataDocument, options);
        }
export type GetRedirectToLandingDataQueryHookResult = ReturnType<typeof useGetRedirectToLandingDataQuery>;
export type GetRedirectToLandingDataLazyQueryHookResult = ReturnType<typeof useGetRedirectToLandingDataLazyQuery>;
export type GetRedirectToLandingDataQueryResult = Apollo.QueryResult<GetRedirectToLandingDataQuery, GetRedirectToLandingDataQueryVariables>;
export const UpdateMenuProductDocument = gql`
    mutation UpdateMenuProduct($restaurantId: ID!, $menuProductId: ID!, $patch: MenuProductPatch!) {
  updateMenuProduct(
    restaurantId: $restaurantId
    menuProductId: $menuProductId
    patch: $patch
  ) {
    ...MenuProductFields
  }
}
    ${MenuProductFieldsFragmentDoc}`;
export type UpdateMenuProductMutationFn = Apollo.MutationFunction<UpdateMenuProductMutation, UpdateMenuProductMutationVariables>;

/**
 * __useUpdateMenuProductMutation__
 *
 * To run a mutation, you first call `useUpdateMenuProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuProductMutation, { data, loading, error }] = useUpdateMenuProductMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      menuProductId: // value for 'menuProductId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateMenuProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuProductMutation, UpdateMenuProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuProductMutation, UpdateMenuProductMutationVariables>(UpdateMenuProductDocument, options);
      }
export type UpdateMenuProductMutationHookResult = ReturnType<typeof useUpdateMenuProductMutation>;
export type UpdateMenuProductMutationResult = Apollo.MutationResult<UpdateMenuProductMutation>;
export type UpdateMenuProductMutationOptions = Apollo.BaseMutationOptions<UpdateMenuProductMutation, UpdateMenuProductMutationVariables>;